export const MUNICIPIOS_BRASIL = [
    { id: 1, nome: 'ALTA FLORESTA D OESTE', codigo_ibge: 1100015, codigo_uf: 11 },
    { id: 26, nome: 'ALTO ALEGRE DOS PARECIS', codigo_ibge: 1100379, codigo_uf: 11 },
    { id: 27, nome: 'ALTO PARAISO', codigo_ibge: 1100403, codigo_uf: 11 },
    { id: 25, nome: 'ALVORADA D OESTE', codigo_ibge: 1100346, codigo_uf: 11 },
    { id: 2, nome: 'ARIQUEMES', codigo_ibge: 1100023, codigo_uf: 11 },
    { id: 28, nome: 'BURITIS', codigo_ibge: 1100452, codigo_uf: 11 },
    { id: 3, nome: 'CABIXI', codigo_ibge: 1100031, codigo_uf: 11 },
    { id: 30, nome: 'CACAULANDIA', codigo_ibge: 1100601, codigo_uf: 11 },
    { id: 4, nome: 'CACOAL', codigo_ibge: 1100049, codigo_uf: 11 },
    { id: 31, nome: 'CAMPO NOVO DE RONDONIA', codigo_ibge: 1100700, codigo_uf: 11 },
    { id: 32, nome: 'CANDEIAS DO JAMARI', codigo_ibge: 1100809, codigo_uf: 11 },
    { id: 33, nome: 'CASTANHEIRAS', codigo_ibge: 1100908, codigo_uf: 11 },
    { id: 5, nome: 'CEREJEIRAS', codigo_ibge: 1100056, codigo_uf: 11 },
    { id: 34, nome: 'CHUPINGUAIA', codigo_ibge: 1100924, codigo_uf: 11 },
    { id: 6, nome: 'COLORADO DO OESTE', codigo_ibge: 1100064, codigo_uf: 11 },
    { id: 7, nome: 'CORUMBIARA', codigo_ibge: 1100072, codigo_uf: 11 },
    { id: 8, nome: 'COSTA MARQUES', codigo_ibge: 1100080, codigo_uf: 11 },
    { id: 35, nome: 'CUJUBIM', codigo_ibge: 1100940, codigo_uf: 11 },
    { id: 9, nome: 'ESPIGAO D OESTE', codigo_ibge: 1100098, codigo_uf: 11 },
    { id: 36, nome: 'GOVERNADOR JORGE TEIXEIRA', codigo_ibge: 1101005, codigo_uf: 11 },
    { id: 10, nome: 'GUAJARA-MIRIM', codigo_ibge: 1100106, codigo_uf: 11 },
    { id: 37, nome: 'ITAPUA DO OESTE', codigo_ibge: 1101104, codigo_uf: 11 },
    { id: 11, nome: 'JARU', codigo_ibge: 1100114, codigo_uf: 11 },
    { id: 12, nome: 'JI-PARANA', codigo_ibge: 1100122, codigo_uf: 11 },
    { id: 13, nome: 'MACHADINHO D OESTE', codigo_ibge: 1100130, codigo_uf: 11 },
    { id: 38, nome: 'MINISTRO ANDREAZZA', codigo_ibge: 1101203, codigo_uf: 11 },
    { id: 39, nome: 'MIRANTE DA SERRA', codigo_ibge: 1101302, codigo_uf: 11 },
    { id: 40, nome: 'MONTE NEGRO', codigo_ibge: 1101401, codigo_uf: 11 },
    { id: 14, nome: 'NOVA BRASILANDIA D OESTE', codigo_ibge: 1100148, codigo_uf: 11 },
    { id: 24, nome: 'NOVA MAMORE', codigo_ibge: 1100338, codigo_uf: 11 },
    { id: 41, nome: 'NOVA UNIAO', codigo_ibge: 1101435, codigo_uf: 11 },
    { id: 29, nome: 'NOVO HORIZONTE DO OESTE', codigo_ibge: 1100502, codigo_uf: 11 },
    { id: 15, nome: 'OURO PRETO DO OESTE', codigo_ibge: 1100155, codigo_uf: 11 },
    { id: 42, nome: 'PARECIS', codigo_ibge: 1101450, codigo_uf: 11 },
    { id: 16, nome: 'PIMENTA BUENO', codigo_ibge: 1100189, codigo_uf: 11 },
    { id: 43, nome: 'PIMENTEIRAS DO OESTE', codigo_ibge: 1101468, codigo_uf: 11 },
    { id: 17, nome: 'PORTO VELHO', codigo_ibge: 1100205, codigo_uf: 11 },
    { id: 18, nome: 'PRESIDENTE MEDICI', codigo_ibge: 1100254, codigo_uf: 11 },
    { id: 44, nome: 'PRIMAVERA DE RONDONIA', codigo_ibge: 1101476, codigo_uf: 11 },
    { id: 19, nome: 'RIO CRESPO', codigo_ibge: 1100262, codigo_uf: 11 },
    { id: 20, nome: 'ROLIM DE MOURA', codigo_ibge: 1100288, codigo_uf: 11 },
    { id: 21, nome: 'SANTA LUZIA D OESTE', codigo_ibge: 1100296, codigo_uf: 11 },
    { id: 45, nome: 'SAO FELIPE D OESTE', codigo_ibge: 1101484, codigo_uf: 11 },
    { id: 46, nome: 'SAO FRANCISCO DO GUAPORE', codigo_ibge: 1101492, codigo_uf: 11 },
    { id: 23, nome: 'SAO MIGUEL DO GUAPORE', codigo_ibge: 1100320, codigo_uf: 11 },
    { id: 47, nome: 'SERINGUEIRAS', codigo_ibge: 1101500, codigo_uf: 11 },
    { id: 48, nome: 'TEIXEIROPOLIS', codigo_ibge: 1101559, codigo_uf: 11 },
    { id: 49, nome: 'THEOBROMA', codigo_ibge: 1101609, codigo_uf: 11 },
    { id: 50, nome: 'URUPA', codigo_ibge: 1101708, codigo_uf: 11 },
    { id: 51, nome: 'VALE DO ANARI', codigo_ibge: 1101757, codigo_uf: 11 },
    { id: 52, nome: 'VALE DO PARAISO', codigo_ibge: 1101807, codigo_uf: 11 },
    { id: 22, nome: 'VILHENA', codigo_ibge: 1100304, codigo_uf: 11 },
    { id: 53, nome: 'ACRELANDIA', codigo_ibge: 1200013, codigo_uf: 12 },
    { id: 54, nome: 'ASSIS BRASIL', codigo_ibge: 1200054, codigo_uf: 12 },
    { id: 55, nome: 'BRASILEIA', codigo_ibge: 1200104, codigo_uf: 12 },
    { id: 56, nome: 'BUJARI', codigo_ibge: 1200138, codigo_uf: 12 },
    { id: 57, nome: 'CAPIXABA', codigo_ibge: 1200179, codigo_uf: 12 },
    { id: 58, nome: 'CRUZEIRO DO SUL', codigo_ibge: 1200203, codigo_uf: 12 },
    { id: 59, nome: 'EPITACIOLANDIA', codigo_ibge: 1200252, codigo_uf: 12 },
    { id: 60, nome: 'FEIJO', codigo_ibge: 1200302, codigo_uf: 12 },
    { id: 61, nome: 'JORDAO', codigo_ibge: 1200328, codigo_uf: 12 },
    { id: 62, nome: 'MANCIO LIMA', codigo_ibge: 1200336, codigo_uf: 12 },
    { id: 63, nome: 'MANOEL URBANO', codigo_ibge: 1200344, codigo_uf: 12 },
    { id: 64, nome: 'MARECHAL THAUMATURGO', codigo_ibge: 1200351, codigo_uf: 12 },
    { id: 65, nome: 'PLACIDO DE CASTRO', codigo_ibge: 1200385, codigo_uf: 12 },
    { id: 74, nome: 'PORTO ACRE', codigo_ibge: 1200807, codigo_uf: 12 },
    { id: 66, nome: 'PORTO WALTER', codigo_ibge: 1200393, codigo_uf: 12 },
    { id: 67, nome: 'RIO BRANCO', codigo_ibge: 1200401, codigo_uf: 12 },
    { id: 68, nome: 'RODRIGUES ALVES', codigo_ibge: 1200427, codigo_uf: 12 },
    { id: 69, nome: 'SANTA ROSA DO PURUS', codigo_ibge: 1200435, codigo_uf: 12 },
    { id: 71, nome: 'SENA MADUREIRA', codigo_ibge: 1200500, codigo_uf: 12 },
    { id: 70, nome: 'SENADOR GUIOMARD', codigo_ibge: 1200450, codigo_uf: 12 },
    { id: 72, nome: 'TARAUACA', codigo_ibge: 1200609, codigo_uf: 12 },
    { id: 73, nome: 'XAPURI', codigo_ibge: 1200708, codigo_uf: 12 },
    { id: 75, nome: 'ALVARAES', codigo_ibge: 1300029, codigo_uf: 13 },
    { id: 76, nome: 'AMATURA', codigo_ibge: 1300060, codigo_uf: 13 },
    { id: 77, nome: 'ANAMA', codigo_ibge: 1300086, codigo_uf: 13 },
    { id: 78, nome: 'ANORI', codigo_ibge: 1300102, codigo_uf: 13 },
    { id: 79, nome: 'APUI', codigo_ibge: 1300144, codigo_uf: 13 },
    { id: 80, nome: 'ATALAIA DO NORTE', codigo_ibge: 1300201, codigo_uf: 13 },
    { id: 81, nome: 'AUTAZES', codigo_ibge: 1300300, codigo_uf: 13 },
    { id: 82, nome: 'BARCELOS', codigo_ibge: 1300409, codigo_uf: 13 },
    { id: 83, nome: 'BARREIRINHA', codigo_ibge: 1300508, codigo_uf: 13 },
    { id: 84, nome: 'BENJAMIN CONSTANT', codigo_ibge: 1300607, codigo_uf: 13 },
    { id: 85, nome: 'BERURI', codigo_ibge: 1300631, codigo_uf: 13 },
    { id: 86, nome: 'BOA VISTA DO RAMOS', codigo_ibge: 1300680, codigo_uf: 13 },
    { id: 87, nome: 'BOCA DO ACRE', codigo_ibge: 1300706, codigo_uf: 13 },
    { id: 88, nome: 'BORBA', codigo_ibge: 1300805, codigo_uf: 13 },
    { id: 89, nome: 'CAAPIRANGA', codigo_ibge: 1300839, codigo_uf: 13 },
    { id: 90, nome: 'CANUTAMA', codigo_ibge: 1300904, codigo_uf: 13 },
    { id: 91, nome: 'CARAUARI', codigo_ibge: 1301001, codigo_uf: 13 },
    { id: 92, nome: 'CAREIRO', codigo_ibge: 1301100, codigo_uf: 13 },
    { id: 93, nome: 'CAREIRO DA VARZEA', codigo_ibge: 1301159, codigo_uf: 13 },
    { id: 94, nome: 'COARI', codigo_ibge: 1301209, codigo_uf: 13 },
    { id: 95, nome: 'CODAJAS', codigo_ibge: 1301308, codigo_uf: 13 },
    { id: 96, nome: 'EIRUNEPE', codigo_ibge: 1301407, codigo_uf: 13 },
    { id: 97, nome: 'ENVIRA', codigo_ibge: 1301506, codigo_uf: 13 },
    { id: 98, nome: 'FONTE BOA', codigo_ibge: 1301605, codigo_uf: 13 },
    { id: 99, nome: 'GUAJARA', codigo_ibge: 1301654, codigo_uf: 13 },
    { id: 100, nome: 'HUMAITA', codigo_ibge: 1301704, codigo_uf: 13 },
    { id: 101, nome: 'IPIXUNA', codigo_ibge: 1301803, codigo_uf: 13 },
    { id: 102, nome: 'IRANDUBA', codigo_ibge: 1301852, codigo_uf: 13 },
    { id: 103, nome: 'ITACOATIARA', codigo_ibge: 1301902, codigo_uf: 13 },
    { id: 104, nome: 'ITAMARATI', codigo_ibge: 1301951, codigo_uf: 13 },
    { id: 105, nome: 'ITAPIRANGA', codigo_ibge: 1302009, codigo_uf: 13 },
    { id: 106, nome: 'JAPURA', codigo_ibge: 1302108, codigo_uf: 13 },
    { id: 107, nome: 'JURUA', codigo_ibge: 1302207, codigo_uf: 13 },
    { id: 108, nome: 'JUTAI', codigo_ibge: 1302306, codigo_uf: 13 },
    { id: 109, nome: 'LABREA', codigo_ibge: 1302405, codigo_uf: 13 },
    { id: 110, nome: 'MANACAPURU', codigo_ibge: 1302504, codigo_uf: 13 },
    { id: 111, nome: 'MANAQUIRI', codigo_ibge: 1302553, codigo_uf: 13 },
    { id: 112, nome: 'MANAUS', codigo_ibge: 1302603, codigo_uf: 13 },
    { id: 113, nome: 'MANICORE', codigo_ibge: 1302702, codigo_uf: 13 },
    { id: 114, nome: 'MARAA', codigo_ibge: 1302801, codigo_uf: 13 },
    { id: 115, nome: 'MAUES', codigo_ibge: 1302900, codigo_uf: 13 },
    { id: 116, nome: 'NHAMUNDA', codigo_ibge: 1303007, codigo_uf: 13 },
    { id: 117, nome: 'NOVA OLINDA DO NORTE', codigo_ibge: 1303106, codigo_uf: 13 },
    { id: 118, nome: 'NOVO AIRAO', codigo_ibge: 1303205, codigo_uf: 13 },
    { id: 119, nome: 'NOVO ARIPUANA', codigo_ibge: 1303304, codigo_uf: 13 },
    { id: 120, nome: 'PARINTINS', codigo_ibge: 1303403, codigo_uf: 13 },
    { id: 121, nome: 'PAUINI', codigo_ibge: 1303502, codigo_uf: 13 },
    { id: 122, nome: 'PRESIDENTE FIGUEIREDO', codigo_ibge: 1303536, codigo_uf: 13 },
    { id: 123, nome: 'RIO PRETO DA EVA', codigo_ibge: 1303569, codigo_uf: 13 },
    { id: 124, nome: 'SANTA ISABEL DO RIO NEGRO', codigo_ibge: 1303601, codigo_uf: 13 },
    { id: 125, nome: 'SANTO ANTONIO DO ICA', codigo_ibge: 1303700, codigo_uf: 13 },
    { id: 126, nome: 'SAO GABRIEL DA CACHOEIRA', codigo_ibge: 1303809, codigo_uf: 13 },
    { id: 127, nome: 'SAO PAULO DE OLIVENCA', codigo_ibge: 1303908, codigo_uf: 13 },
    { id: 128, nome: 'SAO SEBASTIAO DO UATUMA', codigo_ibge: 1303957, codigo_uf: 13 },
    { id: 129, nome: 'SILVES', codigo_ibge: 1304005, codigo_uf: 13 },
    { id: 130, nome: 'TABATINGA', codigo_ibge: 1304062, codigo_uf: 13 },
    { id: 131, nome: 'TAPAUA', codigo_ibge: 1304104, codigo_uf: 13 },
    { id: 132, nome: 'TEFE', codigo_ibge: 1304203, codigo_uf: 13 },
    { id: 133, nome: 'TONANTINS', codigo_ibge: 1304237, codigo_uf: 13 },
    { id: 134, nome: 'UARINI', codigo_ibge: 1304260, codigo_uf: 13 },
    { id: 135, nome: 'URUCARA', codigo_ibge: 1304302, codigo_uf: 13 },
    { id: 136, nome: 'URUCURITUBA', codigo_ibge: 1304401, codigo_uf: 13 },
    { id: 138, nome: 'ALTO ALEGRE', codigo_ibge: 1400050, codigo_uf: 14 },
    { id: 137, nome: 'AMAJARI', codigo_ibge: 1400027, codigo_uf: 14 },
    { id: 139, nome: 'BOA VISTA', codigo_ibge: 1400100, codigo_uf: 14 },
    { id: 140, nome: 'BONFIM', codigo_ibge: 1400159, codigo_uf: 14 },
    { id: 141, nome: 'CANTA', codigo_ibge: 1400175, codigo_uf: 14 },
    { id: 142, nome: 'CARACARAI', codigo_ibge: 1400209, codigo_uf: 14 },
    { id: 143, nome: 'CAROEBE', codigo_ibge: 1400233, codigo_uf: 14 },
    { id: 144, nome: 'IRACEMA', codigo_ibge: 1400282, codigo_uf: 14 },
    { id: 145, nome: 'MUCAJAI', codigo_ibge: 1400308, codigo_uf: 14 },
    { id: 146, nome: 'NORMANDIA', codigo_ibge: 1400407, codigo_uf: 14 },
    { id: 147, nome: 'PACARAIMA', codigo_ibge: 1400456, codigo_uf: 14 },
    { id: 148, nome: 'RORAINOPOLIS', codigo_ibge: 1400472, codigo_uf: 14 },
    { id: 149, nome: 'SAO JOAO DA BALIZA', codigo_ibge: 1400506, codigo_uf: 14 },
    { id: 150, nome: 'SAO LUIZ', codigo_ibge: 1400605, codigo_uf: 14 },
    { id: 151, nome: 'UIRAMUTA', codigo_ibge: 1400704, codigo_uf: 14 },
    { id: 152, nome: 'ABAETETUBA', codigo_ibge: 1500107, codigo_uf: 15 },
    { id: 153, nome: 'ABEL FIGUEIREDO', codigo_ibge: 1500131, codigo_uf: 15 },
    { id: 154, nome: 'ACARA', codigo_ibge: 1500206, codigo_uf: 15 },
    { id: 155, nome: 'AFUA', codigo_ibge: 1500305, codigo_uf: 15 },
    { id: 156, nome: 'AGUA AZUL DO NORTE', codigo_ibge: 1500347, codigo_uf: 15 },
    { id: 157, nome: 'ALENQUER', codigo_ibge: 1500404, codigo_uf: 15 },
    { id: 158, nome: 'ALMEIRIM', codigo_ibge: 1500503, codigo_uf: 15 },
    { id: 159, nome: 'ALTAMIRA', codigo_ibge: 1500602, codigo_uf: 15 },
    { id: 160, nome: 'ANAJAS', codigo_ibge: 1500701, codigo_uf: 15 },
    { id: 161, nome: 'ANANINDEUA', codigo_ibge: 1500800, codigo_uf: 15 },
    { id: 162, nome: 'ANAPU', codigo_ibge: 1500859, codigo_uf: 15 },
    { id: 163, nome: 'AUGUSTO CORREA', codigo_ibge: 1500909, codigo_uf: 15 },
    { id: 164, nome: 'AURORA DO PARA', codigo_ibge: 1500958, codigo_uf: 15 },
    { id: 165, nome: 'AVEIRO', codigo_ibge: 1501006, codigo_uf: 15 },
    { id: 166, nome: 'BAGRE', codigo_ibge: 1501105, codigo_uf: 15 },
    { id: 167, nome: 'BAIAO', codigo_ibge: 1501204, codigo_uf: 15 },
    { id: 168, nome: 'BANNACH', codigo_ibge: 1501253, codigo_uf: 15 },
    { id: 169, nome: 'BARCARENA', codigo_ibge: 1501303, codigo_uf: 15 },
    { id: 170, nome: 'BELEM', codigo_ibge: 1501402, codigo_uf: 15 },
    { id: 171, nome: 'BELTERRA', codigo_ibge: 1501451, codigo_uf: 15 },
    { id: 172, nome: 'BENEVIDES', codigo_ibge: 1501501, codigo_uf: 15 },
    { id: 173, nome: 'BOM JESUS DO TOCANTINS', codigo_ibge: 1501576, codigo_uf: 15 },
    { id: 174, nome: 'BONITO', codigo_ibge: 1501600, codigo_uf: 15 },
    { id: 175, nome: 'BRAGANCA', codigo_ibge: 1501709, codigo_uf: 15 },
    { id: 176, nome: 'BRASIL NOVO', codigo_ibge: 1501725, codigo_uf: 15 },
    { id: 177, nome: 'BREJO GRANDE DO ARAGUAIA', codigo_ibge: 1501758, codigo_uf: 15 },
    { id: 178, nome: 'BREU BRANCO', codigo_ibge: 1501782, codigo_uf: 15 },
    { id: 179, nome: 'BREVES', codigo_ibge: 1501808, codigo_uf: 15 },
    { id: 180, nome: 'BUJARU', codigo_ibge: 1501907, codigo_uf: 15 },
    { id: 182, nome: 'CACHOEIRA DO ARARI', codigo_ibge: 1502004, codigo_uf: 15 },
    { id: 181, nome: 'CACHOEIRA DO PIRIA', codigo_ibge: 1501956, codigo_uf: 15 },
    { id: 183, nome: 'CAMETA', codigo_ibge: 1502103, codigo_uf: 15 },
    { id: 184, nome: 'CANAA DOS CARAJAS', codigo_ibge: 1502152, codigo_uf: 15 },
    { id: 185, nome: 'CAPANEMA', codigo_ibge: 1502202, codigo_uf: 15 },
    { id: 186, nome: 'CAPITAO POCO', codigo_ibge: 1502301, codigo_uf: 15 },
    { id: 187, nome: 'CASTANHAL', codigo_ibge: 1502400, codigo_uf: 15 },
    { id: 188, nome: 'CHAVES', codigo_ibge: 1502509, codigo_uf: 15 },
    { id: 189, nome: 'COLARES', codigo_ibge: 1502608, codigo_uf: 15 },
    { id: 190, nome: 'CONCEICAO DO ARAGUAIA', codigo_ibge: 1502707, codigo_uf: 15 },
    { id: 191, nome: 'CONCORDIA DO PARA', codigo_ibge: 1502756, codigo_uf: 15 },
    { id: 192, nome: 'CUMARU DO NORTE', codigo_ibge: 1502764, codigo_uf: 15 },
    { id: 193, nome: 'CURIONOPOLIS', codigo_ibge: 1502772, codigo_uf: 15 },
    { id: 194, nome: 'CURRALINHO', codigo_ibge: 1502806, codigo_uf: 15 },
    { id: 195, nome: 'CURUA', codigo_ibge: 1502855, codigo_uf: 15 },
    { id: 196, nome: 'CURUCA', codigo_ibge: 1502905, codigo_uf: 15 },
    { id: 197, nome: 'DOM ELISEU', codigo_ibge: 1502939, codigo_uf: 15 },
    { id: 198, nome: 'ELDORADO DO CARAJAS', codigo_ibge: 1502954, codigo_uf: 15 },
    { id: 199, nome: 'FARO', codigo_ibge: 1503002, codigo_uf: 15 },
    { id: 200, nome: 'FLORESTA DO ARAGUAIA', codigo_ibge: 1503044, codigo_uf: 15 },
    { id: 201, nome: 'GARRAFAO DO NORTE', codigo_ibge: 1503077, codigo_uf: 15 },
    { id: 202, nome: 'GOIANESIA DO PARA', codigo_ibge: 1503093, codigo_uf: 15 },
    { id: 203, nome: 'GURUPA', codigo_ibge: 1503101, codigo_uf: 15 },
    { id: 204, nome: 'IGARAPE-ACU', codigo_ibge: 1503200, codigo_uf: 15 },
    { id: 205, nome: 'IGARAPE-MIRI', codigo_ibge: 1503309, codigo_uf: 15 },
    { id: 206, nome: 'INHANGAPI', codigo_ibge: 1503408, codigo_uf: 15 },
    { id: 207, nome: 'IPIXUNA DO PARA', codigo_ibge: 1503457, codigo_uf: 15 },
    { id: 208, nome: 'IRITUIA', codigo_ibge: 1503507, codigo_uf: 15 },
    { id: 209, nome: 'ITAITUBA', codigo_ibge: 1503606, codigo_uf: 15 },
    { id: 210, nome: 'ITUPIRANGA', codigo_ibge: 1503705, codigo_uf: 15 },
    { id: 211, nome: 'JACAREACANGA', codigo_ibge: 1503754, codigo_uf: 15 },
    { id: 212, nome: 'JACUNDA', codigo_ibge: 1503804, codigo_uf: 15 },
    { id: 213, nome: 'JURUTI', codigo_ibge: 1503903, codigo_uf: 15 },
    { id: 214, nome: 'LIMOEIRO DO AJURU', codigo_ibge: 1504000, codigo_uf: 15 },
    { id: 215, nome: 'MAE DO RIO', codigo_ibge: 1504059, codigo_uf: 15 },
    { id: 216, nome: 'MAGALHAES BARATA', codigo_ibge: 1504109, codigo_uf: 15 },
    { id: 217, nome: 'MARABA', codigo_ibge: 1504208, codigo_uf: 15 },
    { id: 218, nome: 'MARACANA', codigo_ibge: 1504307, codigo_uf: 15 },
    { id: 219, nome: 'MARAPANIM', codigo_ibge: 1504406, codigo_uf: 15 },
    { id: 220, nome: 'MARITUBA', codigo_ibge: 1504422, codigo_uf: 15 },
    { id: 221, nome: 'MEDICILANDIA', codigo_ibge: 1504455, codigo_uf: 15 },
    { id: 222, nome: 'MELGACO', codigo_ibge: 1504505, codigo_uf: 15 },
    { id: 223, nome: 'MOCAJUBA', codigo_ibge: 1504604, codigo_uf: 15 },
    { id: 224, nome: 'MOJU', codigo_ibge: 1504703, codigo_uf: 15 },
    { id: 225, nome: 'MOJUI DOS CAMPOS', codigo_ibge: 1504752, codigo_uf: 15 },
    { id: 226, nome: 'MONTE ALEGRE', codigo_ibge: 1504802, codigo_uf: 15 },
    { id: 227, nome: 'MUANA', codigo_ibge: 1504901, codigo_uf: 15 },
    { id: 228, nome: 'NOVA ESPERANCA DO PIRIA', codigo_ibge: 1504950, codigo_uf: 15 },
    { id: 229, nome: 'NOVA IPIXUNA', codigo_ibge: 1504976, codigo_uf: 15 },
    { id: 230, nome: 'NOVA TIMBOTEUA', codigo_ibge: 1505007, codigo_uf: 15 },
    { id: 231, nome: 'NOVO PROGRESSO', codigo_ibge: 1505031, codigo_uf: 15 },
    { id: 232, nome: 'NOVO REPARTIMENTO', codigo_ibge: 1505064, codigo_uf: 15 },
    { id: 233, nome: 'OBIDOS', codigo_ibge: 1505106, codigo_uf: 15 },
    { id: 234, nome: 'OEIRAS DO PARA', codigo_ibge: 1505205, codigo_uf: 15 },
    { id: 235, nome: 'ORIXIMINA', codigo_ibge: 1505304, codigo_uf: 15 },
    { id: 236, nome: 'OUREM', codigo_ibge: 1505403, codigo_uf: 15 },
    { id: 237, nome: 'OURILANDIA DO NORTE', codigo_ibge: 1505437, codigo_uf: 15 },
    { id: 238, nome: 'PACAJA', codigo_ibge: 1505486, codigo_uf: 15 },
    { id: 239, nome: 'PALESTINA DO PARA', codigo_ibge: 1505494, codigo_uf: 15 },
    { id: 240, nome: 'PARAGOMINAS', codigo_ibge: 1505502, codigo_uf: 15 },
    { id: 241, nome: 'PARAUAPEBAS', codigo_ibge: 1505536, codigo_uf: 15 },
    { id: 242, nome: 'PAU D ARCO', codigo_ibge: 1505551, codigo_uf: 15 },
    { id: 243, nome: 'PEIXE-BOI', codigo_ibge: 1505601, codigo_uf: 15 },
    { id: 244, nome: 'PICARRA', codigo_ibge: 1505635, codigo_uf: 15 },
    { id: 245, nome: 'PLACAS', codigo_ibge: 1505650, codigo_uf: 15 },
    { id: 246, nome: 'PONTA DE PEDRAS', codigo_ibge: 1505700, codigo_uf: 15 },
    { id: 247, nome: 'PORTEL', codigo_ibge: 1505809, codigo_uf: 15 },
    { id: 248, nome: 'PORTO DE MOZ', codigo_ibge: 1505908, codigo_uf: 15 },
    { id: 249, nome: 'PRAINHA', codigo_ibge: 1506005, codigo_uf: 15 },
    { id: 250, nome: 'PRIMAVERA', codigo_ibge: 1506104, codigo_uf: 15 },
    { id: 251, nome: 'QUATIPURU', codigo_ibge: 1506112, codigo_uf: 15 },
    { id: 252, nome: 'REDENCAO', codigo_ibge: 1506138, codigo_uf: 15 },
    { id: 253, nome: 'RIO MARIA', codigo_ibge: 1506161, codigo_uf: 15 },
    { id: 254, nome: 'RONDON DO PARA', codigo_ibge: 1506187, codigo_uf: 15 },
    { id: 255, nome: 'RUROPOLIS', codigo_ibge: 1506195, codigo_uf: 15 },
    { id: 256, nome: 'SALINOPOLIS', codigo_ibge: 1506203, codigo_uf: 15 },
    { id: 257, nome: 'SALVATERRA', codigo_ibge: 1506302, codigo_uf: 15 },
    { id: 258, nome: 'SANTA BARBARA DO PARA', codigo_ibge: 1506351, codigo_uf: 15 },
    { id: 259, nome: 'SANTA CRUZ DO ARARI', codigo_ibge: 1506401, codigo_uf: 15 },
    { id: 260, nome: 'SANTA IZABEL DO PARA', codigo_ibge: 1506500, codigo_uf: 15 },
    { id: 261, nome: 'SANTA LUZIA DO PARA', codigo_ibge: 1506559, codigo_uf: 15 },
    { id: 262, nome: 'SANTA MARIA DAS BARREIRAS', codigo_ibge: 1506583, codigo_uf: 15 },
    { id: 263, nome: 'SANTA MARIA DO PARA', codigo_ibge: 1506609, codigo_uf: 15 },
    { id: 264, nome: 'SANTANA DO ARAGUAIA', codigo_ibge: 1506708, codigo_uf: 15 },
    { id: 265, nome: 'SANTAREM', codigo_ibge: 1506807, codigo_uf: 15 },
    { id: 266, nome: 'SANTAREM NOVO', codigo_ibge: 1506906, codigo_uf: 15 },
    { id: 267, nome: 'SANTO ANTONIO DO TAUA', codigo_ibge: 1507003, codigo_uf: 15 },
    { id: 268, nome: 'SAO CAETANO DE ODIVELAS', codigo_ibge: 1507102, codigo_uf: 15 },
    { id: 269, nome: 'SAO DOMINGOS DO ARAGUAIA', codigo_ibge: 1507151, codigo_uf: 15 },
    { id: 270, nome: 'SAO DOMINGOS DO CAPIM', codigo_ibge: 1507201, codigo_uf: 15 },
    { id: 271, nome: 'SAO FELIX DO XINGU', codigo_ibge: 1507300, codigo_uf: 15 },
    { id: 272, nome: 'SAO FRANCISCO DO PARA', codigo_ibge: 1507409, codigo_uf: 15 },
    { id: 273, nome: 'SAO GERALDO DO ARAGUAIA', codigo_ibge: 1507458, codigo_uf: 15 },
    { id: 274, nome: 'SAO JOAO DA PONTA', codigo_ibge: 1507466, codigo_uf: 15 },
    { id: 275, nome: 'SAO JOAO DE PIRABAS', codigo_ibge: 1507474, codigo_uf: 15 },
    { id: 276, nome: 'SAO JOAO DO ARAGUAIA', codigo_ibge: 1507508, codigo_uf: 15 },
    { id: 277, nome: 'SAO MIGUEL DO GUAMA', codigo_ibge: 1507607, codigo_uf: 15 },
    { id: 278, nome: 'SAO SEBASTIAO DA BOA VISTA', codigo_ibge: 1507706, codigo_uf: 15 },
    { id: 279, nome: 'SAPUCAIA', codigo_ibge: 1507755, codigo_uf: 15 },
    { id: 280, nome: 'SENADOR JOSE PORFIRIO', codigo_ibge: 1507805, codigo_uf: 15 },
    { id: 281, nome: 'SOURE', codigo_ibge: 1507904, codigo_uf: 15 },
    { id: 282, nome: 'TAILANDIA', codigo_ibge: 1507953, codigo_uf: 15 },
    { id: 283, nome: 'TERRA ALTA', codigo_ibge: 1507961, codigo_uf: 15 },
    { id: 284, nome: 'TERRA SANTA', codigo_ibge: 1507979, codigo_uf: 15 },
    { id: 285, nome: 'TOME-ACU', codigo_ibge: 1508001, codigo_uf: 15 },
    { id: 286, nome: 'TRACUATEUA', codigo_ibge: 1508035, codigo_uf: 15 },
    { id: 287, nome: 'TRAIRAO', codigo_ibge: 1508050, codigo_uf: 15 },
    { id: 288, nome: 'TUCUMA', codigo_ibge: 1508084, codigo_uf: 15 },
    { id: 289, nome: 'TUCURUI', codigo_ibge: 1508100, codigo_uf: 15 },
    { id: 290, nome: 'ULIANOPOLIS', codigo_ibge: 1508126, codigo_uf: 15 },
    { id: 291, nome: 'URUARA', codigo_ibge: 1508159, codigo_uf: 15 },
    { id: 292, nome: 'VIGIA', codigo_ibge: 1508209, codigo_uf: 15 },
    { id: 293, nome: 'VISEU', codigo_ibge: 1508308, codigo_uf: 15 },
    { id: 294, nome: 'VITORIA DO XINGU', codigo_ibge: 1508357, codigo_uf: 15 },
    { id: 295, nome: 'XINGUARA', codigo_ibge: 1508407, codigo_uf: 15 },
    { id: 297, nome: 'AMAPA', codigo_ibge: 1600105, codigo_uf: 16 },
    { id: 299, nome: 'CALCOENE', codigo_ibge: 1600204, codigo_uf: 16 },
    { id: 300, nome: 'CUTIAS', codigo_ibge: 1600212, codigo_uf: 16 },
    { id: 301, nome: 'FERREIRA GOMES', codigo_ibge: 1600238, codigo_uf: 16 },
    { id: 302, nome: 'ITAUBAL', codigo_ibge: 1600253, codigo_uf: 16 },
    { id: 303, nome: 'LARANJAL DO JARI', codigo_ibge: 1600279, codigo_uf: 16 },
    { id: 304, nome: 'MACAPA', codigo_ibge: 1600303, codigo_uf: 16 },
    { id: 305, nome: 'MAZAGAO', codigo_ibge: 1600402, codigo_uf: 16 },
    { id: 306, nome: 'OIAPOQUE', codigo_ibge: 1600501, codigo_uf: 16 },
    { id: 298, nome: 'PEDRA BRANCA DO AMAPARI', codigo_ibge: 1600154, codigo_uf: 16 },
    { id: 307, nome: 'PORTO GRANDE', codigo_ibge: 1600535, codigo_uf: 16 },
    { id: 308, nome: 'PRACUUBA', codigo_ibge: 1600550, codigo_uf: 16 },
    { id: 309, nome: 'SANTANA', codigo_ibge: 1600600, codigo_uf: 16 },
    { id: 296, nome: 'SERRA DO NAVIO', codigo_ibge: 1600055, codigo_uf: 16 },
    { id: 310, nome: 'TARTARUGALZINHO', codigo_ibge: 1600709, codigo_uf: 16 },
    { id: 311, nome: 'VITORIA DO JARI', codigo_ibge: 1600808, codigo_uf: 16 },
    { id: 312, nome: 'ABREULANDIA', codigo_ibge: 1700251, codigo_uf: 17 },
    { id: 313, nome: 'AGUIARNOPOLIS', codigo_ibge: 1700301, codigo_uf: 17 },
    { id: 314, nome: 'ALIANCA DO TOCANTINS', codigo_ibge: 1700350, codigo_uf: 17 },
    { id: 315, nome: 'ALMAS', codigo_ibge: 1700400, codigo_uf: 17 },
    { id: 316, nome: 'ALVORADA', codigo_ibge: 1700707, codigo_uf: 17 },
    { id: 317, nome: 'ANANAS', codigo_ibge: 1701002, codigo_uf: 17 },
    { id: 318, nome: 'ANGICO', codigo_ibge: 1701051, codigo_uf: 17 },
    { id: 319, nome: 'APARECIDA DO RIO NEGRO', codigo_ibge: 1701101, codigo_uf: 17 },
    { id: 320, nome: 'ARAGOMINAS', codigo_ibge: 1701309, codigo_uf: 17 },
    { id: 321, nome: 'ARAGUACEMA', codigo_ibge: 1701903, codigo_uf: 17 },
    { id: 322, nome: 'ARAGUACU', codigo_ibge: 1702000, codigo_uf: 17 },
    { id: 323, nome: 'ARAGUAINA', codigo_ibge: 1702109, codigo_uf: 17 },
    { id: 324, nome: 'ARAGUANA', codigo_ibge: 1702158, codigo_uf: 17 },
    { id: 325, nome: 'ARAGUATINS', codigo_ibge: 1702208, codigo_uf: 17 },
    { id: 326, nome: 'ARAPOEMA', codigo_ibge: 1702307, codigo_uf: 17 },
    { id: 327, nome: 'ARRAIAS', codigo_ibge: 1702406, codigo_uf: 17 },
    { id: 328, nome: 'AUGUSTINOPOLIS', codigo_ibge: 1702554, codigo_uf: 17 },
    { id: 329, nome: 'AURORA DO TOCANTINS', codigo_ibge: 1702703, codigo_uf: 17 },
    { id: 330, nome: 'AXIXA DO TOCANTINS', codigo_ibge: 1702901, codigo_uf: 17 },
    { id: 331, nome: 'BABACULANDIA', codigo_ibge: 1703008, codigo_uf: 17 },
    { id: 332, nome: 'BANDEIRANTES DO TOCANTINS', codigo_ibge: 1703057, codigo_uf: 17 },
    { id: 333, nome: 'BARRA DO OURO', codigo_ibge: 1703073, codigo_uf: 17 },
    { id: 334, nome: 'BARROLANDIA', codigo_ibge: 1703107, codigo_uf: 17 },
    { id: 335, nome: 'BERNARDO SAYAO', codigo_ibge: 1703206, codigo_uf: 17 },
    { id: 336, nome: 'BOM JESUS DO TOCANTINS', codigo_ibge: 1703305, codigo_uf: 17 },
    { id: 337, nome: 'BRASILANDIA DO TOCANTINS', codigo_ibge: 1703602, codigo_uf: 17 },
    { id: 338, nome: 'BREJINHO DE NAZARE', codigo_ibge: 1703701, codigo_uf: 17 },
    { id: 339, nome: 'BURITI DO TOCANTINS', codigo_ibge: 1703800, codigo_uf: 17 },
    { id: 340, nome: 'CACHOEIRINHA', codigo_ibge: 1703826, codigo_uf: 17 },
    { id: 341, nome: 'CAMPOS LINDOS', codigo_ibge: 1703842, codigo_uf: 17 },
    { id: 342, nome: 'CARIRI DO TOCANTINS', codigo_ibge: 1703867, codigo_uf: 17 },
    { id: 343, nome: 'CARMOLANDIA', codigo_ibge: 1703883, codigo_uf: 17 },
    { id: 344, nome: 'CARRASCO BONITO', codigo_ibge: 1703891, codigo_uf: 17 },
    { id: 345, nome: 'CASEARA', codigo_ibge: 1703909, codigo_uf: 17 },
    { id: 346, nome: 'CENTENARIO', codigo_ibge: 1704105, codigo_uf: 17 },
    { id: 348, nome: 'CHAPADA DA NATIVIDADE', codigo_ibge: 1705102, codigo_uf: 17 },
    { id: 347, nome: 'CHAPADA DE AREIA', codigo_ibge: 1704600, codigo_uf: 17 },
    { id: 349, nome: 'COLINAS DO TOCANTINS', codigo_ibge: 1705508, codigo_uf: 17 },
    { id: 408, nome: 'COLMEIA', codigo_ibge: 1716703, codigo_uf: 17 },
    { id: 350, nome: 'COMBINADO', codigo_ibge: 1705557, codigo_uf: 17 },
    { id: 351, nome: 'CONCEICAO DO TOCANTINS', codigo_ibge: 1705607, codigo_uf: 17 },
    { id: 352, nome: 'COUTO MAGALHAES', codigo_ibge: 1706001, codigo_uf: 17 },
    { id: 353, nome: 'CRISTALANDIA', codigo_ibge: 1706100, codigo_uf: 17 },
    { id: 354, nome: 'CRIXAS DO TOCANTINS', codigo_ibge: 1706258, codigo_uf: 17 },
    { id: 355, nome: 'DARCINOPOLIS', codigo_ibge: 1706506, codigo_uf: 17 },
    { id: 356, nome: 'DIANOPOLIS', codigo_ibge: 1707009, codigo_uf: 17 },
    { id: 357, nome: 'DIVINOPOLIS DO TOCANTINS', codigo_ibge: 1707108, codigo_uf: 17 },
    { id: 358, nome: 'DOIS IRMAOS DO TOCANTINS', codigo_ibge: 1707207, codigo_uf: 17 },
    { id: 359, nome: 'DUERE', codigo_ibge: 1707306, codigo_uf: 17 },
    { id: 360, nome: 'ESPERANTINA', codigo_ibge: 1707405, codigo_uf: 17 },
    { id: 361, nome: 'FATIMA', codigo_ibge: 1707553, codigo_uf: 17 },
    { id: 362, nome: 'FIGUEIROPOLIS', codigo_ibge: 1707652, codigo_uf: 17 },
    { id: 363, nome: 'FILADELFIA', codigo_ibge: 1707702, codigo_uf: 17 },
    { id: 364, nome: 'FORMOSO DO ARAGUAIA', codigo_ibge: 1708205, codigo_uf: 17 },
    { id: 365, nome: 'FORTALEZA DO TABOCAO', codigo_ibge: 1708254, codigo_uf: 17 },
    { id: 366, nome: 'GOIANORTE', codigo_ibge: 1708304, codigo_uf: 17 },
    { id: 367, nome: 'GOIATINS', codigo_ibge: 1709005, codigo_uf: 17 },
    { id: 368, nome: 'GUARAI', codigo_ibge: 1709302, codigo_uf: 17 },
    { id: 369, nome: 'GURUPI', codigo_ibge: 1709500, codigo_uf: 17 },
    { id: 370, nome: 'IPUEIRAS', codigo_ibge: 1709807, codigo_uf: 17 },
    { id: 371, nome: 'ITACAJA', codigo_ibge: 1710508, codigo_uf: 17 },
    { id: 372, nome: 'ITAGUATINS', codigo_ibge: 1710706, codigo_uf: 17 },
    { id: 373, nome: 'ITAPIRATINS', codigo_ibge: 1710904, codigo_uf: 17 },
    { id: 374, nome: 'ITAPORA DO TOCANTINS', codigo_ibge: 1711100, codigo_uf: 17 },
    { id: 375, nome: 'JAU DO TOCANTINS', codigo_ibge: 1711506, codigo_uf: 17 },
    { id: 376, nome: 'JUARINA', codigo_ibge: 1711803, codigo_uf: 17 },
    { id: 377, nome: 'LAGOA DA CONFUSAO', codigo_ibge: 1711902, codigo_uf: 17 },
    { id: 378, nome: 'LAGOA DO TOCANTINS', codigo_ibge: 1711951, codigo_uf: 17 },
    { id: 379, nome: 'LAJEADO', codigo_ibge: 1712009, codigo_uf: 17 },
    { id: 380, nome: 'LAVANDEIRA', codigo_ibge: 1712157, codigo_uf: 17 },
    { id: 381, nome: 'LIZARDA', codigo_ibge: 1712405, codigo_uf: 17 },
    { id: 382, nome: 'LUZINOPOLIS', codigo_ibge: 1712454, codigo_uf: 17 },
    { id: 383, nome: 'MARIANOPOLIS DO TOCANTINS', codigo_ibge: 1712504, codigo_uf: 17 },
    { id: 384, nome: 'MATEIROS', codigo_ibge: 1712702, codigo_uf: 17 },
    { id: 385, nome: 'MAURILANDIA DO TOCANTINS', codigo_ibge: 1712801, codigo_uf: 17 },
    { id: 386, nome: 'MIRACEMA DO TOCANTINS', codigo_ibge: 1713205, codigo_uf: 17 },
    { id: 387, nome: 'MIRANORTE', codigo_ibge: 1713304, codigo_uf: 17 },
    { id: 388, nome: 'MONTE DO CARMO', codigo_ibge: 1713601, codigo_uf: 17 },
    { id: 389, nome: 'MONTE SANTO DO TOCANTINS', codigo_ibge: 1713700, codigo_uf: 17 },
    { id: 391, nome: 'MURICILANDIA', codigo_ibge: 1713957, codigo_uf: 17 },
    { id: 392, nome: 'NATIVIDADE', codigo_ibge: 1714203, codigo_uf: 17 },
    { id: 393, nome: 'NAZARE', codigo_ibge: 1714302, codigo_uf: 17 },
    { id: 394, nome: 'NOVA OLINDA', codigo_ibge: 1714880, codigo_uf: 17 },
    { id: 395, nome: 'NOVA ROSALANDIA', codigo_ibge: 1715002, codigo_uf: 17 },
    { id: 396, nome: 'NOVO ACORDO', codigo_ibge: 1715101, codigo_uf: 17 },
    { id: 397, nome: 'NOVO ALEGRE', codigo_ibge: 1715150, codigo_uf: 17 },
    { id: 398, nome: 'NOVO JARDIM', codigo_ibge: 1715259, codigo_uf: 17 },
    { id: 399, nome: 'OLIVEIRA DE FATIMA', codigo_ibge: 1715507, codigo_uf: 17 },
    { id: 444, nome: 'PALMAS', codigo_ibge: 1721000, codigo_uf: 17 },
    { id: 400, nome: 'PALMEIRANTE', codigo_ibge: 1715705, codigo_uf: 17 },
    { id: 390, nome: 'PALMEIRAS DO TOCANTINS', codigo_ibge: 1713809, codigo_uf: 17 },
    { id: 401, nome: 'PALMEIROPOLIS', codigo_ibge: 1715754, codigo_uf: 17 },
    { id: 402, nome: 'PARAISO DO TOCANTINS', codigo_ibge: 1716109, codigo_uf: 17 },
    { id: 403, nome: 'PARANA', codigo_ibge: 1716208, codigo_uf: 17 },
    { id: 404, nome: 'PAU D ARCO', codigo_ibge: 1716307, codigo_uf: 17 },
    { id: 405, nome: 'PEDRO AFONSO', codigo_ibge: 1716505, codigo_uf: 17 },
    { id: 406, nome: 'PEIXE', codigo_ibge: 1716604, codigo_uf: 17 },
    { id: 407, nome: 'PEQUIZEIRO', codigo_ibge: 1716653, codigo_uf: 17 },
    { id: 409, nome: 'PINDORAMA DO TOCANTINS', codigo_ibge: 1717008, codigo_uf: 17 },
    { id: 410, nome: 'PIRAQUE', codigo_ibge: 1717206, codigo_uf: 17 },
    { id: 411, nome: 'PIUM', codigo_ibge: 1717503, codigo_uf: 17 },
    { id: 412, nome: 'PONTE ALTA DO BOM JESUS', codigo_ibge: 1717800, codigo_uf: 17 },
    { id: 413, nome: 'PONTE ALTA DO TOCANTINS', codigo_ibge: 1717909, codigo_uf: 17 },
    { id: 414, nome: 'PORTO ALEGRE DO TOCANTINS', codigo_ibge: 1718006, codigo_uf: 17 },
    { id: 415, nome: 'PORTO NACIONAL', codigo_ibge: 1718204, codigo_uf: 17 },
    { id: 416, nome: 'PRAIA NORTE', codigo_ibge: 1718303, codigo_uf: 17 },
    { id: 417, nome: 'PRESIDENTE KENNEDY', codigo_ibge: 1718402, codigo_uf: 17 },
    { id: 418, nome: 'PUGMIL', codigo_ibge: 1718451, codigo_uf: 17 },
    { id: 419, nome: 'RECURSOLANDIA', codigo_ibge: 1718501, codigo_uf: 17 },
    { id: 420, nome: 'RIACHINHO', codigo_ibge: 1718550, codigo_uf: 17 },
    { id: 421, nome: 'RIO DA CONCEICAO', codigo_ibge: 1718659, codigo_uf: 17 },
    { id: 422, nome: 'RIO DOS BOIS', codigo_ibge: 1718709, codigo_uf: 17 },
    { id: 423, nome: 'RIO SONO', codigo_ibge: 1718758, codigo_uf: 17 },
    { id: 424, nome: 'SAMPAIO', codigo_ibge: 1718808, codigo_uf: 17 },
    { id: 425, nome: 'SANDOLANDIA', codigo_ibge: 1718840, codigo_uf: 17 },
    { id: 426, nome: 'SANTA FE DO ARAGUAIA', codigo_ibge: 1718865, codigo_uf: 17 },
    { id: 427, nome: 'SANTA MARIA DO TOCANTINS', codigo_ibge: 1718881, codigo_uf: 17 },
    { id: 428, nome: 'SANTA RITA DO TOCANTINS', codigo_ibge: 1718899, codigo_uf: 17 },
    { id: 429, nome: 'SANTA ROSA DO TOCANTINS', codigo_ibge: 1718907, codigo_uf: 17 },
    { id: 430, nome: 'SANTA TEREZA DO TOCANTINS', codigo_ibge: 1719004, codigo_uf: 17 },
    { id: 431, nome: 'SANTA TEREZINHA DO TOCANTINS', codigo_ibge: 1720002, codigo_uf: 17 },
    { id: 432, nome: 'SAO BENTO DO TOCANTINS', codigo_ibge: 1720101, codigo_uf: 17 },
    { id: 433, nome: 'SAO FELIX DO TOCANTINS', codigo_ibge: 1720150, codigo_uf: 17 },
    { id: 434, nome: 'SAO MIGUEL DO TOCANTINS', codigo_ibge: 1720200, codigo_uf: 17 },
    { id: 435, nome: 'SAO SALVADOR DO TOCANTINS', codigo_ibge: 1720259, codigo_uf: 17 },
    { id: 436, nome: 'SAO SEBASTIAO DO TOCANTINS', codigo_ibge: 1720309, codigo_uf: 17 },
    { id: 437, nome: 'SAO VALERIO', codigo_ibge: 1720499, codigo_uf: 17 },
    { id: 438, nome: 'SILVANOPOLIS', codigo_ibge: 1720655, codigo_uf: 17 },
    { id: 439, nome: 'SITIO NOVO DO TOCANTINS', codigo_ibge: 1720804, codigo_uf: 17 },
    { id: 440, nome: 'SUCUPIRA', codigo_ibge: 1720853, codigo_uf: 17 },
    { id: 441, nome: 'TAGUATINGA', codigo_ibge: 1720903, codigo_uf: 17 },
    { id: 442, nome: 'TAIPAS DO TOCANTINS', codigo_ibge: 1720937, codigo_uf: 17 },
    { id: 443, nome: 'TALISMA', codigo_ibge: 1720978, codigo_uf: 17 },
    { id: 445, nome: 'TOCANTINIA', codigo_ibge: 1721109, codigo_uf: 17 },
    { id: 446, nome: 'TOCANTINOPOLIS', codigo_ibge: 1721208, codigo_uf: 17 },
    { id: 447, nome: 'TUPIRAMA', codigo_ibge: 1721257, codigo_uf: 17 },
    { id: 448, nome: 'TUPIRATINS', codigo_ibge: 1721307, codigo_uf: 17 },
    { id: 449, nome: 'WANDERLANDIA', codigo_ibge: 1722081, codigo_uf: 17 },
    { id: 450, nome: 'XAMBIOA', codigo_ibge: 1722107, codigo_uf: 17 },
    { id: 451, nome: 'ACAILANDIA', codigo_ibge: 2100055, codigo_uf: 21 },
    { id: 452, nome: 'AFONSO CUNHA', codigo_ibge: 2100105, codigo_uf: 21 },
    { id: 453, nome: 'AGUA DOCE DO MARANHAO', codigo_ibge: 2100154, codigo_uf: 21 },
    { id: 454, nome: 'ALCANTARA', codigo_ibge: 2100204, codigo_uf: 21 },
    { id: 455, nome: 'ALDEIAS ALTAS', codigo_ibge: 2100303, codigo_uf: 21 },
    { id: 456, nome: 'ALTAMIRA DO MARANHAO', codigo_ibge: 2100402, codigo_uf: 21 },
    { id: 457, nome: 'ALTO ALEGRE DO MARANHAO', codigo_ibge: 2100436, codigo_uf: 21 },
    { id: 458, nome: 'ALTO ALEGRE DO PINDARE', codigo_ibge: 2100477, codigo_uf: 21 },
    { id: 459, nome: 'ALTO PARNAIBA', codigo_ibge: 2100501, codigo_uf: 21 },
    { id: 460, nome: 'AMAPA DO MARANHAO', codigo_ibge: 2100550, codigo_uf: 21 },
    { id: 461, nome: 'AMARANTE DO MARANHAO', codigo_ibge: 2100600, codigo_uf: 21 },
    { id: 462, nome: 'ANAJATUBA', codigo_ibge: 2100709, codigo_uf: 21 },
    { id: 463, nome: 'ANAPURUS', codigo_ibge: 2100808, codigo_uf: 21 },
    { id: 464, nome: 'APICUM-ACU', codigo_ibge: 2100832, codigo_uf: 21 },
    { id: 465, nome: 'ARAGUANA', codigo_ibge: 2100873, codigo_uf: 21 },
    { id: 466, nome: 'ARAIOSES', codigo_ibge: 2100907, codigo_uf: 21 },
    { id: 467, nome: 'ARAME', codigo_ibge: 2100956, codigo_uf: 21 },
    { id: 468, nome: 'ARARI', codigo_ibge: 2101004, codigo_uf: 21 },
    { id: 469, nome: 'AXIXA', codigo_ibge: 2101103, codigo_uf: 21 },
    { id: 470, nome: 'BACABAL', codigo_ibge: 2101202, codigo_uf: 21 },
    { id: 471, nome: 'BACABEIRA', codigo_ibge: 2101251, codigo_uf: 21 },
    { id: 472, nome: 'BACURI', codigo_ibge: 2101301, codigo_uf: 21 },
    { id: 473, nome: 'BACURITUBA', codigo_ibge: 2101350, codigo_uf: 21 },
    { id: 474, nome: 'BALSAS', codigo_ibge: 2101400, codigo_uf: 21 },
    { id: 475, nome: 'BARAO DE GRAJAU', codigo_ibge: 2101509, codigo_uf: 21 },
    { id: 476, nome: 'BARRA DO CORDA', codigo_ibge: 2101608, codigo_uf: 21 },
    { id: 477, nome: 'BARREIRINHAS', codigo_ibge: 2101707, codigo_uf: 21 },
    { id: 479, nome: 'BELA VISTA DO MARANHAO', codigo_ibge: 2101772, codigo_uf: 21 },
    { id: 478, nome: 'BELAGUA', codigo_ibge: 2101731, codigo_uf: 21 },
    { id: 480, nome: 'BENEDITO LEITE', codigo_ibge: 2101806, codigo_uf: 21 },
    { id: 481, nome: 'BEQUIMAO', codigo_ibge: 2101905, codigo_uf: 21 },
    { id: 482, nome: 'BERNARDO DO MEARIM', codigo_ibge: 2101939, codigo_uf: 21 },
    { id: 483, nome: 'BOA VISTA DO GURUPI', codigo_ibge: 2101970, codigo_uf: 21 },
    { id: 484, nome: 'BOM JARDIM', codigo_ibge: 2102002, codigo_uf: 21 },
    { id: 485, nome: 'BOM JESUS DAS SELVAS', codigo_ibge: 2102036, codigo_uf: 21 },
    { id: 486, nome: 'BOM LUGAR', codigo_ibge: 2102077, codigo_uf: 21 },
    { id: 487, nome: 'BREJO', codigo_ibge: 2102101, codigo_uf: 21 },
    { id: 488, nome: 'BREJO DE AREIA', codigo_ibge: 2102150, codigo_uf: 21 },
    { id: 489, nome: 'BURITI', codigo_ibge: 2102200, codigo_uf: 21 },
    { id: 490, nome: 'BURITI BRAVO', codigo_ibge: 2102309, codigo_uf: 21 },
    { id: 491, nome: 'BURITICUPU', codigo_ibge: 2102325, codigo_uf: 21 },
    { id: 492, nome: 'BURITIRANA', codigo_ibge: 2102358, codigo_uf: 21 },
    { id: 493, nome: 'CACHOEIRA GRANDE', codigo_ibge: 2102374, codigo_uf: 21 },
    { id: 494, nome: 'CAJAPIO', codigo_ibge: 2102408, codigo_uf: 21 },
    { id: 495, nome: 'CAJARI', codigo_ibge: 2102507, codigo_uf: 21 },
    { id: 496, nome: 'CAMPESTRE DO MARANHAO', codigo_ibge: 2102556, codigo_uf: 21 },
    { id: 497, nome: 'CANDIDO MENDES', codigo_ibge: 2102606, codigo_uf: 21 },
    { id: 498, nome: 'CANTANHEDE', codigo_ibge: 2102705, codigo_uf: 21 },
    { id: 499, nome: 'CAPINZAL DO NORTE', codigo_ibge: 2102754, codigo_uf: 21 },
    { id: 500, nome: 'CAROLINA', codigo_ibge: 2102804, codigo_uf: 21 },
    { id: 501, nome: 'CARUTAPERA', codigo_ibge: 2102903, codigo_uf: 21 },
    { id: 502, nome: 'CAXIAS', codigo_ibge: 2103000, codigo_uf: 21 },
    { id: 503, nome: 'CEDRAL', codigo_ibge: 2103109, codigo_uf: 21 },
    { id: 504, nome: 'CENTRAL DO MARANHAO', codigo_ibge: 2103125, codigo_uf: 21 },
    { id: 505, nome: 'CENTRO DO GUILHERME', codigo_ibge: 2103158, codigo_uf: 21 },
    { id: 506, nome: 'CENTRO NOVO DO MARANHAO', codigo_ibge: 2103174, codigo_uf: 21 },
    { id: 507, nome: 'CHAPADINHA', codigo_ibge: 2103208, codigo_uf: 21 },
    { id: 508, nome: 'CIDELANDIA', codigo_ibge: 2103257, codigo_uf: 21 },
    { id: 509, nome: 'CODO', codigo_ibge: 2103307, codigo_uf: 21 },
    { id: 510, nome: 'COELHO NETO', codigo_ibge: 2103406, codigo_uf: 21 },
    { id: 511, nome: 'COLINAS', codigo_ibge: 2103505, codigo_uf: 21 },
    { id: 512, nome: 'CONCEICAO DO LAGO-ACU', codigo_ibge: 2103554, codigo_uf: 21 },
    { id: 513, nome: 'COROATA', codigo_ibge: 2103604, codigo_uf: 21 },
    { id: 514, nome: 'CURURUPU', codigo_ibge: 2103703, codigo_uf: 21 },
    { id: 515, nome: 'DAVINOPOLIS', codigo_ibge: 2103752, codigo_uf: 21 },
    { id: 516, nome: 'DOM PEDRO', codigo_ibge: 2103802, codigo_uf: 21 },
    { id: 517, nome: 'DUQUE BACELAR', codigo_ibge: 2103901, codigo_uf: 21 },
    { id: 518, nome: 'ESPERANTINOPOLIS', codigo_ibge: 2104008, codigo_uf: 21 },
    { id: 519, nome: 'ESTREITO', codigo_ibge: 2104057, codigo_uf: 21 },
    { id: 520, nome: 'FEIRA NOVA DO MARANHAO', codigo_ibge: 2104073, codigo_uf: 21 },
    { id: 521, nome: 'FERNANDO FALCAO', codigo_ibge: 2104081, codigo_uf: 21 },
    { id: 522, nome: 'FORMOSA DA SERRA NEGRA', codigo_ibge: 2104099, codigo_uf: 21 },
    { id: 523, nome: 'FORTALEZA DOS NOGUEIRAS', codigo_ibge: 2104107, codigo_uf: 21 },
    { id: 524, nome: 'FORTUNA', codigo_ibge: 2104206, codigo_uf: 21 },
    { id: 525, nome: 'GODOFREDO VIANA', codigo_ibge: 2104305, codigo_uf: 21 },
    { id: 526, nome: 'GONCALVES DIAS', codigo_ibge: 2104404, codigo_uf: 21 },
    { id: 527, nome: 'GOVERNADOR ARCHER', codigo_ibge: 2104503, codigo_uf: 21 },
    { id: 528, nome: 'GOVERNADOR EDISON LOBAO', codigo_ibge: 2104552, codigo_uf: 21 },
    { id: 529, nome: 'GOVERNADOR EUGENIO BARROS', codigo_ibge: 2104602, codigo_uf: 21 },
    { id: 530, nome: 'GOVERNADOR LUIZ ROCHA', codigo_ibge: 2104628, codigo_uf: 21 },
    { id: 531, nome: 'GOVERNADOR NEWTON BELLO', codigo_ibge: 2104651, codigo_uf: 21 },
    { id: 532, nome: 'GOVERNADOR NUNES FREIRE', codigo_ibge: 2104677, codigo_uf: 21 },
    { id: 533, nome: 'GRACA ARANHA', codigo_ibge: 2104701, codigo_uf: 21 },
    { id: 534, nome: 'GRAJAU', codigo_ibge: 2104800, codigo_uf: 21 },
    { id: 535, nome: 'GUIMARAES', codigo_ibge: 2104909, codigo_uf: 21 },
    { id: 536, nome: 'HUMBERTO DE CAMPOS', codigo_ibge: 2105005, codigo_uf: 21 },
    { id: 537, nome: 'ICATU', codigo_ibge: 2105104, codigo_uf: 21 },
    { id: 538, nome: 'IGARAPE DO MEIO', codigo_ibge: 2105153, codigo_uf: 21 },
    { id: 539, nome: 'IGARAPE GRANDE', codigo_ibge: 2105203, codigo_uf: 21 },
    { id: 540, nome: 'IMPERATRIZ', codigo_ibge: 2105302, codigo_uf: 21 },
    { id: 541, nome: 'ITAIPAVA DO GRAJAU', codigo_ibge: 2105351, codigo_uf: 21 },
    { id: 542, nome: 'ITAPECURU MIRIM', codigo_ibge: 2105401, codigo_uf: 21 },
    { id: 543, nome: 'ITINGA DO MARANHAO', codigo_ibge: 2105427, codigo_uf: 21 },
    { id: 544, nome: 'JATOBA', codigo_ibge: 2105450, codigo_uf: 21 },
    { id: 545, nome: 'JENIPAPO DOS VIEIRAS', codigo_ibge: 2105476, codigo_uf: 21 },
    { id: 546, nome: 'JOAO LISBOA', codigo_ibge: 2105500, codigo_uf: 21 },
    { id: 547, nome: 'JOSELANDIA', codigo_ibge: 2105609, codigo_uf: 21 },
    { id: 548, nome: 'JUNCO DO MARANHAO', codigo_ibge: 2105658, codigo_uf: 21 },
    { id: 549, nome: 'LAGO DA PEDRA', codigo_ibge: 2105708, codigo_uf: 21 },
    { id: 550, nome: 'LAGO DO JUNCO', codigo_ibge: 2105807, codigo_uf: 21 },
    { id: 553, nome: 'LAGO DOS RODRIGUES', codigo_ibge: 2105948, codigo_uf: 21 },
    { id: 551, nome: 'LAGO VERDE', codigo_ibge: 2105906, codigo_uf: 21 },
    { id: 552, nome: 'LAGOA DO MATO', codigo_ibge: 2105922, codigo_uf: 21 },
    { id: 554, nome: 'LAGOA GRANDE DO MARANHAO', codigo_ibge: 2105963, codigo_uf: 21 },
    { id: 555, nome: 'LAJEADO NOVO', codigo_ibge: 2105989, codigo_uf: 21 },
    { id: 556, nome: 'LIMA CAMPOS', codigo_ibge: 2106003, codigo_uf: 21 },
    { id: 557, nome: 'LORETO', codigo_ibge: 2106102, codigo_uf: 21 },
    { id: 558, nome: 'LUIS DOMINGUES', codigo_ibge: 2106201, codigo_uf: 21 },
    { id: 559, nome: 'MAGALHAES DE ALMEIDA', codigo_ibge: 2106300, codigo_uf: 21 },
    { id: 560, nome: 'MARACACUME', codigo_ibge: 2106326, codigo_uf: 21 },
    { id: 561, nome: 'MARAJA DO SENA', codigo_ibge: 2106359, codigo_uf: 21 },
    { id: 562, nome: 'MARANHAOZINHO', codigo_ibge: 2106375, codigo_uf: 21 },
    { id: 563, nome: 'MATA ROMA', codigo_ibge: 2106409, codigo_uf: 21 },
    { id: 564, nome: 'MATINHA', codigo_ibge: 2106508, codigo_uf: 21 },
    { id: 565, nome: 'MATOES', codigo_ibge: 2106607, codigo_uf: 21 },
    { id: 566, nome: 'MATOES DO NORTE', codigo_ibge: 2106631, codigo_uf: 21 },
    { id: 567, nome: 'MILAGRES DO MARANHAO', codigo_ibge: 2106672, codigo_uf: 21 },
    { id: 568, nome: 'MIRADOR', codigo_ibge: 2106706, codigo_uf: 21 },
    { id: 569, nome: 'MIRANDA DO NORTE', codigo_ibge: 2106755, codigo_uf: 21 },
    { id: 570, nome: 'MIRINZAL', codigo_ibge: 2106805, codigo_uf: 21 },
    { id: 571, nome: 'MONCAO', codigo_ibge: 2106904, codigo_uf: 21 },
    { id: 572, nome: 'MONTES ALTOS', codigo_ibge: 2107001, codigo_uf: 21 },
    { id: 573, nome: 'MORROS', codigo_ibge: 2107100, codigo_uf: 21 },
    { id: 574, nome: 'NINA RODRIGUES', codigo_ibge: 2107209, codigo_uf: 21 },
    { id: 575, nome: 'NOVA COLINAS', codigo_ibge: 2107258, codigo_uf: 21 },
    { id: 576, nome: 'NOVA IORQUE', codigo_ibge: 2107308, codigo_uf: 21 },
    { id: 577, nome: 'NOVA OLINDA DO MARANHAO', codigo_ibge: 2107357, codigo_uf: 21 },
    { id: 578, nome: 'OLHO D AGUA DAS CUNHAS', codigo_ibge: 2107407, codigo_uf: 21 },
    { id: 579, nome: 'OLINDA NOVA DO MARANHAO', codigo_ibge: 2107456, codigo_uf: 21 },
    { id: 580, nome: 'PACO DO LUMIAR', codigo_ibge: 2107506, codigo_uf: 21 },
    { id: 581, nome: 'PALMEIRANDIA', codigo_ibge: 2107605, codigo_uf: 21 },
    { id: 582, nome: 'PARAIBANO', codigo_ibge: 2107704, codigo_uf: 21 },
    { id: 583, nome: 'PARNARAMA', codigo_ibge: 2107803, codigo_uf: 21 },
    { id: 584, nome: 'PASSAGEM FRANCA', codigo_ibge: 2107902, codigo_uf: 21 },
    { id: 585, nome: 'PASTOS BONS', codigo_ibge: 2108009, codigo_uf: 21 },
    { id: 586, nome: 'PAULINO NEVES', codigo_ibge: 2108058, codigo_uf: 21 },
    { id: 587, nome: 'PAULO RAMOS', codigo_ibge: 2108108, codigo_uf: 21 },
    { id: 588, nome: 'PEDREIRAS', codigo_ibge: 2108207, codigo_uf: 21 },
    { id: 589, nome: 'PEDRO DO ROSARIO', codigo_ibge: 2108256, codigo_uf: 21 },
    { id: 590, nome: 'PENALVA', codigo_ibge: 2108306, codigo_uf: 21 },
    { id: 591, nome: 'PERI MIRIM', codigo_ibge: 2108405, codigo_uf: 21 },
    { id: 592, nome: 'PERITORO', codigo_ibge: 2108454, codigo_uf: 21 },
    { id: 593, nome: 'PINDARE-MIRIM', codigo_ibge: 2108504, codigo_uf: 21 },
    { id: 594, nome: 'PINHEIRO', codigo_ibge: 2108603, codigo_uf: 21 },
    { id: 595, nome: 'PIO XII', codigo_ibge: 2108702, codigo_uf: 21 },
    { id: 596, nome: 'PIRAPEMAS', codigo_ibge: 2108801, codigo_uf: 21 },
    { id: 597, nome: 'POCAO DE PEDRAS', codigo_ibge: 2108900, codigo_uf: 21 },
    { id: 598, nome: 'PORTO FRANCO', codigo_ibge: 2109007, codigo_uf: 21 },
    { id: 599, nome: 'PORTO RICO DO MARANHAO', codigo_ibge: 2109056, codigo_uf: 21 },
    { id: 600, nome: 'PRESIDENTE DUTRA', codigo_ibge: 2109106, codigo_uf: 21 },
    { id: 601, nome: 'PRESIDENTE JUSCELINO', codigo_ibge: 2109205, codigo_uf: 21 },
    { id: 602, nome: 'PRESIDENTE MEDICI', codigo_ibge: 2109239, codigo_uf: 21 },
    { id: 603, nome: 'PRESIDENTE SARNEY', codigo_ibge: 2109270, codigo_uf: 21 },
    { id: 604, nome: 'PRESIDENTE VARGAS', codigo_ibge: 2109304, codigo_uf: 21 },
    { id: 605, nome: 'PRIMEIRA CRUZ', codigo_ibge: 2109403, codigo_uf: 21 },
    { id: 606, nome: 'RAPOSA', codigo_ibge: 2109452, codigo_uf: 21 },
    { id: 607, nome: 'RIACHAO', codigo_ibge: 2109502, codigo_uf: 21 },
    { id: 608, nome: 'RIBAMAR FIQUENE', codigo_ibge: 2109551, codigo_uf: 21 },
    { id: 609, nome: 'ROSARIO', codigo_ibge: 2109601, codigo_uf: 21 },
    { id: 610, nome: 'SAMBAIBA', codigo_ibge: 2109700, codigo_uf: 21 },
    { id: 611, nome: 'SANTA FILOMENA DO MARANHAO', codigo_ibge: 2109759, codigo_uf: 21 },
    { id: 612, nome: 'SANTA HELENA', codigo_ibge: 2109809, codigo_uf: 21 },
    { id: 613, nome: 'SANTA INES', codigo_ibge: 2109908, codigo_uf: 21 },
    { id: 614, nome: 'SANTA LUZIA', codigo_ibge: 2110005, codigo_uf: 21 },
    { id: 615, nome: 'SANTA LUZIA DO PARUA', codigo_ibge: 2110039, codigo_uf: 21 },
    { id: 616, nome: 'SANTA QUITERIA DO MARANHAO', codigo_ibge: 2110104, codigo_uf: 21 },
    { id: 617, nome: 'SANTA RITA', codigo_ibge: 2110203, codigo_uf: 21 },
    { id: 618, nome: 'SANTANA DO MARANHAO', codigo_ibge: 2110237, codigo_uf: 21 },
    { id: 619, nome: 'SANTO AMARO DO MARANHAO', codigo_ibge: 2110278, codigo_uf: 21 },
    { id: 620, nome: 'SANTO ANTONIO DOS LOPES', codigo_ibge: 2110302, codigo_uf: 21 },
    { id: 621, nome: 'SAO BENEDITO DO RIO PRETO', codigo_ibge: 2110401, codigo_uf: 21 },
    { id: 622, nome: 'SAO BENTO', codigo_ibge: 2110500, codigo_uf: 21 },
    { id: 623, nome: 'SAO BERNARDO', codigo_ibge: 2110609, codigo_uf: 21 },
    { id: 624, nome: 'SAO DOMINGOS DO AZEITAO', codigo_ibge: 2110658, codigo_uf: 21 },
    { id: 625, nome: 'SAO DOMINGOS DO MARANHAO', codigo_ibge: 2110708, codigo_uf: 21 },
    { id: 626, nome: 'SAO FELIX DE BALSAS', codigo_ibge: 2110807, codigo_uf: 21 },
    { id: 627, nome: 'SAO FRANCISCO DO BREJAO', codigo_ibge: 2110856, codigo_uf: 21 },
    { id: 628, nome: 'SAO FRANCISCO DO MARANHAO', codigo_ibge: 2110906, codigo_uf: 21 },
    { id: 629, nome: 'SAO JOAO BATISTA', codigo_ibge: 2111003, codigo_uf: 21 },
    { id: 630, nome: 'SAO JOAO DO CARU', codigo_ibge: 2111029, codigo_uf: 21 },
    { id: 631, nome: 'SAO JOAO DO PARAISO', codigo_ibge: 2111052, codigo_uf: 21 },
    { id: 632, nome: 'SAO JOAO DO SOTER', codigo_ibge: 2111078, codigo_uf: 21 },
    { id: 633, nome: 'SAO JOAO DOS PATOS', codigo_ibge: 2111102, codigo_uf: 21 },
    { id: 634, nome: 'SAO JOSE DE RIBAMAR', codigo_ibge: 2111201, codigo_uf: 21 },
    { id: 635, nome: 'SAO JOSE DOS BASILIOS', codigo_ibge: 2111250, codigo_uf: 21 },
    { id: 636, nome: 'SAO LUIS', codigo_ibge: 2111300, codigo_uf: 21 },
    { id: 637, nome: 'SAO LUIS GONZAGA DO MARANHAO', codigo_ibge: 2111409, codigo_uf: 21 },
    { id: 638, nome: 'SAO MATEUS DO MARANHAO', codigo_ibge: 2111508, codigo_uf: 21 },
    { id: 639, nome: 'SAO PEDRO DA AGUA BRANCA', codigo_ibge: 2111532, codigo_uf: 21 },
    { id: 640, nome: 'SAO PEDRO DOS CRENTES', codigo_ibge: 2111573, codigo_uf: 21 },
    { id: 641, nome: 'SAO RAIMUNDO DAS MANGABEIRAS', codigo_ibge: 2111607, codigo_uf: 21 },
    { id: 642, nome: 'SAO RAIMUNDO DO DOCA BEZERRA', codigo_ibge: 2111631, codigo_uf: 21 },
    { id: 643, nome: 'SAO ROBERTO', codigo_ibge: 2111672, codigo_uf: 21 },
    { id: 644, nome: 'SAO VICENTE FERRER', codigo_ibge: 2111706, codigo_uf: 21 },
    { id: 645, nome: 'SATUBINHA', codigo_ibge: 2111722, codigo_uf: 21 },
    { id: 646, nome: 'SENADOR ALEXANDRE COSTA', codigo_ibge: 2111748, codigo_uf: 21 },
    { id: 647, nome: 'SENADOR LA ROCQUE', codigo_ibge: 2111763, codigo_uf: 21 },
    { id: 648, nome: 'SERRANO DO MARANHAO', codigo_ibge: 2111789, codigo_uf: 21 },
    { id: 649, nome: 'SITIO NOVO', codigo_ibge: 2111805, codigo_uf: 21 },
    { id: 650, nome: 'SUCUPIRA DO NORTE', codigo_ibge: 2111904, codigo_uf: 21 },
    { id: 651, nome: 'SUCUPIRA DO RIACHAO', codigo_ibge: 2111953, codigo_uf: 21 },
    { id: 652, nome: 'TASSO FRAGOSO', codigo_ibge: 2112001, codigo_uf: 21 },
    { id: 653, nome: 'TIMBIRAS', codigo_ibge: 2112100, codigo_uf: 21 },
    { id: 654, nome: 'TIMON', codigo_ibge: 2112209, codigo_uf: 21 },
    { id: 655, nome: 'TRIZIDELA DO VALE', codigo_ibge: 2112233, codigo_uf: 21 },
    { id: 656, nome: 'TUFILANDIA', codigo_ibge: 2112274, codigo_uf: 21 },
    { id: 657, nome: 'TUNTUM', codigo_ibge: 2112308, codigo_uf: 21 },
    { id: 658, nome: 'TURIACU', codigo_ibge: 2112407, codigo_uf: 21 },
    { id: 659, nome: 'TURILANDIA', codigo_ibge: 2112456, codigo_uf: 21 },
    { id: 660, nome: 'TUTOIA', codigo_ibge: 2112506, codigo_uf: 21 },
    { id: 661, nome: 'URBANO SANTOS', codigo_ibge: 2112605, codigo_uf: 21 },
    { id: 662, nome: 'VARGEM GRANDE', codigo_ibge: 2112704, codigo_uf: 21 },
    { id: 663, nome: 'VIANA', codigo_ibge: 2112803, codigo_uf: 21 },
    { id: 664, nome: 'VILA NOVA DOS MARTIRIOS', codigo_ibge: 2112852, codigo_uf: 21 },
    { id: 665, nome: 'VITORIA DO MEARIM', codigo_ibge: 2112902, codigo_uf: 21 },
    { id: 666, nome: 'VITORINO FREIRE', codigo_ibge: 2113009, codigo_uf: 21 },
    { id: 667, nome: 'ZE DOCA', codigo_ibge: 2114007, codigo_uf: 21 },
    { id: 668, nome: 'ACAUA', codigo_ibge: 2200053, codigo_uf: 22 },
    { id: 669, nome: 'AGRICOLANDIA', codigo_ibge: 2200103, codigo_uf: 22 },
    { id: 670, nome: 'AGUA BRANCA', codigo_ibge: 2200202, codigo_uf: 22 },
    { id: 671, nome: 'ALAGOINHA DO PIAUI', codigo_ibge: 2200251, codigo_uf: 22 },
    { id: 672, nome: 'ALEGRETE DO PIAUI', codigo_ibge: 2200277, codigo_uf: 22 },
    { id: 673, nome: 'ALTO LONGA', codigo_ibge: 2200301, codigo_uf: 22 },
    { id: 674, nome: 'ALTOS', codigo_ibge: 2200400, codigo_uf: 22 },
    { id: 675, nome: 'ALVORADA DO GURGUEIA', codigo_ibge: 2200459, codigo_uf: 22 },
    { id: 676, nome: 'AMARANTE', codigo_ibge: 2200509, codigo_uf: 22 },
    { id: 677, nome: 'ANGICAL DO PIAUI', codigo_ibge: 2200608, codigo_uf: 22 },
    { id: 678, nome: 'ANISIO DE ABREU', codigo_ibge: 2200707, codigo_uf: 22 },
    { id: 679, nome: 'ANTONIO ALMEIDA', codigo_ibge: 2200806, codigo_uf: 22 },
    { id: 680, nome: 'AROAZES', codigo_ibge: 2200905, codigo_uf: 22 },
    { id: 681, nome: 'AROEIRAS DO ITAIM', codigo_ibge: 2200954, codigo_uf: 22 },
    { id: 682, nome: 'ARRAIAL', codigo_ibge: 2201002, codigo_uf: 22 },
    { id: 683, nome: 'ASSUNCAO DO PIAUI', codigo_ibge: 2201051, codigo_uf: 22 },
    { id: 684, nome: 'AVELINO LOPES', codigo_ibge: 2201101, codigo_uf: 22 },
    { id: 685, nome: 'BAIXA GRANDE DO RIBEIRO', codigo_ibge: 2201150, codigo_uf: 22 },
    { id: 686, nome: 'BARRA D ALCANTARA', codigo_ibge: 2201176, codigo_uf: 22 },
    { id: 687, nome: 'BARRAS', codigo_ibge: 2201200, codigo_uf: 22 },
    { id: 688, nome: 'BARREIRAS DO PIAUI', codigo_ibge: 2201309, codigo_uf: 22 },
    { id: 689, nome: 'BARRO DURO', codigo_ibge: 2201408, codigo_uf: 22 },
    { id: 690, nome: 'BATALHA', codigo_ibge: 2201507, codigo_uf: 22 },
    { id: 691, nome: 'BELA VISTA DO PIAUI', codigo_ibge: 2201556, codigo_uf: 22 },
    { id: 692, nome: 'BELEM DO PIAUI', codigo_ibge: 2201572, codigo_uf: 22 },
    { id: 693, nome: 'BENEDITINOS', codigo_ibge: 2201606, codigo_uf: 22 },
    { id: 694, nome: 'BERTOLINIA', codigo_ibge: 2201705, codigo_uf: 22 },
    { id: 695, nome: 'BETANIA DO PIAUI', codigo_ibge: 2201739, codigo_uf: 22 },
    { id: 696, nome: 'BOA HORA', codigo_ibge: 2201770, codigo_uf: 22 },
    { id: 697, nome: 'BOCAINA', codigo_ibge: 2201804, codigo_uf: 22 },
    { id: 698, nome: 'BOM JESUS', codigo_ibge: 2201903, codigo_uf: 22 },
    { id: 699, nome: 'BOM PRINCIPIO DO PIAUI', codigo_ibge: 2201919, codigo_uf: 22 },
    { id: 700, nome: 'BONFIM DO PIAUI', codigo_ibge: 2201929, codigo_uf: 22 },
    { id: 701, nome: 'BOQUEIRAO DO PIAUI', codigo_ibge: 2201945, codigo_uf: 22 },
    { id: 702, nome: 'BRASILEIRA', codigo_ibge: 2201960, codigo_uf: 22 },
    { id: 703, nome: 'BREJO DO PIAUI', codigo_ibge: 2201988, codigo_uf: 22 },
    { id: 704, nome: 'BURITI DOS LOPES', codigo_ibge: 2202000, codigo_uf: 22 },
    { id: 705, nome: 'BURITI DOS MONTES', codigo_ibge: 2202026, codigo_uf: 22 },
    { id: 706, nome: 'CABECEIRAS DO PIAUI', codigo_ibge: 2202059, codigo_uf: 22 },
    { id: 707, nome: 'CAJAZEIRAS DO PIAUI', codigo_ibge: 2202075, codigo_uf: 22 },
    { id: 708, nome: 'CAJUEIRO DA PRAIA', codigo_ibge: 2202083, codigo_uf: 22 },
    { id: 709, nome: 'CALDEIRAO GRANDE DO PIAUI', codigo_ibge: 2202091, codigo_uf: 22 },
    { id: 710, nome: 'CAMPINAS DO PIAUI', codigo_ibge: 2202109, codigo_uf: 22 },
    { id: 711, nome: 'CAMPO ALEGRE DO FIDALGO', codigo_ibge: 2202117, codigo_uf: 22 },
    { id: 712, nome: 'CAMPO GRANDE DO PIAUI', codigo_ibge: 2202133, codigo_uf: 22 },
    { id: 713, nome: 'CAMPO LARGO DO PIAUI', codigo_ibge: 2202174, codigo_uf: 22 },
    { id: 714, nome: 'CAMPO MAIOR', codigo_ibge: 2202208, codigo_uf: 22 },
    { id: 715, nome: 'CANAVIEIRA', codigo_ibge: 2202251, codigo_uf: 22 },
    { id: 716, nome: 'CANTO DO BURITI', codigo_ibge: 2202307, codigo_uf: 22 },
    { id: 717, nome: 'CAPITAO DE CAMPOS', codigo_ibge: 2202406, codigo_uf: 22 },
    { id: 718, nome: 'CAPITAO GERVASIO OLIVEIRA', codigo_ibge: 2202455, codigo_uf: 22 },
    { id: 719, nome: 'CARACOL', codigo_ibge: 2202505, codigo_uf: 22 },
    { id: 720, nome: 'CARAUBAS DO PIAUI', codigo_ibge: 2202539, codigo_uf: 22 },
    { id: 721, nome: 'CARIDADE DO PIAUI', codigo_ibge: 2202554, codigo_uf: 22 },
    { id: 722, nome: 'CASTELO DO PIAUI', codigo_ibge: 2202604, codigo_uf: 22 },
    { id: 723, nome: 'CAXINGO', codigo_ibge: 2202653, codigo_uf: 22 },
    { id: 724, nome: 'COCAL', codigo_ibge: 2202703, codigo_uf: 22 },
    { id: 725, nome: 'COCAL DE TELHA', codigo_ibge: 2202711, codigo_uf: 22 },
    { id: 726, nome: 'COCAL DOS ALVES', codigo_ibge: 2202729, codigo_uf: 22 },
    { id: 727, nome: 'COIVARAS', codigo_ibge: 2202737, codigo_uf: 22 },
    { id: 728, nome: 'COLONIA DO GURGUEIA', codigo_ibge: 2202752, codigo_uf: 22 },
    { id: 729, nome: 'COLONIA DO PIAUI', codigo_ibge: 2202778, codigo_uf: 22 },
    { id: 730, nome: 'CONCEICAO DO CANINDE', codigo_ibge: 2202802, codigo_uf: 22 },
    { id: 731, nome: 'CORONEL JOSE DIAS', codigo_ibge: 2202851, codigo_uf: 22 },
    { id: 732, nome: 'CORRENTE', codigo_ibge: 2202901, codigo_uf: 22 },
    { id: 733, nome: 'CRISTALANDIA DO PIAUI', codigo_ibge: 2203008, codigo_uf: 22 },
    { id: 734, nome: 'CRISTINO CASTRO', codigo_ibge: 2203107, codigo_uf: 22 },
    { id: 735, nome: 'CURIMATA', codigo_ibge: 2203206, codigo_uf: 22 },
    { id: 736, nome: 'CURRAIS', codigo_ibge: 2203230, codigo_uf: 22 },
    { id: 738, nome: 'CURRAL NOVO DO PIAUI', codigo_ibge: 2203271, codigo_uf: 22 },
    { id: 737, nome: 'CURRALINHOS', codigo_ibge: 2203255, codigo_uf: 22 },
    { id: 739, nome: 'DEMERVAL LOBAO', codigo_ibge: 2203305, codigo_uf: 22 },
    { id: 740, nome: 'DIRCEU ARCOVERDE', codigo_ibge: 2203354, codigo_uf: 22 },
    { id: 741, nome: 'DOM EXPEDITO LOPES', codigo_ibge: 2203404, codigo_uf: 22 },
    { id: 743, nome: 'DOM INOCENCIO', codigo_ibge: 2203453, codigo_uf: 22 },
    { id: 742, nome: 'DOMINGOS MOURAO', codigo_ibge: 2203420, codigo_uf: 22 },
    { id: 744, nome: 'ELESBAO VELOSO', codigo_ibge: 2203503, codigo_uf: 22 },
    { id: 745, nome: 'ELISEU MARTINS', codigo_ibge: 2203602, codigo_uf: 22 },
    { id: 746, nome: 'ESPERANTINA', codigo_ibge: 2203701, codigo_uf: 22 },
    { id: 747, nome: 'FARTURA DO PIAUI', codigo_ibge: 2203750, codigo_uf: 22 },
    { id: 748, nome: 'FLORES DO PIAUI', codigo_ibge: 2203800, codigo_uf: 22 },
    { id: 749, nome: 'FLORESTA DO PIAUI', codigo_ibge: 2203859, codigo_uf: 22 },
    { id: 750, nome: 'FLORIANO', codigo_ibge: 2203909, codigo_uf: 22 },
    { id: 751, nome: 'FRANCINOPOLIS', codigo_ibge: 2204006, codigo_uf: 22 },
    { id: 752, nome: 'FRANCISCO AYRES', codigo_ibge: 2204105, codigo_uf: 22 },
    { id: 753, nome: 'FRANCISCO MACEDO', codigo_ibge: 2204154, codigo_uf: 22 },
    { id: 754, nome: 'FRANCISCO SANTOS', codigo_ibge: 2204204, codigo_uf: 22 },
    { id: 755, nome: 'FRONTEIRAS', codigo_ibge: 2204303, codigo_uf: 22 },
    { id: 756, nome: 'GEMINIANO', codigo_ibge: 2204352, codigo_uf: 22 },
    { id: 757, nome: 'GILBUES', codigo_ibge: 2204402, codigo_uf: 22 },
    { id: 758, nome: 'GUADALUPE', codigo_ibge: 2204501, codigo_uf: 22 },
    { id: 759, nome: 'GUARIBAS', codigo_ibge: 2204550, codigo_uf: 22 },
    { id: 760, nome: 'HUGO NAPOLEAO', codigo_ibge: 2204600, codigo_uf: 22 },
    { id: 761, nome: 'ILHA GRANDE', codigo_ibge: 2204659, codigo_uf: 22 },
    { id: 762, nome: 'INHUMA', codigo_ibge: 2204709, codigo_uf: 22 },
    { id: 763, nome: 'IPIRANGA DO PIAUI', codigo_ibge: 2204808, codigo_uf: 22 },
    { id: 764, nome: 'ISAIAS COELHO', codigo_ibge: 2204907, codigo_uf: 22 },
    { id: 765, nome: 'ITAINOPOLIS', codigo_ibge: 2205003, codigo_uf: 22 },
    { id: 766, nome: 'ITAUEIRA', codigo_ibge: 2205102, codigo_uf: 22 },
    { id: 767, nome: 'JACOBINA DO PIAUI', codigo_ibge: 2205151, codigo_uf: 22 },
    { id: 768, nome: 'JAICOS', codigo_ibge: 2205201, codigo_uf: 22 },
    { id: 769, nome: 'JARDIM DO MULATO', codigo_ibge: 2205250, codigo_uf: 22 },
    { id: 770, nome: 'JATOBA DO PIAUI', codigo_ibge: 2205276, codigo_uf: 22 },
    { id: 771, nome: 'JERUMENHA', codigo_ibge: 2205300, codigo_uf: 22 },
    { id: 772, nome: 'JOAO COSTA', codigo_ibge: 2205359, codigo_uf: 22 },
    { id: 773, nome: 'JOAQUIM PIRES', codigo_ibge: 2205409, codigo_uf: 22 },
    { id: 774, nome: 'JOCA MARQUES', codigo_ibge: 2205458, codigo_uf: 22 },
    { id: 775, nome: 'JOSE DE FREITAS', codigo_ibge: 2205508, codigo_uf: 22 },
    { id: 776, nome: 'JUAZEIRO DO PIAUI', codigo_ibge: 2205516, codigo_uf: 22 },
    { id: 777, nome: 'JULIO BORGES', codigo_ibge: 2205524, codigo_uf: 22 },
    { id: 778, nome: 'JUREMA', codigo_ibge: 2205532, codigo_uf: 22 },
    { id: 780, nome: 'LAGOA ALEGRE', codigo_ibge: 2205557, codigo_uf: 22 },
    { id: 782, nome: 'LAGOA DE SAO FRANCISCO', codigo_ibge: 2205573, codigo_uf: 22 },
    { id: 781, nome: 'LAGOA DO BARRO DO PIAUI', codigo_ibge: 2205565, codigo_uf: 22 },
    { id: 783, nome: 'LAGOA DO PIAUI', codigo_ibge: 2205581, codigo_uf: 22 },
    { id: 784, nome: 'LAGOA DO SITIO', codigo_ibge: 2205599, codigo_uf: 22 },
    { id: 779, nome: 'LAGOINHA DO PIAUI', codigo_ibge: 2205540, codigo_uf: 22 },
    { id: 785, nome: 'LANDRI SALES', codigo_ibge: 2205607, codigo_uf: 22 },
    { id: 786, nome: 'LUIS CORREIA', codigo_ibge: 2205706, codigo_uf: 22 },
    { id: 787, nome: 'LUZILANDIA', codigo_ibge: 2205805, codigo_uf: 22 },
    { id: 788, nome: 'MADEIRO', codigo_ibge: 2205854, codigo_uf: 22 },
    { id: 789, nome: 'MANOEL EMIDIO', codigo_ibge: 2205904, codigo_uf: 22 },
    { id: 790, nome: 'MARCOLANDIA', codigo_ibge: 2205953, codigo_uf: 22 },
    { id: 791, nome: 'MARCOS PARENTE', codigo_ibge: 2206001, codigo_uf: 22 },
    { id: 792, nome: 'MASSAPE DO PIAUI', codigo_ibge: 2206050, codigo_uf: 22 },
    { id: 793, nome: 'MATIAS OLIMPIO', codigo_ibge: 2206100, codigo_uf: 22 },
    { id: 794, nome: 'MIGUEL ALVES', codigo_ibge: 2206209, codigo_uf: 22 },
    { id: 795, nome: 'MIGUEL LEAO', codigo_ibge: 2206308, codigo_uf: 22 },
    { id: 796, nome: 'MILTON BRANDAO', codigo_ibge: 2206357, codigo_uf: 22 },
    { id: 797, nome: 'MONSENHOR GIL', codigo_ibge: 2206407, codigo_uf: 22 },
    { id: 798, nome: 'MONSENHOR HIPOLITO', codigo_ibge: 2206506, codigo_uf: 22 },
    { id: 799, nome: 'MONTE ALEGRE DO PIAUI', codigo_ibge: 2206605, codigo_uf: 22 },
    { id: 800, nome: 'MORRO CABECA NO TEMPO', codigo_ibge: 2206654, codigo_uf: 22 },
    { id: 801, nome: 'MORRO DO CHAPEU DO PIAUI', codigo_ibge: 2206670, codigo_uf: 22 },
    { id: 802, nome: 'MURICI DOS PORTELAS', codigo_ibge: 2206696, codigo_uf: 22 },
    { id: 803, nome: 'NAZARE DO PIAUI', codigo_ibge: 2206704, codigo_uf: 22 },
    { id: 804, nome: 'NAZARIA', codigo_ibge: 2206720, codigo_uf: 22 },
    { id: 805, nome: 'NOSSA SENHORA DE NAZARE', codigo_ibge: 2206753, codigo_uf: 22 },
    { id: 806, nome: 'NOSSA SENHORA DOS REMEDIOS', codigo_ibge: 2206803, codigo_uf: 22 },
    { id: 826, nome: 'NOVA SANTA RITA', codigo_ibge: 2207959, codigo_uf: 22 },
    { id: 807, nome: 'NOVO ORIENTE DO PIAUI', codigo_ibge: 2206902, codigo_uf: 22 },
    { id: 808, nome: 'NOVO SANTO ANTONIO', codigo_ibge: 2206951, codigo_uf: 22 },
    { id: 809, nome: 'OEIRAS', codigo_ibge: 2207009, codigo_uf: 22 },
    { id: 810, nome: 'OLHO D AGUA DO PIAUI', codigo_ibge: 2207108, codigo_uf: 22 },
    { id: 811, nome: 'PADRE MARCOS', codigo_ibge: 2207207, codigo_uf: 22 },
    { id: 812, nome: 'PAES LANDIM', codigo_ibge: 2207306, codigo_uf: 22 },
    { id: 813, nome: 'PAJEU DO PIAUI', codigo_ibge: 2207355, codigo_uf: 22 },
    { id: 814, nome: 'PALMEIRA DO PIAUI', codigo_ibge: 2207405, codigo_uf: 22 },
    { id: 815, nome: 'PALMEIRAIS', codigo_ibge: 2207504, codigo_uf: 22 },
    { id: 816, nome: 'PAQUETA', codigo_ibge: 2207553, codigo_uf: 22 },
    { id: 817, nome: 'PARNAGUA', codigo_ibge: 2207603, codigo_uf: 22 },
    { id: 818, nome: 'PARNAIBA', codigo_ibge: 2207702, codigo_uf: 22 },
    { id: 819, nome: 'PASSAGEM FRANCA DO PIAUI', codigo_ibge: 2207751, codigo_uf: 22 },
    { id: 820, nome: 'PATOS DO PIAUI', codigo_ibge: 2207777, codigo_uf: 22 },
    { id: 821, nome: 'PAU D ARCO DO PIAUI', codigo_ibge: 2207793, codigo_uf: 22 },
    { id: 822, nome: 'PAULISTANA', codigo_ibge: 2207801, codigo_uf: 22 },
    { id: 823, nome: 'PAVUSSU', codigo_ibge: 2207850, codigo_uf: 22 },
    { id: 824, nome: 'PEDRO II', codigo_ibge: 2207900, codigo_uf: 22 },
    { id: 825, nome: 'PEDRO LAURENTINO', codigo_ibge: 2207934, codigo_uf: 22 },
    { id: 827, nome: 'PICOS', codigo_ibge: 2208007, codigo_uf: 22 },
    { id: 828, nome: 'PIMENTEIRAS', codigo_ibge: 2208106, codigo_uf: 22 },
    { id: 829, nome: 'PIO IX', codigo_ibge: 2208205, codigo_uf: 22 },
    { id: 830, nome: 'PIRACURUCA', codigo_ibge: 2208304, codigo_uf: 22 },
    { id: 831, nome: 'PIRIPIRI', codigo_ibge: 2208403, codigo_uf: 22 },
    { id: 832, nome: 'PORTO', codigo_ibge: 2208502, codigo_uf: 22 },
    { id: 833, nome: 'PORTO ALEGRE DO PIAUI', codigo_ibge: 2208551, codigo_uf: 22 },
    { id: 834, nome: 'PRATA DO PIAUI', codigo_ibge: 2208601, codigo_uf: 22 },
    { id: 835, nome: 'QUEIMADA NOVA', codigo_ibge: 2208650, codigo_uf: 22 },
    { id: 836, nome: 'REDENCAO DO GURGUEIA', codigo_ibge: 2208700, codigo_uf: 22 },
    { id: 837, nome: 'REGENERACAO', codigo_ibge: 2208809, codigo_uf: 22 },
    { id: 838, nome: 'RIACHO FRIO', codigo_ibge: 2208858, codigo_uf: 22 },
    { id: 839, nome: 'RIBEIRA DO PIAUI', codigo_ibge: 2208874, codigo_uf: 22 },
    { id: 840, nome: 'RIBEIRO GONCALVES', codigo_ibge: 2208908, codigo_uf: 22 },
    { id: 841, nome: 'RIO GRANDE DO PIAUI', codigo_ibge: 2209005, codigo_uf: 22 },
    { id: 842, nome: 'SANTA CRUZ DO PIAUI', codigo_ibge: 2209104, codigo_uf: 22 },
    { id: 843, nome: 'SANTA CRUZ DOS MILAGRES', codigo_ibge: 2209153, codigo_uf: 22 },
    { id: 844, nome: 'SANTA FILOMENA', codigo_ibge: 2209203, codigo_uf: 22 },
    { id: 845, nome: 'SANTA LUZ', codigo_ibge: 2209302, codigo_uf: 22 },
    { id: 847, nome: 'SANTA ROSA DO PIAUI', codigo_ibge: 2209377, codigo_uf: 22 },
    { id: 846, nome: 'SANTANA DO PIAUI', codigo_ibge: 2209351, codigo_uf: 22 },
    { id: 848, nome: 'SANTO ANTONIO DE LISBOA', codigo_ibge: 2209401, codigo_uf: 22 },
    { id: 849, nome: 'SANTO ANTONIO DOS MILAGRES', codigo_ibge: 2209450, codigo_uf: 22 },
    { id: 850, nome: 'SANTO INACIO DO PIAUI', codigo_ibge: 2209500, codigo_uf: 22 },
    { id: 851, nome: 'SAO BRAZ DO PIAUI', codigo_ibge: 2209559, codigo_uf: 22 },
    { id: 852, nome: 'SAO FELIX DO PIAUI', codigo_ibge: 2209609, codigo_uf: 22 },
    { id: 853, nome: 'SAO FRANCISCO DE ASSIS DO PIAUI', codigo_ibge: 2209658, codigo_uf: 22 },
    { id: 854, nome: 'SAO FRANCISCO DO PIAUI', codigo_ibge: 2209708, codigo_uf: 22 },
    { id: 855, nome: 'SAO GONCALO DO GURGUEIA', codigo_ibge: 2209757, codigo_uf: 22 },
    { id: 856, nome: 'SAO GONCALO DO PIAUI', codigo_ibge: 2209807, codigo_uf: 22 },
    { id: 857, nome: 'SAO JOAO DA CANABRAVA', codigo_ibge: 2209856, codigo_uf: 22 },
    { id: 858, nome: 'SAO JOAO DA FRONTEIRA', codigo_ibge: 2209872, codigo_uf: 22 },
    { id: 859, nome: 'SAO JOAO DA SERRA', codigo_ibge: 2209906, codigo_uf: 22 },
    { id: 860, nome: 'SAO JOAO DA VARJOTA', codigo_ibge: 2209955, codigo_uf: 22 },
    { id: 861, nome: 'SAO JOAO DO ARRAIAL', codigo_ibge: 2209971, codigo_uf: 22 },
    { id: 862, nome: 'SAO JOAO DO PIAUI', codigo_ibge: 2210003, codigo_uf: 22 },
    { id: 863, nome: 'SAO JOSE DO DIVINO', codigo_ibge: 2210052, codigo_uf: 22 },
    { id: 864, nome: 'SAO JOSE DO PEIXE', codigo_ibge: 2210102, codigo_uf: 22 },
    { id: 865, nome: 'SAO JOSE DO PIAUI', codigo_ibge: 2210201, codigo_uf: 22 },
    { id: 866, nome: 'SAO JULIAO', codigo_ibge: 2210300, codigo_uf: 22 },
    { id: 867, nome: 'SAO LOURENCO DO PIAUI', codigo_ibge: 2210359, codigo_uf: 22 },
    { id: 868, nome: 'SAO LUIS DO PIAUI', codigo_ibge: 2210375, codigo_uf: 22 },
    { id: 869, nome: 'SAO MIGUEL DA BAIXA GRANDE', codigo_ibge: 2210383, codigo_uf: 22 },
    { id: 870, nome: 'SAO MIGUEL DO FIDALGO', codigo_ibge: 2210391, codigo_uf: 22 },
    { id: 871, nome: 'SAO MIGUEL DO TAPUIO', codigo_ibge: 2210409, codigo_uf: 22 },
    { id: 872, nome: 'SAO PEDRO DO PIAUI', codigo_ibge: 2210508, codigo_uf: 22 },
    { id: 873, nome: 'SAO RAIMUNDO NONATO', codigo_ibge: 2210607, codigo_uf: 22 },
    { id: 874, nome: 'SEBASTIAO BARROS', codigo_ibge: 2210623, codigo_uf: 22 },
    { id: 875, nome: 'SEBASTIAO LEAL', codigo_ibge: 2210631, codigo_uf: 22 },
    { id: 876, nome: 'SIGEFREDO PACHECO', codigo_ibge: 2210656, codigo_uf: 22 },
    { id: 877, nome: 'SIMOES', codigo_ibge: 2210706, codigo_uf: 22 },
    { id: 878, nome: 'SIMPLICIO MENDES', codigo_ibge: 2210805, codigo_uf: 22 },
    { id: 879, nome: 'SOCORRO DO PIAUI', codigo_ibge: 2210904, codigo_uf: 22 },
    { id: 880, nome: 'SUSSUAPARA', codigo_ibge: 2210938, codigo_uf: 22 },
    { id: 881, nome: 'TAMBORIL DO PIAUI', codigo_ibge: 2210953, codigo_uf: 22 },
    { id: 882, nome: 'TANQUE DO PIAUI', codigo_ibge: 2210979, codigo_uf: 22 },
    { id: 883, nome: 'TERESINA', codigo_ibge: 2211001, codigo_uf: 22 },
    { id: 884, nome: 'UNIAO', codigo_ibge: 2211100, codigo_uf: 22 },
    { id: 885, nome: 'URUCUI', codigo_ibge: 2211209, codigo_uf: 22 },
    { id: 886, nome: 'VALENCA DO PIAUI', codigo_ibge: 2211308, codigo_uf: 22 },
    { id: 887, nome: 'VARZEA BRANCA', codigo_ibge: 2211357, codigo_uf: 22 },
    { id: 888, nome: 'VARZEA GRANDE', codigo_ibge: 2211407, codigo_uf: 22 },
    { id: 889, nome: 'VERA MENDES', codigo_ibge: 2211506, codigo_uf: 22 },
    { id: 890, nome: 'VILA NOVA DO PIAUI', codigo_ibge: 2211605, codigo_uf: 22 },
    { id: 891, nome: 'WALL FERRAZ', codigo_ibge: 2211704, codigo_uf: 22 },
    { id: 892, nome: 'ABAIARA', codigo_ibge: 2300101, codigo_uf: 23 },
    { id: 893, nome: 'ACARAPE', codigo_ibge: 2300150, codigo_uf: 23 },
    { id: 894, nome: 'ACARAU', codigo_ibge: 2300200, codigo_uf: 23 },
    { id: 895, nome: 'ACOPIARA', codigo_ibge: 2300309, codigo_uf: 23 },
    { id: 896, nome: 'AIUABA', codigo_ibge: 2300408, codigo_uf: 23 },
    { id: 897, nome: 'ALCANTARAS', codigo_ibge: 2300507, codigo_uf: 23 },
    { id: 898, nome: 'ALTANEIRA', codigo_ibge: 2300606, codigo_uf: 23 },
    { id: 899, nome: 'ALTO SANTO', codigo_ibge: 2300705, codigo_uf: 23 },
    { id: 900, nome: 'AMONTADA', codigo_ibge: 2300754, codigo_uf: 23 },
    { id: 901, nome: 'ANTONINA DO NORTE', codigo_ibge: 2300804, codigo_uf: 23 },
    { id: 902, nome: 'APUIARES', codigo_ibge: 2300903, codigo_uf: 23 },
    { id: 903, nome: 'AQUIRAZ', codigo_ibge: 2301000, codigo_uf: 23 },
    { id: 904, nome: 'ARACATI', codigo_ibge: 2301109, codigo_uf: 23 },
    { id: 905, nome: 'ARACOIABA', codigo_ibge: 2301208, codigo_uf: 23 },
    { id: 906, nome: 'ARARENDA', codigo_ibge: 2301257, codigo_uf: 23 },
    { id: 907, nome: 'ARARIPE', codigo_ibge: 2301307, codigo_uf: 23 },
    { id: 908, nome: 'ARATUBA', codigo_ibge: 2301406, codigo_uf: 23 },
    { id: 909, nome: 'ARNEIROZ', codigo_ibge: 2301505, codigo_uf: 23 },
    { id: 910, nome: 'ASSARE', codigo_ibge: 2301604, codigo_uf: 23 },
    { id: 911, nome: 'AURORA', codigo_ibge: 2301703, codigo_uf: 23 },
    { id: 912, nome: 'BAIXIO', codigo_ibge: 2301802, codigo_uf: 23 },
    { id: 913, nome: 'BANABUIU', codigo_ibge: 2301851, codigo_uf: 23 },
    { id: 914, nome: 'BARBALHA', codigo_ibge: 2301901, codigo_uf: 23 },
    { id: 915, nome: 'BARREIRA', codigo_ibge: 2301950, codigo_uf: 23 },
    { id: 916, nome: 'BARRO', codigo_ibge: 2302008, codigo_uf: 23 },
    { id: 917, nome: 'BARROQUINHA', codigo_ibge: 2302057, codigo_uf: 23 },
    { id: 918, nome: 'BATURITE', codigo_ibge: 2302107, codigo_uf: 23 },
    { id: 919, nome: 'BEBERIBE', codigo_ibge: 2302206, codigo_uf: 23 },
    { id: 920, nome: 'BELA CRUZ', codigo_ibge: 2302305, codigo_uf: 23 },
    { id: 921, nome: 'BOA VIAGEM', codigo_ibge: 2302404, codigo_uf: 23 },
    { id: 922, nome: 'BREJO SANTO', codigo_ibge: 2302503, codigo_uf: 23 },
    { id: 923, nome: 'CAMOCIM', codigo_ibge: 2302602, codigo_uf: 23 },
    { id: 924, nome: 'CAMPOS SALES', codigo_ibge: 2302701, codigo_uf: 23 },
    { id: 925, nome: 'CANINDE', codigo_ibge: 2302800, codigo_uf: 23 },
    { id: 926, nome: 'CAPISTRANO', codigo_ibge: 2302909, codigo_uf: 23 },
    { id: 927, nome: 'CARIDADE', codigo_ibge: 2303006, codigo_uf: 23 },
    { id: 928, nome: 'CARIRE', codigo_ibge: 2303105, codigo_uf: 23 },
    { id: 929, nome: 'CARIRIACU', codigo_ibge: 2303204, codigo_uf: 23 },
    { id: 930, nome: 'CARIUS', codigo_ibge: 2303303, codigo_uf: 23 },
    { id: 931, nome: 'CARNAUBAL', codigo_ibge: 2303402, codigo_uf: 23 },
    { id: 932, nome: 'CASCAVEL', codigo_ibge: 2303501, codigo_uf: 23 },
    { id: 933, nome: 'CATARINA', codigo_ibge: 2303600, codigo_uf: 23 },
    { id: 934, nome: 'CATUNDA', codigo_ibge: 2303659, codigo_uf: 23 },
    { id: 935, nome: 'CAUCAIA', codigo_ibge: 2303709, codigo_uf: 23 },
    { id: 936, nome: 'CEDRO', codigo_ibge: 2303808, codigo_uf: 23 },
    { id: 937, nome: 'CHAVAL', codigo_ibge: 2303907, codigo_uf: 23 },
    { id: 938, nome: 'CHORO', codigo_ibge: 2303931, codigo_uf: 23 },
    { id: 939, nome: 'CHOROZINHO', codigo_ibge: 2303956, codigo_uf: 23 },
    { id: 940, nome: 'COREAU', codigo_ibge: 2304004, codigo_uf: 23 },
    { id: 941, nome: 'CRATEUS', codigo_ibge: 2304103, codigo_uf: 23 },
    { id: 942, nome: 'CRATO', codigo_ibge: 2304202, codigo_uf: 23 },
    { id: 943, nome: 'CROATA', codigo_ibge: 2304236, codigo_uf: 23 },
    { id: 944, nome: 'CRUZ', codigo_ibge: 2304251, codigo_uf: 23 },
    { id: 945, nome: 'DEPUTADO IRAPUAN PINHEIRO', codigo_ibge: 2304269, codigo_uf: 23 },
    { id: 946, nome: 'ERERE', codigo_ibge: 2304277, codigo_uf: 23 },
    { id: 947, nome: 'EUSEBIO', codigo_ibge: 2304285, codigo_uf: 23 },
    { id: 948, nome: 'FARIAS BRITO', codigo_ibge: 2304301, codigo_uf: 23 },
    { id: 949, nome: 'FORQUILHA', codigo_ibge: 2304350, codigo_uf: 23 },
    { id: 950, nome: 'FORTALEZA', codigo_ibge: 2304400, codigo_uf: 23 },
    { id: 951, nome: 'FORTIM', codigo_ibge: 2304459, codigo_uf: 23 },
    { id: 952, nome: 'FRECHEIRINHA', codigo_ibge: 2304509, codigo_uf: 23 },
    { id: 953, nome: 'GENERAL SAMPAIO', codigo_ibge: 2304608, codigo_uf: 23 },
    { id: 954, nome: 'GRACA', codigo_ibge: 2304657, codigo_uf: 23 },
    { id: 955, nome: 'GRANJA', codigo_ibge: 2304707, codigo_uf: 23 },
    { id: 956, nome: 'GRANJEIRO', codigo_ibge: 2304806, codigo_uf: 23 },
    { id: 957, nome: 'GROAIRAS', codigo_ibge: 2304905, codigo_uf: 23 },
    { id: 958, nome: 'GUAIUBA', codigo_ibge: 2304954, codigo_uf: 23 },
    { id: 959, nome: 'GUARACIABA DO NORTE', codigo_ibge: 2305001, codigo_uf: 23 },
    { id: 960, nome: 'GUARAMIRANGA', codigo_ibge: 2305100, codigo_uf: 23 },
    { id: 961, nome: 'HIDROLANDIA', codigo_ibge: 2305209, codigo_uf: 23 },
    { id: 962, nome: 'HORIZONTE', codigo_ibge: 2305233, codigo_uf: 23 },
    { id: 963, nome: 'IBARETAMA', codigo_ibge: 2305266, codigo_uf: 23 },
    { id: 964, nome: 'IBIAPINA', codigo_ibge: 2305308, codigo_uf: 23 },
    { id: 965, nome: 'IBICUITINGA', codigo_ibge: 2305332, codigo_uf: 23 },
    { id: 966, nome: 'ICAPUI', codigo_ibge: 2305357, codigo_uf: 23 },
    { id: 967, nome: 'ICO', codigo_ibge: 2305407, codigo_uf: 23 },
    { id: 968, nome: 'IGUATU', codigo_ibge: 2305506, codigo_uf: 23 },
    { id: 969, nome: 'INDEPENDENCIA', codigo_ibge: 2305605, codigo_uf: 23 },
    { id: 970, nome: 'IPAPORANGA', codigo_ibge: 2305654, codigo_uf: 23 },
    { id: 971, nome: 'IPAUMIRIM', codigo_ibge: 2305704, codigo_uf: 23 },
    { id: 972, nome: 'IPU', codigo_ibge: 2305803, codigo_uf: 23 },
    { id: 973, nome: 'IPUEIRAS', codigo_ibge: 2305902, codigo_uf: 23 },
    { id: 974, nome: 'IRACEMA', codigo_ibge: 2306009, codigo_uf: 23 },
    { id: 975, nome: 'IRAUCUBA', codigo_ibge: 2306108, codigo_uf: 23 },
    { id: 976, nome: 'ITAICABA', codigo_ibge: 2306207, codigo_uf: 23 },
    { id: 977, nome: 'ITAITINGA', codigo_ibge: 2306256, codigo_uf: 23 },
    { id: 978, nome: 'ITAPAJE', codigo_ibge: 2306306, codigo_uf: 23 },
    { id: 979, nome: 'ITAPIPOCA', codigo_ibge: 2306405, codigo_uf: 23 },
    { id: 980, nome: 'ITAPIUNA', codigo_ibge: 2306504, codigo_uf: 23 },
    { id: 981, nome: 'ITAREMA', codigo_ibge: 2306553, codigo_uf: 23 },
    { id: 982, nome: 'ITATIRA', codigo_ibge: 2306603, codigo_uf: 23 },
    { id: 983, nome: 'JAGUARETAMA', codigo_ibge: 2306702, codigo_uf: 23 },
    { id: 984, nome: 'JAGUARIBARA', codigo_ibge: 2306801, codigo_uf: 23 },
    { id: 985, nome: 'JAGUARIBE', codigo_ibge: 2306900, codigo_uf: 23 },
    { id: 986, nome: 'JAGUARUANA', codigo_ibge: 2307007, codigo_uf: 23 },
    { id: 987, nome: 'JARDIM', codigo_ibge: 2307106, codigo_uf: 23 },
    { id: 988, nome: 'JATI', codigo_ibge: 2307205, codigo_uf: 23 },
    { id: 989, nome: 'JIJOCA DE JERICOACOARA', codigo_ibge: 2307254, codigo_uf: 23 },
    { id: 990, nome: 'JUAZEIRO DO NORTE', codigo_ibge: 2307304, codigo_uf: 23 },
    { id: 991, nome: 'JUCAS', codigo_ibge: 2307403, codigo_uf: 23 },
    { id: 992, nome: 'LAVRAS DA MANGABEIRA', codigo_ibge: 2307502, codigo_uf: 23 },
    { id: 993, nome: 'LIMOEIRO DO NORTE', codigo_ibge: 2307601, codigo_uf: 23 },
    { id: 994, nome: 'MADALENA', codigo_ibge: 2307635, codigo_uf: 23 },
    { id: 995, nome: 'MARACANAU', codigo_ibge: 2307650, codigo_uf: 23 },
    { id: 996, nome: 'MARANGUAPE', codigo_ibge: 2307700, codigo_uf: 23 },
    { id: 997, nome: 'MARCO', codigo_ibge: 2307809, codigo_uf: 23 },
    { id: 998, nome: 'MARTINOPOLE', codigo_ibge: 2307908, codigo_uf: 23 },
    { id: 999, nome: 'MASSAPE', codigo_ibge: 2308005, codigo_uf: 23 },
    { id: 1000, nome: 'MAURITI', codigo_ibge: 2308104, codigo_uf: 23 },
    { id: 1001, nome: 'MERUOCA', codigo_ibge: 2308203, codigo_uf: 23 },
    { id: 1002, nome: 'MILAGRES', codigo_ibge: 2308302, codigo_uf: 23 },
    { id: 1003, nome: 'MILHA', codigo_ibge: 2308351, codigo_uf: 23 },
    { id: 1004, nome: 'MIRAIMA', codigo_ibge: 2308377, codigo_uf: 23 },
    { id: 1005, nome: 'MISSAO VELHA', codigo_ibge: 2308401, codigo_uf: 23 },
    { id: 1006, nome: 'MOMBACA', codigo_ibge: 2308500, codigo_uf: 23 },
    { id: 1007, nome: 'MONSENHOR TABOSA', codigo_ibge: 2308609, codigo_uf: 23 },
    { id: 1008, nome: 'MORADA NOVA', codigo_ibge: 2308708, codigo_uf: 23 },
    { id: 1009, nome: 'MORAUJO', codigo_ibge: 2308807, codigo_uf: 23 },
    { id: 1010, nome: 'MORRINHOS', codigo_ibge: 2308906, codigo_uf: 23 },
    { id: 1011, nome: 'MUCAMBO', codigo_ibge: 2309003, codigo_uf: 23 },
    { id: 1012, nome: 'MULUNGU', codigo_ibge: 2309102, codigo_uf: 23 },
    { id: 1013, nome: 'NOVA OLINDA', codigo_ibge: 2309201, codigo_uf: 23 },
    { id: 1014, nome: 'NOVA RUSSAS', codigo_ibge: 2309300, codigo_uf: 23 },
    { id: 1015, nome: 'NOVO ORIENTE', codigo_ibge: 2309409, codigo_uf: 23 },
    { id: 1016, nome: 'OCARA', codigo_ibge: 2309458, codigo_uf: 23 },
    { id: 1017, nome: 'OROS', codigo_ibge: 2309508, codigo_uf: 23 },
    { id: 1018, nome: 'PACAJUS', codigo_ibge: 2309607, codigo_uf: 23 },
    { id: 1019, nome: 'PACATUBA', codigo_ibge: 2309706, codigo_uf: 23 },
    { id: 1020, nome: 'PACOTI', codigo_ibge: 2309805, codigo_uf: 23 },
    { id: 1021, nome: 'PACUJA', codigo_ibge: 2309904, codigo_uf: 23 },
    { id: 1022, nome: 'PALHANO', codigo_ibge: 2310001, codigo_uf: 23 },
    { id: 1023, nome: 'PALMACIA', codigo_ibge: 2310100, codigo_uf: 23 },
    { id: 1024, nome: 'PARACURU', codigo_ibge: 2310209, codigo_uf: 23 },
    { id: 1025, nome: 'PARAIPABA', codigo_ibge: 2310258, codigo_uf: 23 },
    { id: 1026, nome: 'PARAMBU', codigo_ibge: 2310308, codigo_uf: 23 },
    { id: 1027, nome: 'PARAMOTI', codigo_ibge: 2310407, codigo_uf: 23 },
    { id: 1028, nome: 'PEDRA BRANCA', codigo_ibge: 2310506, codigo_uf: 23 },
    { id: 1029, nome: 'PENAFORTE', codigo_ibge: 2310605, codigo_uf: 23 },
    { id: 1030, nome: 'PENTECOSTE', codigo_ibge: 2310704, codigo_uf: 23 },
    { id: 1031, nome: 'PEREIRO', codigo_ibge: 2310803, codigo_uf: 23 },
    { id: 1032, nome: 'PINDORETAMA', codigo_ibge: 2310852, codigo_uf: 23 },
    { id: 1033, nome: 'PIQUET CARNEIRO', codigo_ibge: 2310902, codigo_uf: 23 },
    { id: 1034, nome: 'PIRES FERREIRA', codigo_ibge: 2310951, codigo_uf: 23 },
    { id: 1035, nome: 'PORANGA', codigo_ibge: 2311009, codigo_uf: 23 },
    { id: 1036, nome: 'PORTEIRAS', codigo_ibge: 2311108, codigo_uf: 23 },
    { id: 1037, nome: 'POTENGI', codigo_ibge: 2311207, codigo_uf: 23 },
    { id: 1038, nome: 'POTIRETAMA', codigo_ibge: 2311231, codigo_uf: 23 },
    { id: 1039, nome: 'QUITERIANOPOLIS', codigo_ibge: 2311264, codigo_uf: 23 },
    { id: 1040, nome: 'QUIXADA', codigo_ibge: 2311306, codigo_uf: 23 },
    { id: 1041, nome: 'QUIXELO', codigo_ibge: 2311355, codigo_uf: 23 },
    { id: 1042, nome: 'QUIXERAMOBIM', codigo_ibge: 2311405, codigo_uf: 23 },
    { id: 1043, nome: 'QUIXERE', codigo_ibge: 2311504, codigo_uf: 23 },
    { id: 1044, nome: 'REDENCAO', codigo_ibge: 2311603, codigo_uf: 23 },
    { id: 1045, nome: 'RERIUTABA', codigo_ibge: 2311702, codigo_uf: 23 },
    { id: 1046, nome: 'RUSSAS', codigo_ibge: 2311801, codigo_uf: 23 },
    { id: 1047, nome: 'SABOEIRO', codigo_ibge: 2311900, codigo_uf: 23 },
    { id: 1048, nome: 'SALITRE', codigo_ibge: 2311959, codigo_uf: 23 },
    { id: 1051, nome: 'SANTA QUITERIA', codigo_ibge: 2312205, codigo_uf: 23 },
    { id: 1049, nome: 'SANTANA DO ACARAU', codigo_ibge: 2312007, codigo_uf: 23 },
    { id: 1050, nome: 'SANTANA DO CARIRI', codigo_ibge: 2312106, codigo_uf: 23 },
    { id: 1052, nome: 'SAO BENEDITO', codigo_ibge: 2312304, codigo_uf: 23 },
    { id: 1053, nome: 'SAO GONCALO DO AMARANTE', codigo_ibge: 2312403, codigo_uf: 23 },
    { id: 1054, nome: 'SAO JOAO DO JAGUARIBE', codigo_ibge: 2312502, codigo_uf: 23 },
    { id: 1055, nome: 'SAO LUIS DO CURU', codigo_ibge: 2312601, codigo_uf: 23 },
    { id: 1056, nome: 'SENADOR POMPEU', codigo_ibge: 2312700, codigo_uf: 23 },
    { id: 1057, nome: 'SENADOR SA', codigo_ibge: 2312809, codigo_uf: 23 },
    { id: 1058, nome: 'SOBRAL', codigo_ibge: 2312908, codigo_uf: 23 },
    { id: 1059, nome: 'SOLONOPOLE', codigo_ibge: 2313005, codigo_uf: 23 },
    { id: 1060, nome: 'TABULEIRO DO NORTE', codigo_ibge: 2313104, codigo_uf: 23 },
    { id: 1061, nome: 'TAMBORIL', codigo_ibge: 2313203, codigo_uf: 23 },
    { id: 1062, nome: 'TARRAFAS', codigo_ibge: 2313252, codigo_uf: 23 },
    { id: 1063, nome: 'TAUA', codigo_ibge: 2313302, codigo_uf: 23 },
    { id: 1064, nome: 'TEJUCUOCA', codigo_ibge: 2313351, codigo_uf: 23 },
    { id: 1065, nome: 'TIANGUA', codigo_ibge: 2313401, codigo_uf: 23 },
    { id: 1066, nome: 'TRAIRI', codigo_ibge: 2313500, codigo_uf: 23 },
    { id: 1067, nome: 'TURURU', codigo_ibge: 2313559, codigo_uf: 23 },
    { id: 1068, nome: 'UBAJARA', codigo_ibge: 2313609, codigo_uf: 23 },
    { id: 1069, nome: 'UMARI', codigo_ibge: 2313708, codigo_uf: 23 },
    { id: 1070, nome: 'UMIRIM', codigo_ibge: 2313757, codigo_uf: 23 },
    { id: 1071, nome: 'URUBURETAMA', codigo_ibge: 2313807, codigo_uf: 23 },
    { id: 1072, nome: 'URUOCA', codigo_ibge: 2313906, codigo_uf: 23 },
    { id: 1073, nome: 'VARJOTA', codigo_ibge: 2313955, codigo_uf: 23 },
    { id: 1074, nome: 'VARZEA ALEGRE', codigo_ibge: 2314003, codigo_uf: 23 },
    { id: 1075, nome: 'VICOSA DO CEARA', codigo_ibge: 2314102, codigo_uf: 23 },
    { id: 1076, nome: 'ACARI', codigo_ibge: 2400109, codigo_uf: 24 },
    { id: 1077, nome: 'ACU', codigo_ibge: 2400208, codigo_uf: 24 },
    { id: 1078, nome: 'AFONSO BEZERRA', codigo_ibge: 2400307, codigo_uf: 24 },
    { id: 1079, nome: 'AGUA NOVA', codigo_ibge: 2400406, codigo_uf: 24 },
    { id: 1080, nome: 'ALEXANDRIA', codigo_ibge: 2400505, codigo_uf: 24 },
    { id: 1081, nome: 'ALMINO AFONSO', codigo_ibge: 2400604, codigo_uf: 24 },
    { id: 1082, nome: 'ALTO DO RODRIGUES', codigo_ibge: 2400703, codigo_uf: 24 },
    { id: 1083, nome: 'ANGICOS', codigo_ibge: 2400802, codigo_uf: 24 },
    { id: 1084, nome: 'ANTONIO MARTINS', codigo_ibge: 2400901, codigo_uf: 24 },
    { id: 1085, nome: 'APODI', codigo_ibge: 2401008, codigo_uf: 24 },
    { id: 1086, nome: 'AREIA BRANCA', codigo_ibge: 2401107, codigo_uf: 24 },
    { id: 1087, nome: 'ARES', codigo_ibge: 2401206, codigo_uf: 24 },
    { id: 1088, nome: 'AUGUSTO SEVERO (CAMPO GRANDE)', codigo_ibge: 2401305, codigo_uf: 24 },
    { id: 1089, nome: 'BAIA FORMOSA', codigo_ibge: 2401404, codigo_uf: 24 },
    { id: 1090, nome: 'BARAUNA', codigo_ibge: 2401453, codigo_uf: 24 },
    { id: 1091, nome: 'BARCELONA', codigo_ibge: 2401503, codigo_uf: 24 },
    { id: 1092, nome: 'BENTO FERNANDES', codigo_ibge: 2401602, codigo_uf: 24 },
    { id: 1093, nome: 'BODO', codigo_ibge: 2401651, codigo_uf: 24 },
    { id: 1094, nome: 'BOM JESUS', codigo_ibge: 2401701, codigo_uf: 24 },
    { id: 1095, nome: 'BREJINHO', codigo_ibge: 2401800, codigo_uf: 24 },
    { id: 1096, nome: 'CAICARA DO NORTE', codigo_ibge: 2401859, codigo_uf: 24 },
    { id: 1097, nome: 'CAICARA DO RIO DO VENTO', codigo_ibge: 2401909, codigo_uf: 24 },
    { id: 1098, nome: 'CAICO', codigo_ibge: 2402006, codigo_uf: 24 },
    { id: 1099, nome: 'CAMPO REDONDO', codigo_ibge: 2402105, codigo_uf: 24 },
    { id: 1100, nome: 'CANGUARETAMA', codigo_ibge: 2402204, codigo_uf: 24 },
    { id: 1101, nome: 'CARAUBAS', codigo_ibge: 2402303, codigo_uf: 24 },
    { id: 1102, nome: 'CARNAUBA DOS DANTAS', codigo_ibge: 2402402, codigo_uf: 24 },
    { id: 1103, nome: 'CARNAUBAIS', codigo_ibge: 2402501, codigo_uf: 24 },
    { id: 1104, nome: 'CEARA-MIRIM', codigo_ibge: 2402600, codigo_uf: 24 },
    { id: 1105, nome: 'CERRO CORA', codigo_ibge: 2402709, codigo_uf: 24 },
    { id: 1106, nome: 'CORONEL EZEQUIEL', codigo_ibge: 2402808, codigo_uf: 24 },
    { id: 1107, nome: 'CORONEL JOAO PESSOA', codigo_ibge: 2402907, codigo_uf: 24 },
    { id: 1108, nome: 'CRUZETA', codigo_ibge: 2403004, codigo_uf: 24 },
    { id: 1109, nome: 'CURRAIS NOVOS', codigo_ibge: 2403103, codigo_uf: 24 },
    { id: 1110, nome: 'DOUTOR SEVERIANO', codigo_ibge: 2403202, codigo_uf: 24 },
    { id: 1112, nome: 'ENCANTO', codigo_ibge: 2403301, codigo_uf: 24 },
    { id: 1113, nome: 'EQUADOR', codigo_ibge: 2403400, codigo_uf: 24 },
    { id: 1114, nome: 'ESPIRITO SANTO', codigo_ibge: 2403509, codigo_uf: 24 },
    { id: 1115, nome: 'EXTREMOZ', codigo_ibge: 2403608, codigo_uf: 24 },
    { id: 1116, nome: 'FELIPE GUERRA', codigo_ibge: 2403707, codigo_uf: 24 },
    { id: 1117, nome: 'FERNANDO PEDROZA', codigo_ibge: 2403756, codigo_uf: 24 },
    { id: 1118, nome: 'FLORANIA', codigo_ibge: 2403806, codigo_uf: 24 },
    { id: 1119, nome: 'FRANCISCO DANTAS', codigo_ibge: 2403905, codigo_uf: 24 },
    { id: 1120, nome: 'FRUTUOSO GOMES', codigo_ibge: 2404002, codigo_uf: 24 },
    { id: 1121, nome: 'GALINHOS', codigo_ibge: 2404101, codigo_uf: 24 },
    { id: 1122, nome: 'GOIANINHA', codigo_ibge: 2404200, codigo_uf: 24 },
    { id: 1123, nome: 'GOVERNADOR DIX-SEPT ROSADO', codigo_ibge: 2404309, codigo_uf: 24 },
    { id: 1124, nome: 'GROSSOS', codigo_ibge: 2404408, codigo_uf: 24 },
    { id: 1125, nome: 'GUAMARE', codigo_ibge: 2404507, codigo_uf: 24 },
    { id: 1126, nome: 'IELMO MARINHO', codigo_ibge: 2404606, codigo_uf: 24 },
    { id: 1127, nome: 'IPANGUACU', codigo_ibge: 2404705, codigo_uf: 24 },
    { id: 1128, nome: 'IPUEIRA', codigo_ibge: 2404804, codigo_uf: 24 },
    { id: 1129, nome: 'ITAJA', codigo_ibge: 2404853, codigo_uf: 24 },
    { id: 1130, nome: 'ITAU', codigo_ibge: 2404903, codigo_uf: 24 },
    { id: 1131, nome: 'JACANA', codigo_ibge: 2405009, codigo_uf: 24 },
    { id: 1132, nome: 'JANDAIRA', codigo_ibge: 2405108, codigo_uf: 24 },
    { id: 1133, nome: 'JANDUIS', codigo_ibge: 2405207, codigo_uf: 24 },
    { id: 1134, nome: 'JANUARIO CICCO (BOA SAUDE)', codigo_ibge: 2405306, codigo_uf: 24 },
    { id: 1135, nome: 'JAPI', codigo_ibge: 2405405, codigo_uf: 24 },
    { id: 1136, nome: 'JARDIM DE ANGICOS', codigo_ibge: 2405504, codigo_uf: 24 },
    { id: 1137, nome: 'JARDIM DE PIRANHAS', codigo_ibge: 2405603, codigo_uf: 24 },
    { id: 1138, nome: 'JARDIM DO SERIDO', codigo_ibge: 2405702, codigo_uf: 24 },
    { id: 1139, nome: 'JOAO CAMARA', codigo_ibge: 2405801, codigo_uf: 24 },
    { id: 1140, nome: 'JOAO DIAS', codigo_ibge: 2405900, codigo_uf: 24 },
    { id: 1141, nome: 'JOSE DA PENHA', codigo_ibge: 2406007, codigo_uf: 24 },
    { id: 1142, nome: 'JUCURUTU', codigo_ibge: 2406106, codigo_uf: 24 },
    { id: 1143, nome: 'JUNDIA', codigo_ibge: 2406155, codigo_uf: 24 },
    { id: 1144, nome: 'LAGOA D ANTA', codigo_ibge: 2406205, codigo_uf: 24 },
    { id: 1145, nome: 'LAGOA DE PEDRAS', codigo_ibge: 2406304, codigo_uf: 24 },
    { id: 1146, nome: 'LAGOA DE VELHOS', codigo_ibge: 2406403, codigo_uf: 24 },
    { id: 1147, nome: 'LAGOA NOVA', codigo_ibge: 2406502, codigo_uf: 24 },
    { id: 1148, nome: 'LAGOA SALGADA', codigo_ibge: 2406601, codigo_uf: 24 },
    { id: 1149, nome: 'LAJES', codigo_ibge: 2406700, codigo_uf: 24 },
    { id: 1150, nome: 'LAJES PINTADAS', codigo_ibge: 2406809, codigo_uf: 24 },
    { id: 1151, nome: 'LUCRECIA', codigo_ibge: 2406908, codigo_uf: 24 },
    { id: 1152, nome: 'LUIS GOMES', codigo_ibge: 2407005, codigo_uf: 24 },
    { id: 1153, nome: 'MACAIBA', codigo_ibge: 2407104, codigo_uf: 24 },
    { id: 1154, nome: 'MACAU', codigo_ibge: 2407203, codigo_uf: 24 },
    { id: 1155, nome: 'MAJOR SALES', codigo_ibge: 2407252, codigo_uf: 24 },
    { id: 1156, nome: 'MARCELINO VIEIRA', codigo_ibge: 2407302, codigo_uf: 24 },
    { id: 1157, nome: 'MARTINS', codigo_ibge: 2407401, codigo_uf: 24 },
    { id: 1158, nome: 'MAXARANGUAPE', codigo_ibge: 2407500, codigo_uf: 24 },
    { id: 1159, nome: 'MESSIAS TARGINO', codigo_ibge: 2407609, codigo_uf: 24 },
    { id: 1160, nome: 'MONTANHAS', codigo_ibge: 2407708, codigo_uf: 24 },
    { id: 1161, nome: 'MONTE ALEGRE', codigo_ibge: 2407807, codigo_uf: 24 },
    { id: 1162, nome: 'MONTE DAS GAMELEIRAS', codigo_ibge: 2407906, codigo_uf: 24 },
    { id: 1163, nome: 'MOSSORO', codigo_ibge: 2408003, codigo_uf: 24 },
    { id: 1164, nome: 'NATAL', codigo_ibge: 2408102, codigo_uf: 24 },
    { id: 1165, nome: 'NISIA FLORESTA', codigo_ibge: 2408201, codigo_uf: 24 },
    { id: 1166, nome: 'NOVA CRUZ', codigo_ibge: 2408300, codigo_uf: 24 },
    { id: 1167, nome: 'OLHO-D AGUA DO BORGES', codigo_ibge: 2408409, codigo_uf: 24 },
    { id: 1168, nome: 'OURO BRANCO', codigo_ibge: 2408508, codigo_uf: 24 },
    { id: 1169, nome: 'PARANA', codigo_ibge: 2408607, codigo_uf: 24 },
    { id: 1170, nome: 'PARAU', codigo_ibge: 2408706, codigo_uf: 24 },
    { id: 1171, nome: 'PARAZINHO', codigo_ibge: 2408805, codigo_uf: 24 },
    { id: 1172, nome: 'PARELHAS', codigo_ibge: 2408904, codigo_uf: 24 },
    { id: 1111, nome: 'PARNAMIRIM', codigo_ibge: 2403251, codigo_uf: 24 },
    { id: 1174, nome: 'PASSA E FICA', codigo_ibge: 2409100, codigo_uf: 24 },
    { id: 1175, nome: 'PASSAGEM', codigo_ibge: 2409209, codigo_uf: 24 },
    { id: 1176, nome: 'PATU', codigo_ibge: 2409308, codigo_uf: 24 },
    { id: 1178, nome: 'PAU DOS FERROS', codigo_ibge: 2409407, codigo_uf: 24 },
    { id: 1179, nome: 'PEDRA GRANDE', codigo_ibge: 2409506, codigo_uf: 24 },
    { id: 1180, nome: 'PEDRA PRETA', codigo_ibge: 2409605, codigo_uf: 24 },
    { id: 1181, nome: 'PEDRO AVELINO', codigo_ibge: 2409704, codigo_uf: 24 },
    { id: 1182, nome: 'PEDRO VELHO', codigo_ibge: 2409803, codigo_uf: 24 },
    { id: 1183, nome: 'PENDENCIAS', codigo_ibge: 2409902, codigo_uf: 24 },
    { id: 1184, nome: 'PILOES', codigo_ibge: 2410009, codigo_uf: 24 },
    { id: 1185, nome: 'POCO BRANCO', codigo_ibge: 2410108, codigo_uf: 24 },
    { id: 1186, nome: 'PORTALEGRE', codigo_ibge: 2410207, codigo_uf: 24 },
    { id: 1187, nome: 'PORTO DO MANGUE', codigo_ibge: 2410256, codigo_uf: 24 },
    { id: 1189, nome: 'PUREZA', codigo_ibge: 2410405, codigo_uf: 24 },
    { id: 1190, nome: 'RAFAEL FERNANDES', codigo_ibge: 2410504, codigo_uf: 24 },
    { id: 1191, nome: 'RAFAEL GODEIRO', codigo_ibge: 2410603, codigo_uf: 24 },
    { id: 1192, nome: 'RIACHO DA CRUZ', codigo_ibge: 2410702, codigo_uf: 24 },
    { id: 1193, nome: 'RIACHO DE SANTANA', codigo_ibge: 2410801, codigo_uf: 24 },
    { id: 1194, nome: 'RIACHUELO', codigo_ibge: 2410900, codigo_uf: 24 },
    { id: 1173, nome: 'RIO DO FOGO', codigo_ibge: 2408953, codigo_uf: 24 },
    { id: 1195, nome: 'RODOLFO FERNANDES', codigo_ibge: 2411007, codigo_uf: 24 },
    { id: 1197, nome: 'RUY BARBOSA', codigo_ibge: 2411106, codigo_uf: 24 },
    { id: 1198, nome: 'SANTA CRUZ', codigo_ibge: 2411205, codigo_uf: 24 },
    { id: 1177, nome: 'SANTA MARIA', codigo_ibge: 2409332, codigo_uf: 24 },
    { id: 1199, nome: 'SANTANA DO MATOS', codigo_ibge: 2411403, codigo_uf: 24 },
    { id: 1200, nome: 'SANTANA DO SERIDO', codigo_ibge: 2411429, codigo_uf: 24 },
    { id: 1201, nome: 'SANTO ANTONIO', codigo_ibge: 2411502, codigo_uf: 24 },
    { id: 1202, nome: 'SAO BENTO DO NORTE', codigo_ibge: 2411601, codigo_uf: 24 },
    { id: 1203, nome: 'SAO BENTO DO TRAIRI', codigo_ibge: 2411700, codigo_uf: 24 },
    { id: 1204, nome: 'SAO FERNANDO', codigo_ibge: 2411809, codigo_uf: 24 },
    { id: 1205, nome: 'SAO FRANCISCO DO OESTE', codigo_ibge: 2411908, codigo_uf: 24 },
    { id: 1206, nome: 'SAO GONCALO DO AMARANTE', codigo_ibge: 2412005, codigo_uf: 24 },
    { id: 1207, nome: 'SAO JOAO DO SABUGI', codigo_ibge: 2412104, codigo_uf: 24 },
    { id: 1208, nome: 'SAO JOSE DE MIPIBU', codigo_ibge: 2412203, codigo_uf: 24 },
    { id: 1209, nome: 'SAO JOSE DO CAMPESTRE', codigo_ibge: 2412302, codigo_uf: 24 },
    { id: 1210, nome: 'SAO JOSE DO SERIDO', codigo_ibge: 2412401, codigo_uf: 24 },
    { id: 1211, nome: 'SAO MIGUEL', codigo_ibge: 2412500, codigo_uf: 24 },
    { id: 1212, nome: 'SAO MIGUEL DO GOSTOSO', codigo_ibge: 2412559, codigo_uf: 24 },
    { id: 1213, nome: 'SAO PAULO DO POTENGI', codigo_ibge: 2412609, codigo_uf: 24 },
    { id: 1214, nome: 'SAO PEDRO', codigo_ibge: 2412708, codigo_uf: 24 },
    { id: 1215, nome: 'SAO RAFAEL', codigo_ibge: 2412807, codigo_uf: 24 },
    { id: 1216, nome: 'SAO TOME', codigo_ibge: 2412906, codigo_uf: 24 },
    { id: 1217, nome: 'SAO VICENTE', codigo_ibge: 2413003, codigo_uf: 24 },
    { id: 1218, nome: 'SENADOR ELOI DE SOUZA', codigo_ibge: 2413102, codigo_uf: 24 },
    { id: 1219, nome: 'SENADOR GEORGINO AVELINO', codigo_ibge: 2413201, codigo_uf: 24 },
    { id: 1188, nome: 'SERRA CAIADA', codigo_ibge: 2410306, codigo_uf: 24 },
    { id: 1220, nome: 'SERRA DE SAO BENTO', codigo_ibge: 2413300, codigo_uf: 24 },
    { id: 1221, nome: 'SERRA DO MEL', codigo_ibge: 2413359, codigo_uf: 24 },
    { id: 1222, nome: 'SERRA NEGRA DO NORTE', codigo_ibge: 2413409, codigo_uf: 24 },
    { id: 1223, nome: 'SERRINHA', codigo_ibge: 2413508, codigo_uf: 24 },
    { id: 1224, nome: 'SERRINHA DOS PINTOS', codigo_ibge: 2413557, codigo_uf: 24 },
    { id: 1225, nome: 'SEVERIANO MELO', codigo_ibge: 2413607, codigo_uf: 24 },
    { id: 1226, nome: 'SITIO NOVO', codigo_ibge: 2413706, codigo_uf: 24 },
    { id: 1227, nome: 'TABOLEIRO GRANDE', codigo_ibge: 2413805, codigo_uf: 24 },
    { id: 1228, nome: 'TAIPU', codigo_ibge: 2413904, codigo_uf: 24 },
    { id: 1229, nome: 'TANGARA', codigo_ibge: 2414001, codigo_uf: 24 },
    { id: 1230, nome: 'TENENTE ANANIAS', codigo_ibge: 2414100, codigo_uf: 24 },
    { id: 1231, nome: 'TENENTE LAURENTINO CRUZ', codigo_ibge: 2414159, codigo_uf: 24 },
    { id: 1196, nome: 'TIBAU', codigo_ibge: 2411056, codigo_uf: 24 },
    { id: 1232, nome: 'TIBAU DO SUL', codigo_ibge: 2414209, codigo_uf: 24 },
    { id: 1233, nome: 'TIMBAUBA DOS BATISTAS', codigo_ibge: 2414308, codigo_uf: 24 },
    { id: 1234, nome: 'TOUROS', codigo_ibge: 2414407, codigo_uf: 24 },
    { id: 1235, nome: 'TRIUNFO POTIGUAR', codigo_ibge: 2414456, codigo_uf: 24 },
    { id: 1236, nome: 'UMARIZAL', codigo_ibge: 2414506, codigo_uf: 24 },
    { id: 1237, nome: 'UPANEMA', codigo_ibge: 2414605, codigo_uf: 24 },
    { id: 1238, nome: 'VARZEA', codigo_ibge: 2414704, codigo_uf: 24 },
    { id: 1239, nome: 'VENHA-VER', codigo_ibge: 2414753, codigo_uf: 24 },
    { id: 1240, nome: 'VERA CRUZ', codigo_ibge: 2414803, codigo_uf: 24 },
    { id: 1241, nome: 'VICOSA', codigo_ibge: 2414902, codigo_uf: 24 },
    { id: 1242, nome: 'VILA FLOR', codigo_ibge: 2415008, codigo_uf: 24 },
    { id: 1243, nome: 'AGUA BRANCA', codigo_ibge: 2500106, codigo_uf: 25 },
    { id: 1244, nome: 'AGUIAR', codigo_ibge: 2500205, codigo_uf: 25 },
    { id: 1245, nome: 'ALAGOA GRANDE', codigo_ibge: 2500304, codigo_uf: 25 },
    { id: 1246, nome: 'ALAGOA NOVA', codigo_ibge: 2500403, codigo_uf: 25 },
    { id: 1247, nome: 'ALAGOINHA', codigo_ibge: 2500502, codigo_uf: 25 },
    { id: 1248, nome: 'ALCANTIL', codigo_ibge: 2500536, codigo_uf: 25 },
    { id: 1249, nome: 'ALGODAO DE JANDAIRA', codigo_ibge: 2500577, codigo_uf: 25 },
    { id: 1250, nome: 'ALHANDRA', codigo_ibge: 2500601, codigo_uf: 25 },
    { id: 1252, nome: 'AMPARO', codigo_ibge: 2500734, codigo_uf: 25 },
    { id: 1253, nome: 'APARECIDA', codigo_ibge: 2500775, codigo_uf: 25 },
    { id: 1254, nome: 'ARACAGI', codigo_ibge: 2500809, codigo_uf: 25 },
    { id: 1255, nome: 'ARARA', codigo_ibge: 2500908, codigo_uf: 25 },
    { id: 1256, nome: 'ARARUNA', codigo_ibge: 2501005, codigo_uf: 25 },
    { id: 1257, nome: 'AREIA', codigo_ibge: 2501104, codigo_uf: 25 },
    { id: 1258, nome: 'AREIA DE BARAUNAS', codigo_ibge: 2501153, codigo_uf: 25 },
    { id: 1259, nome: 'AREIAL', codigo_ibge: 2501203, codigo_uf: 25 },
    { id: 1260, nome: 'AROEIRAS', codigo_ibge: 2501302, codigo_uf: 25 },
    { id: 1261, nome: 'ASSUNCAO', codigo_ibge: 2501351, codigo_uf: 25 },
    { id: 1262, nome: 'BAIA DA TRAICAO', codigo_ibge: 2501401, codigo_uf: 25 },
    { id: 1263, nome: 'BANANEIRAS', codigo_ibge: 2501500, codigo_uf: 25 },
    { id: 1264, nome: 'BARAUNA', codigo_ibge: 2501534, codigo_uf: 25 },
    { id: 1266, nome: 'BARRA DE SANTA ROSA', codigo_ibge: 2501609, codigo_uf: 25 },
    { id: 1265, nome: 'BARRA DE SANTANA', codigo_ibge: 2501575, codigo_uf: 25 },
    { id: 1267, nome: 'BARRA DE SAO MIGUEL', codigo_ibge: 2501708, codigo_uf: 25 },
    { id: 1268, nome: 'BAYEUX', codigo_ibge: 2501807, codigo_uf: 25 },
    { id: 1269, nome: 'BELEM', codigo_ibge: 2501906, codigo_uf: 25 },
    { id: 1270, nome: 'BELEM DO BREJO DO CRUZ', codigo_ibge: 2502003, codigo_uf: 25 },
    { id: 1271, nome: 'BERNARDINO BATISTA', codigo_ibge: 2502052, codigo_uf: 25 },
    { id: 1272, nome: 'BOA VENTURA', codigo_ibge: 2502102, codigo_uf: 25 },
    { id: 1273, nome: 'BOA VISTA', codigo_ibge: 2502151, codigo_uf: 25 },
    { id: 1274, nome: 'BOM JESUS', codigo_ibge: 2502201, codigo_uf: 25 },
    { id: 1275, nome: 'BOM SUCESSO', codigo_ibge: 2502300, codigo_uf: 25 },
    { id: 1276, nome: 'BONITO DE SANTA FE', codigo_ibge: 2502409, codigo_uf: 25 },
    { id: 1277, nome: 'BOQUEIRAO', codigo_ibge: 2502508, codigo_uf: 25 },
    { id: 1279, nome: 'BORBOREMA', codigo_ibge: 2502706, codigo_uf: 25 },
    { id: 1280, nome: 'BREJO DO CRUZ', codigo_ibge: 2502805, codigo_uf: 25 },
    { id: 1281, nome: 'BREJO DOS SANTOS', codigo_ibge: 2502904, codigo_uf: 25 },
    { id: 1282, nome: 'CAAPORA', codigo_ibge: 2503001, codigo_uf: 25 },
    { id: 1283, nome: 'CABACEIRAS', codigo_ibge: 2503100, codigo_uf: 25 },
    { id: 1284, nome: 'CABEDELO', codigo_ibge: 2503209, codigo_uf: 25 },
    { id: 1285, nome: 'CACHOEIRA DOS INDIOS', codigo_ibge: 2503308, codigo_uf: 25 },
    { id: 1286, nome: 'CACIMBA DE AREIA', codigo_ibge: 2503407, codigo_uf: 25 },
    { id: 1287, nome: 'CACIMBA DE DENTRO', codigo_ibge: 2503506, codigo_uf: 25 },
    { id: 1288, nome: 'CACIMBAS', codigo_ibge: 2503555, codigo_uf: 25 },
    { id: 1289, nome: 'CAICARA', codigo_ibge: 2503605, codigo_uf: 25 },
    { id: 1290, nome: 'CAJAZEIRAS', codigo_ibge: 2503704, codigo_uf: 25 },
    { id: 1291, nome: 'CAJAZEIRINHAS', codigo_ibge: 2503753, codigo_uf: 25 },
    { id: 1292, nome: 'CALDAS BRANDAO', codigo_ibge: 2503803, codigo_uf: 25 },
    { id: 1293, nome: 'CAMALAU', codigo_ibge: 2503902, codigo_uf: 25 },
    { id: 1294, nome: 'CAMPINA GRANDE', codigo_ibge: 2504009, codigo_uf: 25 },
    { id: 1295, nome: 'CAPIM', codigo_ibge: 2504033, codigo_uf: 25 },
    { id: 1296, nome: 'CARAUBAS', codigo_ibge: 2504074, codigo_uf: 25 },
    { id: 1297, nome: 'CARRAPATEIRA', codigo_ibge: 2504108, codigo_uf: 25 },
    { id: 1298, nome: 'CASSERENGUE', codigo_ibge: 2504157, codigo_uf: 25 },
    { id: 1299, nome: 'CATINGUEIRA', codigo_ibge: 2504207, codigo_uf: 25 },
    { id: 1300, nome: 'CATOLE DO ROCHA', codigo_ibge: 2504306, codigo_uf: 25 },
    { id: 1301, nome: 'CATURITE', codigo_ibge: 2504355, codigo_uf: 25 },
    { id: 1302, nome: 'CONCEICAO', codigo_ibge: 2504405, codigo_uf: 25 },
    { id: 1303, nome: 'CONDADO', codigo_ibge: 2504504, codigo_uf: 25 },
    { id: 1304, nome: 'CONDE', codigo_ibge: 2504603, codigo_uf: 25 },
    { id: 1305, nome: 'CONGO', codigo_ibge: 2504702, codigo_uf: 25 },
    { id: 1306, nome: 'COREMAS', codigo_ibge: 2504801, codigo_uf: 25 },
    { id: 1307, nome: 'COXIXOLA', codigo_ibge: 2504850, codigo_uf: 25 },
    { id: 1308, nome: 'CRUZ DO ESPIRITO SANTO', codigo_ibge: 2504900, codigo_uf: 25 },
    { id: 1309, nome: 'CUBATI', codigo_ibge: 2505006, codigo_uf: 25 },
    { id: 1310, nome: 'CUITE', codigo_ibge: 2505105, codigo_uf: 25 },
    { id: 1312, nome: 'CUITE DE MAMANGUAPE', codigo_ibge: 2505238, codigo_uf: 25 },
    { id: 1311, nome: 'CUITEGI', codigo_ibge: 2505204, codigo_uf: 25 },
    { id: 1313, nome: 'CURRAL DE CIMA', codigo_ibge: 2505279, codigo_uf: 25 },
    { id: 1314, nome: 'CURRAL VELHO', codigo_ibge: 2505303, codigo_uf: 25 },
    { id: 1315, nome: 'DAMIAO', codigo_ibge: 2505352, codigo_uf: 25 },
    { id: 1316, nome: 'DESTERRO', codigo_ibge: 2505402, codigo_uf: 25 },
    { id: 1318, nome: 'DIAMANTE', codigo_ibge: 2505600, codigo_uf: 25 },
    { id: 1319, nome: 'DONA INES', codigo_ibge: 2505709, codigo_uf: 25 },
    { id: 1320, nome: 'DUAS ESTRADAS', codigo_ibge: 2505808, codigo_uf: 25 },
    { id: 1321, nome: 'EMAS', codigo_ibge: 2505907, codigo_uf: 25 },
    { id: 1322, nome: 'ESPERANCA', codigo_ibge: 2506004, codigo_uf: 25 },
    { id: 1323, nome: 'FAGUNDES', codigo_ibge: 2506103, codigo_uf: 25 },
    { id: 1324, nome: 'FREI MARTINHO', codigo_ibge: 2506202, codigo_uf: 25 },
    { id: 1325, nome: 'GADO BRAVO', codigo_ibge: 2506251, codigo_uf: 25 },
    { id: 1326, nome: 'GUARABIRA', codigo_ibge: 2506301, codigo_uf: 25 },
    { id: 1327, nome: 'GURINHEM', codigo_ibge: 2506400, codigo_uf: 25 },
    { id: 1328, nome: 'GURJAO', codigo_ibge: 2506509, codigo_uf: 25 },
    { id: 1329, nome: 'IBIARA', codigo_ibge: 2506608, codigo_uf: 25 },
    { id: 1278, nome: 'IGARACY', codigo_ibge: 2502607, codigo_uf: 25 },
    { id: 1330, nome: 'IMACULADA', codigo_ibge: 2506707, codigo_uf: 25 },
    { id: 1331, nome: 'INGA', codigo_ibge: 2506806, codigo_uf: 25 },
    { id: 1332, nome: 'ITABAIANA', codigo_ibge: 2506905, codigo_uf: 25 },
    { id: 1333, nome: 'ITAPORANGA', codigo_ibge: 2507002, codigo_uf: 25 },
    { id: 1334, nome: 'ITAPOROROCA', codigo_ibge: 2507101, codigo_uf: 25 },
    { id: 1335, nome: 'ITATUBA', codigo_ibge: 2507200, codigo_uf: 25 },
    { id: 1336, nome: 'JACARAU', codigo_ibge: 2507309, codigo_uf: 25 },
    { id: 1337, nome: 'JERICO', codigo_ibge: 2507408, codigo_uf: 25 },
    { id: 1338, nome: 'JOAO PESSOA', codigo_ibge: 2507507, codigo_uf: 25 },
    { id: 1416, nome: 'JOCA CLAUDINO', codigo_ibge: 2513653, codigo_uf: 25 },
    { id: 1339, nome: 'JUAREZ TAVORA', codigo_ibge: 2507606, codigo_uf: 25 },
    { id: 1340, nome: 'JUAZEIRINHO', codigo_ibge: 2507705, codigo_uf: 25 },
    { id: 1341, nome: 'JUNCO DO SERIDO', codigo_ibge: 2507804, codigo_uf: 25 },
    { id: 1342, nome: 'JURIPIRANGA', codigo_ibge: 2507903, codigo_uf: 25 },
    { id: 1343, nome: 'JURU', codigo_ibge: 2508000, codigo_uf: 25 },
    { id: 1344, nome: 'LAGOA', codigo_ibge: 2508109, codigo_uf: 25 },
    { id: 1345, nome: 'LAGOA DE DENTRO', codigo_ibge: 2508208, codigo_uf: 25 },
    { id: 1346, nome: 'LAGOA SECA', codigo_ibge: 2508307, codigo_uf: 25 },
    { id: 1347, nome: 'LASTRO', codigo_ibge: 2508406, codigo_uf: 25 },
    { id: 1348, nome: 'LIVRAMENTO', codigo_ibge: 2508505, codigo_uf: 25 },
    { id: 1349, nome: 'LOGRADOURO', codigo_ibge: 2508554, codigo_uf: 25 },
    { id: 1350, nome: 'LUCENA', codigo_ibge: 2508604, codigo_uf: 25 },
    { id: 1351, nome: 'MAE D AGUA', codigo_ibge: 2508703, codigo_uf: 25 },
    { id: 1352, nome: 'MALTA', codigo_ibge: 2508802, codigo_uf: 25 },
    { id: 1353, nome: 'MAMANGUAPE', codigo_ibge: 2508901, codigo_uf: 25 },
    { id: 1354, nome: 'MANAIRA', codigo_ibge: 2509008, codigo_uf: 25 },
    { id: 1355, nome: 'MARCACAO', codigo_ibge: 2509057, codigo_uf: 25 },
    { id: 1356, nome: 'MARI', codigo_ibge: 2509107, codigo_uf: 25 },
    { id: 1357, nome: 'MARIZOPOLIS', codigo_ibge: 2509156, codigo_uf: 25 },
    { id: 1358, nome: 'MASSARANDUBA', codigo_ibge: 2509206, codigo_uf: 25 },
    { id: 1359, nome: 'MATARACA', codigo_ibge: 2509305, codigo_uf: 25 },
    { id: 1360, nome: 'MATINHAS', codigo_ibge: 2509339, codigo_uf: 25 },
    { id: 1361, nome: 'MATO GROSSO', codigo_ibge: 2509370, codigo_uf: 25 },
    { id: 1362, nome: 'MATUREIA', codigo_ibge: 2509396, codigo_uf: 25 },
    { id: 1363, nome: 'MOGEIRO', codigo_ibge: 2509404, codigo_uf: 25 },
    { id: 1364, nome: 'MONTADAS', codigo_ibge: 2509503, codigo_uf: 25 },
    { id: 1365, nome: 'MONTE HOREBE', codigo_ibge: 2509602, codigo_uf: 25 },
    { id: 1366, nome: 'MONTEIRO', codigo_ibge: 2509701, codigo_uf: 25 },
    { id: 1367, nome: 'MULUNGU', codigo_ibge: 2509800, codigo_uf: 25 },
    { id: 1368, nome: 'NATUBA', codigo_ibge: 2509909, codigo_uf: 25 },
    { id: 1369, nome: 'NAZAREZINHO', codigo_ibge: 2510006, codigo_uf: 25 },
    { id: 1370, nome: 'NOVA FLORESTA', codigo_ibge: 2510105, codigo_uf: 25 },
    { id: 1371, nome: 'NOVA OLINDA', codigo_ibge: 2510204, codigo_uf: 25 },
    { id: 1372, nome: 'NOVA PALMEIRA', codigo_ibge: 2510303, codigo_uf: 25 },
    { id: 1373, nome: 'OLHO D AGUA', codigo_ibge: 2510402, codigo_uf: 25 },
    { id: 1374, nome: 'OLIVEDOS', codigo_ibge: 2510501, codigo_uf: 25 },
    { id: 1375, nome: 'OURO VELHO', codigo_ibge: 2510600, codigo_uf: 25 },
    { id: 1376, nome: 'PARARI', codigo_ibge: 2510659, codigo_uf: 25 },
    { id: 1377, nome: 'PASSAGEM', codigo_ibge: 2510709, codigo_uf: 25 },
    { id: 1378, nome: 'PATOS', codigo_ibge: 2510808, codigo_uf: 25 },
    { id: 1379, nome: 'PAULISTA', codigo_ibge: 2510907, codigo_uf: 25 },
    { id: 1380, nome: 'PEDRA BRANCA', codigo_ibge: 2511004, codigo_uf: 25 },
    { id: 1381, nome: 'PEDRA LAVRADA', codigo_ibge: 2511103, codigo_uf: 25 },
    { id: 1382, nome: 'PEDRAS DE FOGO', codigo_ibge: 2511202, codigo_uf: 25 },
    { id: 1400, nome: 'PEDRO REGIS', codigo_ibge: 2512721, codigo_uf: 25 },
    { id: 1383, nome: 'PIANCO', codigo_ibge: 2511301, codigo_uf: 25 },
    { id: 1384, nome: 'PICUI', codigo_ibge: 2511400, codigo_uf: 25 },
    { id: 1385, nome: 'PILAR', codigo_ibge: 2511509, codigo_uf: 25 },
    { id: 1386, nome: 'PILOES', codigo_ibge: 2511608, codigo_uf: 25 },
    { id: 1387, nome: 'PILOEZINHOS', codigo_ibge: 2511707, codigo_uf: 25 },
    { id: 1388, nome: 'PIRPIRITUBA', codigo_ibge: 2511806, codigo_uf: 25 },
    { id: 1389, nome: 'PITIMBU', codigo_ibge: 2511905, codigo_uf: 25 },
    { id: 1390, nome: 'POCINHOS', codigo_ibge: 2512002, codigo_uf: 25 },
    { id: 1391, nome: 'POCO DANTAS', codigo_ibge: 2512036, codigo_uf: 25 },
    { id: 1392, nome: 'POCO DE JOSE DE MOURA', codigo_ibge: 2512077, codigo_uf: 25 },
    { id: 1393, nome: 'POMBAL', codigo_ibge: 2512101, codigo_uf: 25 },
    { id: 1394, nome: 'PRATA', codigo_ibge: 2512200, codigo_uf: 25 },
    { id: 1395, nome: 'PRINCESA ISABEL', codigo_ibge: 2512309, codigo_uf: 25 },
    { id: 1396, nome: 'PUXINANA', codigo_ibge: 2512408, codigo_uf: 25 },
    { id: 1397, nome: 'QUEIMADAS', codigo_ibge: 2512507, codigo_uf: 25 },
    { id: 1398, nome: 'QUIXABA', codigo_ibge: 2512606, codigo_uf: 25 },
    { id: 1399, nome: 'REMIGIO', codigo_ibge: 2512705, codigo_uf: 25 },
    { id: 1401, nome: 'RIACHAO', codigo_ibge: 2512747, codigo_uf: 25 },
    { id: 1402, nome: 'RIACHAO DO BACAMARTE', codigo_ibge: 2512754, codigo_uf: 25 },
    { id: 1403, nome: 'RIACHAO DO POCO', codigo_ibge: 2512762, codigo_uf: 25 },
    { id: 1404, nome: 'RIACHO DE SANTO ANTONIO', codigo_ibge: 2512788, codigo_uf: 25 },
    { id: 1405, nome: 'RIACHO DOS CAVALOS', codigo_ibge: 2512804, codigo_uf: 25 },
    { id: 1406, nome: 'RIO TINTO', codigo_ibge: 2512903, codigo_uf: 25 },
    { id: 1407, nome: 'SALGADINHO', codigo_ibge: 2513000, codigo_uf: 25 },
    { id: 1408, nome: 'SALGADO DE SAO FELIX', codigo_ibge: 2513109, codigo_uf: 25 },
    { id: 1409, nome: 'SANTA CECILIA', codigo_ibge: 2513158, codigo_uf: 25 },
    { id: 1410, nome: 'SANTA CRUZ', codigo_ibge: 2513208, codigo_uf: 25 },
    { id: 1411, nome: 'SANTA HELENA', codigo_ibge: 2513307, codigo_uf: 25 },
    { id: 1412, nome: 'SANTA INES', codigo_ibge: 2513356, codigo_uf: 25 },
    { id: 1413, nome: 'SANTA LUZIA', codigo_ibge: 2513406, codigo_uf: 25 },
    { id: 1417, nome: 'SANTA RITA', codigo_ibge: 2513703, codigo_uf: 25 },
    { id: 1418, nome: 'SANTA TERESINHA', codigo_ibge: 2513802, codigo_uf: 25 },
    { id: 1414, nome: 'SANTANA DE MANGUEIRA', codigo_ibge: 2513505, codigo_uf: 25 },
    { id: 1415, nome: 'SANTANA DOS GARROTES', codigo_ibge: 2513604, codigo_uf: 25 },
    { id: 1419, nome: 'SANTO ANDRE', codigo_ibge: 2513851, codigo_uf: 25 },
    { id: 1421, nome: 'SAO BENTINHO', codigo_ibge: 2513927, codigo_uf: 25 },
    { id: 1420, nome: 'SAO BENTO', codigo_ibge: 2513901, codigo_uf: 25 },
    { id: 1423, nome: 'SAO DOMINGOS', codigo_ibge: 2513968, codigo_uf: 25 },
    { id: 1422, nome: 'SAO DOMINGOS DO CARIRI', codigo_ibge: 2513943, codigo_uf: 25 },
    { id: 1424, nome: 'SAO FRANCISCO', codigo_ibge: 2513984, codigo_uf: 25 },
    { id: 1425, nome: 'SAO JOAO DO CARIRI', codigo_ibge: 2514008, codigo_uf: 25 },
    { id: 1251, nome: 'SAO JOAO DO RIO DO PEIXE', codigo_ibge: 2500700, codigo_uf: 25 },
    { id: 1426, nome: 'SAO JOAO DO TIGRE', codigo_ibge: 2514107, codigo_uf: 25 },
    { id: 1427, nome: 'SAO JOSE DA LAGOA TAPADA', codigo_ibge: 2514206, codigo_uf: 25 },
    { id: 1428, nome: 'SAO JOSE DE CAIANA', codigo_ibge: 2514305, codigo_uf: 25 },
    { id: 1429, nome: 'SAO JOSE DE ESPINHARAS', codigo_ibge: 2514404, codigo_uf: 25 },
    { id: 1431, nome: 'SAO JOSE DE PIRANHAS', codigo_ibge: 2514503, codigo_uf: 25 },
    { id: 1432, nome: 'SAO JOSE DE PRINCESA', codigo_ibge: 2514552, codigo_uf: 25 },
    { id: 1433, nome: 'SAO JOSE DO BONFIM', codigo_ibge: 2514602, codigo_uf: 25 },
    { id: 1434, nome: 'SAO JOSE DO BREJO DO CRUZ', codigo_ibge: 2514651, codigo_uf: 25 },
    { id: 1435, nome: 'SAO JOSE DO SABUGI', codigo_ibge: 2514701, codigo_uf: 25 },
    { id: 1436, nome: 'SAO JOSE DOS CORDEIROS', codigo_ibge: 2514800, codigo_uf: 25 },
    { id: 1430, nome: 'SAO JOSE DOS RAMOS', codigo_ibge: 2514453, codigo_uf: 25 },
    { id: 1437, nome: 'SAO MAMEDE', codigo_ibge: 2514909, codigo_uf: 25 },
    { id: 1438, nome: 'SAO MIGUEL DE TAIPU', codigo_ibge: 2515005, codigo_uf: 25 },
    { id: 1439, nome: 'SAO SEBASTIAO DE LAGOA DE ROCA', codigo_ibge: 2515104, codigo_uf: 25 },
    { id: 1440, nome: 'SAO SEBASTIAO DO UMBUZEIRO', codigo_ibge: 2515203, codigo_uf: 25 },
    { id: 1442, nome: 'SAO VICENTE DO SERIDO', codigo_ibge: 2515401, codigo_uf: 25 },
    { id: 1441, nome: 'SAPE', codigo_ibge: 2515302, codigo_uf: 25 },
    { id: 1443, nome: 'SERRA BRANCA', codigo_ibge: 2515500, codigo_uf: 25 },
    { id: 1444, nome: 'SERRA DA RAIZ', codigo_ibge: 2515609, codigo_uf: 25 },
    { id: 1445, nome: 'SERRA GRANDE', codigo_ibge: 2515708, codigo_uf: 25 },
    { id: 1446, nome: 'SERRA REDONDA', codigo_ibge: 2515807, codigo_uf: 25 },
    { id: 1447, nome: 'SERRARIA', codigo_ibge: 2515906, codigo_uf: 25 },
    { id: 1448, nome: 'SERTAOZINHO', codigo_ibge: 2515930, codigo_uf: 25 },
    { id: 1449, nome: 'SOBRADO', codigo_ibge: 2515971, codigo_uf: 25 },
    { id: 1450, nome: 'SOLANEA', codigo_ibge: 2516003, codigo_uf: 25 },
    { id: 1451, nome: 'SOLEDADE', codigo_ibge: 2516102, codigo_uf: 25 },
    { id: 1452, nome: 'SOSSEGO', codigo_ibge: 2516151, codigo_uf: 25 },
    { id: 1453, nome: 'SOUSA', codigo_ibge: 2516201, codigo_uf: 25 },
    { id: 1454, nome: 'SUME', codigo_ibge: 2516300, codigo_uf: 25 },
    { id: 1455, nome: 'TACIMA', codigo_ibge: 2516409, codigo_uf: 25 },
    { id: 1456, nome: 'TAPEROA', codigo_ibge: 2516508, codigo_uf: 25 },
    { id: 1457, nome: 'TAVARES', codigo_ibge: 2516607, codigo_uf: 25 },
    { id: 1458, nome: 'TEIXEIRA', codigo_ibge: 2516706, codigo_uf: 25 },
    { id: 1459, nome: 'TENORIO', codigo_ibge: 2516755, codigo_uf: 25 },
    { id: 1460, nome: 'TRIUNFO', codigo_ibge: 2516805, codigo_uf: 25 },
    { id: 1461, nome: 'UIRAUNA', codigo_ibge: 2516904, codigo_uf: 25 },
    { id: 1462, nome: 'UMBUZEIRO', codigo_ibge: 2517001, codigo_uf: 25 },
    { id: 1463, nome: 'VARZEA', codigo_ibge: 2517100, codigo_uf: 25 },
    { id: 1464, nome: 'VIEIROPOLIS', codigo_ibge: 2517209, codigo_uf: 25 },
    { id: 1317, nome: 'VISTA SERRANA', codigo_ibge: 2505501, codigo_uf: 25 },
    { id: 1465, nome: 'ZABELE', codigo_ibge: 2517407, codigo_uf: 25 },
    { id: 1466, nome: 'ABREU E LIMA', codigo_ibge: 2600054, codigo_uf: 26 },
    { id: 1467, nome: 'AFOGADOS DA INGAZEIRA', codigo_ibge: 2600104, codigo_uf: 26 },
    { id: 1468, nome: 'AFRANIO', codigo_ibge: 2600203, codigo_uf: 26 },
    { id: 1469, nome: 'AGRESTINA', codigo_ibge: 2600302, codigo_uf: 26 },
    { id: 1470, nome: 'AGUA PRETA', codigo_ibge: 2600401, codigo_uf: 26 },
    { id: 1471, nome: 'AGUAS BELAS', codigo_ibge: 2600500, codigo_uf: 26 },
    { id: 1472, nome: 'ALAGOINHA', codigo_ibge: 2600609, codigo_uf: 26 },
    { id: 1473, nome: 'ALIANCA', codigo_ibge: 2600708, codigo_uf: 26 },
    { id: 1474, nome: 'ALTINHO', codigo_ibge: 2600807, codigo_uf: 26 },
    { id: 1475, nome: 'AMARAJI', codigo_ibge: 2600906, codigo_uf: 26 },
    { id: 1476, nome: 'ANGELIM', codigo_ibge: 2601003, codigo_uf: 26 },
    { id: 1477, nome: 'ARACOIABA', codigo_ibge: 2601052, codigo_uf: 26 },
    { id: 1478, nome: 'ARARIPINA', codigo_ibge: 2601102, codigo_uf: 26 },
    { id: 1479, nome: 'ARCOVERDE', codigo_ibge: 2601201, codigo_uf: 26 },
    { id: 1480, nome: 'BARRA DE GUABIRABA', codigo_ibge: 2601300, codigo_uf: 26 },
    { id: 1481, nome: 'BARREIROS', codigo_ibge: 2601409, codigo_uf: 26 },
    { id: 1482, nome: 'BELEM DE MARIA', codigo_ibge: 2601508, codigo_uf: 26 },
    { id: 1483, nome: 'BELEM DO SAO FRANCISCO', codigo_ibge: 2601607, codigo_uf: 26 },
    { id: 1484, nome: 'BELO JARDIM', codigo_ibge: 2601706, codigo_uf: 26 },
    { id: 1485, nome: 'BETANIA', codigo_ibge: 2601805, codigo_uf: 26 },
    { id: 1486, nome: 'BEZERROS', codigo_ibge: 2601904, codigo_uf: 26 },
    { id: 1487, nome: 'BODOCO', codigo_ibge: 2602001, codigo_uf: 26 },
    { id: 1488, nome: 'BOM CONSELHO', codigo_ibge: 2602100, codigo_uf: 26 },
    { id: 1489, nome: 'BOM JARDIM', codigo_ibge: 2602209, codigo_uf: 26 },
    { id: 1490, nome: 'BONITO', codigo_ibge: 2602308, codigo_uf: 26 },
    { id: 1491, nome: 'BREJAO', codigo_ibge: 2602407, codigo_uf: 26 },
    { id: 1492, nome: 'BREJINHO', codigo_ibge: 2602506, codigo_uf: 26 },
    { id: 1493, nome: 'BREJO DA MADRE DE DEUS', codigo_ibge: 2602605, codigo_uf: 26 },
    { id: 1494, nome: 'BUENOS AIRES', codigo_ibge: 2602704, codigo_uf: 26 },
    { id: 1495, nome: 'BUIQUE', codigo_ibge: 2602803, codigo_uf: 26 },
    { id: 1496, nome: 'CABO DE SANTO AGOSTINHO', codigo_ibge: 2602902, codigo_uf: 26 },
    { id: 1497, nome: 'CABROBO', codigo_ibge: 2603009, codigo_uf: 26 },
    { id: 1498, nome: 'CACHOEIRINHA', codigo_ibge: 2603108, codigo_uf: 26 },
    { id: 1499, nome: 'CAETES', codigo_ibge: 2603207, codigo_uf: 26 },
    { id: 1500, nome: 'CALCADO', codigo_ibge: 2603306, codigo_uf: 26 },
    { id: 1501, nome: 'CALUMBI', codigo_ibge: 2603405, codigo_uf: 26 },
    { id: 1502, nome: 'CAMARAGIBE', codigo_ibge: 2603454, codigo_uf: 26 },
    { id: 1503, nome: 'CAMOCIM DE SAO FELIX', codigo_ibge: 2603504, codigo_uf: 26 },
    { id: 1504, nome: 'CAMUTANGA', codigo_ibge: 2603603, codigo_uf: 26 },
    { id: 1505, nome: 'CANHOTINHO', codigo_ibge: 2603702, codigo_uf: 26 },
    { id: 1506, nome: 'CAPOEIRAS', codigo_ibge: 2603801, codigo_uf: 26 },
    { id: 1507, nome: 'CARNAIBA', codigo_ibge: 2603900, codigo_uf: 26 },
    { id: 1508, nome: 'CARNAUBEIRA DA PENHA', codigo_ibge: 2603926, codigo_uf: 26 },
    { id: 1509, nome: 'CARPINA', codigo_ibge: 2604007, codigo_uf: 26 },
    { id: 1510, nome: 'CARUARU', codigo_ibge: 2604106, codigo_uf: 26 },
    { id: 1511, nome: 'CASINHAS', codigo_ibge: 2604155, codigo_uf: 26 },
    { id: 1512, nome: 'CATENDE', codigo_ibge: 2604205, codigo_uf: 26 },
    { id: 1513, nome: 'CEDRO', codigo_ibge: 2604304, codigo_uf: 26 },
    { id: 1514, nome: 'CHA DE ALEGRIA', codigo_ibge: 2604403, codigo_uf: 26 },
    { id: 1515, nome: 'CHA GRANDE', codigo_ibge: 2604502, codigo_uf: 26 },
    { id: 1516, nome: 'CONDADO', codigo_ibge: 2604601, codigo_uf: 26 },
    { id: 1517, nome: 'CORRENTES', codigo_ibge: 2604700, codigo_uf: 26 },
    { id: 1518, nome: 'CORTES', codigo_ibge: 2604809, codigo_uf: 26 },
    { id: 1519, nome: 'CUMARU', codigo_ibge: 2604908, codigo_uf: 26 },
    { id: 1520, nome: 'CUPIRA', codigo_ibge: 2605004, codigo_uf: 26 },
    { id: 1521, nome: 'CUSTODIA', codigo_ibge: 2605103, codigo_uf: 26 },
    { id: 1522, nome: 'DORMENTES', codigo_ibge: 2605152, codigo_uf: 26 },
    { id: 1523, nome: 'ESCADA', codigo_ibge: 2605202, codigo_uf: 26 },
    { id: 1524, nome: 'EXU', codigo_ibge: 2605301, codigo_uf: 26 },
    { id: 1525, nome: 'FEIRA NOVA', codigo_ibge: 2605400, codigo_uf: 26 },
    { id: 1526, nome: 'FERNANDO DE NORONHA', codigo_ibge: 2605459, codigo_uf: 26 },
    { id: 1527, nome: 'FERREIROS', codigo_ibge: 2605509, codigo_uf: 26 },
    { id: 1528, nome: 'FLORES', codigo_ibge: 2605608, codigo_uf: 26 },
    { id: 1529, nome: 'FLORESTA', codigo_ibge: 2605707, codigo_uf: 26 },
    { id: 1530, nome: 'FREI MIGUELINHO', codigo_ibge: 2605806, codigo_uf: 26 },
    { id: 1531, nome: 'GAMELEIRA', codigo_ibge: 2605905, codigo_uf: 26 },
    { id: 1532, nome: 'GARANHUNS', codigo_ibge: 2606002, codigo_uf: 26 },
    { id: 1533, nome: 'GLORIA DO GOITA', codigo_ibge: 2606101, codigo_uf: 26 },
    { id: 1534, nome: 'GOIANA', codigo_ibge: 2606200, codigo_uf: 26 },
    { id: 1535, nome: 'GRANITO', codigo_ibge: 2606309, codigo_uf: 26 },
    { id: 1536, nome: 'GRAVATA', codigo_ibge: 2606408, codigo_uf: 26 },
    { id: 1537, nome: 'IATI', codigo_ibge: 2606507, codigo_uf: 26 },
    { id: 1538, nome: 'IBIMIRIM', codigo_ibge: 2606606, codigo_uf: 26 },
    { id: 1539, nome: 'IBIRAJUBA', codigo_ibge: 2606705, codigo_uf: 26 },
    { id: 1540, nome: 'IGARASSU', codigo_ibge: 2606804, codigo_uf: 26 },
    { id: 1541, nome: 'IGUARACY', codigo_ibge: 2606903, codigo_uf: 26 },
    { id: 1548, nome: 'ILHA DE ITAMARACA', codigo_ibge: 2607604, codigo_uf: 26 },
    { id: 1542, nome: 'INAJA', codigo_ibge: 2607000, codigo_uf: 26 },
    { id: 1543, nome: 'INGAZEIRA', codigo_ibge: 2607109, codigo_uf: 26 },
    { id: 1544, nome: 'IPOJUCA', codigo_ibge: 2607208, codigo_uf: 26 },
    { id: 1545, nome: 'IPUBI', codigo_ibge: 2607307, codigo_uf: 26 },
    { id: 1546, nome: 'ITACURUBA', codigo_ibge: 2607406, codigo_uf: 26 },
    { id: 1547, nome: 'ITAIBA', codigo_ibge: 2607505, codigo_uf: 26 },
    { id: 1549, nome: 'ITAMBE', codigo_ibge: 2607653, codigo_uf: 26 },
    { id: 1550, nome: 'ITAPETIM', codigo_ibge: 2607703, codigo_uf: 26 },
    { id: 1551, nome: 'ITAPISSUMA', codigo_ibge: 2607752, codigo_uf: 26 },
    { id: 1552, nome: 'ITAQUITINGA', codigo_ibge: 2607802, codigo_uf: 26 },
    { id: 1553, nome: 'JABOATAO DOS GUARARAPES', codigo_ibge: 2607901, codigo_uf: 26 },
    { id: 1554, nome: 'JAQUEIRA', codigo_ibge: 2607950, codigo_uf: 26 },
    { id: 1555, nome: 'JATAUBA', codigo_ibge: 2608008, codigo_uf: 26 },
    { id: 1556, nome: 'JATOBA', codigo_ibge: 2608057, codigo_uf: 26 },
    { id: 1557, nome: 'JOAO ALFREDO', codigo_ibge: 2608107, codigo_uf: 26 },
    { id: 1558, nome: 'JOAQUIM NABUCO', codigo_ibge: 2608206, codigo_uf: 26 },
    { id: 1559, nome: 'JUCATI', codigo_ibge: 2608255, codigo_uf: 26 },
    { id: 1560, nome: 'JUPI', codigo_ibge: 2608305, codigo_uf: 26 },
    { id: 1561, nome: 'JUREMA', codigo_ibge: 2608404, codigo_uf: 26 },
    { id: 1563, nome: 'LAGOA DE ITAENGA', codigo_ibge: 2608503, codigo_uf: 26 },
    { id: 1562, nome: 'LAGOA DO CARRO', codigo_ibge: 2608453, codigo_uf: 26 },
    { id: 1564, nome: 'LAGOA DO OURO', codigo_ibge: 2608602, codigo_uf: 26 },
    { id: 1565, nome: 'LAGOA DOS GATOS', codigo_ibge: 2608701, codigo_uf: 26 },
    { id: 1566, nome: 'LAGOA GRANDE', codigo_ibge: 2608750, codigo_uf: 26 },
    { id: 1567, nome: 'LAJEDO', codigo_ibge: 2608800, codigo_uf: 26 },
    { id: 1568, nome: 'LIMOEIRO', codigo_ibge: 2608909, codigo_uf: 26 },
    { id: 1569, nome: 'MACAPARANA', codigo_ibge: 2609006, codigo_uf: 26 },
    { id: 1570, nome: 'MACHADOS', codigo_ibge: 2609105, codigo_uf: 26 },
    { id: 1571, nome: 'MANARI', codigo_ibge: 2609154, codigo_uf: 26 },
    { id: 1572, nome: 'MARAIAL', codigo_ibge: 2609204, codigo_uf: 26 },
    { id: 1573, nome: 'MIRANDIBA', codigo_ibge: 2609303, codigo_uf: 26 },
    { id: 1627, nome: 'MOREILANDIA', codigo_ibge: 2614303, codigo_uf: 26 },
    { id: 1574, nome: 'MORENO', codigo_ibge: 2609402, codigo_uf: 26 },
    { id: 1575, nome: 'NAZARE DA MATA', codigo_ibge: 2609501, codigo_uf: 26 },
    { id: 1576, nome: 'OLINDA', codigo_ibge: 2609600, codigo_uf: 26 },
    { id: 1577, nome: 'OROBO', codigo_ibge: 2609709, codigo_uf: 26 },
    { id: 1578, nome: 'OROCO', codigo_ibge: 2609808, codigo_uf: 26 },
    { id: 1579, nome: 'OURICURI', codigo_ibge: 2609907, codigo_uf: 26 },
    { id: 1580, nome: 'PALMARES', codigo_ibge: 2610004, codigo_uf: 26 },
    { id: 1581, nome: 'PALMEIRINA', codigo_ibge: 2610103, codigo_uf: 26 },
    { id: 1582, nome: 'PANELAS', codigo_ibge: 2610202, codigo_uf: 26 },
    { id: 1583, nome: 'PARANATAMA', codigo_ibge: 2610301, codigo_uf: 26 },
    { id: 1584, nome: 'PARNAMIRIM', codigo_ibge: 2610400, codigo_uf: 26 },
    { id: 1585, nome: 'PASSIRA', codigo_ibge: 2610509, codigo_uf: 26 },
    { id: 1586, nome: 'PAUDALHO', codigo_ibge: 2610608, codigo_uf: 26 },
    { id: 1587, nome: 'PAULISTA', codigo_ibge: 2610707, codigo_uf: 26 },
    { id: 1588, nome: 'PEDRA', codigo_ibge: 2610806, codigo_uf: 26 },
    { id: 1589, nome: 'PESQUEIRA', codigo_ibge: 2610905, codigo_uf: 26 },
    { id: 1590, nome: 'PETROLANDIA', codigo_ibge: 2611002, codigo_uf: 26 },
    { id: 1591, nome: 'PETROLINA', codigo_ibge: 2611101, codigo_uf: 26 },
    { id: 1592, nome: 'POCAO', codigo_ibge: 2611200, codigo_uf: 26 },
    { id: 1593, nome: 'POMBOS', codigo_ibge: 2611309, codigo_uf: 26 },
    { id: 1594, nome: 'PRIMAVERA', codigo_ibge: 2611408, codigo_uf: 26 },
    { id: 1595, nome: 'QUIPAPA', codigo_ibge: 2611507, codigo_uf: 26 },
    { id: 1596, nome: 'QUIXABA', codigo_ibge: 2611533, codigo_uf: 26 },
    { id: 1597, nome: 'RECIFE', codigo_ibge: 2611606, codigo_uf: 26 },
    { id: 1598, nome: 'RIACHO DAS ALMAS', codigo_ibge: 2611705, codigo_uf: 26 },
    { id: 1599, nome: 'RIBEIRAO', codigo_ibge: 2611804, codigo_uf: 26 },
    { id: 1600, nome: 'RIO FORMOSO', codigo_ibge: 2611903, codigo_uf: 26 },
    { id: 1601, nome: 'SAIRE', codigo_ibge: 2612000, codigo_uf: 26 },
    { id: 1602, nome: 'SALGADINHO', codigo_ibge: 2612109, codigo_uf: 26 },
    { id: 1603, nome: 'SALGUEIRO', codigo_ibge: 2612208, codigo_uf: 26 },
    { id: 1604, nome: 'SALOA', codigo_ibge: 2612307, codigo_uf: 26 },
    { id: 1605, nome: 'SANHARO', codigo_ibge: 2612406, codigo_uf: 26 },
    { id: 1606, nome: 'SANTA CRUZ', codigo_ibge: 2612455, codigo_uf: 26 },
    { id: 1607, nome: 'SANTA CRUZ DA BAIXA VERDE', codigo_ibge: 2612471, codigo_uf: 26 },
    { id: 1608, nome: 'SANTA CRUZ DO CAPIBARIBE', codigo_ibge: 2612505, codigo_uf: 26 },
    { id: 1609, nome: 'SANTA FILOMENA', codigo_ibge: 2612554, codigo_uf: 26 },
    { id: 1610, nome: 'SANTA MARIA DA BOA VISTA', codigo_ibge: 2612604, codigo_uf: 26 },
    { id: 1611, nome: 'SANTA MARIA DO CAMBUCA', codigo_ibge: 2612703, codigo_uf: 26 },
    { id: 1612, nome: 'SANTA TEREZINHA', codigo_ibge: 2612802, codigo_uf: 26 },
    { id: 1613, nome: 'SAO BENEDITO DO SUL', codigo_ibge: 2612901, codigo_uf: 26 },
    { id: 1614, nome: 'SAO BENTO DO UNA', codigo_ibge: 2613008, codigo_uf: 26 },
    { id: 1615, nome: 'SAO CAETANO', codigo_ibge: 2613107, codigo_uf: 26 },
    { id: 1616, nome: 'SAO JOAO', codigo_ibge: 2613206, codigo_uf: 26 },
    { id: 1617, nome: 'SAO JOAQUIM DO MONTE', codigo_ibge: 2613305, codigo_uf: 26 },
    { id: 1618, nome: 'SAO JOSE DA COROA GRANDE', codigo_ibge: 2613404, codigo_uf: 26 },
    { id: 1619, nome: 'SAO JOSE DO BELMONTE', codigo_ibge: 2613503, codigo_uf: 26 },
    { id: 1620, nome: 'SAO JOSE DO EGITO', codigo_ibge: 2613602, codigo_uf: 26 },
    { id: 1621, nome: 'SAO LOURENCO DA MATA', codigo_ibge: 2613701, codigo_uf: 26 },
    { id: 1622, nome: 'SAO VICENTE FERRER', codigo_ibge: 2613800, codigo_uf: 26 },
    { id: 1623, nome: 'SERRA TALHADA', codigo_ibge: 2613909, codigo_uf: 26 },
    { id: 1624, nome: 'SERRITA', codigo_ibge: 2614006, codigo_uf: 26 },
    { id: 1625, nome: 'SERTANIA', codigo_ibge: 2614105, codigo_uf: 26 },
    { id: 1626, nome: 'SIRINHAEM', codigo_ibge: 2614204, codigo_uf: 26 },
    { id: 1628, nome: 'SOLIDAO', codigo_ibge: 2614402, codigo_uf: 26 },
    { id: 1629, nome: 'SURUBIM', codigo_ibge: 2614501, codigo_uf: 26 },
    { id: 1630, nome: 'TABIRA', codigo_ibge: 2614600, codigo_uf: 26 },
    { id: 1631, nome: 'TACAIMBO', codigo_ibge: 2614709, codigo_uf: 26 },
    { id: 1632, nome: 'TACARATU', codigo_ibge: 2614808, codigo_uf: 26 },
    { id: 1633, nome: 'TAMANDARE', codigo_ibge: 2614857, codigo_uf: 26 },
    { id: 1634, nome: 'TAQUARITINGA DO NORTE', codigo_ibge: 2615003, codigo_uf: 26 },
    { id: 1635, nome: 'TEREZINHA', codigo_ibge: 2615102, codigo_uf: 26 },
    { id: 1636, nome: 'TERRA NOVA', codigo_ibge: 2615201, codigo_uf: 26 },
    { id: 1637, nome: 'TIMBAUBA', codigo_ibge: 2615300, codigo_uf: 26 },
    { id: 1638, nome: 'TORITAMA', codigo_ibge: 2615409, codigo_uf: 26 },
    { id: 1639, nome: 'TRACUNHAEM', codigo_ibge: 2615508, codigo_uf: 26 },
    { id: 1640, nome: 'TRINDADE', codigo_ibge: 2615607, codigo_uf: 26 },
    { id: 1641, nome: 'TRIUNFO', codigo_ibge: 2615706, codigo_uf: 26 },
    { id: 1642, nome: 'TUPANATINGA', codigo_ibge: 2615805, codigo_uf: 26 },
    { id: 1643, nome: 'TUPARETAMA', codigo_ibge: 2615904, codigo_uf: 26 },
    { id: 1644, nome: 'VENTUROSA', codigo_ibge: 2616001, codigo_uf: 26 },
    { id: 1645, nome: 'VERDEJANTE', codigo_ibge: 2616100, codigo_uf: 26 },
    { id: 1646, nome: 'VERTENTE DO LERIO', codigo_ibge: 2616183, codigo_uf: 26 },
    { id: 1647, nome: 'VERTENTES', codigo_ibge: 2616209, codigo_uf: 26 },
    { id: 1648, nome: 'VICENCIA', codigo_ibge: 2616308, codigo_uf: 26 },
    { id: 1649, nome: 'VITORIA DE SANTO ANTAO', codigo_ibge: 2616407, codigo_uf: 26 },
    { id: 1650, nome: 'XEXEU', codigo_ibge: 2616506, codigo_uf: 26 },
    { id: 1651, nome: 'AGUA BRANCA', codigo_ibge: 2700102, codigo_uf: 27 },
    { id: 1652, nome: 'ANADIA', codigo_ibge: 2700201, codigo_uf: 27 },
    { id: 1653, nome: 'ARAPIRACA', codigo_ibge: 2700300, codigo_uf: 27 },
    { id: 1654, nome: 'ATALAIA', codigo_ibge: 2700409, codigo_uf: 27 },
    { id: 1655, nome: 'BARRA DE SANTO ANTONIO', codigo_ibge: 2700508, codigo_uf: 27 },
    { id: 1656, nome: 'BARRA DE SAO MIGUEL', codigo_ibge: 2700607, codigo_uf: 27 },
    { id: 1657, nome: 'BATALHA', codigo_ibge: 2700706, codigo_uf: 27 },
    { id: 1658, nome: 'BELEM', codigo_ibge: 2700805, codigo_uf: 27 },
    { id: 1659, nome: 'BELO MONTE', codigo_ibge: 2700904, codigo_uf: 27 },
    { id: 1660, nome: 'BOCA DA MATA', codigo_ibge: 2701001, codigo_uf: 27 },
    { id: 1661, nome: 'BRANQUINHA', codigo_ibge: 2701100, codigo_uf: 27 },
    { id: 1662, nome: 'CACIMBINHAS', codigo_ibge: 2701209, codigo_uf: 27 },
    { id: 1663, nome: 'CAJUEIRO', codigo_ibge: 2701308, codigo_uf: 27 },
    { id: 1664, nome: 'CAMPESTRE', codigo_ibge: 2701357, codigo_uf: 27 },
    { id: 1665, nome: 'CAMPO ALEGRE', codigo_ibge: 2701407, codigo_uf: 27 },
    { id: 1666, nome: 'CAMPO GRANDE', codigo_ibge: 2701506, codigo_uf: 27 },
    { id: 1667, nome: 'CANAPI', codigo_ibge: 2701605, codigo_uf: 27 },
    { id: 1668, nome: 'CAPELA', codigo_ibge: 2701704, codigo_uf: 27 },
    { id: 1669, nome: 'CARNEIROS', codigo_ibge: 2701803, codigo_uf: 27 },
    { id: 1670, nome: 'CHA PRETA', codigo_ibge: 2701902, codigo_uf: 27 },
    { id: 1671, nome: 'COITE DO NOIA', codigo_ibge: 2702009, codigo_uf: 27 },
    { id: 1672, nome: 'COLONIA LEOPOLDINA', codigo_ibge: 2702108, codigo_uf: 27 },
    { id: 1673, nome: 'COQUEIRO SECO', codigo_ibge: 2702207, codigo_uf: 27 },
    { id: 1674, nome: 'CORURIPE', codigo_ibge: 2702306, codigo_uf: 27 },
    { id: 1675, nome: 'CRAIBAS', codigo_ibge: 2702355, codigo_uf: 27 },
    { id: 1676, nome: 'DELMIRO GOUVEIA', codigo_ibge: 2702405, codigo_uf: 27 },
    { id: 1677, nome: 'DOIS RIACHOS', codigo_ibge: 2702504, codigo_uf: 27 },
    { id: 1678, nome: 'ESTRELA DE ALAGOAS', codigo_ibge: 2702553, codigo_uf: 27 },
    { id: 1679, nome: 'FEIRA GRANDE', codigo_ibge: 2702603, codigo_uf: 27 },
    { id: 1680, nome: 'FELIZ DESERTO', codigo_ibge: 2702702, codigo_uf: 27 },
    { id: 1681, nome: 'FLEXEIRAS', codigo_ibge: 2702801, codigo_uf: 27 },
    { id: 1682, nome: 'GIRAU DO PONCIANO', codigo_ibge: 2702900, codigo_uf: 27 },
    { id: 1683, nome: 'IBATEGUARA', codigo_ibge: 2703007, codigo_uf: 27 },
    { id: 1684, nome: 'IGACI', codigo_ibge: 2703106, codigo_uf: 27 },
    { id: 1685, nome: 'IGREJA NOVA', codigo_ibge: 2703205, codigo_uf: 27 },
    { id: 1686, nome: 'INHAPI', codigo_ibge: 2703304, codigo_uf: 27 },
    { id: 1687, nome: 'JACARE DOS HOMENS', codigo_ibge: 2703403, codigo_uf: 27 },
    { id: 1688, nome: 'JACUIPE', codigo_ibge: 2703502, codigo_uf: 27 },
    { id: 1689, nome: 'JAPARATINGA', codigo_ibge: 2703601, codigo_uf: 27 },
    { id: 1690, nome: 'JARAMATAIA', codigo_ibge: 2703700, codigo_uf: 27 },
    { id: 1691, nome: 'JEQUIA DA PRAIA', codigo_ibge: 2703759, codigo_uf: 27 },
    { id: 1692, nome: 'JOAQUIM GOMES', codigo_ibge: 2703809, codigo_uf: 27 },
    { id: 1693, nome: 'JUNDIA', codigo_ibge: 2703908, codigo_uf: 27 },
    { id: 1694, nome: 'JUNQUEIRO', codigo_ibge: 2704005, codigo_uf: 27 },
    { id: 1695, nome: 'LAGOA DA CANOA', codigo_ibge: 2704104, codigo_uf: 27 },
    { id: 1696, nome: 'LIMOEIRO DE ANADIA', codigo_ibge: 2704203, codigo_uf: 27 },
    { id: 1697, nome: 'MACEIO', codigo_ibge: 2704302, codigo_uf: 27 },
    { id: 1698, nome: 'MAJOR ISIDORO', codigo_ibge: 2704401, codigo_uf: 27 },
    { id: 1703, nome: 'MAR VERMELHO', codigo_ibge: 2704906, codigo_uf: 27 },
    { id: 1699, nome: 'MARAGOGI', codigo_ibge: 2704500, codigo_uf: 27 },
    { id: 1700, nome: 'MARAVILHA', codigo_ibge: 2704609, codigo_uf: 27 },
    { id: 1701, nome: 'MARECHAL DEODORO', codigo_ibge: 2704708, codigo_uf: 27 },
    { id: 1702, nome: 'MARIBONDO', codigo_ibge: 2704807, codigo_uf: 27 },
    { id: 1704, nome: 'MATA GRANDE', codigo_ibge: 2705002, codigo_uf: 27 },
    { id: 1705, nome: 'MATRIZ DE CAMARAGIBE', codigo_ibge: 2705101, codigo_uf: 27 },
    { id: 1706, nome: 'MESSIAS', codigo_ibge: 2705200, codigo_uf: 27 },
    { id: 1707, nome: 'MINADOR DO NEGRAO', codigo_ibge: 2705309, codigo_uf: 27 },
    { id: 1708, nome: 'MONTEIROPOLIS', codigo_ibge: 2705408, codigo_uf: 27 },
    { id: 1709, nome: 'MURICI', codigo_ibge: 2705507, codigo_uf: 27 },
    { id: 1710, nome: 'NOVO LINO', codigo_ibge: 2705606, codigo_uf: 27 },
    { id: 1711, nome: 'OLHO D AGUA DAS FLORES', codigo_ibge: 2705705, codigo_uf: 27 },
    { id: 1712, nome: 'OLHO D AGUA DO CASADO', codigo_ibge: 2705804, codigo_uf: 27 },
    { id: 1713, nome: 'OLHO D AGUA GRANDE', codigo_ibge: 2705903, codigo_uf: 27 },
    { id: 1714, nome: 'OLIVENCA', codigo_ibge: 2706000, codigo_uf: 27 },
    { id: 1715, nome: 'OURO BRANCO', codigo_ibge: 2706109, codigo_uf: 27 },
    { id: 1716, nome: 'PALESTINA', codigo_ibge: 2706208, codigo_uf: 27 },
    { id: 1717, nome: 'PALMEIRA DOS INDIOS', codigo_ibge: 2706307, codigo_uf: 27 },
    { id: 1718, nome: 'PAO DE ACUCAR', codigo_ibge: 2706406, codigo_uf: 27 },
    { id: 1719, nome: 'PARICONHA', codigo_ibge: 2706422, codigo_uf: 27 },
    { id: 1720, nome: 'PARIPUEIRA', codigo_ibge: 2706448, codigo_uf: 27 },
    { id: 1721, nome: 'PASSO DE CAMARAGIBE', codigo_ibge: 2706505, codigo_uf: 27 },
    { id: 1722, nome: 'PAULO JACINTO', codigo_ibge: 2706604, codigo_uf: 27 },
    { id: 1723, nome: 'PENEDO', codigo_ibge: 2706703, codigo_uf: 27 },
    { id: 1724, nome: 'PIACABUCU', codigo_ibge: 2706802, codigo_uf: 27 },
    { id: 1725, nome: 'PILAR', codigo_ibge: 2706901, codigo_uf: 27 },
    { id: 1726, nome: 'PINDOBA', codigo_ibge: 2707008, codigo_uf: 27 },
    { id: 1727, nome: 'PIRANHAS', codigo_ibge: 2707107, codigo_uf: 27 },
    { id: 1728, nome: 'POCO DAS TRINCHEIRAS', codigo_ibge: 2707206, codigo_uf: 27 },
    { id: 1729, nome: 'PORTO CALVO', codigo_ibge: 2707305, codigo_uf: 27 },
    { id: 1730, nome: 'PORTO DE PEDRAS', codigo_ibge: 2707404, codigo_uf: 27 },
    { id: 1731, nome: 'PORTO REAL DO COLEGIO', codigo_ibge: 2707503, codigo_uf: 27 },
    { id: 1732, nome: 'QUEBRANGULO', codigo_ibge: 2707602, codigo_uf: 27 },
    { id: 1733, nome: 'RIO LARGO', codigo_ibge: 2707701, codigo_uf: 27 },
    { id: 1734, nome: 'ROTEIRO', codigo_ibge: 2707800, codigo_uf: 27 },
    { id: 1735, nome: 'SANTA LUZIA DO NORTE', codigo_ibge: 2707909, codigo_uf: 27 },
    { id: 1736, nome: 'SANTANA DO IPANEMA', codigo_ibge: 2708006, codigo_uf: 27 },
    { id: 1737, nome: 'SANTANA DO MUNDAU', codigo_ibge: 2708105, codigo_uf: 27 },
    { id: 1738, nome: 'SAO BRAS', codigo_ibge: 2708204, codigo_uf: 27 },
    { id: 1739, nome: 'SAO JOSE DA LAJE', codigo_ibge: 2708303, codigo_uf: 27 },
    { id: 1740, nome: 'SAO JOSE DA TAPERA', codigo_ibge: 2708402, codigo_uf: 27 },
    { id: 1741, nome: 'SAO LUIS DO QUITUNDE', codigo_ibge: 2708501, codigo_uf: 27 },
    { id: 1742, nome: 'SAO MIGUEL DOS CAMPOS', codigo_ibge: 2708600, codigo_uf: 27 },
    { id: 1743, nome: 'SAO MIGUEL DOS MILAGRES', codigo_ibge: 2708709, codigo_uf: 27 },
    { id: 1744, nome: 'SAO SEBASTIAO', codigo_ibge: 2708808, codigo_uf: 27 },
    { id: 1745, nome: 'SATUBA', codigo_ibge: 2708907, codigo_uf: 27 },
    { id: 1746, nome: 'SENADOR RUI PALMEIRA', codigo_ibge: 2708956, codigo_uf: 27 },
    { id: 1747, nome: 'TANQUE D ARCA', codigo_ibge: 2709004, codigo_uf: 27 },
    { id: 1748, nome: 'TAQUARANA', codigo_ibge: 2709103, codigo_uf: 27 },
    { id: 1749, nome: 'TEOTONIO VILELA', codigo_ibge: 2709152, codigo_uf: 27 },
    { id: 1750, nome: 'TRAIPU', codigo_ibge: 2709202, codigo_uf: 27 },
    { id: 1751, nome: 'UNIAO DOS PALMARES', codigo_ibge: 2709301, codigo_uf: 27 },
    { id: 1752, nome: 'VICOSA', codigo_ibge: 2709400, codigo_uf: 27 },
    { id: 1753, nome: 'AMPARO DE SAO FRANCISCO', codigo_ibge: 2800100, codigo_uf: 28 },
    { id: 1754, nome: 'AQUIDABA', codigo_ibge: 2800209, codigo_uf: 28 },
    { id: 1755, nome: 'ARACAJU', codigo_ibge: 2800308, codigo_uf: 28 },
    { id: 1756, nome: 'ARAUA', codigo_ibge: 2800407, codigo_uf: 28 },
    { id: 1757, nome: 'AREIA BRANCA', codigo_ibge: 2800506, codigo_uf: 28 },
    { id: 1758, nome: 'BARRA DOS COQUEIROS', codigo_ibge: 2800605, codigo_uf: 28 },
    { id: 1759, nome: 'BOQUIM', codigo_ibge: 2800670, codigo_uf: 28 },
    { id: 1760, nome: 'BREJO GRANDE', codigo_ibge: 2800704, codigo_uf: 28 },
    { id: 1761, nome: 'CAMPO DO BRITO', codigo_ibge: 2801009, codigo_uf: 28 },
    { id: 1762, nome: 'CANHOBA', codigo_ibge: 2801108, codigo_uf: 28 },
    { id: 1763, nome: 'CANINDE DE SAO FRANCISCO', codigo_ibge: 2801207, codigo_uf: 28 },
    { id: 1764, nome: 'CAPELA', codigo_ibge: 2801306, codigo_uf: 28 },
    { id: 1765, nome: 'CARIRA', codigo_ibge: 2801405, codigo_uf: 28 },
    { id: 1766, nome: 'CARMOPOLIS', codigo_ibge: 2801504, codigo_uf: 28 },
    { id: 1767, nome: 'CEDRO DE SAO JOAO', codigo_ibge: 2801603, codigo_uf: 28 },
    { id: 1768, nome: 'CRISTINAPOLIS', codigo_ibge: 2801702, codigo_uf: 28 },
    { id: 1769, nome: 'CUMBE', codigo_ibge: 2801900, codigo_uf: 28 },
    { id: 1770, nome: 'DIVINA PASTORA', codigo_ibge: 2802007, codigo_uf: 28 },
    { id: 1771, nome: 'ESTANCIA', codigo_ibge: 2802106, codigo_uf: 28 },
    { id: 1772, nome: 'FEIRA NOVA', codigo_ibge: 2802205, codigo_uf: 28 },
    { id: 1773, nome: 'FREI PAULO', codigo_ibge: 2802304, codigo_uf: 28 },
    { id: 1774, nome: 'GARARU', codigo_ibge: 2802403, codigo_uf: 28 },
    { id: 1775, nome: 'GENERAL MAYNARD', codigo_ibge: 2802502, codigo_uf: 28 },
    { id: 1776, nome: 'GRACHO CARDOSO', codigo_ibge: 2802601, codigo_uf: 28 },
    { id: 1777, nome: 'ILHA DAS FLORES', codigo_ibge: 2802700, codigo_uf: 28 },
    { id: 1778, nome: 'INDIAROBA', codigo_ibge: 2802809, codigo_uf: 28 },
    { id: 1779, nome: 'ITABAIANA', codigo_ibge: 2802908, codigo_uf: 28 },
    { id: 1780, nome: 'ITABAIANINHA', codigo_ibge: 2803005, codigo_uf: 28 },
    { id: 1781, nome: 'ITABI', codigo_ibge: 2803104, codigo_uf: 28 },
    { id: 1782, nome: 'ITAPORANGA D AJUDA', codigo_ibge: 2803203, codigo_uf: 28 },
    { id: 1783, nome: 'JAPARATUBA', codigo_ibge: 2803302, codigo_uf: 28 },
    { id: 1784, nome: 'JAPOATA', codigo_ibge: 2803401, codigo_uf: 28 },
    { id: 1785, nome: 'LAGARTO', codigo_ibge: 2803500, codigo_uf: 28 },
    { id: 1786, nome: 'LARANJEIRAS', codigo_ibge: 2803609, codigo_uf: 28 },
    { id: 1787, nome: 'MACAMBIRA', codigo_ibge: 2803708, codigo_uf: 28 },
    { id: 1788, nome: 'MALHADA DOS BOIS', codigo_ibge: 2803807, codigo_uf: 28 },
    { id: 1789, nome: 'MALHADOR', codigo_ibge: 2803906, codigo_uf: 28 },
    { id: 1790, nome: 'MARUIM', codigo_ibge: 2804003, codigo_uf: 28 },
    { id: 1791, nome: 'MOITA BONITA', codigo_ibge: 2804102, codigo_uf: 28 },
    { id: 1792, nome: 'MONTE ALEGRE DE SERGIPE', codigo_ibge: 2804201, codigo_uf: 28 },
    { id: 1793, nome: 'MURIBECA', codigo_ibge: 2804300, codigo_uf: 28 },
    { id: 1794, nome: 'NEOPOLIS', codigo_ibge: 2804409, codigo_uf: 28 },
    { id: 1795, nome: 'NOSSA SENHORA APARECIDA', codigo_ibge: 2804458, codigo_uf: 28 },
    { id: 1796, nome: 'NOSSA SENHORA DA GLORIA', codigo_ibge: 2804508, codigo_uf: 28 },
    { id: 1797, nome: 'NOSSA SENHORA DAS DORES', codigo_ibge: 2804607, codigo_uf: 28 },
    { id: 1798, nome: 'NOSSA SENHORA DE LOURDES', codigo_ibge: 2804706, codigo_uf: 28 },
    { id: 1799, nome: 'NOSSA SENHORA DO SOCORRO', codigo_ibge: 2804805, codigo_uf: 28 },
    { id: 1800, nome: 'PACATUBA', codigo_ibge: 2804904, codigo_uf: 28 },
    { id: 1801, nome: 'PEDRA MOLE', codigo_ibge: 2805000, codigo_uf: 28 },
    { id: 1802, nome: 'PEDRINHAS', codigo_ibge: 2805109, codigo_uf: 28 },
    { id: 1803, nome: 'PINHAO', codigo_ibge: 2805208, codigo_uf: 28 },
    { id: 1804, nome: 'PIRAMBU', codigo_ibge: 2805307, codigo_uf: 28 },
    { id: 1805, nome: 'POCO REDONDO', codigo_ibge: 2805406, codigo_uf: 28 },
    { id: 1806, nome: 'POCO VERDE', codigo_ibge: 2805505, codigo_uf: 28 },
    { id: 1807, nome: 'PORTO DA FOLHA', codigo_ibge: 2805604, codigo_uf: 28 },
    { id: 1808, nome: 'PROPRIA', codigo_ibge: 2805703, codigo_uf: 28 },
    { id: 1809, nome: 'RIACHAO DO DANTAS', codigo_ibge: 2805802, codigo_uf: 28 },
    { id: 1810, nome: 'RIACHUELO', codigo_ibge: 2805901, codigo_uf: 28 },
    { id: 1811, nome: 'RIBEIROPOLIS', codigo_ibge: 2806008, codigo_uf: 28 },
    { id: 1812, nome: 'ROSARIO DO CATETE', codigo_ibge: 2806107, codigo_uf: 28 },
    { id: 1813, nome: 'SALGADO', codigo_ibge: 2806206, codigo_uf: 28 },
    { id: 1814, nome: 'SANTA LUZIA DO ITANHY', codigo_ibge: 2806305, codigo_uf: 28 },
    { id: 1816, nome: 'SANTA ROSA DE LIMA', codigo_ibge: 2806503, codigo_uf: 28 },
    { id: 1815, nome: 'SANTANA DO SAO FRANCISCO', codigo_ibge: 2806404, codigo_uf: 28 },
    { id: 1817, nome: 'SANTO AMARO DAS BROTAS', codigo_ibge: 2806602, codigo_uf: 28 },
    { id: 1818, nome: 'SAO CRISTOVAO', codigo_ibge: 2806701, codigo_uf: 28 },
    { id: 1819, nome: 'SAO DOMINGOS', codigo_ibge: 2806800, codigo_uf: 28 },
    { id: 1820, nome: 'SAO FRANCISCO', codigo_ibge: 2806909, codigo_uf: 28 },
    { id: 1821, nome: 'SAO MIGUEL DO ALEIXO', codigo_ibge: 2807006, codigo_uf: 28 },
    { id: 1822, nome: 'SIMAO DIAS', codigo_ibge: 2807105, codigo_uf: 28 },
    { id: 1823, nome: 'SIRIRI', codigo_ibge: 2807204, codigo_uf: 28 },
    { id: 1824, nome: 'TELHA', codigo_ibge: 2807303, codigo_uf: 28 },
    { id: 1825, nome: 'TOBIAS BARRETO', codigo_ibge: 2807402, codigo_uf: 28 },
    { id: 1826, nome: 'TOMAR DO GERU', codigo_ibge: 2807501, codigo_uf: 28 },
    { id: 1827, nome: 'UMBAUBA', codigo_ibge: 2807600, codigo_uf: 28 },
    { id: 1828, nome: 'ABAIRA', codigo_ibge: 2900108, codigo_uf: 29 },
    { id: 1829, nome: 'ABARE', codigo_ibge: 2900207, codigo_uf: 29 },
    { id: 1830, nome: 'ACAJUTIBA', codigo_ibge: 2900306, codigo_uf: 29 },
    { id: 1831, nome: 'ADUSTINA', codigo_ibge: 2900355, codigo_uf: 29 },
    { id: 1832, nome: 'AGUA FRIA', codigo_ibge: 2900405, codigo_uf: 29 },
    { id: 1834, nome: 'AIQUARA', codigo_ibge: 2900603, codigo_uf: 29 },
    { id: 1835, nome: 'ALAGOINHAS', codigo_ibge: 2900702, codigo_uf: 29 },
    { id: 1836, nome: 'ALCOBACA', codigo_ibge: 2900801, codigo_uf: 29 },
    { id: 1837, nome: 'ALMADINA', codigo_ibge: 2900900, codigo_uf: 29 },
    { id: 1838, nome: 'AMARGOSA', codigo_ibge: 2901007, codigo_uf: 29 },
    { id: 1839, nome: 'AMELIA RODRIGUES', codigo_ibge: 2901106, codigo_uf: 29 },
    { id: 1840, nome: 'AMERICA DOURADA', codigo_ibge: 2901155, codigo_uf: 29 },
    { id: 1841, nome: 'ANAGE', codigo_ibge: 2901205, codigo_uf: 29 },
    { id: 1842, nome: 'ANDARAI', codigo_ibge: 2901304, codigo_uf: 29 },
    { id: 1843, nome: 'ANDORINHA', codigo_ibge: 2901353, codigo_uf: 29 },
    { id: 1844, nome: 'ANGICAL', codigo_ibge: 2901403, codigo_uf: 29 },
    { id: 1845, nome: 'ANGUERA', codigo_ibge: 2901502, codigo_uf: 29 },
    { id: 1846, nome: 'ANTAS', codigo_ibge: 2901601, codigo_uf: 29 },
    { id: 1847, nome: 'ANTONIO CARDOSO', codigo_ibge: 2901700, codigo_uf: 29 },
    { id: 1848, nome: 'ANTONIO GONCALVES', codigo_ibge: 2901809, codigo_uf: 29 },
    { id: 1849, nome: 'APORA', codigo_ibge: 2901908, codigo_uf: 29 },
    { id: 1850, nome: 'APUAREMA', codigo_ibge: 2901957, codigo_uf: 29 },
    { id: 1852, nome: 'ARACAS', codigo_ibge: 2902054, codigo_uf: 29 },
    { id: 1851, nome: 'ARACATU', codigo_ibge: 2902005, codigo_uf: 29 },
    { id: 1853, nome: 'ARACI', codigo_ibge: 2902104, codigo_uf: 29 },
    { id: 1854, nome: 'ARAMARI', codigo_ibge: 2902203, codigo_uf: 29 },
    { id: 1855, nome: 'ARATACA', codigo_ibge: 2902252, codigo_uf: 29 },
    { id: 1856, nome: 'ARATUIPE', codigo_ibge: 2902302, codigo_uf: 29 },
    { id: 1857, nome: 'AURELINO LEAL', codigo_ibge: 2902401, codigo_uf: 29 },
    { id: 1858, nome: 'BAIANOPOLIS', codigo_ibge: 2902500, codigo_uf: 29 },
    { id: 1859, nome: 'BAIXA GRANDE', codigo_ibge: 2902609, codigo_uf: 29 },
    { id: 1860, nome: 'BANZAE', codigo_ibge: 2902658, codigo_uf: 29 },
    { id: 1861, nome: 'BARRA', codigo_ibge: 2902708, codigo_uf: 29 },
    { id: 1862, nome: 'BARRA DA ESTIVA', codigo_ibge: 2902807, codigo_uf: 29 },
    { id: 1863, nome: 'BARRA DO CHOCA', codigo_ibge: 2902906, codigo_uf: 29 },
    { id: 1864, nome: 'BARRA DO MENDES', codigo_ibge: 2903003, codigo_uf: 29 },
    { id: 1865, nome: 'BARRA DO ROCHA', codigo_ibge: 2903102, codigo_uf: 29 },
    { id: 1866, nome: 'BARREIRAS', codigo_ibge: 2903201, codigo_uf: 29 },
    { id: 1867, nome: 'BARRO ALTO', codigo_ibge: 2903235, codigo_uf: 29 },
    { id: 1869, nome: 'BARRO PRETO', codigo_ibge: 2903300, codigo_uf: 29 },
    { id: 1868, nome: 'BARROCAS', codigo_ibge: 2903276, codigo_uf: 29 },
    { id: 1870, nome: 'BELMONTE', codigo_ibge: 2903409, codigo_uf: 29 },
    { id: 1871, nome: 'BELO CAMPO', codigo_ibge: 2903508, codigo_uf: 29 },
    { id: 1872, nome: 'BIRITINGA', codigo_ibge: 2903607, codigo_uf: 29 },
    { id: 1873, nome: 'BOA NOVA', codigo_ibge: 2903706, codigo_uf: 29 },
    { id: 1874, nome: 'BOA VISTA DO TUPIM', codigo_ibge: 2903805, codigo_uf: 29 },
    { id: 1875, nome: 'BOM JESUS DA LAPA', codigo_ibge: 2903904, codigo_uf: 29 },
    { id: 1876, nome: 'BOM JESUS DA SERRA', codigo_ibge: 2903953, codigo_uf: 29 },
    { id: 1877, nome: 'BONINAL', codigo_ibge: 2904001, codigo_uf: 29 },
    { id: 1878, nome: 'BONITO', codigo_ibge: 2904050, codigo_uf: 29 },
    { id: 1879, nome: 'BOQUIRA', codigo_ibge: 2904100, codigo_uf: 29 },
    { id: 1880, nome: 'BOTUPORA', codigo_ibge: 2904209, codigo_uf: 29 },
    { id: 1881, nome: 'BREJOES', codigo_ibge: 2904308, codigo_uf: 29 },
    { id: 1882, nome: 'BREJOLANDIA', codigo_ibge: 2904407, codigo_uf: 29 },
    { id: 1883, nome: 'BROTAS DE MACAUBAS', codigo_ibge: 2904506, codigo_uf: 29 },
    { id: 1884, nome: 'BRUMADO', codigo_ibge: 2904605, codigo_uf: 29 },
    { id: 1885, nome: 'BUERAREMA', codigo_ibge: 2904704, codigo_uf: 29 },
    { id: 1886, nome: 'BURITIRAMA', codigo_ibge: 2904753, codigo_uf: 29 },
    { id: 1887, nome: 'CAATIBA', codigo_ibge: 2904803, codigo_uf: 29 },
    { id: 1888, nome: 'CABACEIRAS DO PARAGUACU', codigo_ibge: 2904852, codigo_uf: 29 },
    { id: 1889, nome: 'CACHOEIRA', codigo_ibge: 2904902, codigo_uf: 29 },
    { id: 1890, nome: 'CACULE', codigo_ibge: 2905008, codigo_uf: 29 },
    { id: 1891, nome: 'CAEM', codigo_ibge: 2905107, codigo_uf: 29 },
    { id: 1892, nome: 'CAETANOS', codigo_ibge: 2905156, codigo_uf: 29 },
    { id: 1893, nome: 'CAETITE', codigo_ibge: 2905206, codigo_uf: 29 },
    { id: 1894, nome: 'CAFARNAUM', codigo_ibge: 2905305, codigo_uf: 29 },
    { id: 1895, nome: 'CAIRU', codigo_ibge: 2905404, codigo_uf: 29 },
    { id: 1896, nome: 'CALDEIRAO GRANDE', codigo_ibge: 2905503, codigo_uf: 29 },
    { id: 1897, nome: 'CAMACAN', codigo_ibge: 2905602, codigo_uf: 29 },
    { id: 1898, nome: 'CAMACARI', codigo_ibge: 2905701, codigo_uf: 29 },
    { id: 1899, nome: 'CAMAMU', codigo_ibge: 2905800, codigo_uf: 29 },
    { id: 1900, nome: 'CAMPO ALEGRE DE LOURDES', codigo_ibge: 2905909, codigo_uf: 29 },
    { id: 1901, nome: 'CAMPO FORMOSO', codigo_ibge: 2906006, codigo_uf: 29 },
    { id: 1902, nome: 'CANAPOLIS', codigo_ibge: 2906105, codigo_uf: 29 },
    { id: 1903, nome: 'CANARANA', codigo_ibge: 2906204, codigo_uf: 29 },
    { id: 1904, nome: 'CANAVIEIRAS', codigo_ibge: 2906303, codigo_uf: 29 },
    { id: 1905, nome: 'CANDEAL', codigo_ibge: 2906402, codigo_uf: 29 },
    { id: 1906, nome: 'CANDEIAS', codigo_ibge: 2906501, codigo_uf: 29 },
    { id: 1907, nome: 'CANDIBA', codigo_ibge: 2906600, codigo_uf: 29 },
    { id: 1908, nome: 'CANDIDO SALES', codigo_ibge: 2906709, codigo_uf: 29 },
    { id: 1909, nome: 'CANSANCAO', codigo_ibge: 2906808, codigo_uf: 29 },
    { id: 1910, nome: 'CANUDOS', codigo_ibge: 2906824, codigo_uf: 29 },
    { id: 1911, nome: 'CAPELA DO ALTO ALEGRE', codigo_ibge: 2906857, codigo_uf: 29 },
    { id: 1912, nome: 'CAPIM GROSSO', codigo_ibge: 2906873, codigo_uf: 29 },
    { id: 1913, nome: 'CARAIBAS', codigo_ibge: 2906899, codigo_uf: 29 },
    { id: 1914, nome: 'CARAVELAS', codigo_ibge: 2906907, codigo_uf: 29 },
    { id: 1915, nome: 'CARDEAL DA SILVA', codigo_ibge: 2907004, codigo_uf: 29 },
    { id: 1916, nome: 'CARINHANHA', codigo_ibge: 2907103, codigo_uf: 29 },
    { id: 1917, nome: 'CASA NOVA', codigo_ibge: 2907202, codigo_uf: 29 },
    { id: 1918, nome: 'CASTRO ALVES', codigo_ibge: 2907301, codigo_uf: 29 },
    { id: 1919, nome: 'CATOLANDIA', codigo_ibge: 2907400, codigo_uf: 29 },
    { id: 1920, nome: 'CATU', codigo_ibge: 2907509, codigo_uf: 29 },
    { id: 1921, nome: 'CATURAMA', codigo_ibge: 2907558, codigo_uf: 29 },
    { id: 1922, nome: 'CENTRAL', codigo_ibge: 2907608, codigo_uf: 29 },
    { id: 1923, nome: 'CHORROCHO', codigo_ibge: 2907707, codigo_uf: 29 },
    { id: 1924, nome: 'CICERO DANTAS', codigo_ibge: 2907806, codigo_uf: 29 },
    { id: 1925, nome: 'CIPO', codigo_ibge: 2907905, codigo_uf: 29 },
    { id: 1926, nome: 'COARACI', codigo_ibge: 2908002, codigo_uf: 29 },
    { id: 1927, nome: 'COCOS', codigo_ibge: 2908101, codigo_uf: 29 },
    { id: 1928, nome: 'CONCEICAO DA FEIRA', codigo_ibge: 2908200, codigo_uf: 29 },
    { id: 1929, nome: 'CONCEICAO DO ALMEIDA', codigo_ibge: 2908309, codigo_uf: 29 },
    { id: 1930, nome: 'CONCEICAO DO COITE', codigo_ibge: 2908408, codigo_uf: 29 },
    { id: 1931, nome: 'CONCEICAO DO JACUIPE', codigo_ibge: 2908507, codigo_uf: 29 },
    { id: 1932, nome: 'CONDE', codigo_ibge: 2908606, codigo_uf: 29 },
    { id: 1933, nome: 'CONDEUBA', codigo_ibge: 2908705, codigo_uf: 29 },
    { id: 1934, nome: 'CONTENDAS DO SINCORA', codigo_ibge: 2908804, codigo_uf: 29 },
    { id: 1935, nome: 'CORACAO DE MARIA', codigo_ibge: 2908903, codigo_uf: 29 },
    { id: 1936, nome: 'CORDEIROS', codigo_ibge: 2909000, codigo_uf: 29 },
    { id: 1937, nome: 'CORIBE', codigo_ibge: 2909109, codigo_uf: 29 },
    { id: 1938, nome: 'CORONEL JOAO SA', codigo_ibge: 2909208, codigo_uf: 29 },
    { id: 1939, nome: 'CORRENTINA', codigo_ibge: 2909307, codigo_uf: 29 },
    { id: 1940, nome: 'COTEGIPE', codigo_ibge: 2909406, codigo_uf: 29 },
    { id: 1941, nome: 'CRAVOLANDIA', codigo_ibge: 2909505, codigo_uf: 29 },
    { id: 1942, nome: 'CRISOPOLIS', codigo_ibge: 2909604, codigo_uf: 29 },
    { id: 1943, nome: 'CRISTOPOLIS', codigo_ibge: 2909703, codigo_uf: 29 },
    { id: 1944, nome: 'CRUZ DAS ALMAS', codigo_ibge: 2909802, codigo_uf: 29 },
    { id: 1945, nome: 'CURACA', codigo_ibge: 2909901, codigo_uf: 29 },
    { id: 1946, nome: 'DARIO MEIRA', codigo_ibge: 2910008, codigo_uf: 29 },
    { id: 1947, nome: 'DIAS D AVILA', codigo_ibge: 2910057, codigo_uf: 29 },
    { id: 1948, nome: 'DOM BASILIO', codigo_ibge: 2910107, codigo_uf: 29 },
    { id: 1949, nome: 'DOM MACEDO COSTA', codigo_ibge: 2910206, codigo_uf: 29 },
    { id: 1950, nome: 'ELISIO MEDRADO', codigo_ibge: 2910305, codigo_uf: 29 },
    { id: 1951, nome: 'ENCRUZILHADA', codigo_ibge: 2910404, codigo_uf: 29 },
    { id: 1952, nome: 'ENTRE RIOS', codigo_ibge: 2910503, codigo_uf: 29 },
    { id: 1833, nome: 'ERICO CARDOSO', codigo_ibge: 2900504, codigo_uf: 29 },
    { id: 1953, nome: 'ESPLANADA', codigo_ibge: 2910602, codigo_uf: 29 },
    { id: 1954, nome: 'EUCLIDES DA CUNHA', codigo_ibge: 2910701, codigo_uf: 29 },
    { id: 1955, nome: 'EUNAPOLIS', codigo_ibge: 2910727, codigo_uf: 29 },
    { id: 1956, nome: 'FATIMA', codigo_ibge: 2910750, codigo_uf: 29 },
    { id: 1957, nome: 'FEIRA DA MATA', codigo_ibge: 2910776, codigo_uf: 29 },
    { id: 1958, nome: 'FEIRA DE SANTANA', codigo_ibge: 2910800, codigo_uf: 29 },
    { id: 1959, nome: 'FILADELFIA', codigo_ibge: 2910859, codigo_uf: 29 },
    { id: 1960, nome: 'FIRMINO ALVES', codigo_ibge: 2910909, codigo_uf: 29 },
    { id: 1961, nome: 'FLORESTA AZUL', codigo_ibge: 2911006, codigo_uf: 29 },
    { id: 1962, nome: 'FORMOSA DO RIO PRETO', codigo_ibge: 2911105, codigo_uf: 29 },
    { id: 1963, nome: 'GANDU', codigo_ibge: 2911204, codigo_uf: 29 },
    { id: 1964, nome: 'GAVIAO', codigo_ibge: 2911253, codigo_uf: 29 },
    { id: 1965, nome: 'GENTIO DO OURO', codigo_ibge: 2911303, codigo_uf: 29 },
    { id: 1966, nome: 'GLORIA', codigo_ibge: 2911402, codigo_uf: 29 },
    { id: 1967, nome: 'GONGOGI', codigo_ibge: 2911501, codigo_uf: 29 },
    { id: 1968, nome: 'GOVERNADOR MANGABEIRA', codigo_ibge: 2911600, codigo_uf: 29 },
    { id: 1969, nome: 'GUAJERU', codigo_ibge: 2911659, codigo_uf: 29 },
    { id: 1970, nome: 'GUANAMBI', codigo_ibge: 2911709, codigo_uf: 29 },
    { id: 1971, nome: 'GUARATINGA', codigo_ibge: 2911808, codigo_uf: 29 },
    { id: 1972, nome: 'HELIOPOLIS', codigo_ibge: 2911857, codigo_uf: 29 },
    { id: 1973, nome: 'IACU', codigo_ibge: 2911907, codigo_uf: 29 },
    { id: 1974, nome: 'IBIASSUCE', codigo_ibge: 2912004, codigo_uf: 29 },
    { id: 1975, nome: 'IBICARAI', codigo_ibge: 2912103, codigo_uf: 29 },
    { id: 1976, nome: 'IBICOARA', codigo_ibge: 2912202, codigo_uf: 29 },
    { id: 1977, nome: 'IBICUI', codigo_ibge: 2912301, codigo_uf: 29 },
    { id: 1978, nome: 'IBIPEBA', codigo_ibge: 2912400, codigo_uf: 29 },
    { id: 1979, nome: 'IBIPITANGA', codigo_ibge: 2912509, codigo_uf: 29 },
    { id: 1980, nome: 'IBIQUERA', codigo_ibge: 2912608, codigo_uf: 29 },
    { id: 1981, nome: 'IBIRAPITANGA', codigo_ibge: 2912707, codigo_uf: 29 },
    { id: 1982, nome: 'IBIRAPUA', codigo_ibge: 2912806, codigo_uf: 29 },
    { id: 1983, nome: 'IBIRATAIA', codigo_ibge: 2912905, codigo_uf: 29 },
    { id: 1984, nome: 'IBITIARA', codigo_ibge: 2913002, codigo_uf: 29 },
    { id: 1985, nome: 'IBITITA', codigo_ibge: 2913101, codigo_uf: 29 },
    { id: 1986, nome: 'IBOTIRAMA', codigo_ibge: 2913200, codigo_uf: 29 },
    { id: 1987, nome: 'ICHU', codigo_ibge: 2913309, codigo_uf: 29 },
    { id: 1988, nome: 'IGAPORA', codigo_ibge: 2913408, codigo_uf: 29 },
    { id: 1989, nome: 'IGRAPIUNA', codigo_ibge: 2913457, codigo_uf: 29 },
    { id: 1990, nome: 'IGUAI', codigo_ibge: 2913507, codigo_uf: 29 },
    { id: 1991, nome: 'ILHEUS', codigo_ibge: 2913606, codigo_uf: 29 },
    { id: 1992, nome: 'INHAMBUPE', codigo_ibge: 2913705, codigo_uf: 29 },
    { id: 1993, nome: 'IPECAETA', codigo_ibge: 2913804, codigo_uf: 29 },
    { id: 1994, nome: 'IPIAU', codigo_ibge: 2913903, codigo_uf: 29 },
    { id: 1995, nome: 'IPIRA', codigo_ibge: 2914000, codigo_uf: 29 },
    { id: 1996, nome: 'IPUPIARA', codigo_ibge: 2914109, codigo_uf: 29 },
    { id: 1997, nome: 'IRAJUBA', codigo_ibge: 2914208, codigo_uf: 29 },
    { id: 1998, nome: 'IRAMAIA', codigo_ibge: 2914307, codigo_uf: 29 },
    { id: 1999, nome: 'IRAQUARA', codigo_ibge: 2914406, codigo_uf: 29 },
    { id: 2000, nome: 'IRARA', codigo_ibge: 2914505, codigo_uf: 29 },
    { id: 2001, nome: 'IRECE', codigo_ibge: 2914604, codigo_uf: 29 },
    { id: 2002, nome: 'ITABELA', codigo_ibge: 2914653, codigo_uf: 29 },
    { id: 2003, nome: 'ITABERABA', codigo_ibge: 2914703, codigo_uf: 29 },
    { id: 2004, nome: 'ITABUNA', codigo_ibge: 2914802, codigo_uf: 29 },
    { id: 2005, nome: 'ITACARE', codigo_ibge: 2914901, codigo_uf: 29 },
    { id: 2006, nome: 'ITAETE', codigo_ibge: 2915007, codigo_uf: 29 },
    { id: 2007, nome: 'ITAGI', codigo_ibge: 2915106, codigo_uf: 29 },
    { id: 2008, nome: 'ITAGIBA', codigo_ibge: 2915205, codigo_uf: 29 },
    { id: 2009, nome: 'ITAGIMIRIM', codigo_ibge: 2915304, codigo_uf: 29 },
    { id: 2010, nome: 'ITAGUACU DA BAHIA', codigo_ibge: 2915353, codigo_uf: 29 },
    { id: 2011, nome: 'ITAJU DO COLONIA', codigo_ibge: 2915403, codigo_uf: 29 },
    { id: 2012, nome: 'ITAJUIPE', codigo_ibge: 2915502, codigo_uf: 29 },
    { id: 2013, nome: 'ITAMARAJU', codigo_ibge: 2915601, codigo_uf: 29 },
    { id: 2014, nome: 'ITAMARI', codigo_ibge: 2915700, codigo_uf: 29 },
    { id: 2015, nome: 'ITAMBE', codigo_ibge: 2915809, codigo_uf: 29 },
    { id: 2016, nome: 'ITANAGRA', codigo_ibge: 2915908, codigo_uf: 29 },
    { id: 2017, nome: 'ITANHEM', codigo_ibge: 2916005, codigo_uf: 29 },
    { id: 2018, nome: 'ITAPARICA', codigo_ibge: 2916104, codigo_uf: 29 },
    { id: 2019, nome: 'ITAPE', codigo_ibge: 2916203, codigo_uf: 29 },
    { id: 2020, nome: 'ITAPEBI', codigo_ibge: 2916302, codigo_uf: 29 },
    { id: 2021, nome: 'ITAPETINGA', codigo_ibge: 2916401, codigo_uf: 29 },
    { id: 2022, nome: 'ITAPICURU', codigo_ibge: 2916500, codigo_uf: 29 },
    { id: 2023, nome: 'ITAPITANGA', codigo_ibge: 2916609, codigo_uf: 29 },
    { id: 2024, nome: 'ITAQUARA', codigo_ibge: 2916708, codigo_uf: 29 },
    { id: 2025, nome: 'ITARANTIM', codigo_ibge: 2916807, codigo_uf: 29 },
    { id: 2026, nome: 'ITATIM', codigo_ibge: 2916856, codigo_uf: 29 },
    { id: 2027, nome: 'ITIRUCU', codigo_ibge: 2916906, codigo_uf: 29 },
    { id: 2028, nome: 'ITIUBA', codigo_ibge: 2917003, codigo_uf: 29 },
    { id: 2029, nome: 'ITORORO', codigo_ibge: 2917102, codigo_uf: 29 },
    { id: 2030, nome: 'ITUACU', codigo_ibge: 2917201, codigo_uf: 29 },
    { id: 2031, nome: 'ITUBERA', codigo_ibge: 2917300, codigo_uf: 29 },
    { id: 2032, nome: 'IUIU', codigo_ibge: 2917334, codigo_uf: 29 },
    { id: 2033, nome: 'JABORANDI', codigo_ibge: 2917359, codigo_uf: 29 },
    { id: 2034, nome: 'JACARACI', codigo_ibge: 2917409, codigo_uf: 29 },
    { id: 2035, nome: 'JACOBINA', codigo_ibge: 2917508, codigo_uf: 29 },
    { id: 2036, nome: 'JAGUAQUARA', codigo_ibge: 2917607, codigo_uf: 29 },
    { id: 2037, nome: 'JAGUARARI', codigo_ibge: 2917706, codigo_uf: 29 },
    { id: 2038, nome: 'JAGUARIPE', codigo_ibge: 2917805, codigo_uf: 29 },
    { id: 2039, nome: 'JANDAIRA', codigo_ibge: 2917904, codigo_uf: 29 },
    { id: 2040, nome: 'JEQUIE', codigo_ibge: 2918001, codigo_uf: 29 },
    { id: 2041, nome: 'JEREMOABO', codigo_ibge: 2918100, codigo_uf: 29 },
    { id: 2042, nome: 'JIQUIRICA', codigo_ibge: 2918209, codigo_uf: 29 },
    { id: 2043, nome: 'JITAUNA', codigo_ibge: 2918308, codigo_uf: 29 },
    { id: 2044, nome: 'JOAO DOURADO', codigo_ibge: 2918357, codigo_uf: 29 },
    { id: 2045, nome: 'JUAZEIRO', codigo_ibge: 2918407, codigo_uf: 29 },
    { id: 2046, nome: 'JUCURUCU', codigo_ibge: 2918456, codigo_uf: 29 },
    { id: 2047, nome: 'JUSSARA', codigo_ibge: 2918506, codigo_uf: 29 },
    { id: 2048, nome: 'JUSSARI', codigo_ibge: 2918555, codigo_uf: 29 },
    { id: 2049, nome: 'JUSSIAPE', codigo_ibge: 2918605, codigo_uf: 29 },
    { id: 2050, nome: 'LAFAIETE COUTINHO', codigo_ibge: 2918704, codigo_uf: 29 },
    { id: 2051, nome: 'LAGOA REAL', codigo_ibge: 2918753, codigo_uf: 29 },
    { id: 2052, nome: 'LAJE', codigo_ibge: 2918803, codigo_uf: 29 },
    { id: 2053, nome: 'LAJEDAO', codigo_ibge: 2918902, codigo_uf: 29 },
    { id: 2054, nome: 'LAJEDINHO', codigo_ibge: 2919009, codigo_uf: 29 },
    { id: 2055, nome: 'LAJEDO DO TABOCAL', codigo_ibge: 2919058, codigo_uf: 29 },
    { id: 2056, nome: 'LAMARAO', codigo_ibge: 2919108, codigo_uf: 29 },
    { id: 2057, nome: 'LAPAO', codigo_ibge: 2919157, codigo_uf: 29 },
    { id: 2058, nome: 'LAURO DE FREITAS', codigo_ibge: 2919207, codigo_uf: 29 },
    { id: 2059, nome: 'LENCOIS', codigo_ibge: 2919306, codigo_uf: 29 },
    { id: 2060, nome: 'LICINIO DE ALMEIDA', codigo_ibge: 2919405, codigo_uf: 29 },
    { id: 2061, nome: 'LIVRAMENTO DE NOSSA SENHORA', codigo_ibge: 2919504, codigo_uf: 29 },
    { id: 2062, nome: 'LUIS EDUARDO MAGALHAES', codigo_ibge: 2919553, codigo_uf: 29 },
    { id: 2063, nome: 'MACAJUBA', codigo_ibge: 2919603, codigo_uf: 29 },
    { id: 2064, nome: 'MACARANI', codigo_ibge: 2919702, codigo_uf: 29 },
    { id: 2065, nome: 'MACAUBAS', codigo_ibge: 2919801, codigo_uf: 29 },
    { id: 2066, nome: 'MACURURE', codigo_ibge: 2919900, codigo_uf: 29 },
    { id: 2067, nome: 'MADRE DE DEUS', codigo_ibge: 2919926, codigo_uf: 29 },
    { id: 2068, nome: 'MAETINGA', codigo_ibge: 2919959, codigo_uf: 29 },
    { id: 2069, nome: 'MAIQUINIQUE', codigo_ibge: 2920007, codigo_uf: 29 },
    { id: 2070, nome: 'MAIRI', codigo_ibge: 2920106, codigo_uf: 29 },
    { id: 2071, nome: 'MALHADA', codigo_ibge: 2920205, codigo_uf: 29 },
    { id: 2072, nome: 'MALHADA DE PEDRAS', codigo_ibge: 2920304, codigo_uf: 29 },
    { id: 2073, nome: 'MANOEL VITORINO', codigo_ibge: 2920403, codigo_uf: 29 },
    { id: 2074, nome: 'MANSIDAO', codigo_ibge: 2920452, codigo_uf: 29 },
    { id: 2075, nome: 'MARACAS', codigo_ibge: 2920502, codigo_uf: 29 },
    { id: 2076, nome: 'MARAGOGIPE', codigo_ibge: 2920601, codigo_uf: 29 },
    { id: 2077, nome: 'MARAU', codigo_ibge: 2920700, codigo_uf: 29 },
    { id: 2078, nome: 'MARCIONILIO SOUZA', codigo_ibge: 2920809, codigo_uf: 29 },
    { id: 2079, nome: 'MASCOTE', codigo_ibge: 2920908, codigo_uf: 29 },
    { id: 2080, nome: 'MATA DE SAO JOAO', codigo_ibge: 2921005, codigo_uf: 29 },
    { id: 2081, nome: 'MATINA', codigo_ibge: 2921054, codigo_uf: 29 },
    { id: 2082, nome: 'MEDEIROS NETO', codigo_ibge: 2921104, codigo_uf: 29 },
    { id: 2083, nome: 'MIGUEL CALMON', codigo_ibge: 2921203, codigo_uf: 29 },
    { id: 2084, nome: 'MILAGRES', codigo_ibge: 2921302, codigo_uf: 29 },
    { id: 2085, nome: 'MIRANGABA', codigo_ibge: 2921401, codigo_uf: 29 },
    { id: 2086, nome: 'MIRANTE', codigo_ibge: 2921450, codigo_uf: 29 },
    { id: 2087, nome: 'MONTE SANTO', codigo_ibge: 2921500, codigo_uf: 29 },
    { id: 2088, nome: 'MORPARA', codigo_ibge: 2921609, codigo_uf: 29 },
    { id: 2089, nome: 'MORRO DO CHAPEU', codigo_ibge: 2921708, codigo_uf: 29 },
    { id: 2090, nome: 'MORTUGABA', codigo_ibge: 2921807, codigo_uf: 29 },
    { id: 2091, nome: 'MUCUGE', codigo_ibge: 2921906, codigo_uf: 29 },
    { id: 2092, nome: 'MUCURI', codigo_ibge: 2922003, codigo_uf: 29 },
    { id: 2093, nome: 'MULUNGU DO MORRO', codigo_ibge: 2922052, codigo_uf: 29 },
    { id: 2094, nome: 'MUNDO NOVO', codigo_ibge: 2922102, codigo_uf: 29 },
    { id: 2095, nome: 'MUNIZ FERREIRA', codigo_ibge: 2922201, codigo_uf: 29 },
    { id: 2096, nome: 'MUQUEM DE SAO FRANCISCO', codigo_ibge: 2922250, codigo_uf: 29 },
    { id: 2097, nome: 'MURITIBA', codigo_ibge: 2922300, codigo_uf: 29 },
    { id: 2098, nome: 'MUTUIPE', codigo_ibge: 2922409, codigo_uf: 29 },
    { id: 2099, nome: 'NAZARE', codigo_ibge: 2922508, codigo_uf: 29 },
    { id: 2100, nome: 'NILO PECANHA', codigo_ibge: 2922607, codigo_uf: 29 },
    { id: 2101, nome: 'NORDESTINA', codigo_ibge: 2922656, codigo_uf: 29 },
    { id: 2102, nome: 'NOVA CANAA', codigo_ibge: 2922706, codigo_uf: 29 },
    { id: 2103, nome: 'NOVA FATIMA', codigo_ibge: 2922730, codigo_uf: 29 },
    { id: 2104, nome: 'NOVA IBIA', codigo_ibge: 2922755, codigo_uf: 29 },
    { id: 2105, nome: 'NOVA ITARANA', codigo_ibge: 2922805, codigo_uf: 29 },
    { id: 2106, nome: 'NOVA REDENCAO', codigo_ibge: 2922854, codigo_uf: 29 },
    { id: 2107, nome: 'NOVA SOURE', codigo_ibge: 2922904, codigo_uf: 29 },
    { id: 2108, nome: 'NOVA VICOSA', codigo_ibge: 2923001, codigo_uf: 29 },
    { id: 2109, nome: 'NOVO HORIZONTE', codigo_ibge: 2923035, codigo_uf: 29 },
    { id: 2110, nome: 'NOVO TRIUNFO', codigo_ibge: 2923050, codigo_uf: 29 },
    { id: 2111, nome: 'OLINDINA', codigo_ibge: 2923100, codigo_uf: 29 },
    { id: 2112, nome: 'OLIVEIRA DOS BREJINHOS', codigo_ibge: 2923209, codigo_uf: 29 },
    { id: 2113, nome: 'OURICANGAS', codigo_ibge: 2923308, codigo_uf: 29 },
    { id: 2114, nome: 'OUROLANDIA', codigo_ibge: 2923357, codigo_uf: 29 },
    { id: 2115, nome: 'PALMAS DE MONTE ALTO', codigo_ibge: 2923407, codigo_uf: 29 },
    { id: 2116, nome: 'PALMEIRAS', codigo_ibge: 2923506, codigo_uf: 29 },
    { id: 2117, nome: 'PARAMIRIM', codigo_ibge: 2923605, codigo_uf: 29 },
    { id: 2118, nome: 'PARATINGA', codigo_ibge: 2923704, codigo_uf: 29 },
    { id: 2119, nome: 'PARIPIRANGA', codigo_ibge: 2923803, codigo_uf: 29 },
    { id: 2120, nome: 'PAU BRASIL', codigo_ibge: 2923902, codigo_uf: 29 },
    { id: 2121, nome: 'PAULO AFONSO', codigo_ibge: 2924009, codigo_uf: 29 },
    { id: 2122, nome: 'PE DE SERRA', codigo_ibge: 2924058, codigo_uf: 29 },
    { id: 2123, nome: 'PEDRAO', codigo_ibge: 2924108, codigo_uf: 29 },
    { id: 2124, nome: 'PEDRO ALEXANDRE', codigo_ibge: 2924207, codigo_uf: 29 },
    { id: 2125, nome: 'PIATA', codigo_ibge: 2924306, codigo_uf: 29 },
    { id: 2126, nome: 'PILAO ARCADO', codigo_ibge: 2924405, codigo_uf: 29 },
    { id: 2127, nome: 'PINDAI', codigo_ibge: 2924504, codigo_uf: 29 },
    { id: 2128, nome: 'PINDOBACU', codigo_ibge: 2924603, codigo_uf: 29 },
    { id: 2129, nome: 'PINTADAS', codigo_ibge: 2924652, codigo_uf: 29 },
    { id: 2130, nome: 'PIRAI DO NORTE', codigo_ibge: 2924678, codigo_uf: 29 },
    { id: 2131, nome: 'PIRIPA', codigo_ibge: 2924702, codigo_uf: 29 },
    { id: 2132, nome: 'PIRITIBA', codigo_ibge: 2924801, codigo_uf: 29 },
    { id: 2133, nome: 'PLANALTINO', codigo_ibge: 2924900, codigo_uf: 29 },
    { id: 2134, nome: 'PLANALTO', codigo_ibge: 2925006, codigo_uf: 29 },
    { id: 2135, nome: 'POCOES', codigo_ibge: 2925105, codigo_uf: 29 },
    { id: 2136, nome: 'POJUCA', codigo_ibge: 2925204, codigo_uf: 29 },
    { id: 2137, nome: 'PONTO NOVO', codigo_ibge: 2925253, codigo_uf: 29 },
    { id: 2138, nome: 'PORTO SEGURO', codigo_ibge: 2925303, codigo_uf: 29 },
    { id: 2139, nome: 'POTIRAGUA', codigo_ibge: 2925402, codigo_uf: 29 },
    { id: 2140, nome: 'PRADO', codigo_ibge: 2925501, codigo_uf: 29 },
    { id: 2141, nome: 'PRESIDENTE DUTRA', codigo_ibge: 2925600, codigo_uf: 29 },
    { id: 2142, nome: 'PRESIDENTE JANIO QUADROS', codigo_ibge: 2925709, codigo_uf: 29 },
    { id: 2143, nome: 'PRESIDENTE TANCREDO NEVES', codigo_ibge: 2925758, codigo_uf: 29 },
    { id: 2144, nome: 'QUEIMADAS', codigo_ibge: 2925808, codigo_uf: 29 },
    { id: 2145, nome: 'QUIJINGUE', codigo_ibge: 2925907, codigo_uf: 29 },
    { id: 2146, nome: 'QUIXABEIRA', codigo_ibge: 2925931, codigo_uf: 29 },
    { id: 2147, nome: 'RAFAEL JAMBEIRO', codigo_ibge: 2925956, codigo_uf: 29 },
    { id: 2148, nome: 'REMANSO', codigo_ibge: 2926004, codigo_uf: 29 },
    { id: 2149, nome: 'RETIROLANDIA', codigo_ibge: 2926103, codigo_uf: 29 },
    { id: 2150, nome: 'RIACHAO DAS NEVES', codigo_ibge: 2926202, codigo_uf: 29 },
    { id: 2151, nome: 'RIACHAO DO JACUIPE', codigo_ibge: 2926301, codigo_uf: 29 },
    { id: 2152, nome: 'RIACHO DE SANTANA', codigo_ibge: 2926400, codigo_uf: 29 },
    { id: 2153, nome: 'RIBEIRA DO AMPARO', codigo_ibge: 2926509, codigo_uf: 29 },
    { id: 2154, nome: 'RIBEIRA DO POMBAL', codigo_ibge: 2926608, codigo_uf: 29 },
    { id: 2155, nome: 'RIBEIRAO DO LARGO', codigo_ibge: 2926657, codigo_uf: 29 },
    { id: 2156, nome: 'RIO DE CONTAS', codigo_ibge: 2926707, codigo_uf: 29 },
    { id: 2157, nome: 'RIO DO ANTONIO', codigo_ibge: 2926806, codigo_uf: 29 },
    { id: 2158, nome: 'RIO DO PIRES', codigo_ibge: 2926905, codigo_uf: 29 },
    { id: 2159, nome: 'RIO REAL', codigo_ibge: 2927002, codigo_uf: 29 },
    { id: 2160, nome: 'RODELAS', codigo_ibge: 2927101, codigo_uf: 29 },
    { id: 2161, nome: 'RUY BARBOSA', codigo_ibge: 2927200, codigo_uf: 29 },
    { id: 2162, nome: 'SALINAS DA MARGARIDA', codigo_ibge: 2927309, codigo_uf: 29 },
    { id: 2163, nome: 'SALVADOR', codigo_ibge: 2927408, codigo_uf: 29 },
    { id: 2164, nome: 'SANTA BARBARA', codigo_ibge: 2927507, codigo_uf: 29 },
    { id: 2165, nome: 'SANTA BRIGIDA', codigo_ibge: 2927606, codigo_uf: 29 },
    { id: 2166, nome: 'SANTA CRUZ CABRALIA', codigo_ibge: 2927705, codigo_uf: 29 },
    { id: 2167, nome: 'SANTA CRUZ DA VITORIA', codigo_ibge: 2927804, codigo_uf: 29 },
    { id: 2168, nome: 'SANTA INES', codigo_ibge: 2927903, codigo_uf: 29 },
    { id: 2170, nome: 'SANTA LUZIA', codigo_ibge: 2928059, codigo_uf: 29 },
    { id: 2171, nome: 'SANTA MARIA DA VITORIA', codigo_ibge: 2928109, codigo_uf: 29 },
    { id: 2174, nome: 'SANTA RITA DE CASSIA', codigo_ibge: 2928406, codigo_uf: 29 },
    { id: 2175, nome: 'SANTA TERESINHA', codigo_ibge: 2928505, codigo_uf: 29 },
    { id: 2169, nome: 'SANTALUZ', codigo_ibge: 2928000, codigo_uf: 29 },
    { id: 2172, nome: 'SANTANA', codigo_ibge: 2928208, codigo_uf: 29 },
    { id: 2173, nome: 'SANTANOPOLIS', codigo_ibge: 2928307, codigo_uf: 29 },
    { id: 2176, nome: 'SANTO AMARO', codigo_ibge: 2928604, codigo_uf: 29 },
    { id: 2177, nome: 'SANTO ANTONIO DE JESUS', codigo_ibge: 2928703, codigo_uf: 29 },
    { id: 2178, nome: 'SANTO ESTEVAO', codigo_ibge: 2928802, codigo_uf: 29 },
    { id: 2179, nome: 'SAO DESIDERIO', codigo_ibge: 2928901, codigo_uf: 29 },
    { id: 2180, nome: 'SAO DOMINGOS', codigo_ibge: 2928950, codigo_uf: 29 },
    { id: 2183, nome: 'SAO FELIPE', codigo_ibge: 2929107, codigo_uf: 29 },
    { id: 2181, nome: 'SAO FELIX', codigo_ibge: 2929008, codigo_uf: 29 },
    { id: 2182, nome: 'SAO FELIX DO CORIBE', codigo_ibge: 2929057, codigo_uf: 29 },
    { id: 2184, nome: 'SAO FRANCISCO DO CONDE', codigo_ibge: 2929206, codigo_uf: 29 },
    { id: 2185, nome: 'SAO GABRIEL', codigo_ibge: 2929255, codigo_uf: 29 },
    { id: 2186, nome: 'SAO GONCALO DOS CAMPOS', codigo_ibge: 2929305, codigo_uf: 29 },
    { id: 2187, nome: 'SAO JOSE DA VITORIA', codigo_ibge: 2929354, codigo_uf: 29 },
    { id: 2188, nome: 'SAO JOSE DO JACUIPE', codigo_ibge: 2929370, codigo_uf: 29 },
    { id: 2189, nome: 'SAO MIGUEL DAS MATAS', codigo_ibge: 2929404, codigo_uf: 29 },
    { id: 2190, nome: 'SAO SEBASTIAO DO PASSE', codigo_ibge: 2929503, codigo_uf: 29 },
    { id: 2191, nome: 'SAPEACU', codigo_ibge: 2929602, codigo_uf: 29 },
    { id: 2192, nome: 'SATIRO DIAS', codigo_ibge: 2929701, codigo_uf: 29 },
    { id: 2193, nome: 'SAUBARA', codigo_ibge: 2929750, codigo_uf: 29 },
    { id: 2194, nome: 'SAUDE', codigo_ibge: 2929800, codigo_uf: 29 },
    { id: 2195, nome: 'SEABRA', codigo_ibge: 2929909, codigo_uf: 29 },
    { id: 2196, nome: 'SEBASTIAO LARANJEIRAS', codigo_ibge: 2930006, codigo_uf: 29 },
    { id: 2197, nome: 'SENHOR DO BONFIM', codigo_ibge: 2930105, codigo_uf: 29 },
    { id: 2199, nome: 'SENTO SE', codigo_ibge: 2930204, codigo_uf: 29 },
    { id: 2198, nome: 'SERRA DO RAMALHO', codigo_ibge: 2930154, codigo_uf: 29 },
    { id: 2200, nome: 'SERRA DOURADA', codigo_ibge: 2930303, codigo_uf: 29 },
    { id: 2201, nome: 'SERRA PRETA', codigo_ibge: 2930402, codigo_uf: 29 },
    { id: 2202, nome: 'SERRINHA', codigo_ibge: 2930501, codigo_uf: 29 },
    { id: 2203, nome: 'SERROLANDIA', codigo_ibge: 2930600, codigo_uf: 29 },
    { id: 2204, nome: 'SIMOES FILHO', codigo_ibge: 2930709, codigo_uf: 29 },
    { id: 2205, nome: 'SITIO DO MATO', codigo_ibge: 2930758, codigo_uf: 29 },
    { id: 2206, nome: 'SITIO DO QUINTO', codigo_ibge: 2930766, codigo_uf: 29 },
    { id: 2207, nome: 'SOBRADINHO', codigo_ibge: 2930774, codigo_uf: 29 },
    { id: 2208, nome: 'SOUTO SOARES', codigo_ibge: 2930808, codigo_uf: 29 },
    { id: 2209, nome: 'TABOCAS DO BREJO VELHO', codigo_ibge: 2930907, codigo_uf: 29 },
    { id: 2210, nome: 'TANHACU', codigo_ibge: 2931004, codigo_uf: 29 },
    { id: 2211, nome: 'TANQUE NOVO', codigo_ibge: 2931053, codigo_uf: 29 },
    { id: 2212, nome: 'TANQUINHO', codigo_ibge: 2931103, codigo_uf: 29 },
    { id: 2213, nome: 'TAPEROA', codigo_ibge: 2931202, codigo_uf: 29 },
    { id: 2214, nome: 'TAPIRAMUTA', codigo_ibge: 2931301, codigo_uf: 29 },
    { id: 2215, nome: 'TEIXEIRA DE FREITAS', codigo_ibge: 2931350, codigo_uf: 29 },
    { id: 2216, nome: 'TEODORO SAMPAIO', codigo_ibge: 2931400, codigo_uf: 29 },
    { id: 2217, nome: 'TEOFILANDIA', codigo_ibge: 2931509, codigo_uf: 29 },
    { id: 2218, nome: 'TEOLANDIA', codigo_ibge: 2931608, codigo_uf: 29 },
    { id: 2219, nome: 'TERRA NOVA', codigo_ibge: 2931707, codigo_uf: 29 },
    { id: 2220, nome: 'TREMEDAL', codigo_ibge: 2931806, codigo_uf: 29 },
    { id: 2221, nome: 'TUCANO', codigo_ibge: 2931905, codigo_uf: 29 },
    { id: 2222, nome: 'UAUA', codigo_ibge: 2932002, codigo_uf: 29 },
    { id: 2223, nome: 'UBAIRA', codigo_ibge: 2932101, codigo_uf: 29 },
    { id: 2224, nome: 'UBAITABA', codigo_ibge: 2932200, codigo_uf: 29 },
    { id: 2225, nome: 'UBATA', codigo_ibge: 2932309, codigo_uf: 29 },
    { id: 2226, nome: 'UIBAI', codigo_ibge: 2932408, codigo_uf: 29 },
    { id: 2227, nome: 'UMBURANAS', codigo_ibge: 2932457, codigo_uf: 29 },
    { id: 2228, nome: 'UNA', codigo_ibge: 2932507, codigo_uf: 29 },
    { id: 2229, nome: 'URANDI', codigo_ibge: 2932606, codigo_uf: 29 },
    { id: 2230, nome: 'URUCUCA', codigo_ibge: 2932705, codigo_uf: 29 },
    { id: 2231, nome: 'UTINGA', codigo_ibge: 2932804, codigo_uf: 29 },
    { id: 2232, nome: 'VALENCA', codigo_ibge: 2932903, codigo_uf: 29 },
    { id: 2233, nome: 'VALENTE', codigo_ibge: 2933000, codigo_uf: 29 },
    { id: 2234, nome: 'VARZEA DA ROCA', codigo_ibge: 2933059, codigo_uf: 29 },
    { id: 2235, nome: 'VARZEA DO POCO', codigo_ibge: 2933109, codigo_uf: 29 },
    { id: 2236, nome: 'VARZEA NOVA', codigo_ibge: 2933158, codigo_uf: 29 },
    { id: 2237, nome: 'VARZEDO', codigo_ibge: 2933174, codigo_uf: 29 },
    { id: 2238, nome: 'VERA CRUZ', codigo_ibge: 2933208, codigo_uf: 29 },
    { id: 2239, nome: 'VEREDA', codigo_ibge: 2933257, codigo_uf: 29 },
    { id: 2240, nome: 'VITORIA DA CONQUISTA', codigo_ibge: 2933307, codigo_uf: 29 },
    { id: 2241, nome: 'WAGNER', codigo_ibge: 2933406, codigo_uf: 29 },
    { id: 2242, nome: 'WANDERLEY', codigo_ibge: 2933455, codigo_uf: 29 },
    { id: 2243, nome: 'WENCESLAU GUIMARAES', codigo_ibge: 2933505, codigo_uf: 29 },
    { id: 2244, nome: 'XIQUE-XIQUE', codigo_ibge: 2933604, codigo_uf: 29 },
    { id: 2245, nome: 'ABADIA DOS DOURADOS', codigo_ibge: 3100104, codigo_uf: 31 },
    { id: 2246, nome: 'ABAETE', codigo_ibge: 3100203, codigo_uf: 31 },
    { id: 2247, nome: 'ABRE CAMPO', codigo_ibge: 3100302, codigo_uf: 31 },
    { id: 2248, nome: 'ACAIACA', codigo_ibge: 3100401, codigo_uf: 31 },
    { id: 2249, nome: 'ACUCENA', codigo_ibge: 3100500, codigo_uf: 31 },
    { id: 2250, nome: 'AGUA BOA', codigo_ibge: 3100609, codigo_uf: 31 },
    { id: 2251, nome: 'AGUA COMPRIDA', codigo_ibge: 3100708, codigo_uf: 31 },
    { id: 2252, nome: 'AGUANIL', codigo_ibge: 3100807, codigo_uf: 31 },
    { id: 2253, nome: 'AGUAS FORMOSAS', codigo_ibge: 3100906, codigo_uf: 31 },
    { id: 2254, nome: 'AGUAS VERMELHAS', codigo_ibge: 3101003, codigo_uf: 31 },
    { id: 2255, nome: 'AIMORES', codigo_ibge: 3101102, codigo_uf: 31 },
    { id: 2256, nome: 'AIURUOCA', codigo_ibge: 3101201, codigo_uf: 31 },
    { id: 2257, nome: 'ALAGOA', codigo_ibge: 3101300, codigo_uf: 31 },
    { id: 2258, nome: 'ALBERTINA', codigo_ibge: 3101409, codigo_uf: 31 },
    { id: 2259, nome: 'ALEM PARAIBA', codigo_ibge: 3101508, codigo_uf: 31 },
    { id: 2260, nome: 'ALFENAS', codigo_ibge: 3101607, codigo_uf: 31 },
    { id: 2261, nome: 'ALFREDO VASCONCELOS', codigo_ibge: 3101631, codigo_uf: 31 },
    { id: 2262, nome: 'ALMENARA', codigo_ibge: 3101706, codigo_uf: 31 },
    { id: 2263, nome: 'ALPERCATA', codigo_ibge: 3101805, codigo_uf: 31 },
    { id: 2264, nome: 'ALPINOPOLIS', codigo_ibge: 3101904, codigo_uf: 31 },
    { id: 2265, nome: 'ALTEROSA', codigo_ibge: 3102001, codigo_uf: 31 },
    { id: 2266, nome: 'ALTO CAPARAO', codigo_ibge: 3102050, codigo_uf: 31 },
    { id: 2868, nome: 'ALTO JEQUITIBA', codigo_ibge: 3153509, codigo_uf: 31 },
    { id: 2267, nome: 'ALTO RIO DOCE', codigo_ibge: 3102100, codigo_uf: 31 },
    { id: 2268, nome: 'ALVARENGA', codigo_ibge: 3102209, codigo_uf: 31 },
    { id: 2269, nome: 'ALVINOPOLIS', codigo_ibge: 3102308, codigo_uf: 31 },
    { id: 2270, nome: 'ALVORADA DE MINAS', codigo_ibge: 3102407, codigo_uf: 31 },
    { id: 2271, nome: 'AMPARO DO SERRA', codigo_ibge: 3102506, codigo_uf: 31 },
    { id: 2272, nome: 'ANDRADAS', codigo_ibge: 3102605, codigo_uf: 31 },
    { id: 2274, nome: 'ANDRELANDIA', codigo_ibge: 3102803, codigo_uf: 31 },
    { id: 2275, nome: 'ANGELANDIA', codigo_ibge: 3102852, codigo_uf: 31 },
    { id: 2276, nome: 'ANTONIO CARLOS', codigo_ibge: 3102902, codigo_uf: 31 },
    { id: 2277, nome: 'ANTONIO DIAS', codigo_ibge: 3103009, codigo_uf: 31 },
    { id: 2278, nome: 'ANTONIO PRADO DE MINAS', codigo_ibge: 3103108, codigo_uf: 31 },
    { id: 2279, nome: 'ARACAI', codigo_ibge: 3103207, codigo_uf: 31 },
    { id: 2280, nome: 'ARACITABA', codigo_ibge: 3103306, codigo_uf: 31 },
    { id: 2281, nome: 'ARACUAI', codigo_ibge: 3103405, codigo_uf: 31 },
    { id: 2282, nome: 'ARAGUARI', codigo_ibge: 3103504, codigo_uf: 31 },
    { id: 2283, nome: 'ARANTINA', codigo_ibge: 3103603, codigo_uf: 31 },
    { id: 2284, nome: 'ARAPONGA', codigo_ibge: 3103702, codigo_uf: 31 },
    { id: 2285, nome: 'ARAPORA', codigo_ibge: 3103751, codigo_uf: 31 },
    { id: 2286, nome: 'ARAPUA', codigo_ibge: 3103801, codigo_uf: 31 },
    { id: 2287, nome: 'ARAUJOS', codigo_ibge: 3103900, codigo_uf: 31 },
    { id: 2288, nome: 'ARAXA', codigo_ibge: 3104007, codigo_uf: 31 },
    { id: 2289, nome: 'ARCEBURGO', codigo_ibge: 3104106, codigo_uf: 31 },
    { id: 2290, nome: 'ARCOS', codigo_ibge: 3104205, codigo_uf: 31 },
    { id: 2291, nome: 'AREADO', codigo_ibge: 3104304, codigo_uf: 31 },
    { id: 2292, nome: 'ARGIRITA', codigo_ibge: 3104403, codigo_uf: 31 },
    { id: 2293, nome: 'ARICANDUVA', codigo_ibge: 3104452, codigo_uf: 31 },
    { id: 2294, nome: 'ARINOS', codigo_ibge: 3104502, codigo_uf: 31 },
    { id: 2295, nome: 'ASTOLFO DUTRA', codigo_ibge: 3104601, codigo_uf: 31 },
    { id: 2296, nome: 'ATALEIA', codigo_ibge: 3104700, codigo_uf: 31 },
    { id: 2297, nome: 'AUGUSTO DE LIMA', codigo_ibge: 3104809, codigo_uf: 31 },
    { id: 2298, nome: 'BAEPENDI', codigo_ibge: 3104908, codigo_uf: 31 },
    { id: 2299, nome: 'BALDIM', codigo_ibge: 3105004, codigo_uf: 31 },
    { id: 2300, nome: 'BAMBUI', codigo_ibge: 3105103, codigo_uf: 31 },
    { id: 2301, nome: 'BANDEIRA', codigo_ibge: 3105202, codigo_uf: 31 },
    { id: 2302, nome: 'BANDEIRA DO SUL', codigo_ibge: 3105301, codigo_uf: 31 },
    { id: 2303, nome: 'BARAO DE COCAIS', codigo_ibge: 3105400, codigo_uf: 31 },
    { id: 2304, nome: 'BARAO DE MONTE ALTO', codigo_ibge: 3105509, codigo_uf: 31 },
    { id: 2305, nome: 'BARBACENA', codigo_ibge: 3105608, codigo_uf: 31 },
    { id: 2306, nome: 'BARRA LONGA', codigo_ibge: 3105707, codigo_uf: 31 },
    { id: 2307, nome: 'BARROSO', codigo_ibge: 3105905, codigo_uf: 31 },
    { id: 2308, nome: 'BELA VISTA DE MINAS', codigo_ibge: 3106002, codigo_uf: 31 },
    { id: 2309, nome: 'BELMIRO BRAGA', codigo_ibge: 3106101, codigo_uf: 31 },
    { id: 2310, nome: 'BELO HORIZONTE', codigo_ibge: 3106200, codigo_uf: 31 },
    { id: 2311, nome: 'BELO ORIENTE', codigo_ibge: 3106309, codigo_uf: 31 },
    { id: 2312, nome: 'BELO VALE', codigo_ibge: 3106408, codigo_uf: 31 },
    { id: 2313, nome: 'BERILO', codigo_ibge: 3106507, codigo_uf: 31 },
    { id: 2315, nome: 'BERIZAL', codigo_ibge: 3106655, codigo_uf: 31 },
    { id: 2314, nome: 'BERTOPOLIS', codigo_ibge: 3106606, codigo_uf: 31 },
    { id: 2316, nome: 'BETIM', codigo_ibge: 3106705, codigo_uf: 31 },
    { id: 2317, nome: 'BIAS FORTES', codigo_ibge: 3106804, codigo_uf: 31 },
    { id: 2318, nome: 'BICAS', codigo_ibge: 3106903, codigo_uf: 31 },
    { id: 2319, nome: 'BIQUINHAS', codigo_ibge: 3107000, codigo_uf: 31 },
    { id: 2320, nome: 'BOA ESPERANCA', codigo_ibge: 3107109, codigo_uf: 31 },
    { id: 2321, nome: 'BOCAINA DE MINAS', codigo_ibge: 3107208, codigo_uf: 31 },
    { id: 2322, nome: 'BOCAIUVA', codigo_ibge: 3107307, codigo_uf: 31 },
    { id: 2323, nome: 'BOM DESPACHO', codigo_ibge: 3107406, codigo_uf: 31 },
    { id: 2324, nome: 'BOM JARDIM DE MINAS', codigo_ibge: 3107505, codigo_uf: 31 },
    { id: 2325, nome: 'BOM JESUS DA PENHA', codigo_ibge: 3107604, codigo_uf: 31 },
    { id: 2326, nome: 'BOM JESUS DO AMPARO', codigo_ibge: 3107703, codigo_uf: 31 },
    { id: 2327, nome: 'BOM JESUS DO GALHO', codigo_ibge: 3107802, codigo_uf: 31 },
    { id: 2328, nome: 'BOM REPOUSO', codigo_ibge: 3107901, codigo_uf: 31 },
    { id: 2329, nome: 'BOM SUCESSO', codigo_ibge: 3108008, codigo_uf: 31 },
    { id: 2330, nome: 'BONFIM', codigo_ibge: 3108107, codigo_uf: 31 },
    { id: 2331, nome: 'BONFINOPOLIS DE MINAS', codigo_ibge: 3108206, codigo_uf: 31 },
    { id: 2332, nome: 'BONITO DE MINAS', codigo_ibge: 3108255, codigo_uf: 31 },
    { id: 2333, nome: 'BORDA DA MATA', codigo_ibge: 3108305, codigo_uf: 31 },
    { id: 2334, nome: 'BOTELHOS', codigo_ibge: 3108404, codigo_uf: 31 },
    { id: 2335, nome: 'BOTUMIRIM', codigo_ibge: 3108503, codigo_uf: 31 },
    { id: 2338, nome: 'BRAS PIRES', codigo_ibge: 3108701, codigo_uf: 31 },
    { id: 2336, nome: 'BRASILANDIA DE MINAS', codigo_ibge: 3108552, codigo_uf: 31 },
    { id: 2337, nome: 'BRASILIA DE MINAS', codigo_ibge: 3108602, codigo_uf: 31 },
    { id: 2339, nome: 'BRAUNAS', codigo_ibge: 3108800, codigo_uf: 31 },
    { id: 2340, nome: 'BRAZOPOLIS', codigo_ibge: 3108909, codigo_uf: 31 },
    { id: 2341, nome: 'BRUMADINHO', codigo_ibge: 3109006, codigo_uf: 31 },
    { id: 2342, nome: 'BUENO BRANDAO', codigo_ibge: 3109105, codigo_uf: 31 },
    { id: 2343, nome: 'BUENOPOLIS', codigo_ibge: 3109204, codigo_uf: 31 },
    { id: 2344, nome: 'BUGRE', codigo_ibge: 3109253, codigo_uf: 31 },
    { id: 2345, nome: 'BURITIS', codigo_ibge: 3109303, codigo_uf: 31 },
    { id: 2346, nome: 'BURITIZEIRO', codigo_ibge: 3109402, codigo_uf: 31 },
    { id: 2347, nome: 'CABECEIRA GRANDE', codigo_ibge: 3109451, codigo_uf: 31 },
    { id: 2348, nome: 'CABO VERDE', codigo_ibge: 3109501, codigo_uf: 31 },
    { id: 2349, nome: 'CACHOEIRA DA PRATA', codigo_ibge: 3109600, codigo_uf: 31 },
    { id: 2350, nome: 'CACHOEIRA DE MINAS', codigo_ibge: 3109709, codigo_uf: 31 },
    { id: 2273, nome: 'CACHOEIRA DE PAJEU', codigo_ibge: 3102704, codigo_uf: 31 },
    { id: 2351, nome: 'CACHOEIRA DOURADA', codigo_ibge: 3109808, codigo_uf: 31 },
    { id: 2352, nome: 'CAETANOPOLIS', codigo_ibge: 3109907, codigo_uf: 31 },
    { id: 2353, nome: 'CAETE', codigo_ibge: 3110004, codigo_uf: 31 },
    { id: 2354, nome: 'CAIANA', codigo_ibge: 3110103, codigo_uf: 31 },
    { id: 2355, nome: 'CAJURI', codigo_ibge: 3110202, codigo_uf: 31 },
    { id: 2356, nome: 'CALDAS', codigo_ibge: 3110301, codigo_uf: 31 },
    { id: 2357, nome: 'CAMACHO', codigo_ibge: 3110400, codigo_uf: 31 },
    { id: 2358, nome: 'CAMANDUCAIA', codigo_ibge: 3110509, codigo_uf: 31 },
    { id: 2359, nome: 'CAMBUI', codigo_ibge: 3110608, codigo_uf: 31 },
    { id: 2360, nome: 'CAMBUQUIRA', codigo_ibge: 3110707, codigo_uf: 31 },
    { id: 2361, nome: 'CAMPANARIO', codigo_ibge: 3110806, codigo_uf: 31 },
    { id: 2362, nome: 'CAMPANHA', codigo_ibge: 3110905, codigo_uf: 31 },
    { id: 2363, nome: 'CAMPESTRE', codigo_ibge: 3111002, codigo_uf: 31 },
    { id: 2364, nome: 'CAMPINA VERDE', codigo_ibge: 3111101, codigo_uf: 31 },
    { id: 2365, nome: 'CAMPO AZUL', codigo_ibge: 3111150, codigo_uf: 31 },
    { id: 2366, nome: 'CAMPO BELO', codigo_ibge: 3111200, codigo_uf: 31 },
    { id: 2367, nome: 'CAMPO DO MEIO', codigo_ibge: 3111309, codigo_uf: 31 },
    { id: 2368, nome: 'CAMPO FLORIDO', codigo_ibge: 3111408, codigo_uf: 31 },
    { id: 2369, nome: 'CAMPOS ALTOS', codigo_ibge: 3111507, codigo_uf: 31 },
    { id: 2370, nome: 'CAMPOS GERAIS', codigo_ibge: 3111606, codigo_uf: 31 },
    { id: 2373, nome: 'CANA VERDE', codigo_ibge: 3111903, codigo_uf: 31 },
    { id: 2371, nome: 'CANAA', codigo_ibge: 3111705, codigo_uf: 31 },
    { id: 2372, nome: 'CANAPOLIS', codigo_ibge: 3111804, codigo_uf: 31 },
    { id: 2374, nome: 'CANDEIAS', codigo_ibge: 3112000, codigo_uf: 31 },
    { id: 2375, nome: 'CANTAGALO', codigo_ibge: 3112059, codigo_uf: 31 },
    { id: 2376, nome: 'CAPARAO', codigo_ibge: 3112109, codigo_uf: 31 },
    { id: 2377, nome: 'CAPELA NOVA', codigo_ibge: 3112208, codigo_uf: 31 },
    { id: 2378, nome: 'CAPELINHA', codigo_ibge: 3112307, codigo_uf: 31 },
    { id: 2379, nome: 'CAPETINGA', codigo_ibge: 3112406, codigo_uf: 31 },
    { id: 2380, nome: 'CAPIM BRANCO', codigo_ibge: 3112505, codigo_uf: 31 },
    { id: 2381, nome: 'CAPINOPOLIS', codigo_ibge: 3112604, codigo_uf: 31 },
    { id: 2382, nome: 'CAPITAO ANDRADE', codigo_ibge: 3112653, codigo_uf: 31 },
    { id: 2383, nome: 'CAPITAO ENEAS', codigo_ibge: 3112703, codigo_uf: 31 },
    { id: 2384, nome: 'CAPITOLIO', codigo_ibge: 3112802, codigo_uf: 31 },
    { id: 2385, nome: 'CAPUTIRA', codigo_ibge: 3112901, codigo_uf: 31 },
    { id: 2386, nome: 'CARAI', codigo_ibge: 3113008, codigo_uf: 31 },
    { id: 2387, nome: 'CARANAIBA', codigo_ibge: 3113107, codigo_uf: 31 },
    { id: 2388, nome: 'CARANDAI', codigo_ibge: 3113206, codigo_uf: 31 },
    { id: 2389, nome: 'CARANGOLA', codigo_ibge: 3113305, codigo_uf: 31 },
    { id: 2390, nome: 'CARATINGA', codigo_ibge: 3113404, codigo_uf: 31 },
    { id: 2391, nome: 'CARBONITA', codigo_ibge: 3113503, codigo_uf: 31 },
    { id: 2392, nome: 'CAREACU', codigo_ibge: 3113602, codigo_uf: 31 },
    { id: 2393, nome: 'CARLOS CHAGAS', codigo_ibge: 3113701, codigo_uf: 31 },
    { id: 2394, nome: 'CARMESIA', codigo_ibge: 3113800, codigo_uf: 31 },
    { id: 2395, nome: 'CARMO DA CACHOEIRA', codigo_ibge: 3113909, codigo_uf: 31 },
    { id: 2396, nome: 'CARMO DA MATA', codigo_ibge: 3114006, codigo_uf: 31 },
    { id: 2397, nome: 'CARMO DE MINAS', codigo_ibge: 3114105, codigo_uf: 31 },
    { id: 2398, nome: 'CARMO DO CAJURU', codigo_ibge: 3114204, codigo_uf: 31 },
    { id: 2399, nome: 'CARMO DO PARANAIBA', codigo_ibge: 3114303, codigo_uf: 31 },
    { id: 2400, nome: 'CARMO DO RIO CLARO', codigo_ibge: 3114402, codigo_uf: 31 },
    { id: 2401, nome: 'CARMOPOLIS DE MINAS', codigo_ibge: 3114501, codigo_uf: 31 },
    { id: 2402, nome: 'CARNEIRINHO', codigo_ibge: 3114550, codigo_uf: 31 },
    { id: 2403, nome: 'CARRANCAS', codigo_ibge: 3114600, codigo_uf: 31 },
    { id: 2404, nome: 'CARVALHOPOLIS', codigo_ibge: 3114709, codigo_uf: 31 },
    { id: 2405, nome: 'CARVALHOS', codigo_ibge: 3114808, codigo_uf: 31 },
    { id: 2406, nome: 'CASA GRANDE', codigo_ibge: 3114907, codigo_uf: 31 },
    { id: 2407, nome: 'CASCALHO RICO', codigo_ibge: 3115003, codigo_uf: 31 },
    { id: 2408, nome: 'CASSIA', codigo_ibge: 3115102, codigo_uf: 31 },
    { id: 2410, nome: 'CATAGUASES', codigo_ibge: 3115300, codigo_uf: 31 },
    { id: 2411, nome: 'CATAS ALTAS', codigo_ibge: 3115359, codigo_uf: 31 },
    { id: 2412, nome: 'CATAS ALTAS DA NORUEGA', codigo_ibge: 3115409, codigo_uf: 31 },
    { id: 2413, nome: 'CATUJI', codigo_ibge: 3115458, codigo_uf: 31 },
    { id: 2414, nome: 'CATUTI', codigo_ibge: 3115474, codigo_uf: 31 },
    { id: 2415, nome: 'CAXAMBU', codigo_ibge: 3115508, codigo_uf: 31 },
    { id: 2416, nome: 'CEDRO DO ABAETE', codigo_ibge: 3115607, codigo_uf: 31 },
    { id: 2417, nome: 'CENTRAL DE MINAS', codigo_ibge: 3115706, codigo_uf: 31 },
    { id: 2418, nome: 'CENTRALINA', codigo_ibge: 3115805, codigo_uf: 31 },
    { id: 2419, nome: 'CHACARA', codigo_ibge: 3115904, codigo_uf: 31 },
    { id: 2420, nome: 'CHALE', codigo_ibge: 3116001, codigo_uf: 31 },
    { id: 2421, nome: 'CHAPADA DO NORTE', codigo_ibge: 3116100, codigo_uf: 31 },
    { id: 2422, nome: 'CHAPADA GAUCHA', codigo_ibge: 3116159, codigo_uf: 31 },
    { id: 2423, nome: 'CHIADOR', codigo_ibge: 3116209, codigo_uf: 31 },
    { id: 2424, nome: 'CIPOTANEA', codigo_ibge: 3116308, codigo_uf: 31 },
    { id: 2425, nome: 'CLARAVAL', codigo_ibge: 3116407, codigo_uf: 31 },
    { id: 2426, nome: 'CLARO DOS POCOES', codigo_ibge: 3116506, codigo_uf: 31 },
    { id: 2427, nome: 'CLAUDIO', codigo_ibge: 3116605, codigo_uf: 31 },
    { id: 2428, nome: 'COIMBRA', codigo_ibge: 3116704, codigo_uf: 31 },
    { id: 2429, nome: 'COLUNA', codigo_ibge: 3116803, codigo_uf: 31 },
    { id: 2430, nome: 'COMENDADOR GOMES', codigo_ibge: 3116902, codigo_uf: 31 },
    { id: 2431, nome: 'COMERCINHO', codigo_ibge: 3117009, codigo_uf: 31 },
    { id: 2432, nome: 'CONCEICAO DA APARECIDA', codigo_ibge: 3117108, codigo_uf: 31 },
    { id: 2409, nome: 'CONCEICAO DA BARRA DE MINAS', codigo_ibge: 3115201, codigo_uf: 31 },
    { id: 2434, nome: 'CONCEICAO DAS ALAGOAS', codigo_ibge: 3117306, codigo_uf: 31 },
    { id: 2433, nome: 'CONCEICAO DAS PEDRAS', codigo_ibge: 3117207, codigo_uf: 31 },
    { id: 2435, nome: 'CONCEICAO DE IPANEMA', codigo_ibge: 3117405, codigo_uf: 31 },
    { id: 2436, nome: 'CONCEICAO DO MATO DENTRO', codigo_ibge: 3117504, codigo_uf: 31 },
    { id: 2437, nome: 'CONCEICAO DO PARA', codigo_ibge: 3117603, codigo_uf: 31 },
    { id: 2438, nome: 'CONCEICAO DO RIO VERDE', codigo_ibge: 3117702, codigo_uf: 31 },
    { id: 2439, nome: 'CONCEICAO DOS OUROS', codigo_ibge: 3117801, codigo_uf: 31 },
    { id: 2440, nome: 'CONEGO MARINHO', codigo_ibge: 3117836, codigo_uf: 31 },
    { id: 2441, nome: 'CONFINS', codigo_ibge: 3117876, codigo_uf: 31 },
    { id: 2442, nome: 'CONGONHAL', codigo_ibge: 3117900, codigo_uf: 31 },
    { id: 2443, nome: 'CONGONHAS', codigo_ibge: 3118007, codigo_uf: 31 },
    { id: 2444, nome: 'CONGONHAS DO NORTE', codigo_ibge: 3118106, codigo_uf: 31 },
    { id: 2445, nome: 'CONQUISTA', codigo_ibge: 3118205, codigo_uf: 31 },
    { id: 2446, nome: 'CONSELHEIRO LAFAIETE', codigo_ibge: 3118304, codigo_uf: 31 },
    { id: 2447, nome: 'CONSELHEIRO PENA', codigo_ibge: 3118403, codigo_uf: 31 },
    { id: 2448, nome: 'CONSOLACAO', codigo_ibge: 3118502, codigo_uf: 31 },
    { id: 2449, nome: 'CONTAGEM', codigo_ibge: 3118601, codigo_uf: 31 },
    { id: 2450, nome: 'COQUEIRAL', codigo_ibge: 3118700, codigo_uf: 31 },
    { id: 2451, nome: 'CORACAO DE JESUS', codigo_ibge: 3118809, codigo_uf: 31 },
    { id: 2452, nome: 'CORDISBURGO', codigo_ibge: 3118908, codigo_uf: 31 },
    { id: 2453, nome: 'CORDISLANDIA', codigo_ibge: 3119005, codigo_uf: 31 },
    { id: 2454, nome: 'CORINTO', codigo_ibge: 3119104, codigo_uf: 31 },
    { id: 2455, nome: 'COROACI', codigo_ibge: 3119203, codigo_uf: 31 },
    { id: 2456, nome: 'COROMANDEL', codigo_ibge: 3119302, codigo_uf: 31 },
    { id: 2457, nome: 'CORONEL FABRICIANO', codigo_ibge: 3119401, codigo_uf: 31 },
    { id: 2458, nome: 'CORONEL MURTA', codigo_ibge: 3119500, codigo_uf: 31 },
    { id: 2459, nome: 'CORONEL PACHECO', codigo_ibge: 3119609, codigo_uf: 31 },
    { id: 2460, nome: 'CORONEL XAVIER CHAVES', codigo_ibge: 3119708, codigo_uf: 31 },
    { id: 2461, nome: 'CORREGO DANTA', codigo_ibge: 3119807, codigo_uf: 31 },
    { id: 2462, nome: 'CORREGO DO BOM JESUS', codigo_ibge: 3119906, codigo_uf: 31 },
    { id: 2463, nome: 'CORREGO FUNDO', codigo_ibge: 3119955, codigo_uf: 31 },
    { id: 2464, nome: 'CORREGO NOVO', codigo_ibge: 3120003, codigo_uf: 31 },
    { id: 2465, nome: 'COUTO DE MAGALHAES DE MINAS', codigo_ibge: 3120102, codigo_uf: 31 },
    { id: 2466, nome: 'CRISOLITA', codigo_ibge: 3120151, codigo_uf: 31 },
    { id: 2467, nome: 'CRISTAIS', codigo_ibge: 3120201, codigo_uf: 31 },
    { id: 2468, nome: 'CRISTALIA', codigo_ibge: 3120300, codigo_uf: 31 },
    { id: 2469, nome: 'CRISTIANO OTONI', codigo_ibge: 3120409, codigo_uf: 31 },
    { id: 2470, nome: 'CRISTINA', codigo_ibge: 3120508, codigo_uf: 31 },
    { id: 2471, nome: 'CRUCILANDIA', codigo_ibge: 3120607, codigo_uf: 31 },
    { id: 2472, nome: 'CRUZEIRO DA FORTALEZA', codigo_ibge: 3120706, codigo_uf: 31 },
    { id: 2473, nome: 'CRUZILIA', codigo_ibge: 3120805, codigo_uf: 31 },
    { id: 2474, nome: 'CUPARAQUE', codigo_ibge: 3120839, codigo_uf: 31 },
    { id: 2475, nome: 'CURRAL DE DENTRO', codigo_ibge: 3120870, codigo_uf: 31 },
    { id: 2476, nome: 'CURVELO', codigo_ibge: 3120904, codigo_uf: 31 },
    { id: 2477, nome: 'DATAS', codigo_ibge: 3121001, codigo_uf: 31 },
    { id: 2478, nome: 'DELFIM MOREIRA', codigo_ibge: 3121100, codigo_uf: 31 },
    { id: 2479, nome: 'DELFINOPOLIS', codigo_ibge: 3121209, codigo_uf: 31 },
    { id: 2480, nome: 'DELTA', codigo_ibge: 3121258, codigo_uf: 31 },
    { id: 2481, nome: 'DESCOBERTO', codigo_ibge: 3121308, codigo_uf: 31 },
    { id: 2482, nome: 'DESTERRO DE ENTRE RIOS', codigo_ibge: 3121407, codigo_uf: 31 },
    { id: 2483, nome: 'DESTERRO DO MELO', codigo_ibge: 3121506, codigo_uf: 31 },
    { id: 2484, nome: 'DIAMANTINA', codigo_ibge: 3121605, codigo_uf: 31 },
    { id: 2485, nome: 'DIOGO DE VASCONCELOS', codigo_ibge: 3121704, codigo_uf: 31 },
    { id: 2486, nome: 'DIONISIO', codigo_ibge: 3121803, codigo_uf: 31 },
    { id: 2487, nome: 'DIVINESIA', codigo_ibge: 3121902, codigo_uf: 31 },
    { id: 2488, nome: 'DIVINO', codigo_ibge: 3122009, codigo_uf: 31 },
    { id: 2489, nome: 'DIVINO DAS LARANJEIRAS', codigo_ibge: 3122108, codigo_uf: 31 },
    { id: 2490, nome: 'DIVINOLANDIA DE MINAS', codigo_ibge: 3122207, codigo_uf: 31 },
    { id: 2491, nome: 'DIVINOPOLIS', codigo_ibge: 3122306, codigo_uf: 31 },
    { id: 2492, nome: 'DIVISA ALEGRE', codigo_ibge: 3122355, codigo_uf: 31 },
    { id: 2493, nome: 'DIVISA NOVA', codigo_ibge: 3122405, codigo_uf: 31 },
    { id: 2494, nome: 'DIVISOPOLIS', codigo_ibge: 3122454, codigo_uf: 31 },
    { id: 2495, nome: 'DOM BOSCO', codigo_ibge: 3122470, codigo_uf: 31 },
    { id: 2496, nome: 'DOM CAVATI', codigo_ibge: 3122504, codigo_uf: 31 },
    { id: 2497, nome: 'DOM JOAQUIM', codigo_ibge: 3122603, codigo_uf: 31 },
    { id: 2498, nome: 'DOM SILVERIO', codigo_ibge: 3122702, codigo_uf: 31 },
    { id: 2499, nome: 'DOM VICOSO', codigo_ibge: 3122801, codigo_uf: 31 },
    { id: 2500, nome: 'DONA EUSEBIA', codigo_ibge: 3122900, codigo_uf: 31 },
    { id: 2501, nome: 'DORES DE CAMPOS', codigo_ibge: 3123007, codigo_uf: 31 },
    { id: 2502, nome: 'DORES DE GUANHAES', codigo_ibge: 3123106, codigo_uf: 31 },
    { id: 2503, nome: 'DORES DO INDAIA', codigo_ibge: 3123205, codigo_uf: 31 },
    { id: 2504, nome: 'DORES DO TURVO', codigo_ibge: 3123304, codigo_uf: 31 },
    { id: 2505, nome: 'DORESOPOLIS', codigo_ibge: 3123403, codigo_uf: 31 },
    { id: 2506, nome: 'DOURADOQUARA', codigo_ibge: 3123502, codigo_uf: 31 },
    { id: 2507, nome: 'DURANDE', codigo_ibge: 3123528, codigo_uf: 31 },
    { id: 2508, nome: 'ELOI MENDES', codigo_ibge: 3123601, codigo_uf: 31 },
    { id: 2509, nome: 'ENGENHEIRO CALDAS', codigo_ibge: 3123700, codigo_uf: 31 },
    { id: 2510, nome: 'ENGENHEIRO NAVARRO', codigo_ibge: 3123809, codigo_uf: 31 },
    { id: 2511, nome: 'ENTRE FOLHAS', codigo_ibge: 3123858, codigo_uf: 31 },
    { id: 2512, nome: 'ENTRE RIOS DE MINAS', codigo_ibge: 3123908, codigo_uf: 31 },
    { id: 2513, nome: 'ERVALIA', codigo_ibge: 3124005, codigo_uf: 31 },
    { id: 2514, nome: 'ESMERALDAS', codigo_ibge: 3124104, codigo_uf: 31 },
    { id: 2515, nome: 'ESPERA FELIZ', codigo_ibge: 3124203, codigo_uf: 31 },
    { id: 2516, nome: 'ESPINOSA', codigo_ibge: 3124302, codigo_uf: 31 },
    { id: 2517, nome: 'ESPIRITO SANTO DO DOURADO', codigo_ibge: 3124401, codigo_uf: 31 },
    { id: 2518, nome: 'ESTIVA', codigo_ibge: 3124500, codigo_uf: 31 },
    { id: 2519, nome: 'ESTRELA DALVA', codigo_ibge: 3124609, codigo_uf: 31 },
    { id: 2520, nome: 'ESTRELA DO INDAIA', codigo_ibge: 3124708, codigo_uf: 31 },
    { id: 2521, nome: 'ESTRELA DO SUL', codigo_ibge: 3124807, codigo_uf: 31 },
    { id: 2522, nome: 'EUGENOPOLIS', codigo_ibge: 3124906, codigo_uf: 31 },
    { id: 2523, nome: 'EWBANK DA CAMARA', codigo_ibge: 3125002, codigo_uf: 31 },
    { id: 2524, nome: 'EXTREMA', codigo_ibge: 3125101, codigo_uf: 31 },
    { id: 2525, nome: 'FAMA', codigo_ibge: 3125200, codigo_uf: 31 },
    { id: 2526, nome: 'FARIA LEMOS', codigo_ibge: 3125309, codigo_uf: 31 },
    { id: 2527, nome: 'FELICIO DOS SANTOS', codigo_ibge: 3125408, codigo_uf: 31 },
    { id: 2529, nome: 'FELISBURGO', codigo_ibge: 3125606, codigo_uf: 31 },
    { id: 2530, nome: 'FELIXLANDIA', codigo_ibge: 3125705, codigo_uf: 31 },
    { id: 2531, nome: 'FERNANDES TOURINHO', codigo_ibge: 3125804, codigo_uf: 31 },
    { id: 2532, nome: 'FERROS', codigo_ibge: 3125903, codigo_uf: 31 },
    { id: 2533, nome: 'FERVEDOURO', codigo_ibge: 3125952, codigo_uf: 31 },
    { id: 2534, nome: 'FLORESTAL', codigo_ibge: 3126000, codigo_uf: 31 },
    { id: 2535, nome: 'FORMIGA', codigo_ibge: 3126109, codigo_uf: 31 },
    { id: 2536, nome: 'FORMOSO', codigo_ibge: 3126208, codigo_uf: 31 },
    { id: 2537, nome: 'FORTALEZA DE MINAS', codigo_ibge: 3126307, codigo_uf: 31 },
    { id: 2538, nome: 'FORTUNA DE MINAS', codigo_ibge: 3126406, codigo_uf: 31 },
    { id: 2539, nome: 'FRANCISCO BADARO', codigo_ibge: 3126505, codigo_uf: 31 },
    { id: 2540, nome: 'FRANCISCO DUMONT', codigo_ibge: 3126604, codigo_uf: 31 },
    { id: 2541, nome: 'FRANCISCO SA', codigo_ibge: 3126703, codigo_uf: 31 },
    { id: 2542, nome: 'FRANCISCOPOLIS', codigo_ibge: 3126752, codigo_uf: 31 },
    { id: 2543, nome: 'FREI GASPAR', codigo_ibge: 3126802, codigo_uf: 31 },
    { id: 2544, nome: 'FREI INOCENCIO', codigo_ibge: 3126901, codigo_uf: 31 },
    { id: 2545, nome: 'FREI LAGONEGRO', codigo_ibge: 3126950, codigo_uf: 31 },
    { id: 2546, nome: 'FRONTEIRA', codigo_ibge: 3127008, codigo_uf: 31 },
    { id: 2547, nome: 'FRONTEIRA DOS VALES', codigo_ibge: 3127057, codigo_uf: 31 },
    { id: 2548, nome: 'FRUTA DE LEITE', codigo_ibge: 3127073, codigo_uf: 31 },
    { id: 2549, nome: 'FRUTAL', codigo_ibge: 3127107, codigo_uf: 31 },
    { id: 2550, nome: 'FUNILANDIA', codigo_ibge: 3127206, codigo_uf: 31 },
    { id: 2551, nome: 'GALILEIA', codigo_ibge: 3127305, codigo_uf: 31 },
    { id: 2552, nome: 'GAMELEIRAS', codigo_ibge: 3127339, codigo_uf: 31 },
    { id: 2553, nome: 'GLAUCILANDIA', codigo_ibge: 3127354, codigo_uf: 31 },
    { id: 2554, nome: 'GOIABEIRA', codigo_ibge: 3127370, codigo_uf: 31 },
    { id: 2555, nome: 'GOIANA', codigo_ibge: 3127388, codigo_uf: 31 },
    { id: 2556, nome: 'GONCALVES', codigo_ibge: 3127404, codigo_uf: 31 },
    { id: 2557, nome: 'GONZAGA', codigo_ibge: 3127503, codigo_uf: 31 },
    { id: 2558, nome: 'GOUVEIA', codigo_ibge: 3127602, codigo_uf: 31 },
    { id: 2559, nome: 'GOVERNADOR VALADARES', codigo_ibge: 3127701, codigo_uf: 31 },
    { id: 2560, nome: 'GRAO MOGOL', codigo_ibge: 3127800, codigo_uf: 31 },
    { id: 2561, nome: 'GRUPIARA', codigo_ibge: 3127909, codigo_uf: 31 },
    { id: 2562, nome: 'GUANHAES', codigo_ibge: 3128006, codigo_uf: 31 },
    { id: 2563, nome: 'GUAPE', codigo_ibge: 3128105, codigo_uf: 31 },
    { id: 2564, nome: 'GUARACIABA', codigo_ibge: 3128204, codigo_uf: 31 },
    { id: 2565, nome: 'GUARACIAMA', codigo_ibge: 3128253, codigo_uf: 31 },
    { id: 2566, nome: 'GUARANESIA', codigo_ibge: 3128303, codigo_uf: 31 },
    { id: 2567, nome: 'GUARANI', codigo_ibge: 3128402, codigo_uf: 31 },
    { id: 2568, nome: 'GUARARA', codigo_ibge: 3128501, codigo_uf: 31 },
    { id: 2569, nome: 'GUARDA-MOR', codigo_ibge: 3128600, codigo_uf: 31 },
    { id: 2570, nome: 'GUAXUPE', codigo_ibge: 3128709, codigo_uf: 31 },
    { id: 2571, nome: 'GUIDOVAL', codigo_ibge: 3128808, codigo_uf: 31 },
    { id: 2572, nome: 'GUIMARANIA', codigo_ibge: 3128907, codigo_uf: 31 },
    { id: 2573, nome: 'GUIRICEMA', codigo_ibge: 3129004, codigo_uf: 31 },
    { id: 2574, nome: 'GURINHATA', codigo_ibge: 3129103, codigo_uf: 31 },
    { id: 2575, nome: 'HELIODORA', codigo_ibge: 3129202, codigo_uf: 31 },
    { id: 2576, nome: 'IAPU', codigo_ibge: 3129301, codigo_uf: 31 },
    { id: 2577, nome: 'IBERTIOGA', codigo_ibge: 3129400, codigo_uf: 31 },
    { id: 2578, nome: 'IBIA', codigo_ibge: 3129509, codigo_uf: 31 },
    { id: 2579, nome: 'IBIAI', codigo_ibge: 3129608, codigo_uf: 31 },
    { id: 2580, nome: 'IBIRACATU', codigo_ibge: 3129657, codigo_uf: 31 },
    { id: 2581, nome: 'IBIRACI', codigo_ibge: 3129707, codigo_uf: 31 },
    { id: 2582, nome: 'IBIRITE', codigo_ibge: 3129806, codigo_uf: 31 },
    { id: 2583, nome: 'IBITIURA DE MINAS', codigo_ibge: 3129905, codigo_uf: 31 },
    { id: 2584, nome: 'IBITURUNA', codigo_ibge: 3130002, codigo_uf: 31 },
    { id: 2585, nome: 'ICARAI DE MINAS', codigo_ibge: 3130051, codigo_uf: 31 },
    { id: 2586, nome: 'IGARAPE', codigo_ibge: 3130101, codigo_uf: 31 },
    { id: 2587, nome: 'IGARATINGA', codigo_ibge: 3130200, codigo_uf: 31 },
    { id: 2588, nome: 'IGUATAMA', codigo_ibge: 3130309, codigo_uf: 31 },
    { id: 2589, nome: 'IJACI', codigo_ibge: 3130408, codigo_uf: 31 },
    { id: 2590, nome: 'ILICINEA', codigo_ibge: 3130507, codigo_uf: 31 },
    { id: 2591, nome: 'IMBE DE MINAS', codigo_ibge: 3130556, codigo_uf: 31 },
    { id: 2592, nome: 'INCONFIDENTES', codigo_ibge: 3130606, codigo_uf: 31 },
    { id: 2593, nome: 'INDAIABIRA', codigo_ibge: 3130655, codigo_uf: 31 },
    { id: 2594, nome: 'INDIANOPOLIS', codigo_ibge: 3130705, codigo_uf: 31 },
    { id: 2595, nome: 'INGAI', codigo_ibge: 3130804, codigo_uf: 31 },
    { id: 2596, nome: 'INHAPIM', codigo_ibge: 3130903, codigo_uf: 31 },
    { id: 2597, nome: 'INHAUMA', codigo_ibge: 3131000, codigo_uf: 31 },
    { id: 2598, nome: 'INIMUTABA', codigo_ibge: 3131109, codigo_uf: 31 },
    { id: 2599, nome: 'IPABA', codigo_ibge: 3131158, codigo_uf: 31 },
    { id: 2600, nome: 'IPANEMA', codigo_ibge: 3131208, codigo_uf: 31 },
    { id: 2601, nome: 'IPATINGA', codigo_ibge: 3131307, codigo_uf: 31 },
    { id: 2602, nome: 'IPIACU', codigo_ibge: 3131406, codigo_uf: 31 },
    { id: 2603, nome: 'IPUIUNA', codigo_ibge: 3131505, codigo_uf: 31 },
    { id: 2604, nome: 'IRAI DE MINAS', codigo_ibge: 3131604, codigo_uf: 31 },
    { id: 2605, nome: 'ITABIRA', codigo_ibge: 3131703, codigo_uf: 31 },
    { id: 2606, nome: 'ITABIRINHA', codigo_ibge: 3131802, codigo_uf: 31 },
    { id: 2607, nome: 'ITABIRITO', codigo_ibge: 3131901, codigo_uf: 31 },
    { id: 2608, nome: 'ITACAMBIRA', codigo_ibge: 3132008, codigo_uf: 31 },
    { id: 2609, nome: 'ITACARAMBI', codigo_ibge: 3132107, codigo_uf: 31 },
    { id: 2610, nome: 'ITAGUARA', codigo_ibge: 3132206, codigo_uf: 31 },
    { id: 2611, nome: 'ITAIPE', codigo_ibge: 3132305, codigo_uf: 31 },
    { id: 2612, nome: 'ITAJUBA', codigo_ibge: 3132404, codigo_uf: 31 },
    { id: 2613, nome: 'ITAMARANDIBA', codigo_ibge: 3132503, codigo_uf: 31 },
    { id: 2614, nome: 'ITAMARATI DE MINAS', codigo_ibge: 3132602, codigo_uf: 31 },
    { id: 2615, nome: 'ITAMBACURI', codigo_ibge: 3132701, codigo_uf: 31 },
    { id: 2616, nome: 'ITAMBE DO MATO DENTRO', codigo_ibge: 3132800, codigo_uf: 31 },
    { id: 2617, nome: 'ITAMOGI', codigo_ibge: 3132909, codigo_uf: 31 },
    { id: 2618, nome: 'ITAMONTE', codigo_ibge: 3133006, codigo_uf: 31 },
    { id: 2619, nome: 'ITANHANDU', codigo_ibge: 3133105, codigo_uf: 31 },
    { id: 2620, nome: 'ITANHOMI', codigo_ibge: 3133204, codigo_uf: 31 },
    { id: 2621, nome: 'ITAOBIM', codigo_ibge: 3133303, codigo_uf: 31 },
    { id: 2622, nome: 'ITAPAGIPE', codigo_ibge: 3133402, codigo_uf: 31 },
    { id: 2623, nome: 'ITAPECERICA', codigo_ibge: 3133501, codigo_uf: 31 },
    { id: 2624, nome: 'ITAPEVA', codigo_ibge: 3133600, codigo_uf: 31 },
    { id: 2625, nome: 'ITATIAIUCU', codigo_ibge: 3133709, codigo_uf: 31 },
    { id: 2626, nome: 'ITAU DE MINAS', codigo_ibge: 3133758, codigo_uf: 31 },
    { id: 2627, nome: 'ITAUNA', codigo_ibge: 3133808, codigo_uf: 31 },
    { id: 2628, nome: 'ITAVERAVA', codigo_ibge: 3133907, codigo_uf: 31 },
    { id: 2629, nome: 'ITINGA', codigo_ibge: 3134004, codigo_uf: 31 },
    { id: 2630, nome: 'ITUETA', codigo_ibge: 3134103, codigo_uf: 31 },
    { id: 2631, nome: 'ITUIUTABA', codigo_ibge: 3134202, codigo_uf: 31 },
    { id: 2632, nome: 'ITUMIRIM', codigo_ibge: 3134301, codigo_uf: 31 },
    { id: 2633, nome: 'ITURAMA', codigo_ibge: 3134400, codigo_uf: 31 },
    { id: 2634, nome: 'ITUTINGA', codigo_ibge: 3134509, codigo_uf: 31 },
    { id: 2635, nome: 'JABOTICATUBAS', codigo_ibge: 3134608, codigo_uf: 31 },
    { id: 2636, nome: 'JACINTO', codigo_ibge: 3134707, codigo_uf: 31 },
    { id: 2637, nome: 'JACUI', codigo_ibge: 3134806, codigo_uf: 31 },
    { id: 2638, nome: 'JACUTINGA', codigo_ibge: 3134905, codigo_uf: 31 },
    { id: 2639, nome: 'JAGUARACU', codigo_ibge: 3135001, codigo_uf: 31 },
    { id: 2640, nome: 'JAIBA', codigo_ibge: 3135050, codigo_uf: 31 },
    { id: 2641, nome: 'JAMPRUCA', codigo_ibge: 3135076, codigo_uf: 31 },
    { id: 2642, nome: 'JANAUBA', codigo_ibge: 3135100, codigo_uf: 31 },
    { id: 2643, nome: 'JANUARIA', codigo_ibge: 3135209, codigo_uf: 31 },
    { id: 2644, nome: 'JAPARAIBA', codigo_ibge: 3135308, codigo_uf: 31 },
    { id: 2645, nome: 'JAPONVAR', codigo_ibge: 3135357, codigo_uf: 31 },
    { id: 2646, nome: 'JECEABA', codigo_ibge: 3135407, codigo_uf: 31 },
    { id: 2647, nome: 'JENIPAPO DE MINAS', codigo_ibge: 3135456, codigo_uf: 31 },
    { id: 2648, nome: 'JEQUERI', codigo_ibge: 3135506, codigo_uf: 31 },
    { id: 2649, nome: 'JEQUITAI', codigo_ibge: 3135605, codigo_uf: 31 },
    { id: 2650, nome: 'JEQUITIBA', codigo_ibge: 3135704, codigo_uf: 31 },
    { id: 2651, nome: 'JEQUITINHONHA', codigo_ibge: 3135803, codigo_uf: 31 },
    { id: 2652, nome: 'JESUANIA', codigo_ibge: 3135902, codigo_uf: 31 },
    { id: 2653, nome: 'JOAIMA', codigo_ibge: 3136009, codigo_uf: 31 },
    { id: 2654, nome: 'JOANESIA', codigo_ibge: 3136108, codigo_uf: 31 },
    { id: 2655, nome: 'JOAO MONLEVADE', codigo_ibge: 3136207, codigo_uf: 31 },
    { id: 2656, nome: 'JOAO PINHEIRO', codigo_ibge: 3136306, codigo_uf: 31 },
    { id: 2657, nome: 'JOAQUIM FELICIO', codigo_ibge: 3136405, codigo_uf: 31 },
    { id: 2658, nome: 'JORDANIA', codigo_ibge: 3136504, codigo_uf: 31 },
    { id: 2659, nome: 'JOSE GONCALVES DE MINAS', codigo_ibge: 3136520, codigo_uf: 31 },
    { id: 2660, nome: 'JOSE RAYDAN', codigo_ibge: 3136553, codigo_uf: 31 },
    { id: 2661, nome: 'JOSENOPOLIS', codigo_ibge: 3136579, codigo_uf: 31 },
    { id: 2663, nome: 'JUATUBA', codigo_ibge: 3136652, codigo_uf: 31 },
    { id: 2664, nome: 'JUIZ DE FORA', codigo_ibge: 3136702, codigo_uf: 31 },
    { id: 2665, nome: 'JURAMENTO', codigo_ibge: 3136801, codigo_uf: 31 },
    { id: 2666, nome: 'JURUAIA', codigo_ibge: 3136900, codigo_uf: 31 },
    { id: 2667, nome: 'JUVENILIA', codigo_ibge: 3136959, codigo_uf: 31 },
    { id: 2668, nome: 'LADAINHA', codigo_ibge: 3137007, codigo_uf: 31 },
    { id: 2669, nome: 'LAGAMAR', codigo_ibge: 3137106, codigo_uf: 31 },
    { id: 2670, nome: 'LAGOA DA PRATA', codigo_ibge: 3137205, codigo_uf: 31 },
    { id: 2671, nome: 'LAGOA DOS PATOS', codigo_ibge: 3137304, codigo_uf: 31 },
    { id: 2672, nome: 'LAGOA DOURADA', codigo_ibge: 3137403, codigo_uf: 31 },
    { id: 2673, nome: 'LAGOA FORMOSA', codigo_ibge: 3137502, codigo_uf: 31 },
    { id: 2674, nome: 'LAGOA GRANDE', codigo_ibge: 3137536, codigo_uf: 31 },
    { id: 2675, nome: 'LAGOA SANTA', codigo_ibge: 3137601, codigo_uf: 31 },
    { id: 2676, nome: 'LAJINHA', codigo_ibge: 3137700, codigo_uf: 31 },
    { id: 2677, nome: 'LAMBARI', codigo_ibge: 3137809, codigo_uf: 31 },
    { id: 2678, nome: 'LAMIM', codigo_ibge: 3137908, codigo_uf: 31 },
    { id: 2679, nome: 'LARANJAL', codigo_ibge: 3138005, codigo_uf: 31 },
    { id: 2680, nome: 'LASSANCE', codigo_ibge: 3138104, codigo_uf: 31 },
    { id: 2681, nome: 'LAVRAS', codigo_ibge: 3138203, codigo_uf: 31 },
    { id: 2682, nome: 'LEANDRO FERREIRA', codigo_ibge: 3138302, codigo_uf: 31 },
    { id: 2683, nome: 'LEME DO PRADO', codigo_ibge: 3138351, codigo_uf: 31 },
    { id: 2684, nome: 'LEOPOLDINA', codigo_ibge: 3138401, codigo_uf: 31 },
    { id: 2685, nome: 'LIBERDADE', codigo_ibge: 3138500, codigo_uf: 31 },
    { id: 2686, nome: 'LIMA DUARTE', codigo_ibge: 3138609, codigo_uf: 31 },
    { id: 2687, nome: 'LIMEIRA DO OESTE', codigo_ibge: 3138625, codigo_uf: 31 },
    { id: 2688, nome: 'LONTRA', codigo_ibge: 3138658, codigo_uf: 31 },
    { id: 2689, nome: 'LUISBURGO', codigo_ibge: 3138674, codigo_uf: 31 },
    { id: 2690, nome: 'LUISLANDIA', codigo_ibge: 3138682, codigo_uf: 31 },
    { id: 2691, nome: 'LUMINARIAS', codigo_ibge: 3138708, codigo_uf: 31 },
    { id: 2692, nome: 'LUZ', codigo_ibge: 3138807, codigo_uf: 31 },
    { id: 2693, nome: 'MACHACALIS', codigo_ibge: 3138906, codigo_uf: 31 },
    { id: 2694, nome: 'MACHADO', codigo_ibge: 3139003, codigo_uf: 31 },
    { id: 2695, nome: 'MADRE DE DEUS DE MINAS', codigo_ibge: 3139102, codigo_uf: 31 },
    { id: 2696, nome: 'MALACACHETA', codigo_ibge: 3139201, codigo_uf: 31 },
    { id: 2697, nome: 'MAMONAS', codigo_ibge: 3139250, codigo_uf: 31 },
    { id: 2698, nome: 'MANGA', codigo_ibge: 3139300, codigo_uf: 31 },
    { id: 2699, nome: 'MANHUACU', codigo_ibge: 3139409, codigo_uf: 31 },
    { id: 2700, nome: 'MANHUMIRIM', codigo_ibge: 3139508, codigo_uf: 31 },
    { id: 2701, nome: 'MANTENA', codigo_ibge: 3139607, codigo_uf: 31 },
    { id: 2703, nome: 'MAR DE ESPANHA', codigo_ibge: 3139805, codigo_uf: 31 },
    { id: 2702, nome: 'MARAVILHAS', codigo_ibge: 3139706, codigo_uf: 31 },
    { id: 2704, nome: 'MARIA DA FE', codigo_ibge: 3139904, codigo_uf: 31 },
    { id: 2705, nome: 'MARIANA', codigo_ibge: 3140001, codigo_uf: 31 },
    { id: 2706, nome: 'MARILAC', codigo_ibge: 3140100, codigo_uf: 31 },
    { id: 2707, nome: 'MARIO CAMPOS', codigo_ibge: 3140159, codigo_uf: 31 },
    { id: 2708, nome: 'MARIPA DE MINAS', codigo_ibge: 3140209, codigo_uf: 31 },
    { id: 2709, nome: 'MARLIERIA', codigo_ibge: 3140308, codigo_uf: 31 },
    { id: 2710, nome: 'MARMELOPOLIS', codigo_ibge: 3140407, codigo_uf: 31 },
    { id: 2711, nome: 'MARTINHO CAMPOS', codigo_ibge: 3140506, codigo_uf: 31 },
    { id: 2712, nome: 'MARTINS SOARES', codigo_ibge: 3140530, codigo_uf: 31 },
    { id: 2713, nome: 'MATA VERDE', codigo_ibge: 3140555, codigo_uf: 31 },
    { id: 2714, nome: 'MATERLANDIA', codigo_ibge: 3140605, codigo_uf: 31 },
    { id: 2715, nome: 'MATEUS LEME', codigo_ibge: 3140704, codigo_uf: 31 },
    { id: 3090, nome: 'MATHIAS LOBATO', codigo_ibge: 3171501, codigo_uf: 31 },
    { id: 2716, nome: 'MATIAS BARBOSA', codigo_ibge: 3140803, codigo_uf: 31 },
    { id: 2717, nome: 'MATIAS CARDOSO', codigo_ibge: 3140852, codigo_uf: 31 },
    { id: 2718, nome: 'MATIPO', codigo_ibge: 3140902, codigo_uf: 31 },
    { id: 2719, nome: 'MATO VERDE', codigo_ibge: 3141009, codigo_uf: 31 },
    { id: 2720, nome: 'MATOZINHOS', codigo_ibge: 3141108, codigo_uf: 31 },
    { id: 2721, nome: 'MATUTINA', codigo_ibge: 3141207, codigo_uf: 31 },
    { id: 2722, nome: 'MEDEIROS', codigo_ibge: 3141306, codigo_uf: 31 },
    { id: 2723, nome: 'MEDINA', codigo_ibge: 3141405, codigo_uf: 31 },
    { id: 2724, nome: 'MENDES PIMENTEL', codigo_ibge: 3141504, codigo_uf: 31 },
    { id: 2725, nome: 'MERCES', codigo_ibge: 3141603, codigo_uf: 31 },
    { id: 2726, nome: 'MESQUITA', codigo_ibge: 3141702, codigo_uf: 31 },
    { id: 2727, nome: 'MINAS NOVAS', codigo_ibge: 3141801, codigo_uf: 31 },
    { id: 2728, nome: 'MINDURI', codigo_ibge: 3141900, codigo_uf: 31 },
    { id: 2729, nome: 'MIRABELA', codigo_ibge: 3142007, codigo_uf: 31 },
    { id: 2730, nome: 'MIRADOURO', codigo_ibge: 3142106, codigo_uf: 31 },
    { id: 2731, nome: 'MIRAI', codigo_ibge: 3142205, codigo_uf: 31 },
    { id: 2732, nome: 'MIRAVANIA', codigo_ibge: 3142254, codigo_uf: 31 },
    { id: 2733, nome: 'MOEDA', codigo_ibge: 3142304, codigo_uf: 31 },
    { id: 2734, nome: 'MOEMA', codigo_ibge: 3142403, codigo_uf: 31 },
    { id: 2735, nome: 'MONJOLOS', codigo_ibge: 3142502, codigo_uf: 31 },
    { id: 2736, nome: 'MONSENHOR PAULO', codigo_ibge: 3142601, codigo_uf: 31 },
    { id: 2737, nome: 'MONTALVANIA', codigo_ibge: 3142700, codigo_uf: 31 },
    { id: 2738, nome: 'MONTE ALEGRE DE MINAS', codigo_ibge: 3142809, codigo_uf: 31 },
    { id: 2739, nome: 'MONTE AZUL', codigo_ibge: 3142908, codigo_uf: 31 },
    { id: 2740, nome: 'MONTE BELO', codigo_ibge: 3143005, codigo_uf: 31 },
    { id: 2741, nome: 'MONTE CARMELO', codigo_ibge: 3143104, codigo_uf: 31 },
    { id: 2742, nome: 'MONTE FORMOSO', codigo_ibge: 3143153, codigo_uf: 31 },
    { id: 2743, nome: 'MONTE SANTO DE MINAS', codigo_ibge: 3143203, codigo_uf: 31 },
    { id: 2745, nome: 'MONTE SIAO', codigo_ibge: 3143401, codigo_uf: 31 },
    { id: 2744, nome: 'MONTES CLAROS', codigo_ibge: 3143302, codigo_uf: 31 },
    { id: 2746, nome: 'MONTEZUMA', codigo_ibge: 3143450, codigo_uf: 31 },
    { id: 2747, nome: 'MORADA NOVA DE MINAS', codigo_ibge: 3143500, codigo_uf: 31 },
    { id: 2748, nome: 'MORRO DA GARCA', codigo_ibge: 3143609, codigo_uf: 31 },
    { id: 2749, nome: 'MORRO DO PILAR', codigo_ibge: 3143708, codigo_uf: 31 },
    { id: 2750, nome: 'MUNHOZ', codigo_ibge: 3143807, codigo_uf: 31 },
    { id: 2751, nome: 'MURIAE', codigo_ibge: 3143906, codigo_uf: 31 },
    { id: 2752, nome: 'MUTUM', codigo_ibge: 3144003, codigo_uf: 31 },
    { id: 2753, nome: 'MUZAMBINHO', codigo_ibge: 3144102, codigo_uf: 31 },
    { id: 2754, nome: 'NACIP RAYDAN', codigo_ibge: 3144201, codigo_uf: 31 },
    { id: 2755, nome: 'NANUQUE', codigo_ibge: 3144300, codigo_uf: 31 },
    { id: 2756, nome: 'NAQUE', codigo_ibge: 3144359, codigo_uf: 31 },
    { id: 2757, nome: 'NATALANDIA', codigo_ibge: 3144375, codigo_uf: 31 },
    { id: 2758, nome: 'NATERCIA', codigo_ibge: 3144409, codigo_uf: 31 },
    { id: 2759, nome: 'NAZARENO', codigo_ibge: 3144508, codigo_uf: 31 },
    { id: 2760, nome: 'NEPOMUCENO', codigo_ibge: 3144607, codigo_uf: 31 },
    { id: 2761, nome: 'NINHEIRA', codigo_ibge: 3144656, codigo_uf: 31 },
    { id: 2762, nome: 'NOVA BELEM', codigo_ibge: 3144672, codigo_uf: 31 },
    { id: 2763, nome: 'NOVA ERA', codigo_ibge: 3144706, codigo_uf: 31 },
    { id: 2764, nome: 'NOVA LIMA', codigo_ibge: 3144805, codigo_uf: 31 },
    { id: 2765, nome: 'NOVA MODICA', codigo_ibge: 3144904, codigo_uf: 31 },
    { id: 2766, nome: 'NOVA PONTE', codigo_ibge: 3145000, codigo_uf: 31 },
    { id: 2767, nome: 'NOVA PORTEIRINHA', codigo_ibge: 3145059, codigo_uf: 31 },
    { id: 2768, nome: 'NOVA RESENDE', codigo_ibge: 3145109, codigo_uf: 31 },
    { id: 2769, nome: 'NOVA SERRANA', codigo_ibge: 3145208, codigo_uf: 31 },
    { id: 2662, nome: 'NOVA UNIAO', codigo_ibge: 3136603, codigo_uf: 31 },
    { id: 2770, nome: 'NOVO CRUZEIRO', codigo_ibge: 3145307, codigo_uf: 31 },
    { id: 2771, nome: 'NOVO ORIENTE DE MINAS', codigo_ibge: 3145356, codigo_uf: 31 },
    { id: 2772, nome: 'NOVORIZONTE', codigo_ibge: 3145372, codigo_uf: 31 },
    { id: 2773, nome: 'OLARIA', codigo_ibge: 3145406, codigo_uf: 31 },
    { id: 2774, nome: 'OLHOS D AGUA', codigo_ibge: 3145455, codigo_uf: 31 },
    { id: 2775, nome: 'OLIMPIO NORONHA', codigo_ibge: 3145505, codigo_uf: 31 },
    { id: 2776, nome: 'OLIVEIRA', codigo_ibge: 3145604, codigo_uf: 31 },
    { id: 2777, nome: 'OLIVEIRA FORTES', codigo_ibge: 3145703, codigo_uf: 31 },
    { id: 2778, nome: 'ONCA DE PITANGUI', codigo_ibge: 3145802, codigo_uf: 31 },
    { id: 2779, nome: 'ORATORIOS', codigo_ibge: 3145851, codigo_uf: 31 },
    { id: 2780, nome: 'ORIZANIA', codigo_ibge: 3145877, codigo_uf: 31 },
    { id: 2781, nome: 'OURO BRANCO', codigo_ibge: 3145901, codigo_uf: 31 },
    { id: 2782, nome: 'OURO FINO', codigo_ibge: 3146008, codigo_uf: 31 },
    { id: 2783, nome: 'OURO PRETO', codigo_ibge: 3146107, codigo_uf: 31 },
    { id: 2784, nome: 'OURO VERDE DE MINAS', codigo_ibge: 3146206, codigo_uf: 31 },
    { id: 2785, nome: 'PADRE CARVALHO', codigo_ibge: 3146255, codigo_uf: 31 },
    { id: 2786, nome: 'PADRE PARAISO', codigo_ibge: 3146305, codigo_uf: 31 },
    { id: 2789, nome: 'PAI PEDRO', codigo_ibge: 3146552, codigo_uf: 31 },
    { id: 2787, nome: 'PAINEIRAS', codigo_ibge: 3146404, codigo_uf: 31 },
    { id: 2788, nome: 'PAINS', codigo_ibge: 3146503, codigo_uf: 31 },
    { id: 2790, nome: 'PAIVA', codigo_ibge: 3146602, codigo_uf: 31 },
    { id: 2791, nome: 'PALMA', codigo_ibge: 3146701, codigo_uf: 31 },
    { id: 2792, nome: 'PALMOPOLIS', codigo_ibge: 3146750, codigo_uf: 31 },
    { id: 2793, nome: 'PAPAGAIOS', codigo_ibge: 3146909, codigo_uf: 31 },
    { id: 2795, nome: 'PARA DE MINAS', codigo_ibge: 3147105, codigo_uf: 31 },
    { id: 2794, nome: 'PARACATU', codigo_ibge: 3147006, codigo_uf: 31 },
    { id: 2796, nome: 'PARAGUACU', codigo_ibge: 3147204, codigo_uf: 31 },
    { id: 2797, nome: 'PARAISOPOLIS', codigo_ibge: 3147303, codigo_uf: 31 },
    { id: 2798, nome: 'PARAOPEBA', codigo_ibge: 3147402, codigo_uf: 31 },
    { id: 2800, nome: 'PASSA QUATRO', codigo_ibge: 3147600, codigo_uf: 31 },
    { id: 2801, nome: 'PASSA TEMPO', codigo_ibge: 3147709, codigo_uf: 31 },
    { id: 2802, nome: 'PASSA-VINTE', codigo_ibge: 3147808, codigo_uf: 31 },
    { id: 2799, nome: 'PASSABEM', codigo_ibge: 3147501, codigo_uf: 31 },
    { id: 2803, nome: 'PASSOS', codigo_ibge: 3147907, codigo_uf: 31 },
    { id: 2804, nome: 'PATIS', codigo_ibge: 3147956, codigo_uf: 31 },
    { id: 2805, nome: 'PATOS DE MINAS', codigo_ibge: 3148004, codigo_uf: 31 },
    { id: 2806, nome: 'PATROCINIO', codigo_ibge: 3148103, codigo_uf: 31 },
    { id: 2807, nome: 'PATROCINIO DO MURIAE', codigo_ibge: 3148202, codigo_uf: 31 },
    { id: 2808, nome: 'PAULA CANDIDO', codigo_ibge: 3148301, codigo_uf: 31 },
    { id: 2809, nome: 'PAULISTAS', codigo_ibge: 3148400, codigo_uf: 31 },
    { id: 2810, nome: 'PAVAO', codigo_ibge: 3148509, codigo_uf: 31 },
    { id: 2811, nome: 'PECANHA', codigo_ibge: 3148608, codigo_uf: 31 },
    { id: 2812, nome: 'PEDRA AZUL', codigo_ibge: 3148707, codigo_uf: 31 },
    { id: 2813, nome: 'PEDRA BONITA', codigo_ibge: 3148756, codigo_uf: 31 },
    { id: 2814, nome: 'PEDRA DO ANTA', codigo_ibge: 3148806, codigo_uf: 31 },
    { id: 2815, nome: 'PEDRA DO INDAIA', codigo_ibge: 3148905, codigo_uf: 31 },
    { id: 2816, nome: 'PEDRA DOURADA', codigo_ibge: 3149002, codigo_uf: 31 },
    { id: 2817, nome: 'PEDRALVA', codigo_ibge: 3149101, codigo_uf: 31 },
    { id: 2818, nome: 'PEDRAS DE MARIA DA CRUZ', codigo_ibge: 3149150, codigo_uf: 31 },
    { id: 2819, nome: 'PEDRINOPOLIS', codigo_ibge: 3149200, codigo_uf: 31 },
    { id: 2820, nome: 'PEDRO LEOPOLDO', codigo_ibge: 3149309, codigo_uf: 31 },
    { id: 2821, nome: 'PEDRO TEIXEIRA', codigo_ibge: 3149408, codigo_uf: 31 },
    { id: 2822, nome: 'PEQUERI', codigo_ibge: 3149507, codigo_uf: 31 },
    { id: 2823, nome: 'PEQUI', codigo_ibge: 3149606, codigo_uf: 31 },
    { id: 2824, nome: 'PERDIGAO', codigo_ibge: 3149705, codigo_uf: 31 },
    { id: 2825, nome: 'PERDIZES', codigo_ibge: 3149804, codigo_uf: 31 },
    { id: 2826, nome: 'PERDOES', codigo_ibge: 3149903, codigo_uf: 31 },
    { id: 2827, nome: 'PERIQUITO', codigo_ibge: 3149952, codigo_uf: 31 },
    { id: 2828, nome: 'PESCADOR', codigo_ibge: 3150000, codigo_uf: 31 },
    { id: 2829, nome: 'PIAU', codigo_ibge: 3150109, codigo_uf: 31 },
    { id: 2830, nome: 'PIEDADE DE CARATINGA', codigo_ibge: 3150158, codigo_uf: 31 },
    { id: 2831, nome: 'PIEDADE DE PONTE NOVA', codigo_ibge: 3150208, codigo_uf: 31 },
    { id: 2832, nome: 'PIEDADE DO RIO GRANDE', codigo_ibge: 3150307, codigo_uf: 31 },
    { id: 2833, nome: 'PIEDADE DOS GERAIS', codigo_ibge: 3150406, codigo_uf: 31 },
    { id: 2834, nome: 'PIMENTA', codigo_ibge: 3150505, codigo_uf: 31 },
    { id: 2835, nome: 'PINGO-D AGUA', codigo_ibge: 3150539, codigo_uf: 31 },
    { id: 2836, nome: 'PINTOPOLIS', codigo_ibge: 3150570, codigo_uf: 31 },
    { id: 2837, nome: 'PIRACEMA', codigo_ibge: 3150604, codigo_uf: 31 },
    { id: 2838, nome: 'PIRAJUBA', codigo_ibge: 3150703, codigo_uf: 31 },
    { id: 2839, nome: 'PIRANGA', codigo_ibge: 3150802, codigo_uf: 31 },
    { id: 2840, nome: 'PIRANGUCU', codigo_ibge: 3150901, codigo_uf: 31 },
    { id: 2841, nome: 'PIRANGUINHO', codigo_ibge: 3151008, codigo_uf: 31 },
    { id: 2842, nome: 'PIRAPETINGA', codigo_ibge: 3151107, codigo_uf: 31 },
    { id: 2843, nome: 'PIRAPORA', codigo_ibge: 3151206, codigo_uf: 31 },
    { id: 2844, nome: 'PIRAUBA', codigo_ibge: 3151305, codigo_uf: 31 },
    { id: 2845, nome: 'PITANGUI', codigo_ibge: 3151404, codigo_uf: 31 },
    { id: 2846, nome: 'PIUMHI', codigo_ibge: 3151503, codigo_uf: 31 },
    { id: 2847, nome: 'PLANURA', codigo_ibge: 3151602, codigo_uf: 31 },
    { id: 2848, nome: 'POCO FUNDO', codigo_ibge: 3151701, codigo_uf: 31 },
    { id: 2849, nome: 'POCOS DE CALDAS', codigo_ibge: 3151800, codigo_uf: 31 },
    { id: 2850, nome: 'POCRANE', codigo_ibge: 3151909, codigo_uf: 31 },
    { id: 2851, nome: 'POMPEU', codigo_ibge: 3152006, codigo_uf: 31 },
    { id: 2852, nome: 'PONTE NOVA', codigo_ibge: 3152105, codigo_uf: 31 },
    { id: 2853, nome: 'PONTO CHIQUE', codigo_ibge: 3152131, codigo_uf: 31 },
    { id: 2854, nome: 'PONTO DOS VOLANTES', codigo_ibge: 3152170, codigo_uf: 31 },
    { id: 2855, nome: 'PORTEIRINHA', codigo_ibge: 3152204, codigo_uf: 31 },
    { id: 2856, nome: 'PORTO FIRME', codigo_ibge: 3152303, codigo_uf: 31 },
    { id: 2857, nome: 'POTE', codigo_ibge: 3152402, codigo_uf: 31 },
    { id: 2858, nome: 'POUSO ALEGRE', codigo_ibge: 3152501, codigo_uf: 31 },
    { id: 2859, nome: 'POUSO ALTO', codigo_ibge: 3152600, codigo_uf: 31 },
    { id: 2860, nome: 'PRADOS', codigo_ibge: 3152709, codigo_uf: 31 },
    { id: 2861, nome: 'PRATA', codigo_ibge: 3152808, codigo_uf: 31 },
    { id: 2862, nome: 'PRATAPOLIS', codigo_ibge: 3152907, codigo_uf: 31 },
    { id: 2863, nome: 'PRATINHA', codigo_ibge: 3153004, codigo_uf: 31 },
    { id: 2864, nome: 'PRESIDENTE BERNARDES', codigo_ibge: 3153103, codigo_uf: 31 },
    { id: 2865, nome: 'PRESIDENTE JUSCELINO', codigo_ibge: 3153202, codigo_uf: 31 },
    { id: 2866, nome: 'PRESIDENTE KUBITSCHEK', codigo_ibge: 3153301, codigo_uf: 31 },
    { id: 2867, nome: 'PRESIDENTE OLEGARIO', codigo_ibge: 3153400, codigo_uf: 31 },
    { id: 2869, nome: 'PRUDENTE DE MORAIS', codigo_ibge: 3153608, codigo_uf: 31 },
    { id: 2870, nome: 'QUARTEL GERAL', codigo_ibge: 3153707, codigo_uf: 31 },
    { id: 2871, nome: 'QUELUZITO', codigo_ibge: 3153806, codigo_uf: 31 },
    { id: 2872, nome: 'RAPOSOS', codigo_ibge: 3153905, codigo_uf: 31 },
    { id: 2873, nome: 'RAUL SOARES', codigo_ibge: 3154002, codigo_uf: 31 },
    { id: 2874, nome: 'RECREIO', codigo_ibge: 3154101, codigo_uf: 31 },
    { id: 2875, nome: 'REDUTO', codigo_ibge: 3154150, codigo_uf: 31 },
    { id: 2876, nome: 'RESENDE COSTA', codigo_ibge: 3154200, codigo_uf: 31 },
    { id: 2877, nome: 'RESPLENDOR', codigo_ibge: 3154309, codigo_uf: 31 },
    { id: 2878, nome: 'RESSAQUINHA', codigo_ibge: 3154408, codigo_uf: 31 },
    { id: 2879, nome: 'RIACHINHO', codigo_ibge: 3154457, codigo_uf: 31 },
    { id: 2880, nome: 'RIACHO DOS MACHADOS', codigo_ibge: 3154507, codigo_uf: 31 },
    { id: 2881, nome: 'RIBEIRAO DAS NEVES', codigo_ibge: 3154606, codigo_uf: 31 },
    { id: 2882, nome: 'RIBEIRAO VERMELHO', codigo_ibge: 3154705, codigo_uf: 31 },
    { id: 2883, nome: 'RIO ACIMA', codigo_ibge: 3154804, codigo_uf: 31 },
    { id: 2884, nome: 'RIO CASCA', codigo_ibge: 3154903, codigo_uf: 31 },
    { id: 2886, nome: 'RIO DO PRADO', codigo_ibge: 3155108, codigo_uf: 31 },
    { id: 2885, nome: 'RIO DOCE', codigo_ibge: 3155009, codigo_uf: 31 },
    { id: 2887, nome: 'RIO ESPERA', codigo_ibge: 3155207, codigo_uf: 31 },
    { id: 2888, nome: 'RIO MANSO', codigo_ibge: 3155306, codigo_uf: 31 },
    { id: 2889, nome: 'RIO NOVO', codigo_ibge: 3155405, codigo_uf: 31 },
    { id: 2890, nome: 'RIO PARANAIBA', codigo_ibge: 3155504, codigo_uf: 31 },
    { id: 2891, nome: 'RIO PARDO DE MINAS', codigo_ibge: 3155603, codigo_uf: 31 },
    { id: 2892, nome: 'RIO PIRACICABA', codigo_ibge: 3155702, codigo_uf: 31 },
    { id: 2893, nome: 'RIO POMBA', codigo_ibge: 3155801, codigo_uf: 31 },
    { id: 2894, nome: 'RIO PRETO', codigo_ibge: 3155900, codigo_uf: 31 },
    { id: 2895, nome: 'RIO VERMELHO', codigo_ibge: 3156007, codigo_uf: 31 },
    { id: 2896, nome: 'RITAPOLIS', codigo_ibge: 3156106, codigo_uf: 31 },
    { id: 2897, nome: 'ROCHEDO DE MINAS', codigo_ibge: 3156205, codigo_uf: 31 },
    { id: 2898, nome: 'RODEIRO', codigo_ibge: 3156304, codigo_uf: 31 },
    { id: 2899, nome: 'ROMARIA', codigo_ibge: 3156403, codigo_uf: 31 },
    { id: 2900, nome: 'ROSARIO DA LIMEIRA', codigo_ibge: 3156452, codigo_uf: 31 },
    { id: 2901, nome: 'RUBELITA', codigo_ibge: 3156502, codigo_uf: 31 },
    { id: 2902, nome: 'RUBIM', codigo_ibge: 3156601, codigo_uf: 31 },
    { id: 2903, nome: 'SABARA', codigo_ibge: 3156700, codigo_uf: 31 },
    { id: 2904, nome: 'SABINOPOLIS', codigo_ibge: 3156809, codigo_uf: 31 },
    { id: 2905, nome: 'SACRAMENTO', codigo_ibge: 3156908, codigo_uf: 31 },
    { id: 2906, nome: 'SALINAS', codigo_ibge: 3157005, codigo_uf: 31 },
    { id: 2907, nome: 'SALTO DA DIVISA', codigo_ibge: 3157104, codigo_uf: 31 },
    { id: 2908, nome: 'SANTA BARBARA', codigo_ibge: 3157203, codigo_uf: 31 },
    { id: 2909, nome: 'SANTA BARBARA DO LESTE', codigo_ibge: 3157252, codigo_uf: 31 },
    { id: 2910, nome: 'SANTA BARBARA DO MONTE VERDE', codigo_ibge: 3157278, codigo_uf: 31 },
    { id: 2911, nome: 'SANTA BARBARA DO TUGURIO', codigo_ibge: 3157302, codigo_uf: 31 },
    { id: 2912, nome: 'SANTA CRUZ DE MINAS', codigo_ibge: 3157336, codigo_uf: 31 },
    { id: 2913, nome: 'SANTA CRUZ DE SALINAS', codigo_ibge: 3157377, codigo_uf: 31 },
    { id: 2914, nome: 'SANTA CRUZ DO ESCALVADO', codigo_ibge: 3157401, codigo_uf: 31 },
    { id: 2915, nome: 'SANTA EFIGENIA DE MINAS', codigo_ibge: 3157500, codigo_uf: 31 },
    { id: 2916, nome: 'SANTA FE DE MINAS', codigo_ibge: 3157609, codigo_uf: 31 },
    { id: 2917, nome: 'SANTA HELENA DE MINAS', codigo_ibge: 3157658, codigo_uf: 31 },
    { id: 2918, nome: 'SANTA JULIANA', codigo_ibge: 3157708, codigo_uf: 31 },
    { id: 2919, nome: 'SANTA LUZIA', codigo_ibge: 3157807, codigo_uf: 31 },
    { id: 2920, nome: 'SANTA MARGARIDA', codigo_ibge: 3157906, codigo_uf: 31 },
    { id: 2921, nome: 'SANTA MARIA DE ITABIRA', codigo_ibge: 3158003, codigo_uf: 31 },
    { id: 2922, nome: 'SANTA MARIA DO SALTO', codigo_ibge: 3158102, codigo_uf: 31 },
    { id: 2923, nome: 'SANTA MARIA DO SUACUI', codigo_ibge: 3158201, codigo_uf: 31 },
    { id: 2934, nome: 'SANTA RITA DE CALDAS', codigo_ibge: 3159209, codigo_uf: 31 },
    { id: 2937, nome: 'SANTA RITA DE IBITIPOCA', codigo_ibge: 3159407, codigo_uf: 31 },
    { id: 2935, nome: 'SANTA RITA DE JACUTINGA', codigo_ibge: 3159308, codigo_uf: 31 },
    { id: 2936, nome: 'SANTA RITA DE MINAS', codigo_ibge: 3159357, codigo_uf: 31 },
    { id: 2938, nome: 'SANTA RITA DO ITUETO', codigo_ibge: 3159506, codigo_uf: 31 },
    { id: 2939, nome: 'SANTA RITA DO SAPUCAI', codigo_ibge: 3159605, codigo_uf: 31 },
    { id: 2940, nome: 'SANTA ROSA DA SERRA', codigo_ibge: 3159704, codigo_uf: 31 },
    { id: 2941, nome: 'SANTA VITORIA', codigo_ibge: 3159803, codigo_uf: 31 },
    { id: 2924, nome: 'SANTANA DA VARGEM', codigo_ibge: 3158300, codigo_uf: 31 },
    { id: 2925, nome: 'SANTANA DE CATAGUASES', codigo_ibge: 3158409, codigo_uf: 31 },
    { id: 2926, nome: 'SANTANA DE PIRAPAMA', codigo_ibge: 3158508, codigo_uf: 31 },
    { id: 2927, nome: 'SANTANA DO DESERTO', codigo_ibge: 3158607, codigo_uf: 31 },
    { id: 2928, nome: 'SANTANA DO GARAMBEU', codigo_ibge: 3158706, codigo_uf: 31 },
    { id: 2929, nome: 'SANTANA DO JACARE', codigo_ibge: 3158805, codigo_uf: 31 },
    { id: 2930, nome: 'SANTANA DO MANHUACU', codigo_ibge: 3158904, codigo_uf: 31 },
    { id: 2931, nome: 'SANTANA DO PARAISO', codigo_ibge: 3158953, codigo_uf: 31 },
    { id: 2932, nome: 'SANTANA DO RIACHO', codigo_ibge: 3159001, codigo_uf: 31 },
    { id: 2933, nome: 'SANTANA DOS MONTES', codigo_ibge: 3159100, codigo_uf: 31 },
    { id: 2942, nome: 'SANTO ANTONIO DO AMPARO', codigo_ibge: 3159902, codigo_uf: 31 },
    { id: 2943, nome: 'SANTO ANTONIO DO AVENTUREIRO', codigo_ibge: 3160009, codigo_uf: 31 },
    { id: 2944, nome: 'SANTO ANTONIO DO GRAMA', codigo_ibge: 3160108, codigo_uf: 31 },
    { id: 2945, nome: 'SANTO ANTONIO DO ITAMBE', codigo_ibge: 3160207, codigo_uf: 31 },
    { id: 2946, nome: 'SANTO ANTONIO DO JACINTO', codigo_ibge: 3160306, codigo_uf: 31 },
    { id: 2947, nome: 'SANTO ANTONIO DO MONTE', codigo_ibge: 3160405, codigo_uf: 31 },
    { id: 2948, nome: 'SANTO ANTONIO DO RETIRO', codigo_ibge: 3160454, codigo_uf: 31 },
    { id: 2949, nome: 'SANTO ANTONIO DO RIO ABAIXO', codigo_ibge: 3160504, codigo_uf: 31 },
    { id: 2950, nome: 'SANTO HIPOLITO', codigo_ibge: 3160603, codigo_uf: 31 },
    { id: 2951, nome: 'SANTOS DUMONT', codigo_ibge: 3160702, codigo_uf: 31 },
    { id: 2952, nome: 'SAO BENTO ABADE', codigo_ibge: 3160801, codigo_uf: 31 },
    { id: 2953, nome: 'SAO BRAS DO SUACUI', codigo_ibge: 3160900, codigo_uf: 31 },
    { id: 2954, nome: 'SAO DOMINGOS DAS DORES', codigo_ibge: 3160959, codigo_uf: 31 },
    { id: 2955, nome: 'SAO DOMINGOS DO PRATA', codigo_ibge: 3161007, codigo_uf: 31 },
    { id: 2956, nome: 'SAO FELIX DE MINAS', codigo_ibge: 3161056, codigo_uf: 31 },
    { id: 2957, nome: 'SAO FRANCISCO', codigo_ibge: 3161106, codigo_uf: 31 },
    { id: 2958, nome: 'SAO FRANCISCO DE PAULA', codigo_ibge: 3161205, codigo_uf: 31 },
    { id: 2959, nome: 'SAO FRANCISCO DE SALES', codigo_ibge: 3161304, codigo_uf: 31 },
    { id: 2960, nome: 'SAO FRANCISCO DO GLORIA', codigo_ibge: 3161403, codigo_uf: 31 },
    { id: 2961, nome: 'SAO GERALDO', codigo_ibge: 3161502, codigo_uf: 31 },
    { id: 2962, nome: 'SAO GERALDO DA PIEDADE', codigo_ibge: 3161601, codigo_uf: 31 },
    { id: 2963, nome: 'SAO GERALDO DO BAIXIO', codigo_ibge: 3161650, codigo_uf: 31 },
    { id: 2964, nome: 'SAO GONCALO DO ABAETE', codigo_ibge: 3161700, codigo_uf: 31 },
    { id: 2965, nome: 'SAO GONCALO DO PARA', codigo_ibge: 3161809, codigo_uf: 31 },
    { id: 2966, nome: 'SAO GONCALO DO RIO ABAIXO', codigo_ibge: 3161908, codigo_uf: 31 },
    { id: 2528, nome: 'SAO GONCALO DO RIO PRETO', codigo_ibge: 3125507, codigo_uf: 31 },
    { id: 2967, nome: 'SAO GONCALO DO SAPUCAI', codigo_ibge: 3162005, codigo_uf: 31 },
    { id: 2968, nome: 'SAO GOTARDO', codigo_ibge: 3162104, codigo_uf: 31 },
    { id: 2969, nome: 'SAO JOAO BATISTA DO GLORIA', codigo_ibge: 3162203, codigo_uf: 31 },
    { id: 2970, nome: 'SAO JOAO DA LAGOA', codigo_ibge: 3162252, codigo_uf: 31 },
    { id: 2971, nome: 'SAO JOAO DA MATA', codigo_ibge: 3162302, codigo_uf: 31 },
    { id: 2972, nome: 'SAO JOAO DA PONTE', codigo_ibge: 3162401, codigo_uf: 31 },
    { id: 2973, nome: 'SAO JOAO DAS MISSOES', codigo_ibge: 3162450, codigo_uf: 31 },
    { id: 2974, nome: 'SAO JOAO DEL REI', codigo_ibge: 3162500, codigo_uf: 31 },
    { id: 2975, nome: 'SAO JOAO DO MANHUACU', codigo_ibge: 3162559, codigo_uf: 31 },
    { id: 2976, nome: 'SAO JOAO DO MANTENINHA', codigo_ibge: 3162575, codigo_uf: 31 },
    { id: 2977, nome: 'SAO JOAO DO ORIENTE', codigo_ibge: 3162609, codigo_uf: 31 },
    { id: 2978, nome: 'SAO JOAO DO PACUI', codigo_ibge: 3162658, codigo_uf: 31 },
    { id: 2979, nome: 'SAO JOAO DO PARAISO', codigo_ibge: 3162708, codigo_uf: 31 },
    { id: 2980, nome: 'SAO JOAO EVANGELISTA', codigo_ibge: 3162807, codigo_uf: 31 },
    { id: 2981, nome: 'SAO JOAO NEPOMUCENO', codigo_ibge: 3162906, codigo_uf: 31 },
    { id: 2982, nome: 'SAO JOAQUIM DE BICAS', codigo_ibge: 3162922, codigo_uf: 31 },
    { id: 2983, nome: 'SAO JOSE DA BARRA', codigo_ibge: 3162948, codigo_uf: 31 },
    { id: 2984, nome: 'SAO JOSE DA LAPA', codigo_ibge: 3162955, codigo_uf: 31 },
    { id: 2985, nome: 'SAO JOSE DA SAFIRA', codigo_ibge: 3163003, codigo_uf: 31 },
    { id: 2986, nome: 'SAO JOSE DA VARGINHA', codigo_ibge: 3163102, codigo_uf: 31 },
    { id: 2987, nome: 'SAO JOSE DO ALEGRE', codigo_ibge: 3163201, codigo_uf: 31 },
    { id: 2988, nome: 'SAO JOSE DO DIVINO', codigo_ibge: 3163300, codigo_uf: 31 },
    { id: 2989, nome: 'SAO JOSE DO GOIABAL', codigo_ibge: 3163409, codigo_uf: 31 },
    { id: 2990, nome: 'SAO JOSE DO JACURI', codigo_ibge: 3163508, codigo_uf: 31 },
    { id: 2991, nome: 'SAO JOSE DO MANTIMENTO', codigo_ibge: 3163607, codigo_uf: 31 },
    { id: 2992, nome: 'SAO LOURENCO', codigo_ibge: 3163706, codigo_uf: 31 },
    { id: 2993, nome: 'SAO MIGUEL DO ANTA', codigo_ibge: 3163805, codigo_uf: 31 },
    { id: 2994, nome: 'SAO PEDRO DA UNIAO', codigo_ibge: 3163904, codigo_uf: 31 },
    { id: 2996, nome: 'SAO PEDRO DO SUACUI', codigo_ibge: 3164100, codigo_uf: 31 },
    { id: 2995, nome: 'SAO PEDRO DOS FERROS', codigo_ibge: 3164001, codigo_uf: 31 },
    { id: 2997, nome: 'SAO ROMAO', codigo_ibge: 3164209, codigo_uf: 31 },
    { id: 2998, nome: 'SAO ROQUE DE MINAS', codigo_ibge: 3164308, codigo_uf: 31 },
    { id: 2999, nome: 'SAO SEBASTIAO DA BELA VISTA', codigo_ibge: 3164407, codigo_uf: 31 },
    { id: 3000, nome: 'SAO SEBASTIAO DA VARGEM ALEGRE', codigo_ibge: 3164431, codigo_uf: 31 },
    { id: 3001, nome: 'SAO SEBASTIAO DO ANTA', codigo_ibge: 3164472, codigo_uf: 31 },
    { id: 3002, nome: 'SAO SEBASTIAO DO MARANHAO', codigo_ibge: 3164506, codigo_uf: 31 },
    { id: 3003, nome: 'SAO SEBASTIAO DO OESTE', codigo_ibge: 3164605, codigo_uf: 31 },
    { id: 3004, nome: 'SAO SEBASTIAO DO PARAISO', codigo_ibge: 3164704, codigo_uf: 31 },
    { id: 3005, nome: 'SAO SEBASTIAO DO RIO PRETO', codigo_ibge: 3164803, codigo_uf: 31 },
    { id: 3006, nome: 'SAO SEBASTIAO DO RIO VERDE', codigo_ibge: 3164902, codigo_uf: 31 },
    { id: 3009, nome: 'SAO THOME DAS LETRAS', codigo_ibge: 3165206, codigo_uf: 31 },
    { id: 3007, nome: 'SAO TIAGO', codigo_ibge: 3165008, codigo_uf: 31 },
    { id: 3008, nome: 'SAO TOMAS DE AQUINO', codigo_ibge: 3165107, codigo_uf: 31 },
    { id: 3010, nome: 'SAO VICENTE DE MINAS', codigo_ibge: 3165305, codigo_uf: 31 },
    { id: 3011, nome: 'SAPUCAI-MIRIM', codigo_ibge: 3165404, codigo_uf: 31 },
    { id: 3012, nome: 'SARDOA', codigo_ibge: 3165503, codigo_uf: 31 },
    { id: 3013, nome: 'SARZEDO', codigo_ibge: 3165537, codigo_uf: 31 },
    { id: 3015, nome: 'SEM-PEIXE', codigo_ibge: 3165560, codigo_uf: 31 },
    { id: 3016, nome: 'SENADOR AMARAL', codigo_ibge: 3165578, codigo_uf: 31 },
    { id: 3017, nome: 'SENADOR CORTES', codigo_ibge: 3165602, codigo_uf: 31 },
    { id: 3018, nome: 'SENADOR FIRMINO', codigo_ibge: 3165701, codigo_uf: 31 },
    { id: 3019, nome: 'SENADOR JOSE BENTO', codigo_ibge: 3165800, codigo_uf: 31 },
    { id: 3020, nome: 'SENADOR MODESTINO GONCALVES', codigo_ibge: 3165909, codigo_uf: 31 },
    { id: 3021, nome: 'SENHORA DE OLIVEIRA', codigo_ibge: 3166006, codigo_uf: 31 },
    { id: 3022, nome: 'SENHORA DO PORTO', codigo_ibge: 3166105, codigo_uf: 31 },
    { id: 3023, nome: 'SENHORA DOS REMEDIOS', codigo_ibge: 3166204, codigo_uf: 31 },
    { id: 3024, nome: 'SERICITA', codigo_ibge: 3166303, codigo_uf: 31 },
    { id: 3025, nome: 'SERITINGA', codigo_ibge: 3166402, codigo_uf: 31 },
    { id: 3026, nome: 'SERRA AZUL DE MINAS', codigo_ibge: 3166501, codigo_uf: 31 },
    { id: 3027, nome: 'SERRA DA SAUDADE', codigo_ibge: 3166600, codigo_uf: 31 },
    { id: 3029, nome: 'SERRA DO SALITRE', codigo_ibge: 3166808, codigo_uf: 31 },
    { id: 3028, nome: 'SERRA DOS AIMORES', codigo_ibge: 3166709, codigo_uf: 31 },
    { id: 3030, nome: 'SERRANIA', codigo_ibge: 3166907, codigo_uf: 31 },
    { id: 3031, nome: 'SERRANOPOLIS DE MINAS', codigo_ibge: 3166956, codigo_uf: 31 },
    { id: 3032, nome: 'SERRANOS', codigo_ibge: 3167004, codigo_uf: 31 },
    { id: 3033, nome: 'SERRO', codigo_ibge: 3167103, codigo_uf: 31 },
    { id: 3034, nome: 'SETE LAGOAS', codigo_ibge: 3167202, codigo_uf: 31 },
    { id: 3014, nome: 'SETUBINHA', codigo_ibge: 3165552, codigo_uf: 31 },
    { id: 3035, nome: 'SILVEIRANIA', codigo_ibge: 3167301, codigo_uf: 31 },
    { id: 3036, nome: 'SILVIANOPOLIS', codigo_ibge: 3167400, codigo_uf: 31 },
    { id: 3037, nome: 'SIMAO PEREIRA', codigo_ibge: 3167509, codigo_uf: 31 },
    { id: 3038, nome: 'SIMONESIA', codigo_ibge: 3167608, codigo_uf: 31 },
    { id: 3039, nome: 'SOBRALIA', codigo_ibge: 3167707, codigo_uf: 31 },
    { id: 3040, nome: 'SOLEDADE DE MINAS', codigo_ibge: 3167806, codigo_uf: 31 },
    { id: 3041, nome: 'TABULEIRO', codigo_ibge: 3167905, codigo_uf: 31 },
    { id: 3042, nome: 'TAIOBEIRAS', codigo_ibge: 3168002, codigo_uf: 31 },
    { id: 3043, nome: 'TAPARUBA', codigo_ibge: 3168051, codigo_uf: 31 },
    { id: 3044, nome: 'TAPIRA', codigo_ibge: 3168101, codigo_uf: 31 },
    { id: 3045, nome: 'TAPIRAI', codigo_ibge: 3168200, codigo_uf: 31 },
    { id: 3046, nome: 'TAQUARACU DE MINAS', codigo_ibge: 3168309, codigo_uf: 31 },
    { id: 3047, nome: 'TARUMIRIM', codigo_ibge: 3168408, codigo_uf: 31 },
    { id: 3048, nome: 'TEIXEIRAS', codigo_ibge: 3168507, codigo_uf: 31 },
    { id: 3049, nome: 'TEOFILO OTONI', codigo_ibge: 3168606, codigo_uf: 31 },
    { id: 3050, nome: 'TIMOTEO', codigo_ibge: 3168705, codigo_uf: 31 },
    { id: 3051, nome: 'TIRADENTES', codigo_ibge: 3168804, codigo_uf: 31 },
    { id: 3052, nome: 'TIROS', codigo_ibge: 3168903, codigo_uf: 31 },
    { id: 3053, nome: 'TOCANTINS', codigo_ibge: 3169000, codigo_uf: 31 },
    { id: 3054, nome: 'TOCOS DO MOJI', codigo_ibge: 3169059, codigo_uf: 31 },
    { id: 3055, nome: 'TOLEDO', codigo_ibge: 3169109, codigo_uf: 31 },
    { id: 3056, nome: 'TOMBOS', codigo_ibge: 3169208, codigo_uf: 31 },
    { id: 3057, nome: 'TRES CORACOES', codigo_ibge: 3169307, codigo_uf: 31 },
    { id: 3058, nome: 'TRES MARIAS', codigo_ibge: 3169356, codigo_uf: 31 },
    { id: 3059, nome: 'TRES PONTAS', codigo_ibge: 3169406, codigo_uf: 31 },
    { id: 3060, nome: 'TUMIRITINGA', codigo_ibge: 3169505, codigo_uf: 31 },
    { id: 3061, nome: 'TUPACIGUARA', codigo_ibge: 3169604, codigo_uf: 31 },
    { id: 3062, nome: 'TURMALINA', codigo_ibge: 3169703, codigo_uf: 31 },
    { id: 3063, nome: 'TURVOLANDIA', codigo_ibge: 3169802, codigo_uf: 31 },
    { id: 3064, nome: 'UBA', codigo_ibge: 3169901, codigo_uf: 31 },
    { id: 3065, nome: 'UBAI', codigo_ibge: 3170008, codigo_uf: 31 },
    { id: 3066, nome: 'UBAPORANGA', codigo_ibge: 3170057, codigo_uf: 31 },
    { id: 3067, nome: 'UBERABA', codigo_ibge: 3170107, codigo_uf: 31 },
    { id: 3068, nome: 'UBERLANDIA', codigo_ibge: 3170206, codigo_uf: 31 },
    { id: 3069, nome: 'UMBURATIBA', codigo_ibge: 3170305, codigo_uf: 31 },
    { id: 3070, nome: 'UNAI', codigo_ibge: 3170404, codigo_uf: 31 },
    { id: 3071, nome: 'UNIAO DE MINAS', codigo_ibge: 3170438, codigo_uf: 31 },
    { id: 3072, nome: 'URUANA DE MINAS', codigo_ibge: 3170479, codigo_uf: 31 },
    { id: 3073, nome: 'URUCANIA', codigo_ibge: 3170503, codigo_uf: 31 },
    { id: 3074, nome: 'URUCUIA', codigo_ibge: 3170529, codigo_uf: 31 },
    { id: 3075, nome: 'VARGEM ALEGRE', codigo_ibge: 3170578, codigo_uf: 31 },
    { id: 3076, nome: 'VARGEM BONITA', codigo_ibge: 3170602, codigo_uf: 31 },
    { id: 3077, nome: 'VARGEM GRANDE DO RIO PARDO', codigo_ibge: 3170651, codigo_uf: 31 },
    { id: 3078, nome: 'VARGINHA', codigo_ibge: 3170701, codigo_uf: 31 },
    { id: 3079, nome: 'VARJAO DE MINAS', codigo_ibge: 3170750, codigo_uf: 31 },
    { id: 3080, nome: 'VARZEA DA PALMA', codigo_ibge: 3170800, codigo_uf: 31 },
    { id: 3081, nome: 'VARZELANDIA', codigo_ibge: 3170909, codigo_uf: 31 },
    { id: 3082, nome: 'VAZANTE', codigo_ibge: 3171006, codigo_uf: 31 },
    { id: 3083, nome: 'VERDELANDIA', codigo_ibge: 3171030, codigo_uf: 31 },
    { id: 3084, nome: 'VEREDINHA', codigo_ibge: 3171071, codigo_uf: 31 },
    { id: 3085, nome: 'VERISSIMO', codigo_ibge: 3171105, codigo_uf: 31 },
    { id: 3086, nome: 'VERMELHO NOVO', codigo_ibge: 3171154, codigo_uf: 31 },
    { id: 3087, nome: 'VESPASIANO', codigo_ibge: 3171204, codigo_uf: 31 },
    { id: 3088, nome: 'VICOSA', codigo_ibge: 3171303, codigo_uf: 31 },
    { id: 3089, nome: 'VIEIRAS', codigo_ibge: 3171402, codigo_uf: 31 },
    { id: 3091, nome: 'VIRGEM DA LAPA', codigo_ibge: 3171600, codigo_uf: 31 },
    { id: 3092, nome: 'VIRGINIA', codigo_ibge: 3171709, codigo_uf: 31 },
    { id: 3093, nome: 'VIRGINOPOLIS', codigo_ibge: 3171808, codigo_uf: 31 },
    { id: 3094, nome: 'VIRGOLANDIA', codigo_ibge: 3171907, codigo_uf: 31 },
    { id: 3095, nome: 'VISCONDE DO RIO BRANCO', codigo_ibge: 3172004, codigo_uf: 31 },
    { id: 3096, nome: 'VOLTA GRANDE', codigo_ibge: 3172103, codigo_uf: 31 },
    { id: 3097, nome: 'WENCESLAU BRAZ', codigo_ibge: 3172202, codigo_uf: 31 },
    { id: 3098, nome: 'AFONSO CLAUDIO', codigo_ibge: 3200102, codigo_uf: 32 },
    { id: 3100, nome: 'AGUA DOCE DO NORTE', codigo_ibge: 3200169, codigo_uf: 32 },
    { id: 3099, nome: 'AGUIA BRANCA', codigo_ibge: 3200136, codigo_uf: 32 },
    { id: 3101, nome: 'ALEGRE', codigo_ibge: 3200201, codigo_uf: 32 },
    { id: 3102, nome: 'ALFREDO CHAVES', codigo_ibge: 3200300, codigo_uf: 32 },
    { id: 3103, nome: 'ALTO RIO NOVO', codigo_ibge: 3200359, codigo_uf: 32 },
    { id: 3104, nome: 'ANCHIETA', codigo_ibge: 3200409, codigo_uf: 32 },
    { id: 3105, nome: 'APIACA', codigo_ibge: 3200508, codigo_uf: 32 },
    { id: 3106, nome: 'ARACRUZ', codigo_ibge: 3200607, codigo_uf: 32 },
    { id: 3107, nome: 'ATILIO VIVACQUA', codigo_ibge: 3200706, codigo_uf: 32 },
    { id: 3108, nome: 'BAIXO GUANDU', codigo_ibge: 3200805, codigo_uf: 32 },
    { id: 3109, nome: 'BARRA DE SAO FRANCISCO', codigo_ibge: 3200904, codigo_uf: 32 },
    { id: 3110, nome: 'BOA ESPERANCA', codigo_ibge: 3201001, codigo_uf: 32 },
    { id: 3111, nome: 'BOM JESUS DO NORTE', codigo_ibge: 3201100, codigo_uf: 32 },
    { id: 3112, nome: 'BREJETUBA', codigo_ibge: 3201159, codigo_uf: 32 },
    { id: 3113, nome: 'CACHOEIRO DE ITAPEMIRIM', codigo_ibge: 3201209, codigo_uf: 32 },
    { id: 3114, nome: 'CARIACICA', codigo_ibge: 3201308, codigo_uf: 32 },
    { id: 3115, nome: 'CASTELO', codigo_ibge: 3201407, codigo_uf: 32 },
    { id: 3116, nome: 'COLATINA', codigo_ibge: 3201506, codigo_uf: 32 },
    { id: 3117, nome: 'CONCEICAO DA BARRA', codigo_ibge: 3201605, codigo_uf: 32 },
    { id: 3118, nome: 'CONCEICAO DO CASTELO', codigo_ibge: 3201704, codigo_uf: 32 },
    { id: 3119, nome: 'DIVINO DE SAO LOURENCO', codigo_ibge: 3201803, codigo_uf: 32 },
    { id: 3120, nome: 'DOMINGOS MARTINS', codigo_ibge: 3201902, codigo_uf: 32 },
    { id: 3121, nome: 'DORES DO RIO PRETO', codigo_ibge: 3202009, codigo_uf: 32 },
    { id: 3122, nome: 'ECOPORANGA', codigo_ibge: 3202108, codigo_uf: 32 },
    { id: 3123, nome: 'FUNDAO', codigo_ibge: 3202207, codigo_uf: 32 },
    { id: 3124, nome: 'GOVERNADOR LINDENBERG', codigo_ibge: 3202256, codigo_uf: 32 },
    { id: 3125, nome: 'GUACUI', codigo_ibge: 3202306, codigo_uf: 32 },
    { id: 3126, nome: 'GUARAPARI', codigo_ibge: 3202405, codigo_uf: 32 },
    { id: 3127, nome: 'IBATIBA', codigo_ibge: 3202454, codigo_uf: 32 },
    { id: 3128, nome: 'IBIRACU', codigo_ibge: 3202504, codigo_uf: 32 },
    { id: 3129, nome: 'IBITIRAMA', codigo_ibge: 3202553, codigo_uf: 32 },
    { id: 3130, nome: 'ICONHA', codigo_ibge: 3202603, codigo_uf: 32 },
    { id: 3131, nome: 'IRUPI', codigo_ibge: 3202652, codigo_uf: 32 },
    { id: 3132, nome: 'ITAGUACU', codigo_ibge: 3202702, codigo_uf: 32 },
    { id: 3133, nome: 'ITAPEMIRIM', codigo_ibge: 3202801, codigo_uf: 32 },
    { id: 3134, nome: 'ITARANA', codigo_ibge: 3202900, codigo_uf: 32 },
    { id: 3135, nome: 'IUNA', codigo_ibge: 3203007, codigo_uf: 32 },
    { id: 3136, nome: 'JAGUARE', codigo_ibge: 3203056, codigo_uf: 32 },
    { id: 3137, nome: 'JERONIMO MONTEIRO', codigo_ibge: 3203106, codigo_uf: 32 },
    { id: 3138, nome: 'JOAO NEIVA', codigo_ibge: 3203130, codigo_uf: 32 },
    { id: 3139, nome: 'LARANJA DA TERRA', codigo_ibge: 3203163, codigo_uf: 32 },
    { id: 3140, nome: 'LINHARES', codigo_ibge: 3203205, codigo_uf: 32 },
    { id: 3141, nome: 'MANTENOPOLIS', codigo_ibge: 3203304, codigo_uf: 32 },
    { id: 3142, nome: 'MARATAIZES', codigo_ibge: 3203320, codigo_uf: 32 },
    { id: 3143, nome: 'MARECHAL FLORIANO', codigo_ibge: 3203346, codigo_uf: 32 },
    { id: 3144, nome: 'MARILANDIA', codigo_ibge: 3203353, codigo_uf: 32 },
    { id: 3145, nome: 'MIMOSO DO SUL', codigo_ibge: 3203403, codigo_uf: 32 },
    { id: 3146, nome: 'MONTANHA', codigo_ibge: 3203502, codigo_uf: 32 },
    { id: 3147, nome: 'MUCURICI', codigo_ibge: 3203601, codigo_uf: 32 },
    { id: 3148, nome: 'MUNIZ FREIRE', codigo_ibge: 3203700, codigo_uf: 32 },
    { id: 3149, nome: 'MUQUI', codigo_ibge: 3203809, codigo_uf: 32 },
    { id: 3150, nome: 'NOVA VENECIA', codigo_ibge: 3203908, codigo_uf: 32 },
    { id: 3151, nome: 'PANCAS', codigo_ibge: 3204005, codigo_uf: 32 },
    { id: 3152, nome: 'PEDRO CANARIO', codigo_ibge: 3204054, codigo_uf: 32 },
    { id: 3153, nome: 'PINHEIROS', codigo_ibge: 3204104, codigo_uf: 32 },
    { id: 3154, nome: 'PIUMA', codigo_ibge: 3204203, codigo_uf: 32 },
    { id: 3155, nome: 'PONTO BELO', codigo_ibge: 3204252, codigo_uf: 32 },
    { id: 3156, nome: 'PRESIDENTE KENNEDY', codigo_ibge: 3204302, codigo_uf: 32 },
    { id: 3157, nome: 'RIO BANANAL', codigo_ibge: 3204351, codigo_uf: 32 },
    { id: 3158, nome: 'RIO NOVO DO SUL', codigo_ibge: 3204401, codigo_uf: 32 },
    { id: 3159, nome: 'SANTA LEOPOLDINA', codigo_ibge: 3204500, codigo_uf: 32 },
    { id: 3160, nome: 'SANTA MARIA DE JETIBA', codigo_ibge: 3204559, codigo_uf: 32 },
    { id: 3161, nome: 'SANTA TERESA', codigo_ibge: 3204609, codigo_uf: 32 },
    { id: 3162, nome: 'SAO DOMINGOS DO NORTE', codigo_ibge: 3204658, codigo_uf: 32 },
    { id: 3163, nome: 'SAO GABRIEL DA PALHA', codigo_ibge: 3204708, codigo_uf: 32 },
    { id: 3164, nome: 'SAO JOSE DO CALCADO', codigo_ibge: 3204807, codigo_uf: 32 },
    { id: 3165, nome: 'SAO MATEUS', codigo_ibge: 3204906, codigo_uf: 32 },
    { id: 3166, nome: 'SAO ROQUE DO CANAA', codigo_ibge: 3204955, codigo_uf: 32 },
    { id: 3167, nome: 'SERRA', codigo_ibge: 3205002, codigo_uf: 32 },
    { id: 3168, nome: 'SOORETAMA', codigo_ibge: 3205010, codigo_uf: 32 },
    { id: 3169, nome: 'VARGEM ALTA', codigo_ibge: 3205036, codigo_uf: 32 },
    { id: 3170, nome: 'VENDA NOVA DO IMIGRANTE', codigo_ibge: 3205069, codigo_uf: 32 },
    { id: 3171, nome: 'VIANA', codigo_ibge: 3205101, codigo_uf: 32 },
    { id: 3172, nome: 'VILA PAVAO', codigo_ibge: 3205150, codigo_uf: 32 },
    { id: 3173, nome: 'VILA VALERIO', codigo_ibge: 3205176, codigo_uf: 32 },
    { id: 3174, nome: 'VILA VELHA', codigo_ibge: 3205200, codigo_uf: 32 },
    { id: 3175, nome: 'VITORIA', codigo_ibge: 3205309, codigo_uf: 32 },
    { id: 3176, nome: 'ANGRA DOS REIS', codigo_ibge: 3300100, codigo_uf: 33 },
    { id: 3177, nome: 'APERIBE', codigo_ibge: 3300159, codigo_uf: 33 },
    { id: 3178, nome: 'ARARUAMA', codigo_ibge: 3300209, codigo_uf: 33 },
    { id: 3179, nome: 'AREAL', codigo_ibge: 3300225, codigo_uf: 33 },
    { id: 3180, nome: 'ARMACAO DOS BUZIOS', codigo_ibge: 3300233, codigo_uf: 33 },
    { id: 3181, nome: 'ARRAIAL DO CABO', codigo_ibge: 3300258, codigo_uf: 33 },
    { id: 3182, nome: 'BARRA DO PIRAI', codigo_ibge: 3300308, codigo_uf: 33 },
    { id: 3183, nome: 'BARRA MANSA', codigo_ibge: 3300407, codigo_uf: 33 },
    { id: 3184, nome: 'BELFORD ROXO', codigo_ibge: 3300456, codigo_uf: 33 },
    { id: 3185, nome: 'BOM JARDIM', codigo_ibge: 3300506, codigo_uf: 33 },
    { id: 3186, nome: 'BOM JESUS DO ITABAPOANA', codigo_ibge: 3300605, codigo_uf: 33 },
    { id: 3187, nome: 'CABO FRIO', codigo_ibge: 3300704, codigo_uf: 33 },
    { id: 3188, nome: 'CACHOEIRAS DE MACACU', codigo_ibge: 3300803, codigo_uf: 33 },
    { id: 3189, nome: 'CAMBUCI', codigo_ibge: 3300902, codigo_uf: 33 },
    { id: 3192, nome: 'CAMPOS DOS GOYTACAZES', codigo_ibge: 3301009, codigo_uf: 33 },
    { id: 3193, nome: 'CANTAGALO', codigo_ibge: 3301108, codigo_uf: 33 },
    { id: 3190, nome: 'CARAPEBUS', codigo_ibge: 3300936, codigo_uf: 33 },
    { id: 3194, nome: 'CARDOSO MOREIRA', codigo_ibge: 3301157, codigo_uf: 33 },
    { id: 3195, nome: 'CARMO', codigo_ibge: 3301207, codigo_uf: 33 },
    { id: 3196, nome: 'CASIMIRO DE ABREU', codigo_ibge: 3301306, codigo_uf: 33 },
    { id: 3191, nome: 'COMENDADOR LEVY GASPARIAN', codigo_ibge: 3300951, codigo_uf: 33 },
    { id: 3197, nome: 'CONCEICAO DE MACABU', codigo_ibge: 3301405, codigo_uf: 33 },
    { id: 3198, nome: 'CORDEIRO', codigo_ibge: 3301504, codigo_uf: 33 },
    { id: 3199, nome: 'DUAS BARRAS', codigo_ibge: 3301603, codigo_uf: 33 },
    { id: 3200, nome: 'DUQUE DE CAXIAS', codigo_ibge: 3301702, codigo_uf: 33 },
    { id: 3201, nome: 'ENGENHEIRO PAULO DE FRONTIN', codigo_ibge: 3301801, codigo_uf: 33 },
    { id: 3202, nome: 'GUAPIMIRIM', codigo_ibge: 3301850, codigo_uf: 33 },
    { id: 3203, nome: 'IGUABA GRANDE', codigo_ibge: 3301876, codigo_uf: 33 },
    { id: 3204, nome: 'ITABORAI', codigo_ibge: 3301900, codigo_uf: 33 },
    { id: 3205, nome: 'ITAGUAI', codigo_ibge: 3302007, codigo_uf: 33 },
    { id: 3206, nome: 'ITALVA', codigo_ibge: 3302056, codigo_uf: 33 },
    { id: 3207, nome: 'ITAOCARA', codigo_ibge: 3302106, codigo_uf: 33 },
    { id: 3208, nome: 'ITAPERUNA', codigo_ibge: 3302205, codigo_uf: 33 },
    { id: 3209, nome: 'ITATIAIA', codigo_ibge: 3302254, codigo_uf: 33 },
    { id: 3210, nome: 'JAPERI', codigo_ibge: 3302270, codigo_uf: 33 },
    { id: 3211, nome: 'LAJE DO MURIAE', codigo_ibge: 3302304, codigo_uf: 33 },
    { id: 3212, nome: 'MACAE', codigo_ibge: 3302403, codigo_uf: 33 },
    { id: 3213, nome: 'MACUCO', codigo_ibge: 3302452, codigo_uf: 33 },
    { id: 3214, nome: 'MAGE', codigo_ibge: 3302502, codigo_uf: 33 },
    { id: 3215, nome: 'MANGARATIBA', codigo_ibge: 3302601, codigo_uf: 33 },
    { id: 3216, nome: 'MARICA', codigo_ibge: 3302700, codigo_uf: 33 },
    { id: 3217, nome: 'MENDES', codigo_ibge: 3302809, codigo_uf: 33 },
    { id: 3218, nome: 'MESQUITA', codigo_ibge: 3302858, codigo_uf: 33 },
    { id: 3219, nome: 'MIGUEL PEREIRA', codigo_ibge: 3302908, codigo_uf: 33 },
    { id: 3220, nome: 'MIRACEMA', codigo_ibge: 3303005, codigo_uf: 33 },
    { id: 3221, nome: 'NATIVIDADE', codigo_ibge: 3303104, codigo_uf: 33 },
    { id: 3222, nome: 'NILOPOLIS', codigo_ibge: 3303203, codigo_uf: 33 },
    { id: 3223, nome: 'NITEROI', codigo_ibge: 3303302, codigo_uf: 33 },
    { id: 3224, nome: 'NOVA FRIBURGO', codigo_ibge: 3303401, codigo_uf: 33 },
    { id: 3225, nome: 'NOVA IGUACU', codigo_ibge: 3303500, codigo_uf: 33 },
    { id: 3226, nome: 'PARACAMBI', codigo_ibge: 3303609, codigo_uf: 33 },
    { id: 3227, nome: 'PARAIBA DO SUL', codigo_ibge: 3303708, codigo_uf: 33 },
    { id: 3228, nome: 'PARATY', codigo_ibge: 3303807, codigo_uf: 33 },
    { id: 3229, nome: 'PATY DO ALFERES', codigo_ibge: 3303856, codigo_uf: 33 },
    { id: 3230, nome: 'PETROPOLIS', codigo_ibge: 3303906, codigo_uf: 33 },
    { id: 3231, nome: 'PINHEIRAL', codigo_ibge: 3303955, codigo_uf: 33 },
    { id: 3232, nome: 'PIRAI', codigo_ibge: 3304003, codigo_uf: 33 },
    { id: 3233, nome: 'PORCIUNCULA', codigo_ibge: 3304102, codigo_uf: 33 },
    { id: 3234, nome: 'PORTO REAL', codigo_ibge: 3304110, codigo_uf: 33 },
    { id: 3235, nome: 'QUATIS', codigo_ibge: 3304128, codigo_uf: 33 },
    { id: 3236, nome: 'QUEIMADOS', codigo_ibge: 3304144, codigo_uf: 33 },
    { id: 3237, nome: 'QUISSAMA', codigo_ibge: 3304151, codigo_uf: 33 },
    { id: 3238, nome: 'RESENDE', codigo_ibge: 3304201, codigo_uf: 33 },
    { id: 3239, nome: 'RIO BONITO', codigo_ibge: 3304300, codigo_uf: 33 },
    { id: 3240, nome: 'RIO CLARO', codigo_ibge: 3304409, codigo_uf: 33 },
    { id: 3241, nome: 'RIO DAS FLORES', codigo_ibge: 3304508, codigo_uf: 33 },
    { id: 3242, nome: 'RIO DAS OSTRAS', codigo_ibge: 3304524, codigo_uf: 33 },
    { id: 3243, nome: 'RIO DE JANEIRO', codigo_ibge: 3304557, codigo_uf: 33 },
    { id: 3244, nome: 'SANTA MARIA MADALENA', codigo_ibge: 3304607, codigo_uf: 33 },
    { id: 3245, nome: 'SANTO ANTONIO DE PADUA', codigo_ibge: 3304706, codigo_uf: 33 },
    { id: 3247, nome: 'SAO FIDELIS', codigo_ibge: 3304805, codigo_uf: 33 },
    { id: 3246, nome: 'SAO FRANCISCO DE ITABAPOANA', codigo_ibge: 3304755, codigo_uf: 33 },
    { id: 3248, nome: 'SAO GONCALO', codigo_ibge: 3304904, codigo_uf: 33 },
    { id: 3249, nome: 'SAO JOAO DA BARRA', codigo_ibge: 3305000, codigo_uf: 33 },
    { id: 3250, nome: 'SAO JOAO DE MERITI', codigo_ibge: 3305109, codigo_uf: 33 },
    { id: 3251, nome: 'SAO JOSE DE UBA', codigo_ibge: 3305133, codigo_uf: 33 },
    { id: 3252, nome: 'SAO JOSE DO VALE DO RIO PRETO', codigo_ibge: 3305158, codigo_uf: 33 },
    { id: 3253, nome: 'SAO PEDRO DA ALDEIA', codigo_ibge: 3305208, codigo_uf: 33 },
    { id: 3254, nome: 'SAO SEBASTIAO DO ALTO', codigo_ibge: 3305307, codigo_uf: 33 },
    { id: 3255, nome: 'SAPUCAIA', codigo_ibge: 3305406, codigo_uf: 33 },
    { id: 3256, nome: 'SAQUAREMA', codigo_ibge: 3305505, codigo_uf: 33 },
    { id: 3257, nome: 'SEROPEDICA', codigo_ibge: 3305554, codigo_uf: 33 },
    { id: 3258, nome: 'SILVA JARDIM', codigo_ibge: 3305604, codigo_uf: 33 },
    { id: 3259, nome: 'SUMIDOURO', codigo_ibge: 3305703, codigo_uf: 33 },
    { id: 3260, nome: 'TANGUA', codigo_ibge: 3305752, codigo_uf: 33 },
    { id: 3261, nome: 'TERESOPOLIS', codigo_ibge: 3305802, codigo_uf: 33 },
    { id: 3262, nome: 'TRAJANO DE MORAES', codigo_ibge: 3305901, codigo_uf: 33 },
    { id: 3263, nome: 'TRES RIOS', codigo_ibge: 3306008, codigo_uf: 33 },
    { id: 3264, nome: 'VALENCA', codigo_ibge: 3306107, codigo_uf: 33 },
    { id: 3265, nome: 'VARRE-SAI', codigo_ibge: 3306156, codigo_uf: 33 },
    { id: 3266, nome: 'VASSOURAS', codigo_ibge: 3306206, codigo_uf: 33 },
    { id: 3267, nome: 'VOLTA REDONDA', codigo_ibge: 3306305, codigo_uf: 33 },
    { id: 3268, nome: 'ADAMANTINA', codigo_ibge: 3500105, codigo_uf: 35 },
    { id: 3269, nome: 'ADOLFO', codigo_ibge: 3500204, codigo_uf: 35 },
    { id: 3270, nome: 'AGUAI', codigo_ibge: 3500303, codigo_uf: 35 },
    { id: 3271, nome: 'AGUAS DA PRATA', codigo_ibge: 3500402, codigo_uf: 35 },
    { id: 3272, nome: 'AGUAS DE LINDOIA', codigo_ibge: 3500501, codigo_uf: 35 },
    { id: 3273, nome: 'AGUAS DE SANTA BARBARA', codigo_ibge: 3500550, codigo_uf: 35 },
    { id: 3274, nome: 'AGUAS DE SAO PEDRO', codigo_ibge: 3500600, codigo_uf: 35 },
    { id: 3275, nome: 'AGUDOS', codigo_ibge: 3500709, codigo_uf: 35 },
    { id: 3276, nome: 'ALAMBARI', codigo_ibge: 3500758, codigo_uf: 35 },
    { id: 3277, nome: 'ALFREDO MARCONDES', codigo_ibge: 3500808, codigo_uf: 35 },
    { id: 3278, nome: 'ALTAIR', codigo_ibge: 3500907, codigo_uf: 35 },
    { id: 3279, nome: 'ALTINOPOLIS', codigo_ibge: 3501004, codigo_uf: 35 },
    { id: 3280, nome: 'ALTO ALEGRE', codigo_ibge: 3501103, codigo_uf: 35 },
    { id: 3281, nome: 'ALUMINIO', codigo_ibge: 3501152, codigo_uf: 35 },
    { id: 3282, nome: 'ALVARES FLORENCE', codigo_ibge: 3501202, codigo_uf: 35 },
    { id: 3283, nome: 'ALVARES MACHADO', codigo_ibge: 3501301, codigo_uf: 35 },
    { id: 3284, nome: 'ALVARO DE CARVALHO', codigo_ibge: 3501400, codigo_uf: 35 },
    { id: 3285, nome: 'ALVINLANDIA', codigo_ibge: 3501509, codigo_uf: 35 },
    { id: 3286, nome: 'AMERICANA', codigo_ibge: 3501608, codigo_uf: 35 },
    { id: 3287, nome: 'AMERICO BRASILIENSE', codigo_ibge: 3501707, codigo_uf: 35 },
    { id: 3288, nome: 'AMERICO DE CAMPOS', codigo_ibge: 3501806, codigo_uf: 35 },
    { id: 3289, nome: 'AMPARO', codigo_ibge: 3501905, codigo_uf: 35 },
    { id: 3290, nome: 'ANALANDIA', codigo_ibge: 3502002, codigo_uf: 35 },
    { id: 3291, nome: 'ANDRADINA', codigo_ibge: 3502101, codigo_uf: 35 },
    { id: 3292, nome: 'ANGATUBA', codigo_ibge: 3502200, codigo_uf: 35 },
    { id: 3293, nome: 'ANHEMBI', codigo_ibge: 3502309, codigo_uf: 35 },
    { id: 3294, nome: 'ANHUMAS', codigo_ibge: 3502408, codigo_uf: 35 },
    { id: 3295, nome: 'APARECIDA', codigo_ibge: 3502507, codigo_uf: 35 },
    { id: 3296, nome: 'APARECIDA D OESTE', codigo_ibge: 3502606, codigo_uf: 35 },
    { id: 3297, nome: 'APIAI', codigo_ibge: 3502705, codigo_uf: 35 },
    { id: 3298, nome: 'ARACARIGUAMA', codigo_ibge: 3502754, codigo_uf: 35 },
    { id: 3299, nome: 'ARACATUBA', codigo_ibge: 3502804, codigo_uf: 35 },
    { id: 3300, nome: 'ARACOIABA DA SERRA', codigo_ibge: 3502903, codigo_uf: 35 },
    { id: 3301, nome: 'ARAMINA', codigo_ibge: 3503000, codigo_uf: 35 },
    { id: 3302, nome: 'ARANDU', codigo_ibge: 3503109, codigo_uf: 35 },
    { id: 3303, nome: 'ARAPEI', codigo_ibge: 3503158, codigo_uf: 35 },
    { id: 3304, nome: 'ARARAQUARA', codigo_ibge: 3503208, codigo_uf: 35 },
    { id: 3305, nome: 'ARARAS', codigo_ibge: 3503307, codigo_uf: 35 },
    { id: 3306, nome: 'ARCO-IRIS', codigo_ibge: 3503356, codigo_uf: 35 },
    { id: 3307, nome: 'AREALVA', codigo_ibge: 3503406, codigo_uf: 35 },
    { id: 3308, nome: 'AREIAS', codigo_ibge: 3503505, codigo_uf: 35 },
    { id: 3309, nome: 'AREIOPOLIS', codigo_ibge: 3503604, codigo_uf: 35 },
    { id: 3310, nome: 'ARIRANHA', codigo_ibge: 3503703, codigo_uf: 35 },
    { id: 3311, nome: 'ARTUR NOGUEIRA', codigo_ibge: 3503802, codigo_uf: 35 },
    { id: 3312, nome: 'ARUJA', codigo_ibge: 3503901, codigo_uf: 35 },
    { id: 3313, nome: 'ASPASIA', codigo_ibge: 3503950, codigo_uf: 35 },
    { id: 3314, nome: 'ASSIS', codigo_ibge: 3504008, codigo_uf: 35 },
    { id: 3315, nome: 'ATIBAIA', codigo_ibge: 3504107, codigo_uf: 35 },
    { id: 3316, nome: 'AURIFLAMA', codigo_ibge: 3504206, codigo_uf: 35 },
    { id: 3317, nome: 'AVAI', codigo_ibge: 3504305, codigo_uf: 35 },
    { id: 3318, nome: 'AVANHANDAVA', codigo_ibge: 3504404, codigo_uf: 35 },
    { id: 3319, nome: 'AVARE', codigo_ibge: 3504503, codigo_uf: 35 },
    { id: 3320, nome: 'BADY BASSITT', codigo_ibge: 3504602, codigo_uf: 35 },
    { id: 3321, nome: 'BALBINOS', codigo_ibge: 3504701, codigo_uf: 35 },
    { id: 3322, nome: 'BALSAMO', codigo_ibge: 3504800, codigo_uf: 35 },
    { id: 3323, nome: 'BANANAL', codigo_ibge: 3504909, codigo_uf: 35 },
    { id: 3324, nome: 'BARAO DE ANTONINA', codigo_ibge: 3505005, codigo_uf: 35 },
    { id: 3325, nome: 'BARBOSA', codigo_ibge: 3505104, codigo_uf: 35 },
    { id: 3326, nome: 'BARIRI', codigo_ibge: 3505203, codigo_uf: 35 },
    { id: 3327, nome: 'BARRA BONITA', codigo_ibge: 3505302, codigo_uf: 35 },
    { id: 3328, nome: 'BARRA DO CHAPEU', codigo_ibge: 3505351, codigo_uf: 35 },
    { id: 3329, nome: 'BARRA DO TURVO', codigo_ibge: 3505401, codigo_uf: 35 },
    { id: 3330, nome: 'BARRETOS', codigo_ibge: 3505500, codigo_uf: 35 },
    { id: 3331, nome: 'BARRINHA', codigo_ibge: 3505609, codigo_uf: 35 },
    { id: 3332, nome: 'BARUERI', codigo_ibge: 3505708, codigo_uf: 35 },
    { id: 3333, nome: 'BASTOS', codigo_ibge: 3505807, codigo_uf: 35 },
    { id: 3334, nome: 'BATATAIS', codigo_ibge: 3505906, codigo_uf: 35 },
    { id: 3335, nome: 'BAURU', codigo_ibge: 3506003, codigo_uf: 35 },
    { id: 3336, nome: 'BEBEDOURO', codigo_ibge: 3506102, codigo_uf: 35 },
    { id: 3337, nome: 'BENTO DE ABREU', codigo_ibge: 3506201, codigo_uf: 35 },
    { id: 3338, nome: 'BERNARDINO DE CAMPOS', codigo_ibge: 3506300, codigo_uf: 35 },
    { id: 3339, nome: 'BERTIOGA', codigo_ibge: 3506359, codigo_uf: 35 },
    { id: 3340, nome: 'BILAC', codigo_ibge: 3506409, codigo_uf: 35 },
    { id: 3341, nome: 'BIRIGUI', codigo_ibge: 3506508, codigo_uf: 35 },
    { id: 3342, nome: 'BIRITIBA-MIRIM', codigo_ibge: 3506607, codigo_uf: 35 },
    { id: 3343, nome: 'BOA ESPERANCA DO SUL', codigo_ibge: 3506706, codigo_uf: 35 },
    { id: 3344, nome: 'BOCAINA', codigo_ibge: 3506805, codigo_uf: 35 },
    { id: 3345, nome: 'BOFETE', codigo_ibge: 3506904, codigo_uf: 35 },
    { id: 3346, nome: 'BOITUVA', codigo_ibge: 3507001, codigo_uf: 35 },
    { id: 3347, nome: 'BOM JESUS DOS PERDOES', codigo_ibge: 3507100, codigo_uf: 35 },
    { id: 3348, nome: 'BOM SUCESSO DE ITARARE', codigo_ibge: 3507159, codigo_uf: 35 },
    { id: 3349, nome: 'BORA', codigo_ibge: 3507209, codigo_uf: 35 },
    { id: 3350, nome: 'BORACEIA', codigo_ibge: 3507308, codigo_uf: 35 },
    { id: 3351, nome: 'BORBOREMA', codigo_ibge: 3507407, codigo_uf: 35 },
    { id: 3352, nome: 'BOREBI', codigo_ibge: 3507456, codigo_uf: 35 },
    { id: 3353, nome: 'BOTUCATU', codigo_ibge: 3507506, codigo_uf: 35 },
    { id: 3354, nome: 'BRAGANCA PAULISTA', codigo_ibge: 3507605, codigo_uf: 35 },
    { id: 3355, nome: 'BRAUNA', codigo_ibge: 3507704, codigo_uf: 35 },
    { id: 3356, nome: 'BREJO ALEGRE', codigo_ibge: 3507753, codigo_uf: 35 },
    { id: 3357, nome: 'BRODOWSKI', codigo_ibge: 3507803, codigo_uf: 35 },
    { id: 3358, nome: 'BROTAS', codigo_ibge: 3507902, codigo_uf: 35 },
    { id: 3359, nome: 'BURI', codigo_ibge: 3508009, codigo_uf: 35 },
    { id: 3360, nome: 'BURITAMA', codigo_ibge: 3508108, codigo_uf: 35 },
    { id: 3361, nome: 'BURITIZAL', codigo_ibge: 3508207, codigo_uf: 35 },
    { id: 3362, nome: 'CABRALIA PAULISTA', codigo_ibge: 3508306, codigo_uf: 35 },
    { id: 3363, nome: 'CABREUVA', codigo_ibge: 3508405, codigo_uf: 35 },
    { id: 3364, nome: 'CACAPAVA', codigo_ibge: 3508504, codigo_uf: 35 },
    { id: 3365, nome: 'CACHOEIRA PAULISTA', codigo_ibge: 3508603, codigo_uf: 35 },
    { id: 3366, nome: 'CACONDE', codigo_ibge: 3508702, codigo_uf: 35 },
    { id: 3367, nome: 'CAFELANDIA', codigo_ibge: 3508801, codigo_uf: 35 },
    { id: 3368, nome: 'CAIABU', codigo_ibge: 3508900, codigo_uf: 35 },
    { id: 3369, nome: 'CAIEIRAS', codigo_ibge: 3509007, codigo_uf: 35 },
    { id: 3370, nome: 'CAIUA', codigo_ibge: 3509106, codigo_uf: 35 },
    { id: 3371, nome: 'CAJAMAR', codigo_ibge: 3509205, codigo_uf: 35 },
    { id: 3372, nome: 'CAJATI', codigo_ibge: 3509254, codigo_uf: 35 },
    { id: 3373, nome: 'CAJOBI', codigo_ibge: 3509304, codigo_uf: 35 },
    { id: 3374, nome: 'CAJURU', codigo_ibge: 3509403, codigo_uf: 35 },
    { id: 3375, nome: 'CAMPINA DO MONTE ALEGRE', codigo_ibge: 3509452, codigo_uf: 35 },
    { id: 3376, nome: 'CAMPINAS', codigo_ibge: 3509502, codigo_uf: 35 },
    { id: 3377, nome: 'CAMPO LIMPO PAULISTA', codigo_ibge: 3509601, codigo_uf: 35 },
    { id: 3378, nome: 'CAMPOS DO JORDAO', codigo_ibge: 3509700, codigo_uf: 35 },
    { id: 3379, nome: 'CAMPOS NOVOS PAULISTA', codigo_ibge: 3509809, codigo_uf: 35 },
    { id: 3380, nome: 'CANANEIA', codigo_ibge: 3509908, codigo_uf: 35 },
    { id: 3381, nome: 'CANAS', codigo_ibge: 3509957, codigo_uf: 35 },
    { id: 3382, nome: 'CANDIDO MOTA', codigo_ibge: 3510005, codigo_uf: 35 },
    { id: 3383, nome: 'CANDIDO RODRIGUES', codigo_ibge: 3510104, codigo_uf: 35 },
    { id: 3384, nome: 'CANITAR', codigo_ibge: 3510153, codigo_uf: 35 },
    { id: 3385, nome: 'CAPAO BONITO', codigo_ibge: 3510203, codigo_uf: 35 },
    { id: 3386, nome: 'CAPELA DO ALTO', codigo_ibge: 3510302, codigo_uf: 35 },
    { id: 3387, nome: 'CAPIVARI', codigo_ibge: 3510401, codigo_uf: 35 },
    { id: 3388, nome: 'CARAGUATATUBA', codigo_ibge: 3510500, codigo_uf: 35 },
    { id: 3389, nome: 'CARAPICUIBA', codigo_ibge: 3510609, codigo_uf: 35 },
    { id: 3390, nome: 'CARDOSO', codigo_ibge: 3510708, codigo_uf: 35 },
    { id: 3391, nome: 'CASA BRANCA', codigo_ibge: 3510807, codigo_uf: 35 },
    { id: 3392, nome: 'CASSIA DOS COQUEIROS', codigo_ibge: 3510906, codigo_uf: 35 },
    { id: 3393, nome: 'CASTILHO', codigo_ibge: 3511003, codigo_uf: 35 },
    { id: 3394, nome: 'CATANDUVA', codigo_ibge: 3511102, codigo_uf: 35 },
    { id: 3395, nome: 'CATIGUA', codigo_ibge: 3511201, codigo_uf: 35 },
    { id: 3396, nome: 'CEDRAL', codigo_ibge: 3511300, codigo_uf: 35 },
    { id: 3397, nome: 'CERQUEIRA CESAR', codigo_ibge: 3511409, codigo_uf: 35 },
    { id: 3398, nome: 'CERQUILHO', codigo_ibge: 3511508, codigo_uf: 35 },
    { id: 3399, nome: 'CESARIO LANGE', codigo_ibge: 3511607, codigo_uf: 35 },
    { id: 3400, nome: 'CHARQUEADA', codigo_ibge: 3511706, codigo_uf: 35 },
    { id: 3911, nome: 'CHAVANTES', codigo_ibge: 3557204, codigo_uf: 35 },
    { id: 3401, nome: 'CLEMENTINA', codigo_ibge: 3511904, codigo_uf: 35 },
    { id: 3402, nome: 'COLINA', codigo_ibge: 3512001, codigo_uf: 35 },
    { id: 3403, nome: 'COLOMBIA', codigo_ibge: 3512100, codigo_uf: 35 },
    { id: 3404, nome: 'CONCHAL', codigo_ibge: 3512209, codigo_uf: 35 },
    { id: 3405, nome: 'CONCHAS', codigo_ibge: 3512308, codigo_uf: 35 },
    { id: 3406, nome: 'CORDEIROPOLIS', codigo_ibge: 3512407, codigo_uf: 35 },
    { id: 3407, nome: 'COROADOS', codigo_ibge: 3512506, codigo_uf: 35 },
    { id: 3408, nome: 'CORONEL MACEDO', codigo_ibge: 3512605, codigo_uf: 35 },
    { id: 3409, nome: 'CORUMBATAI', codigo_ibge: 3512704, codigo_uf: 35 },
    { id: 3410, nome: 'COSMOPOLIS', codigo_ibge: 3512803, codigo_uf: 35 },
    { id: 3411, nome: 'COSMORAMA', codigo_ibge: 3512902, codigo_uf: 35 },
    { id: 3412, nome: 'COTIA', codigo_ibge: 3513009, codigo_uf: 35 },
    { id: 3413, nome: 'CRAVINHOS', codigo_ibge: 3513108, codigo_uf: 35 },
    { id: 3414, nome: 'CRISTAIS PAULISTA', codigo_ibge: 3513207, codigo_uf: 35 },
    { id: 3415, nome: 'CRUZALIA', codigo_ibge: 3513306, codigo_uf: 35 },
    { id: 3416, nome: 'CRUZEIRO', codigo_ibge: 3513405, codigo_uf: 35 },
    { id: 3417, nome: 'CUBATAO', codigo_ibge: 3513504, codigo_uf: 35 },
    { id: 3418, nome: 'CUNHA', codigo_ibge: 3513603, codigo_uf: 35 },
    { id: 3419, nome: 'DESCALVADO', codigo_ibge: 3513702, codigo_uf: 35 },
    { id: 3420, nome: 'DIADEMA', codigo_ibge: 3513801, codigo_uf: 35 },
    { id: 3421, nome: 'DIRCE REIS', codigo_ibge: 3513850, codigo_uf: 35 },
    { id: 3422, nome: 'DIVINOLANDIA', codigo_ibge: 3513900, codigo_uf: 35 },
    { id: 3423, nome: 'DOBRADA', codigo_ibge: 3514007, codigo_uf: 35 },
    { id: 3424, nome: 'DOIS CORREGOS', codigo_ibge: 3514106, codigo_uf: 35 },
    { id: 3425, nome: 'DOLCINOPOLIS', codigo_ibge: 3514205, codigo_uf: 35 },
    { id: 3426, nome: 'DOURADO', codigo_ibge: 3514304, codigo_uf: 35 },
    { id: 3427, nome: 'DRACENA', codigo_ibge: 3514403, codigo_uf: 35 },
    { id: 3428, nome: 'DUARTINA', codigo_ibge: 3514502, codigo_uf: 35 },
    { id: 3429, nome: 'DUMONT', codigo_ibge: 3514601, codigo_uf: 35 },
    { id: 3430, nome: 'ECHAPORA', codigo_ibge: 3514700, codigo_uf: 35 },
    { id: 3431, nome: 'ELDORADO', codigo_ibge: 3514809, codigo_uf: 35 },
    { id: 3432, nome: 'ELIAS FAUSTO', codigo_ibge: 3514908, codigo_uf: 35 },
    { id: 3433, nome: 'ELISIARIO', codigo_ibge: 3514924, codigo_uf: 35 },
    { id: 3434, nome: 'EMBAUBA', codigo_ibge: 3514957, codigo_uf: 35 },
    { id: 3435, nome: 'EMBU DAS ARTES', codigo_ibge: 3515004, codigo_uf: 35 },
    { id: 3436, nome: 'EMBU-GUACU', codigo_ibge: 3515103, codigo_uf: 35 },
    { id: 3437, nome: 'EMILIANOPOLIS', codigo_ibge: 3515129, codigo_uf: 35 },
    { id: 3438, nome: 'ENGENHEIRO COELHO', codigo_ibge: 3515152, codigo_uf: 35 },
    { id: 3439, nome: 'ESPIRITO SANTO DO PINHAL', codigo_ibge: 3515186, codigo_uf: 35 },
    { id: 3440, nome: 'ESPIRITO SANTO DO TURVO', codigo_ibge: 3515194, codigo_uf: 35 },
    { id: 3912, nome: 'ESTIVA GERBI', codigo_ibge: 3557303, codigo_uf: 35 },
    { id: 3441, nome: 'ESTRELA D OESTE', codigo_ibge: 3515202, codigo_uf: 35 },
    { id: 3442, nome: 'ESTRELA DO NORTE', codigo_ibge: 3515301, codigo_uf: 35 },
    { id: 3443, nome: 'EUCLIDES DA CUNHA PAULISTA', codigo_ibge: 3515350, codigo_uf: 35 },
    { id: 3444, nome: 'FARTURA', codigo_ibge: 3515400, codigo_uf: 35 },
    { id: 3446, nome: 'FERNANDO PRESTES', codigo_ibge: 3515608, codigo_uf: 35 },
    { id: 3445, nome: 'FERNANDOPOLIS', codigo_ibge: 3515509, codigo_uf: 35 },
    { id: 3447, nome: 'FERNAO', codigo_ibge: 3515657, codigo_uf: 35 },
    { id: 3448, nome: 'FERRAZ DE VASCONCELOS', codigo_ibge: 3515707, codigo_uf: 35 },
    { id: 3449, nome: 'FLORA RICA', codigo_ibge: 3515806, codigo_uf: 35 },
    { id: 3450, nome: 'FLOREAL', codigo_ibge: 3515905, codigo_uf: 35 },
    { id: 3451, nome: 'FLORIDA PAULISTA', codigo_ibge: 3516002, codigo_uf: 35 },
    { id: 3452, nome: 'FLORINIA', codigo_ibge: 3516101, codigo_uf: 35 },
    { id: 3453, nome: 'FRANCA', codigo_ibge: 3516200, codigo_uf: 35 },
    { id: 3454, nome: 'FRANCISCO MORATO', codigo_ibge: 3516309, codigo_uf: 35 },
    { id: 3455, nome: 'FRANCO DA ROCHA', codigo_ibge: 3516408, codigo_uf: 35 },
    { id: 3456, nome: 'GABRIEL MONTEIRO', codigo_ibge: 3516507, codigo_uf: 35 },
    { id: 3457, nome: 'GALIA', codigo_ibge: 3516606, codigo_uf: 35 },
    { id: 3458, nome: 'GARCA', codigo_ibge: 3516705, codigo_uf: 35 },
    { id: 3459, nome: 'GASTAO VIDIGAL', codigo_ibge: 3516804, codigo_uf: 35 },
    { id: 3460, nome: 'GAVIAO PEIXOTO', codigo_ibge: 3516853, codigo_uf: 35 },
    { id: 3461, nome: 'GENERAL SALGADO', codigo_ibge: 3516903, codigo_uf: 35 },
    { id: 3462, nome: 'GETULINA', codigo_ibge: 3517000, codigo_uf: 35 },
    { id: 3463, nome: 'GLICERIO', codigo_ibge: 3517109, codigo_uf: 35 },
    { id: 3464, nome: 'GUAICARA', codigo_ibge: 3517208, codigo_uf: 35 },
    { id: 3465, nome: 'GUAIMBE', codigo_ibge: 3517307, codigo_uf: 35 },
    { id: 3466, nome: 'GUAIRA', codigo_ibge: 3517406, codigo_uf: 35 },
    { id: 3467, nome: 'GUAPIACU', codigo_ibge: 3517505, codigo_uf: 35 },
    { id: 3468, nome: 'GUAPIARA', codigo_ibge: 3517604, codigo_uf: 35 },
    { id: 3469, nome: 'GUARA', codigo_ibge: 3517703, codigo_uf: 35 },
    { id: 3470, nome: 'GUARACAI', codigo_ibge: 3517802, codigo_uf: 35 },
    { id: 3471, nome: 'GUARACI', codigo_ibge: 3517901, codigo_uf: 35 },
    { id: 3472, nome: 'GUARANI D OESTE', codigo_ibge: 3518008, codigo_uf: 35 },
    { id: 3473, nome: 'GUARANTA', codigo_ibge: 3518107, codigo_uf: 35 },
    { id: 3474, nome: 'GUARARAPES', codigo_ibge: 3518206, codigo_uf: 35 },
    { id: 3475, nome: 'GUARAREMA', codigo_ibge: 3518305, codigo_uf: 35 },
    { id: 3476, nome: 'GUARATINGUETA', codigo_ibge: 3518404, codigo_uf: 35 },
    { id: 3477, nome: 'GUAREI', codigo_ibge: 3518503, codigo_uf: 35 },
    { id: 3478, nome: 'GUARIBA', codigo_ibge: 3518602, codigo_uf: 35 },
    { id: 3479, nome: 'GUARUJA', codigo_ibge: 3518701, codigo_uf: 35 },
    { id: 3480, nome: 'GUARULHOS', codigo_ibge: 3518800, codigo_uf: 35 },
    { id: 3481, nome: 'GUATAPARA', codigo_ibge: 3518859, codigo_uf: 35 },
    { id: 3482, nome: 'GUZOLANDIA', codigo_ibge: 3518909, codigo_uf: 35 },
    { id: 3483, nome: 'HERCULANDIA', codigo_ibge: 3519006, codigo_uf: 35 },
    { id: 3484, nome: 'HOLAMBRA', codigo_ibge: 3519055, codigo_uf: 35 },
    { id: 3485, nome: 'HORTOLANDIA', codigo_ibge: 3519071, codigo_uf: 35 },
    { id: 3486, nome: 'IACANGA', codigo_ibge: 3519105, codigo_uf: 35 },
    { id: 3487, nome: 'IACRI', codigo_ibge: 3519204, codigo_uf: 35 },
    { id: 3488, nome: 'IARAS', codigo_ibge: 3519253, codigo_uf: 35 },
    { id: 3489, nome: 'IBATE', codigo_ibge: 3519303, codigo_uf: 35 },
    { id: 3490, nome: 'IBIRA', codigo_ibge: 3519402, codigo_uf: 35 },
    { id: 3491, nome: 'IBIRAREMA', codigo_ibge: 3519501, codigo_uf: 35 },
    { id: 3492, nome: 'IBITINGA', codigo_ibge: 3519600, codigo_uf: 35 },
    { id: 3493, nome: 'IBIUNA', codigo_ibge: 3519709, codigo_uf: 35 },
    { id: 3494, nome: 'ICEM', codigo_ibge: 3519808, codigo_uf: 35 },
    { id: 3495, nome: 'IEPE', codigo_ibge: 3519907, codigo_uf: 35 },
    { id: 3496, nome: 'IGARACU DO TIETE', codigo_ibge: 3520004, codigo_uf: 35 },
    { id: 3497, nome: 'IGARAPAVA', codigo_ibge: 3520103, codigo_uf: 35 },
    { id: 3498, nome: 'IGARATA', codigo_ibge: 3520202, codigo_uf: 35 },
    { id: 3499, nome: 'IGUAPE', codigo_ibge: 3520301, codigo_uf: 35 },
    { id: 3501, nome: 'ILHA COMPRIDA', codigo_ibge: 3520426, codigo_uf: 35 },
    { id: 3502, nome: 'ILHA SOLTEIRA', codigo_ibge: 3520442, codigo_uf: 35 },
    { id: 3500, nome: 'ILHABELA', codigo_ibge: 3520400, codigo_uf: 35 },
    { id: 3503, nome: 'INDAIATUBA', codigo_ibge: 3520509, codigo_uf: 35 },
    { id: 3504, nome: 'INDIANA', codigo_ibge: 3520608, codigo_uf: 35 },
    { id: 3505, nome: 'INDIAPORA', codigo_ibge: 3520707, codigo_uf: 35 },
    { id: 3506, nome: 'INUBIA PAULISTA', codigo_ibge: 3520806, codigo_uf: 35 },
    { id: 3507, nome: 'IPAUSSU', codigo_ibge: 3520905, codigo_uf: 35 },
    { id: 3508, nome: 'IPERO', codigo_ibge: 3521002, codigo_uf: 35 },
    { id: 3509, nome: 'IPEUNA', codigo_ibge: 3521101, codigo_uf: 35 },
    { id: 3510, nome: 'IPIGUA', codigo_ibge: 3521150, codigo_uf: 35 },
    { id: 3511, nome: 'IPORANGA', codigo_ibge: 3521200, codigo_uf: 35 },
    { id: 3512, nome: 'IPUA', codigo_ibge: 3521309, codigo_uf: 35 },
    { id: 3513, nome: 'IRACEMAPOLIS', codigo_ibge: 3521408, codigo_uf: 35 },
    { id: 3514, nome: 'IRAPUA', codigo_ibge: 3521507, codigo_uf: 35 },
    { id: 3515, nome: 'IRAPURU', codigo_ibge: 3521606, codigo_uf: 35 },
    { id: 3516, nome: 'ITABERA', codigo_ibge: 3521705, codigo_uf: 35 },
    { id: 3517, nome: 'ITAI', codigo_ibge: 3521804, codigo_uf: 35 },
    { id: 3518, nome: 'ITAJOBI', codigo_ibge: 3521903, codigo_uf: 35 },
    { id: 3519, nome: 'ITAJU', codigo_ibge: 3522000, codigo_uf: 35 },
    { id: 3520, nome: 'ITANHAEM', codigo_ibge: 3522109, codigo_uf: 35 },
    { id: 3521, nome: 'ITAOCA', codigo_ibge: 3522158, codigo_uf: 35 },
    { id: 3522, nome: 'ITAPECERICA DA SERRA', codigo_ibge: 3522208, codigo_uf: 35 },
    { id: 3523, nome: 'ITAPETININGA', codigo_ibge: 3522307, codigo_uf: 35 },
    { id: 3524, nome: 'ITAPEVA', codigo_ibge: 3522406, codigo_uf: 35 },
    { id: 3525, nome: 'ITAPEVI', codigo_ibge: 3522505, codigo_uf: 35 },
    { id: 3526, nome: 'ITAPIRA', codigo_ibge: 3522604, codigo_uf: 35 },
    { id: 3527, nome: 'ITAPIRAPUA PAULISTA', codigo_ibge: 3522653, codigo_uf: 35 },
    { id: 3528, nome: 'ITAPOLIS', codigo_ibge: 3522703, codigo_uf: 35 },
    { id: 3529, nome: 'ITAPORANGA', codigo_ibge: 3522802, codigo_uf: 35 },
    { id: 3530, nome: 'ITAPUI', codigo_ibge: 3522901, codigo_uf: 35 },
    { id: 3531, nome: 'ITAPURA', codigo_ibge: 3523008, codigo_uf: 35 },
    { id: 3532, nome: 'ITAQUAQUECETUBA', codigo_ibge: 3523107, codigo_uf: 35 },
    { id: 3533, nome: 'ITARARE', codigo_ibge: 3523206, codigo_uf: 35 },
    { id: 3534, nome: 'ITARIRI', codigo_ibge: 3523305, codigo_uf: 35 },
    { id: 3535, nome: 'ITATIBA', codigo_ibge: 3523404, codigo_uf: 35 },
    { id: 3536, nome: 'ITATINGA', codigo_ibge: 3523503, codigo_uf: 35 },
    { id: 3537, nome: 'ITIRAPINA', codigo_ibge: 3523602, codigo_uf: 35 },
    { id: 3538, nome: 'ITIRAPUA', codigo_ibge: 3523701, codigo_uf: 35 },
    { id: 3539, nome: 'ITOBI', codigo_ibge: 3523800, codigo_uf: 35 },
    { id: 3540, nome: 'ITU', codigo_ibge: 3523909, codigo_uf: 35 },
    { id: 3541, nome: 'ITUPEVA', codigo_ibge: 3524006, codigo_uf: 35 },
    { id: 3542, nome: 'ITUVERAVA', codigo_ibge: 3524105, codigo_uf: 35 },
    { id: 3543, nome: 'JABORANDI', codigo_ibge: 3524204, codigo_uf: 35 },
    { id: 3544, nome: 'JABOTICABAL', codigo_ibge: 3524303, codigo_uf: 35 },
    { id: 3545, nome: 'JACAREI', codigo_ibge: 3524402, codigo_uf: 35 },
    { id: 3546, nome: 'JACI', codigo_ibge: 3524501, codigo_uf: 35 },
    { id: 3547, nome: 'JACUPIRANGA', codigo_ibge: 3524600, codigo_uf: 35 },
    { id: 3548, nome: 'JAGUARIUNA', codigo_ibge: 3524709, codigo_uf: 35 },
    { id: 3549, nome: 'JALES', codigo_ibge: 3524808, codigo_uf: 35 },
    { id: 3550, nome: 'JAMBEIRO', codigo_ibge: 3524907, codigo_uf: 35 },
    { id: 3551, nome: 'JANDIRA', codigo_ibge: 3525003, codigo_uf: 35 },
    { id: 3552, nome: 'JARDINOPOLIS', codigo_ibge: 3525102, codigo_uf: 35 },
    { id: 3553, nome: 'JARINU', codigo_ibge: 3525201, codigo_uf: 35 },
    { id: 3554, nome: 'JAU', codigo_ibge: 3525300, codigo_uf: 35 },
    { id: 3555, nome: 'JERIQUARA', codigo_ibge: 3525409, codigo_uf: 35 },
    { id: 3556, nome: 'JOANOPOLIS', codigo_ibge: 3525508, codigo_uf: 35 },
    { id: 3557, nome: 'JOAO RAMALHO', codigo_ibge: 3525607, codigo_uf: 35 },
    { id: 3558, nome: 'JOSE BONIFACIO', codigo_ibge: 3525706, codigo_uf: 35 },
    { id: 3559, nome: 'JULIO MESQUITA', codigo_ibge: 3525805, codigo_uf: 35 },
    { id: 3560, nome: 'JUMIRIM', codigo_ibge: 3525854, codigo_uf: 35 },
    { id: 3561, nome: 'JUNDIAI', codigo_ibge: 3525904, codigo_uf: 35 },
    { id: 3562, nome: 'JUNQUEIROPOLIS', codigo_ibge: 3526001, codigo_uf: 35 },
    { id: 3563, nome: 'JUQUIA', codigo_ibge: 3526100, codigo_uf: 35 },
    { id: 3564, nome: 'JUQUITIBA', codigo_ibge: 3526209, codigo_uf: 35 },
    { id: 3565, nome: 'LAGOINHA', codigo_ibge: 3526308, codigo_uf: 35 },
    { id: 3566, nome: 'LARANJAL PAULISTA', codigo_ibge: 3526407, codigo_uf: 35 },
    { id: 3567, nome: 'LAVINIA', codigo_ibge: 3526506, codigo_uf: 35 },
    { id: 3568, nome: 'LAVRINHAS', codigo_ibge: 3526605, codigo_uf: 35 },
    { id: 3569, nome: 'LEME', codigo_ibge: 3526704, codigo_uf: 35 },
    { id: 3570, nome: 'LENCOIS PAULISTA', codigo_ibge: 3526803, codigo_uf: 35 },
    { id: 3571, nome: 'LIMEIRA', codigo_ibge: 3526902, codigo_uf: 35 },
    { id: 3572, nome: 'LINDOIA', codigo_ibge: 3527009, codigo_uf: 35 },
    { id: 3573, nome: 'LINS', codigo_ibge: 3527108, codigo_uf: 35 },
    { id: 3574, nome: 'LORENA', codigo_ibge: 3527207, codigo_uf: 35 },
    { id: 3575, nome: 'LOURDES', codigo_ibge: 3527256, codigo_uf: 35 },
    { id: 3576, nome: 'LOUVEIRA', codigo_ibge: 3527306, codigo_uf: 35 },
    { id: 3577, nome: 'LUCELIA', codigo_ibge: 3527405, codigo_uf: 35 },
    { id: 3578, nome: 'LUCIANOPOLIS', codigo_ibge: 3527504, codigo_uf: 35 },
    { id: 3579, nome: 'LUIS ANTONIO', codigo_ibge: 3527603, codigo_uf: 35 },
    { id: 3580, nome: 'LUIZIANIA', codigo_ibge: 3527702, codigo_uf: 35 },
    { id: 3581, nome: 'LUPERCIO', codigo_ibge: 3527801, codigo_uf: 35 },
    { id: 3582, nome: 'LUTECIA', codigo_ibge: 3527900, codigo_uf: 35 },
    { id: 3583, nome: 'MACATUBA', codigo_ibge: 3528007, codigo_uf: 35 },
    { id: 3584, nome: 'MACAUBAL', codigo_ibge: 3528106, codigo_uf: 35 },
    { id: 3585, nome: 'MACEDONIA', codigo_ibge: 3528205, codigo_uf: 35 },
    { id: 3586, nome: 'MAGDA', codigo_ibge: 3528304, codigo_uf: 35 },
    { id: 3587, nome: 'MAIRINQUE', codigo_ibge: 3528403, codigo_uf: 35 },
    { id: 3588, nome: 'MAIRIPORA', codigo_ibge: 3528502, codigo_uf: 35 },
    { id: 3589, nome: 'MANDURI', codigo_ibge: 3528601, codigo_uf: 35 },
    { id: 3590, nome: 'MARABA PAULISTA', codigo_ibge: 3528700, codigo_uf: 35 },
    { id: 3591, nome: 'MARACAI', codigo_ibge: 3528809, codigo_uf: 35 },
    { id: 3592, nome: 'MARAPOAMA', codigo_ibge: 3528858, codigo_uf: 35 },
    { id: 3593, nome: 'MARIAPOLIS', codigo_ibge: 3528908, codigo_uf: 35 },
    { id: 3594, nome: 'MARILIA', codigo_ibge: 3529005, codigo_uf: 35 },
    { id: 3595, nome: 'MARINOPOLIS', codigo_ibge: 3529104, codigo_uf: 35 },
    { id: 3596, nome: 'MARTINOPOLIS', codigo_ibge: 3529203, codigo_uf: 35 },
    { id: 3597, nome: 'MATAO', codigo_ibge: 3529302, codigo_uf: 35 },
    { id: 3598, nome: 'MAUA', codigo_ibge: 3529401, codigo_uf: 35 },
    { id: 3599, nome: 'MENDONCA', codigo_ibge: 3529500, codigo_uf: 35 },
    { id: 3600, nome: 'MERIDIANO', codigo_ibge: 3529609, codigo_uf: 35 },
    { id: 3601, nome: 'MESOPOLIS', codigo_ibge: 3529658, codigo_uf: 35 },
    { id: 3602, nome: 'MIGUELOPOLIS', codigo_ibge: 3529708, codigo_uf: 35 },
    { id: 3603, nome: 'MINEIROS DO TIETE', codigo_ibge: 3529807, codigo_uf: 35 },
    { id: 3605, nome: 'MIRA ESTRELA', codigo_ibge: 3530003, codigo_uf: 35 },
    { id: 3604, nome: 'MIRACATU', codigo_ibge: 3529906, codigo_uf: 35 },
    { id: 3606, nome: 'MIRANDOPOLIS', codigo_ibge: 3530102, codigo_uf: 35 },
    { id: 3607, nome: 'MIRANTE DO PARANAPANEMA', codigo_ibge: 3530201, codigo_uf: 35 },
    { id: 3608, nome: 'MIRASSOL', codigo_ibge: 3530300, codigo_uf: 35 },
    { id: 3609, nome: 'MIRASSOLANDIA', codigo_ibge: 3530409, codigo_uf: 35 },
    { id: 3610, nome: 'MOCOCA', codigo_ibge: 3530508, codigo_uf: 35 },
    { id: 3611, nome: 'MOGI DAS CRUZES', codigo_ibge: 3530607, codigo_uf: 35 },
    { id: 3612, nome: 'MOGI GUACU', codigo_ibge: 3530706, codigo_uf: 35 },
    { id: 3613, nome: 'MOGI MIRIM', codigo_ibge: 3530805, codigo_uf: 35 },
    { id: 3614, nome: 'MOMBUCA', codigo_ibge: 3530904, codigo_uf: 35 },
    { id: 3615, nome: 'MONCOES', codigo_ibge: 3531001, codigo_uf: 35 },
    { id: 3616, nome: 'MONGAGUA', codigo_ibge: 3531100, codigo_uf: 35 },
    { id: 3617, nome: 'MONTE ALEGRE DO SUL', codigo_ibge: 3531209, codigo_uf: 35 },
    { id: 3618, nome: 'MONTE ALTO', codigo_ibge: 3531308, codigo_uf: 35 },
    { id: 3619, nome: 'MONTE APRAZIVEL', codigo_ibge: 3531407, codigo_uf: 35 },
    { id: 3620, nome: 'MONTE AZUL PAULISTA', codigo_ibge: 3531506, codigo_uf: 35 },
    { id: 3621, nome: 'MONTE CASTELO', codigo_ibge: 3531605, codigo_uf: 35 },
    { id: 3623, nome: 'MONTE MOR', codigo_ibge: 3531803, codigo_uf: 35 },
    { id: 3622, nome: 'MONTEIRO LOBATO', codigo_ibge: 3531704, codigo_uf: 35 },
    { id: 3624, nome: 'MORRO AGUDO', codigo_ibge: 3531902, codigo_uf: 35 },
    { id: 3625, nome: 'MORUNGABA', codigo_ibge: 3532009, codigo_uf: 35 },
    { id: 3626, nome: 'MOTUCA', codigo_ibge: 3532058, codigo_uf: 35 },
    { id: 3627, nome: 'MURUTINGA DO SUL', codigo_ibge: 3532108, codigo_uf: 35 },
    { id: 3628, nome: 'NANTES', codigo_ibge: 3532157, codigo_uf: 35 },
    { id: 3629, nome: 'NARANDIBA', codigo_ibge: 3532207, codigo_uf: 35 },
    { id: 3630, nome: 'NATIVIDADE DA SERRA', codigo_ibge: 3532306, codigo_uf: 35 },
    { id: 3631, nome: 'NAZARE PAULISTA', codigo_ibge: 3532405, codigo_uf: 35 },
    { id: 3632, nome: 'NEVES PAULISTA', codigo_ibge: 3532504, codigo_uf: 35 },
    { id: 3633, nome: 'NHANDEARA', codigo_ibge: 3532603, codigo_uf: 35 },
    { id: 3634, nome: 'NIPOA', codigo_ibge: 3532702, codigo_uf: 35 },
    { id: 3635, nome: 'NOVA ALIANCA', codigo_ibge: 3532801, codigo_uf: 35 },
    { id: 3636, nome: 'NOVA CAMPINA', codigo_ibge: 3532827, codigo_uf: 35 },
    { id: 3637, nome: 'NOVA CANAA PAULISTA', codigo_ibge: 3532843, codigo_uf: 35 },
    { id: 3638, nome: 'NOVA CASTILHO', codigo_ibge: 3532868, codigo_uf: 35 },
    { id: 3639, nome: 'NOVA EUROPA', codigo_ibge: 3532900, codigo_uf: 35 },
    { id: 3640, nome: 'NOVA GRANADA', codigo_ibge: 3533007, codigo_uf: 35 },
    { id: 3641, nome: 'NOVA GUATAPORANGA', codigo_ibge: 3533106, codigo_uf: 35 },
    { id: 3642, nome: 'NOVA INDEPENDENCIA', codigo_ibge: 3533205, codigo_uf: 35 },
    { id: 3644, nome: 'NOVA LUZITANIA', codigo_ibge: 3533304, codigo_uf: 35 },
    { id: 3645, nome: 'NOVA ODESSA', codigo_ibge: 3533403, codigo_uf: 35 },
    { id: 3643, nome: 'NOVAIS', codigo_ibge: 3533254, codigo_uf: 35 },
    { id: 3646, nome: 'NOVO HORIZONTE', codigo_ibge: 3533502, codigo_uf: 35 },
    { id: 3647, nome: 'NUPORANGA', codigo_ibge: 3533601, codigo_uf: 35 },
    { id: 3648, nome: 'OCAUCU', codigo_ibge: 3533700, codigo_uf: 35 },
    { id: 3649, nome: 'OLEO', codigo_ibge: 3533809, codigo_uf: 35 },
    { id: 3650, nome: 'OLIMPIA', codigo_ibge: 3533908, codigo_uf: 35 },
    { id: 3651, nome: 'ONDA VERDE', codigo_ibge: 3534005, codigo_uf: 35 },
    { id: 3652, nome: 'ORIENTE', codigo_ibge: 3534104, codigo_uf: 35 },
    { id: 3653, nome: 'ORINDIUVA', codigo_ibge: 3534203, codigo_uf: 35 },
    { id: 3654, nome: 'ORLANDIA', codigo_ibge: 3534302, codigo_uf: 35 },
    { id: 3655, nome: 'OSASCO', codigo_ibge: 3534401, codigo_uf: 35 },
    { id: 3656, nome: 'OSCAR BRESSANE', codigo_ibge: 3534500, codigo_uf: 35 },
    { id: 3657, nome: 'OSVALDO CRUZ', codigo_ibge: 3534609, codigo_uf: 35 },
    { id: 3658, nome: 'OURINHOS', codigo_ibge: 3534708, codigo_uf: 35 },
    { id: 3660, nome: 'OURO VERDE', codigo_ibge: 3534807, codigo_uf: 35 },
    { id: 3659, nome: 'OUROESTE', codigo_ibge: 3534757, codigo_uf: 35 },
    { id: 3661, nome: 'PACAEMBU', codigo_ibge: 3534906, codigo_uf: 35 },
    { id: 3662, nome: 'PALESTINA', codigo_ibge: 3535002, codigo_uf: 35 },
    { id: 3663, nome: 'PALMARES PAULISTA', codigo_ibge: 3535101, codigo_uf: 35 },
    { id: 3664, nome: 'PALMEIRA D OESTE', codigo_ibge: 3535200, codigo_uf: 35 },
    { id: 3665, nome: 'PALMITAL', codigo_ibge: 3535309, codigo_uf: 35 },
    { id: 3666, nome: 'PANORAMA', codigo_ibge: 3535408, codigo_uf: 35 },
    { id: 3667, nome: 'PARAGUACU PAULISTA', codigo_ibge: 3535507, codigo_uf: 35 },
    { id: 3668, nome: 'PARAIBUNA', codigo_ibge: 3535606, codigo_uf: 35 },
    { id: 3669, nome: 'PARAISO', codigo_ibge: 3535705, codigo_uf: 35 },
    { id: 3670, nome: 'PARANAPANEMA', codigo_ibge: 3535804, codigo_uf: 35 },
    { id: 3671, nome: 'PARANAPUA', codigo_ibge: 3535903, codigo_uf: 35 },
    { id: 3672, nome: 'PARAPUA', codigo_ibge: 3536000, codigo_uf: 35 },
    { id: 3673, nome: 'PARDINHO', codigo_ibge: 3536109, codigo_uf: 35 },
    { id: 3674, nome: 'PARIQUERA-ACU', codigo_ibge: 3536208, codigo_uf: 35 },
    { id: 3675, nome: 'PARISI', codigo_ibge: 3536257, codigo_uf: 35 },
    { id: 3676, nome: 'PATROCINIO PAULISTA', codigo_ibge: 3536307, codigo_uf: 35 },
    { id: 3677, nome: 'PAULICEIA', codigo_ibge: 3536406, codigo_uf: 35 },
    { id: 3678, nome: 'PAULINIA', codigo_ibge: 3536505, codigo_uf: 35 },
    { id: 3679, nome: 'PAULISTANIA', codigo_ibge: 3536570, codigo_uf: 35 },
    { id: 3680, nome: 'PAULO DE FARIA', codigo_ibge: 3536604, codigo_uf: 35 },
    { id: 3681, nome: 'PEDERNEIRAS', codigo_ibge: 3536703, codigo_uf: 35 },
    { id: 3682, nome: 'PEDRA BELA', codigo_ibge: 3536802, codigo_uf: 35 },
    { id: 3683, nome: 'PEDRANOPOLIS', codigo_ibge: 3536901, codigo_uf: 35 },
    { id: 3684, nome: 'PEDREGULHO', codigo_ibge: 3537008, codigo_uf: 35 },
    { id: 3685, nome: 'PEDREIRA', codigo_ibge: 3537107, codigo_uf: 35 },
    { id: 3686, nome: 'PEDRINHAS PAULISTA', codigo_ibge: 3537156, codigo_uf: 35 },
    { id: 3687, nome: 'PEDRO DE TOLEDO', codigo_ibge: 3537206, codigo_uf: 35 },
    { id: 3688, nome: 'PENAPOLIS', codigo_ibge: 3537305, codigo_uf: 35 },
    { id: 3689, nome: 'PEREIRA BARRETO', codigo_ibge: 3537404, codigo_uf: 35 },
    { id: 3690, nome: 'PEREIRAS', codigo_ibge: 3537503, codigo_uf: 35 },
    { id: 3691, nome: 'PERUIBE', codigo_ibge: 3537602, codigo_uf: 35 },
    { id: 3692, nome: 'PIACATU', codigo_ibge: 3537701, codigo_uf: 35 },
    { id: 3693, nome: 'PIEDADE', codigo_ibge: 3537800, codigo_uf: 35 },
    { id: 3694, nome: 'PILAR DO SUL', codigo_ibge: 3537909, codigo_uf: 35 },
    { id: 3695, nome: 'PINDAMONHANGABA', codigo_ibge: 3538006, codigo_uf: 35 },
    { id: 3696, nome: 'PINDORAMA', codigo_ibge: 3538105, codigo_uf: 35 },
    { id: 3697, nome: 'PINHALZINHO', codigo_ibge: 3538204, codigo_uf: 35 },
    { id: 3698, nome: 'PIQUEROBI', codigo_ibge: 3538303, codigo_uf: 35 },
    { id: 3699, nome: 'PIQUETE', codigo_ibge: 3538501, codigo_uf: 35 },
    { id: 3700, nome: 'PIRACAIA', codigo_ibge: 3538600, codigo_uf: 35 },
    { id: 3701, nome: 'PIRACICABA', codigo_ibge: 3538709, codigo_uf: 35 },
    { id: 3702, nome: 'PIRAJU', codigo_ibge: 3538808, codigo_uf: 35 },
    { id: 3703, nome: 'PIRAJUI', codigo_ibge: 3538907, codigo_uf: 35 },
    { id: 3704, nome: 'PIRANGI', codigo_ibge: 3539004, codigo_uf: 35 },
    { id: 3705, nome: 'PIRAPORA DO BOM JESUS', codigo_ibge: 3539103, codigo_uf: 35 },
    { id: 3706, nome: 'PIRAPOZINHO', codigo_ibge: 3539202, codigo_uf: 35 },
    { id: 3707, nome: 'PIRASSUNUNGA', codigo_ibge: 3539301, codigo_uf: 35 },
    { id: 3708, nome: 'PIRATININGA', codigo_ibge: 3539400, codigo_uf: 35 },
    { id: 3709, nome: 'PITANGUEIRAS', codigo_ibge: 3539509, codigo_uf: 35 },
    { id: 3710, nome: 'PLANALTO', codigo_ibge: 3539608, codigo_uf: 35 },
    { id: 3711, nome: 'PLATINA', codigo_ibge: 3539707, codigo_uf: 35 },
    { id: 3712, nome: 'POA', codigo_ibge: 3539806, codigo_uf: 35 },
    { id: 3713, nome: 'POLONI', codigo_ibge: 3539905, codigo_uf: 35 },
    { id: 3714, nome: 'POMPEIA', codigo_ibge: 3540002, codigo_uf: 35 },
    { id: 3715, nome: 'PONGAI', codigo_ibge: 3540101, codigo_uf: 35 },
    { id: 3716, nome: 'PONTAL', codigo_ibge: 3540200, codigo_uf: 35 },
    { id: 3717, nome: 'PONTALINDA', codigo_ibge: 3540259, codigo_uf: 35 },
    { id: 3718, nome: 'PONTES GESTAL', codigo_ibge: 3540309, codigo_uf: 35 },
    { id: 3719, nome: 'POPULINA', codigo_ibge: 3540408, codigo_uf: 35 },
    { id: 3720, nome: 'PORANGABA', codigo_ibge: 3540507, codigo_uf: 35 },
    { id: 3721, nome: 'PORTO FELIZ', codigo_ibge: 3540606, codigo_uf: 35 },
    { id: 3722, nome: 'PORTO FERREIRA', codigo_ibge: 3540705, codigo_uf: 35 },
    { id: 3723, nome: 'POTIM', codigo_ibge: 3540754, codigo_uf: 35 },
    { id: 3724, nome: 'POTIRENDABA', codigo_ibge: 3540804, codigo_uf: 35 },
    { id: 3725, nome: 'PRACINHA', codigo_ibge: 3540853, codigo_uf: 35 },
    { id: 3726, nome: 'PRADOPOLIS', codigo_ibge: 3540903, codigo_uf: 35 },
    { id: 3727, nome: 'PRAIA GRANDE', codigo_ibge: 3541000, codigo_uf: 35 },
    { id: 3728, nome: 'PRATANIA', codigo_ibge: 3541059, codigo_uf: 35 },
    { id: 3729, nome: 'PRESIDENTE ALVES', codigo_ibge: 3541109, codigo_uf: 35 },
    { id: 3730, nome: 'PRESIDENTE BERNARDES', codigo_ibge: 3541208, codigo_uf: 35 },
    { id: 3731, nome: 'PRESIDENTE EPITACIO', codigo_ibge: 3541307, codigo_uf: 35 },
    { id: 3732, nome: 'PRESIDENTE PRUDENTE', codigo_ibge: 3541406, codigo_uf: 35 },
    { id: 3733, nome: 'PRESIDENTE VENCESLAU', codigo_ibge: 3541505, codigo_uf: 35 },
    { id: 3734, nome: 'PROMISSAO', codigo_ibge: 3541604, codigo_uf: 35 },
    { id: 3735, nome: 'QUADRA', codigo_ibge: 3541653, codigo_uf: 35 },
    { id: 3736, nome: 'QUATA', codigo_ibge: 3541703, codigo_uf: 35 },
    { id: 3737, nome: 'QUEIROZ', codigo_ibge: 3541802, codigo_uf: 35 },
    { id: 3738, nome: 'QUELUZ', codigo_ibge: 3541901, codigo_uf: 35 },
    { id: 3739, nome: 'QUINTANA', codigo_ibge: 3542008, codigo_uf: 35 },
    { id: 3740, nome: 'RAFARD', codigo_ibge: 3542107, codigo_uf: 35 },
    { id: 3741, nome: 'RANCHARIA', codigo_ibge: 3542206, codigo_uf: 35 },
    { id: 3742, nome: 'REDENCAO DA SERRA', codigo_ibge: 3542305, codigo_uf: 35 },
    { id: 3743, nome: 'REGENTE FEIJO', codigo_ibge: 3542404, codigo_uf: 35 },
    { id: 3744, nome: 'REGINOPOLIS', codigo_ibge: 3542503, codigo_uf: 35 },
    { id: 3745, nome: 'REGISTRO', codigo_ibge: 3542602, codigo_uf: 35 },
    { id: 3746, nome: 'RESTINGA', codigo_ibge: 3542701, codigo_uf: 35 },
    { id: 3747, nome: 'RIBEIRA', codigo_ibge: 3542800, codigo_uf: 35 },
    { id: 3748, nome: 'RIBEIRAO BONITO', codigo_ibge: 3542909, codigo_uf: 35 },
    { id: 3749, nome: 'RIBEIRAO BRANCO', codigo_ibge: 3543006, codigo_uf: 35 },
    { id: 3750, nome: 'RIBEIRAO CORRENTE', codigo_ibge: 3543105, codigo_uf: 35 },
    { id: 3751, nome: 'RIBEIRAO DO SUL', codigo_ibge: 3543204, codigo_uf: 35 },
    { id: 3752, nome: 'RIBEIRAO DOS INDIOS', codigo_ibge: 3543238, codigo_uf: 35 },
    { id: 3753, nome: 'RIBEIRAO GRANDE', codigo_ibge: 3543253, codigo_uf: 35 },
    { id: 3754, nome: 'RIBEIRAO PIRES', codigo_ibge: 3543303, codigo_uf: 35 },
    { id: 3755, nome: 'RIBEIRAO PRETO', codigo_ibge: 3543402, codigo_uf: 35 },
    { id: 3757, nome: 'RIFAINA', codigo_ibge: 3543600, codigo_uf: 35 },
    { id: 3758, nome: 'RINCAO', codigo_ibge: 3543709, codigo_uf: 35 },
    { id: 3759, nome: 'RINOPOLIS', codigo_ibge: 3543808, codigo_uf: 35 },
    { id: 3760, nome: 'RIO CLARO', codigo_ibge: 3543907, codigo_uf: 35 },
    { id: 3761, nome: 'RIO DAS PEDRAS', codigo_ibge: 3544004, codigo_uf: 35 },
    { id: 3762, nome: 'RIO GRANDE DA SERRA', codigo_ibge: 3544103, codigo_uf: 35 },
    { id: 3763, nome: 'RIOLANDIA', codigo_ibge: 3544202, codigo_uf: 35 },
    { id: 3756, nome: 'RIVERSUL', codigo_ibge: 3543501, codigo_uf: 35 },
    { id: 3764, nome: 'ROSANA', codigo_ibge: 3544251, codigo_uf: 35 },
    { id: 3765, nome: 'ROSEIRA', codigo_ibge: 3544301, codigo_uf: 35 },
    { id: 3766, nome: 'RUBIACEA', codigo_ibge: 3544400, codigo_uf: 35 },
    { id: 3767, nome: 'RUBINEIA', codigo_ibge: 3544509, codigo_uf: 35 },
    { id: 3768, nome: 'SABINO', codigo_ibge: 3544608, codigo_uf: 35 },
    { id: 3769, nome: 'SAGRES', codigo_ibge: 3544707, codigo_uf: 35 },
    { id: 3770, nome: 'SALES', codigo_ibge: 3544806, codigo_uf: 35 },
    { id: 3771, nome: 'SALES OLIVEIRA', codigo_ibge: 3544905, codigo_uf: 35 },
    { id: 3772, nome: 'SALESOPOLIS', codigo_ibge: 3545001, codigo_uf: 35 },
    { id: 3773, nome: 'SALMOURAO', codigo_ibge: 3545100, codigo_uf: 35 },
    { id: 3774, nome: 'SALTINHO', codigo_ibge: 3545159, codigo_uf: 35 },
    { id: 3775, nome: 'SALTO', codigo_ibge: 3545209, codigo_uf: 35 },
    { id: 3776, nome: 'SALTO DE PIRAPORA', codigo_ibge: 3545308, codigo_uf: 35 },
    { id: 3777, nome: 'SALTO GRANDE', codigo_ibge: 3545407, codigo_uf: 35 },
    { id: 3778, nome: 'SANDOVALINA', codigo_ibge: 3545506, codigo_uf: 35 },
    { id: 3779, nome: 'SANTA ADELIA', codigo_ibge: 3545605, codigo_uf: 35 },
    { id: 3780, nome: 'SANTA ALBERTINA', codigo_ibge: 3545704, codigo_uf: 35 },
    { id: 3781, nome: 'SANTA BARBARA D OESTE', codigo_ibge: 3545803, codigo_uf: 35 },
    { id: 3782, nome: 'SANTA BRANCA', codigo_ibge: 3546009, codigo_uf: 35 },
    { id: 3783, nome: 'SANTA CLARA D OESTE', codigo_ibge: 3546108, codigo_uf: 35 },
    { id: 3784, nome: 'SANTA CRUZ DA CONCEICAO', codigo_ibge: 3546207, codigo_uf: 35 },
    { id: 3785, nome: 'SANTA CRUZ DA ESPERANCA', codigo_ibge: 3546256, codigo_uf: 35 },
    { id: 3786, nome: 'SANTA CRUZ DAS PALMEIRAS', codigo_ibge: 3546306, codigo_uf: 35 },
    { id: 3787, nome: 'SANTA CRUZ DO RIO PARDO', codigo_ibge: 3546405, codigo_uf: 35 },
    { id: 3788, nome: 'SANTA ERNESTINA', codigo_ibge: 3546504, codigo_uf: 35 },
    { id: 3789, nome: 'SANTA FE DO SUL', codigo_ibge: 3546603, codigo_uf: 35 },
    { id: 3790, nome: 'SANTA GERTRUDES', codigo_ibge: 3546702, codigo_uf: 35 },
    { id: 3791, nome: 'SANTA ISABEL', codigo_ibge: 3546801, codigo_uf: 35 },
    { id: 3792, nome: 'SANTA LUCIA', codigo_ibge: 3546900, codigo_uf: 35 },
    { id: 3793, nome: 'SANTA MARIA DA SERRA', codigo_ibge: 3547007, codigo_uf: 35 },
    { id: 3794, nome: 'SANTA MERCEDES', codigo_ibge: 3547106, codigo_uf: 35 },
    { id: 3797, nome: 'SANTA RITA D OESTE', codigo_ibge: 3547403, codigo_uf: 35 },
    { id: 3798, nome: 'SANTA RITA DO PASSA QUATRO', codigo_ibge: 3547502, codigo_uf: 35 },
    { id: 3799, nome: 'SANTA ROSA DE VITERBO', codigo_ibge: 3547601, codigo_uf: 35 },
    { id: 3800, nome: 'SANTA SALETE', codigo_ibge: 3547650, codigo_uf: 35 },
    { id: 3795, nome: 'SANTANA DA PONTE PENSA', codigo_ibge: 3547205, codigo_uf: 35 },
    { id: 3796, nome: 'SANTANA DE PARNAIBA', codigo_ibge: 3547304, codigo_uf: 35 },
    { id: 3801, nome: 'SANTO ANASTACIO', codigo_ibge: 3547700, codigo_uf: 35 },
    { id: 3802, nome: 'SANTO ANDRE', codigo_ibge: 3547809, codigo_uf: 35 },
    { id: 3803, nome: 'SANTO ANTONIO DA ALEGRIA', codigo_ibge: 3547908, codigo_uf: 35 },
    { id: 3804, nome: 'SANTO ANTONIO DE POSSE', codigo_ibge: 3548005, codigo_uf: 35 },
    { id: 3805, nome: 'SANTO ANTONIO DO ARACANGUA', codigo_ibge: 3548054, codigo_uf: 35 },
    { id: 3806, nome: 'SANTO ANTONIO DO JARDIM', codigo_ibge: 3548104, codigo_uf: 35 },
    { id: 3807, nome: 'SANTO ANTONIO DO PINHAL', codigo_ibge: 3548203, codigo_uf: 35 },
    { id: 3808, nome: 'SANTO EXPEDITO', codigo_ibge: 3548302, codigo_uf: 35 },
    { id: 3809, nome: 'SANTOPOLIS DO AGUAPEI', codigo_ibge: 3548401, codigo_uf: 35 },
    { id: 3810, nome: 'SANTOS', codigo_ibge: 3548500, codigo_uf: 35 },
    { id: 3811, nome: 'SAO BENTO DO SAPUCAI', codigo_ibge: 3548609, codigo_uf: 35 },
    { id: 3812, nome: 'SAO BERNARDO DO CAMPO', codigo_ibge: 3548708, codigo_uf: 35 },
    { id: 3813, nome: 'SAO CAETANO DO SUL', codigo_ibge: 3548807, codigo_uf: 35 },
    { id: 3814, nome: 'SAO CARLOS', codigo_ibge: 3548906, codigo_uf: 35 },
    { id: 3815, nome: 'SAO FRANCISCO', codigo_ibge: 3549003, codigo_uf: 35 },
    { id: 3816, nome: 'SAO JOAO DA BOA VISTA', codigo_ibge: 3549102, codigo_uf: 35 },
    { id: 3817, nome: 'SAO JOAO DAS DUAS PONTES', codigo_ibge: 3549201, codigo_uf: 35 },
    { id: 3818, nome: 'SAO JOAO DE IRACEMA', codigo_ibge: 3549250, codigo_uf: 35 },
    { id: 3819, nome: 'SAO JOAO DO PAU D ALHO', codigo_ibge: 3549300, codigo_uf: 35 },
    { id: 3820, nome: 'SAO JOAQUIM DA BARRA', codigo_ibge: 3549409, codigo_uf: 35 },
    { id: 3821, nome: 'SAO JOSE DA BELA VISTA', codigo_ibge: 3549508, codigo_uf: 35 },
    { id: 3822, nome: 'SAO JOSE DO BARREIRO', codigo_ibge: 3549607, codigo_uf: 35 },
    { id: 3823, nome: 'SAO JOSE DO RIO PARDO', codigo_ibge: 3549706, codigo_uf: 35 },
    { id: 3824, nome: 'SAO JOSE DO RIO PRETO', codigo_ibge: 3549805, codigo_uf: 35 },
    { id: 3825, nome: 'SAO JOSE DOS CAMPOS', codigo_ibge: 3549904, codigo_uf: 35 },
    { id: 3826, nome: 'SAO LOURENCO DA SERRA', codigo_ibge: 3549953, codigo_uf: 35 },
    { id: 3827, nome: 'SAO LUIZ DO PARAITINGA', codigo_ibge: 3550001, codigo_uf: 35 },
    { id: 3828, nome: 'SAO MANUEL', codigo_ibge: 3550100, codigo_uf: 35 },
    { id: 3829, nome: 'SAO MIGUEL ARCANJO', codigo_ibge: 3550209, codigo_uf: 35 },
    { id: 3830, nome: 'SAO PAULO', codigo_ibge: 3550308, codigo_uf: 35 },
    { id: 3831, nome: 'SAO PEDRO', codigo_ibge: 3550407, codigo_uf: 35 },
    { id: 3832, nome: 'SAO PEDRO DO TURVO', codigo_ibge: 3550506, codigo_uf: 35 },
    { id: 3833, nome: 'SAO ROQUE', codigo_ibge: 3550605, codigo_uf: 35 },
    { id: 3834, nome: 'SAO SEBASTIAO', codigo_ibge: 3550704, codigo_uf: 35 },
    { id: 3835, nome: 'SAO SEBASTIAO DA GRAMA', codigo_ibge: 3550803, codigo_uf: 35 },
    { id: 3836, nome: 'SAO SIMAO', codigo_ibge: 3550902, codigo_uf: 35 },
    { id: 3837, nome: 'SAO VICENTE', codigo_ibge: 3551009, codigo_uf: 35 },
    { id: 3838, nome: 'SARAPUI', codigo_ibge: 3551108, codigo_uf: 35 },
    { id: 3839, nome: 'SARUTAIA', codigo_ibge: 3551207, codigo_uf: 35 },
    { id: 3840, nome: 'SEBASTIANOPOLIS DO SUL', codigo_ibge: 3551306, codigo_uf: 35 },
    { id: 3841, nome: 'SERRA AZUL', codigo_ibge: 3551405, codigo_uf: 35 },
    { id: 3843, nome: 'SERRA NEGRA', codigo_ibge: 3551603, codigo_uf: 35 },
    { id: 3842, nome: 'SERRANA', codigo_ibge: 3551504, codigo_uf: 35 },
    { id: 3844, nome: 'SERTAOZINHO', codigo_ibge: 3551702, codigo_uf: 35 },
    { id: 3845, nome: 'SETE BARRAS', codigo_ibge: 3551801, codigo_uf: 35 },
    { id: 3846, nome: 'SEVERINIA', codigo_ibge: 3551900, codigo_uf: 35 },
    { id: 3847, nome: 'SILVEIRAS', codigo_ibge: 3552007, codigo_uf: 35 },
    { id: 3848, nome: 'SOCORRO', codigo_ibge: 3552106, codigo_uf: 35 },
    { id: 3849, nome: 'SOROCABA', codigo_ibge: 3552205, codigo_uf: 35 },
    { id: 3850, nome: 'SUD MENNUCCI', codigo_ibge: 3552304, codigo_uf: 35 },
    { id: 3851, nome: 'SUMARE', codigo_ibge: 3552403, codigo_uf: 35 },
    { id: 3853, nome: 'SUZANAPOLIS', codigo_ibge: 3552551, codigo_uf: 35 },
    { id: 3852, nome: 'SUZANO', codigo_ibge: 3552502, codigo_uf: 35 },
    { id: 3854, nome: 'TABAPUA', codigo_ibge: 3552601, codigo_uf: 35 },
    { id: 3855, nome: 'TABATINGA', codigo_ibge: 3552700, codigo_uf: 35 },
    { id: 3856, nome: 'TABOAO DA SERRA', codigo_ibge: 3552809, codigo_uf: 35 },
    { id: 3857, nome: 'TACIBA', codigo_ibge: 3552908, codigo_uf: 35 },
    { id: 3858, nome: 'TAGUAI', codigo_ibge: 3553005, codigo_uf: 35 },
    { id: 3859, nome: 'TAIACU', codigo_ibge: 3553104, codigo_uf: 35 },
    { id: 3860, nome: 'TAIUVA', codigo_ibge: 3553203, codigo_uf: 35 },
    { id: 3861, nome: 'TAMBAU', codigo_ibge: 3553302, codigo_uf: 35 },
    { id: 3862, nome: 'TANABI', codigo_ibge: 3553401, codigo_uf: 35 },
    { id: 3863, nome: 'TAPIRAI', codigo_ibge: 3553500, codigo_uf: 35 },
    { id: 3864, nome: 'TAPIRATIBA', codigo_ibge: 3553609, codigo_uf: 35 },
    { id: 3865, nome: 'TAQUARAL', codigo_ibge: 3553658, codigo_uf: 35 },
    { id: 3866, nome: 'TAQUARITINGA', codigo_ibge: 3553708, codigo_uf: 35 },
    { id: 3867, nome: 'TAQUARITUBA', codigo_ibge: 3553807, codigo_uf: 35 },
    { id: 3868, nome: 'TAQUARIVAI', codigo_ibge: 3553856, codigo_uf: 35 },
    { id: 3869, nome: 'TARABAI', codigo_ibge: 3553906, codigo_uf: 35 },
    { id: 3870, nome: 'TARUMA', codigo_ibge: 3553955, codigo_uf: 35 },
    { id: 3871, nome: 'TATUI', codigo_ibge: 3554003, codigo_uf: 35 },
    { id: 3872, nome: 'TAUBATE', codigo_ibge: 3554102, codigo_uf: 35 },
    { id: 3873, nome: 'TEJUPA', codigo_ibge: 3554201, codigo_uf: 35 },
    { id: 3874, nome: 'TEODORO SAMPAIO', codigo_ibge: 3554300, codigo_uf: 35 },
    { id: 3875, nome: 'TERRA ROXA', codigo_ibge: 3554409, codigo_uf: 35 },
    { id: 3876, nome: 'TIETE', codigo_ibge: 3554508, codigo_uf: 35 },
    { id: 3877, nome: 'TIMBURI', codigo_ibge: 3554607, codigo_uf: 35 },
    { id: 3878, nome: 'TORRE DE PEDRA', codigo_ibge: 3554656, codigo_uf: 35 },
    { id: 3879, nome: 'TORRINHA', codigo_ibge: 3554706, codigo_uf: 35 },
    { id: 3880, nome: 'TRABIJU', codigo_ibge: 3554755, codigo_uf: 35 },
    { id: 3881, nome: 'TREMEMBE', codigo_ibge: 3554805, codigo_uf: 35 },
    { id: 3882, nome: 'TRES FRONTEIRAS', codigo_ibge: 3554904, codigo_uf: 35 },
    { id: 3883, nome: 'TUIUTI', codigo_ibge: 3554953, codigo_uf: 35 },
    { id: 3884, nome: 'TUPA', codigo_ibge: 3555000, codigo_uf: 35 },
    { id: 3885, nome: 'TUPI PAULISTA', codigo_ibge: 3555109, codigo_uf: 35 },
    { id: 3886, nome: 'TURIUBA', codigo_ibge: 3555208, codigo_uf: 35 },
    { id: 3887, nome: 'TURMALINA', codigo_ibge: 3555307, codigo_uf: 35 },
    { id: 3888, nome: 'UBARANA', codigo_ibge: 3555356, codigo_uf: 35 },
    { id: 3889, nome: 'UBATUBA', codigo_ibge: 3555406, codigo_uf: 35 },
    { id: 3890, nome: 'UBIRAJARA', codigo_ibge: 3555505, codigo_uf: 35 },
    { id: 3891, nome: 'UCHOA', codigo_ibge: 3555604, codigo_uf: 35 },
    { id: 3892, nome: 'UNIAO PAULISTA', codigo_ibge: 3555703, codigo_uf: 35 },
    { id: 3893, nome: 'URANIA', codigo_ibge: 3555802, codigo_uf: 35 },
    { id: 3894, nome: 'URU', codigo_ibge: 3555901, codigo_uf: 35 },
    { id: 3895, nome: 'URUPES', codigo_ibge: 3556008, codigo_uf: 35 },
    { id: 3896, nome: 'VALENTIM GENTIL', codigo_ibge: 3556107, codigo_uf: 35 },
    { id: 3897, nome: 'VALINHOS', codigo_ibge: 3556206, codigo_uf: 35 },
    { id: 3898, nome: 'VALPARAISO', codigo_ibge: 3556305, codigo_uf: 35 },
    { id: 3899, nome: 'VARGEM', codigo_ibge: 3556354, codigo_uf: 35 },
    { id: 3900, nome: 'VARGEM GRANDE DO SUL', codigo_ibge: 3556404, codigo_uf: 35 },
    { id: 3901, nome: 'VARGEM GRANDE PAULISTA', codigo_ibge: 3556453, codigo_uf: 35 },
    { id: 3902, nome: 'VARZEA PAULISTA', codigo_ibge: 3556503, codigo_uf: 35 },
    { id: 3903, nome: 'VERA CRUZ', codigo_ibge: 3556602, codigo_uf: 35 },
    { id: 3904, nome: 'VINHEDO', codigo_ibge: 3556701, codigo_uf: 35 },
    { id: 3905, nome: 'VIRADOURO', codigo_ibge: 3556800, codigo_uf: 35 },
    { id: 3906, nome: 'VISTA ALEGRE DO ALTO', codigo_ibge: 3556909, codigo_uf: 35 },
    { id: 3907, nome: 'VITORIA BRASIL', codigo_ibge: 3556958, codigo_uf: 35 },
    { id: 3908, nome: 'VOTORANTIM', codigo_ibge: 3557006, codigo_uf: 35 },
    { id: 3909, nome: 'VOTUPORANGA', codigo_ibge: 3557105, codigo_uf: 35 },
    { id: 3910, nome: 'ZACARIAS', codigo_ibge: 3557154, codigo_uf: 35 },
    { id: 3913, nome: 'ABATIA', codigo_ibge: 4100103, codigo_uf: 41 },
    { id: 3914, nome: 'ADRIANOPOLIS', codigo_ibge: 4100202, codigo_uf: 41 },
    { id: 3915, nome: 'AGUDOS DO SUL', codigo_ibge: 4100301, codigo_uf: 41 },
    { id: 3916, nome: 'ALMIRANTE TAMANDARE', codigo_ibge: 4100400, codigo_uf: 41 },
    { id: 3917, nome: 'ALTAMIRA DO PARANA', codigo_ibge: 4100459, codigo_uf: 41 },
    { id: 4307, nome: 'ALTO PARAISO', codigo_ibge: 4128625, codigo_uf: 41 },
    { id: 3919, nome: 'ALTO PARANA', codigo_ibge: 4100608, codigo_uf: 41 },
    { id: 3920, nome: 'ALTO PIQUIRI', codigo_ibge: 4100707, codigo_uf: 41 },
    { id: 3918, nome: 'ALTONIA', codigo_ibge: 4100509, codigo_uf: 41 },
    { id: 3921, nome: 'ALVORADA DO SUL', codigo_ibge: 4100806, codigo_uf: 41 },
    { id: 3922, nome: 'AMAPORA', codigo_ibge: 4100905, codigo_uf: 41 },
    { id: 3923, nome: 'AMPERE', codigo_ibge: 4101002, codigo_uf: 41 },
    { id: 3924, nome: 'ANAHY', codigo_ibge: 4101051, codigo_uf: 41 },
    { id: 3925, nome: 'ANDIRA', codigo_ibge: 4101101, codigo_uf: 41 },
    { id: 3926, nome: 'ANGULO', codigo_ibge: 4101150, codigo_uf: 41 },
    { id: 3927, nome: 'ANTONINA', codigo_ibge: 4101200, codigo_uf: 41 },
    { id: 3928, nome: 'ANTONIO OLINTO', codigo_ibge: 4101309, codigo_uf: 41 },
    { id: 3929, nome: 'APUCARANA', codigo_ibge: 4101408, codigo_uf: 41 },
    { id: 3930, nome: 'ARAPONGAS', codigo_ibge: 4101507, codigo_uf: 41 },
    { id: 3931, nome: 'ARAPOTI', codigo_ibge: 4101606, codigo_uf: 41 },
    { id: 3932, nome: 'ARAPUA', codigo_ibge: 4101655, codigo_uf: 41 },
    { id: 3933, nome: 'ARARUNA', codigo_ibge: 4101705, codigo_uf: 41 },
    { id: 3934, nome: 'ARAUCARIA', codigo_ibge: 4101804, codigo_uf: 41 },
    { id: 3935, nome: 'ARIRANHA DO IVAI', codigo_ibge: 4101853, codigo_uf: 41 },
    { id: 3936, nome: 'ASSAI', codigo_ibge: 4101903, codigo_uf: 41 },
    { id: 3937, nome: 'ASSIS CHATEAUBRIAND', codigo_ibge: 4102000, codigo_uf: 41 },
    { id: 3938, nome: 'ASTORGA', codigo_ibge: 4102109, codigo_uf: 41 },
    { id: 3939, nome: 'ATALAIA', codigo_ibge: 4102208, codigo_uf: 41 },
    { id: 3940, nome: 'BALSA NOVA', codigo_ibge: 4102307, codigo_uf: 41 },
    { id: 3941, nome: 'BANDEIRANTES', codigo_ibge: 4102406, codigo_uf: 41 },
    { id: 3942, nome: 'BARBOSA FERRAZ', codigo_ibge: 4102505, codigo_uf: 41 },
    { id: 3944, nome: 'BARRA DO JACARE', codigo_ibge: 4102703, codigo_uf: 41 },
    { id: 3943, nome: 'BARRACAO', codigo_ibge: 4102604, codigo_uf: 41 },
    { id: 3945, nome: 'BELA VISTA DA CAROBA', codigo_ibge: 4102752, codigo_uf: 41 },
    { id: 3946, nome: 'BELA VISTA DO PARAISO', codigo_ibge: 4102802, codigo_uf: 41 },
    { id: 3947, nome: 'BITURUNA', codigo_ibge: 4102901, codigo_uf: 41 },
    { id: 3948, nome: 'BOA ESPERANCA', codigo_ibge: 4103008, codigo_uf: 41 },
    { id: 3949, nome: 'BOA ESPERANCA DO IGUACU', codigo_ibge: 4103024, codigo_uf: 41 },
    { id: 3950, nome: 'BOA VENTURA DE SAO ROQUE', codigo_ibge: 4103040, codigo_uf: 41 },
    { id: 3951, nome: 'BOA VISTA DA APARECIDA', codigo_ibge: 4103057, codigo_uf: 41 },
    { id: 3952, nome: 'BOCAIUVA DO SUL', codigo_ibge: 4103107, codigo_uf: 41 },
    { id: 3953, nome: 'BOM JESUS DO SUL', codigo_ibge: 4103156, codigo_uf: 41 },
    { id: 3954, nome: 'BOM SUCESSO', codigo_ibge: 4103206, codigo_uf: 41 },
    { id: 3955, nome: 'BOM SUCESSO DO SUL', codigo_ibge: 4103222, codigo_uf: 41 },
    { id: 3956, nome: 'BORRAZOPOLIS', codigo_ibge: 4103305, codigo_uf: 41 },
    { id: 3957, nome: 'BRAGANEY', codigo_ibge: 4103354, codigo_uf: 41 },
    { id: 3958, nome: 'BRASILANDIA DO SUL', codigo_ibge: 4103370, codigo_uf: 41 },
    { id: 3959, nome: 'CAFEARA', codigo_ibge: 4103404, codigo_uf: 41 },
    { id: 3960, nome: 'CAFELANDIA', codigo_ibge: 4103453, codigo_uf: 41 },
    { id: 3961, nome: 'CAFEZAL DO SUL', codigo_ibge: 4103479, codigo_uf: 41 },
    { id: 3962, nome: 'CALIFORNIA', codigo_ibge: 4103503, codigo_uf: 41 },
    { id: 3963, nome: 'CAMBARA', codigo_ibge: 4103602, codigo_uf: 41 },
    { id: 3964, nome: 'CAMBE', codigo_ibge: 4103701, codigo_uf: 41 },
    { id: 3965, nome: 'CAMBIRA', codigo_ibge: 4103800, codigo_uf: 41 },
    { id: 3966, nome: 'CAMPINA DA LAGOA', codigo_ibge: 4103909, codigo_uf: 41 },
    { id: 3967, nome: 'CAMPINA DO SIMAO', codigo_ibge: 4103958, codigo_uf: 41 },
    { id: 3968, nome: 'CAMPINA GRANDE DO SUL', codigo_ibge: 4104006, codigo_uf: 41 },
    { id: 3969, nome: 'CAMPO BONITO', codigo_ibge: 4104055, codigo_uf: 41 },
    { id: 3970, nome: 'CAMPO DO TENENTE', codigo_ibge: 4104105, codigo_uf: 41 },
    { id: 3971, nome: 'CAMPO LARGO', codigo_ibge: 4104204, codigo_uf: 41 },
    { id: 3972, nome: 'CAMPO MAGRO', codigo_ibge: 4104253, codigo_uf: 41 },
    { id: 3973, nome: 'CAMPO MOURAO', codigo_ibge: 4104303, codigo_uf: 41 },
    { id: 3974, nome: 'CANDIDO DE ABREU', codigo_ibge: 4104402, codigo_uf: 41 },
    { id: 3975, nome: 'CANDOI', codigo_ibge: 4104428, codigo_uf: 41 },
    { id: 3976, nome: 'CANTAGALO', codigo_ibge: 4104451, codigo_uf: 41 },
    { id: 3977, nome: 'CAPANEMA', codigo_ibge: 4104501, codigo_uf: 41 },
    { id: 3978, nome: 'CAPITAO LEONIDAS MARQUES', codigo_ibge: 4104600, codigo_uf: 41 },
    { id: 3979, nome: 'CARAMBEI', codigo_ibge: 4104659, codigo_uf: 41 },
    { id: 3980, nome: 'CARLOPOLIS', codigo_ibge: 4104709, codigo_uf: 41 },
    { id: 3981, nome: 'CASCAVEL', codigo_ibge: 4104808, codigo_uf: 41 },
    { id: 3982, nome: 'CASTRO', codigo_ibge: 4104907, codigo_uf: 41 },
    { id: 3983, nome: 'CATANDUVAS', codigo_ibge: 4105003, codigo_uf: 41 },
    { id: 3984, nome: 'CENTENARIO DO SUL', codigo_ibge: 4105102, codigo_uf: 41 },
    { id: 3985, nome: 'CERRO AZUL', codigo_ibge: 4105201, codigo_uf: 41 },
    { id: 3986, nome: 'CEU AZUL', codigo_ibge: 4105300, codigo_uf: 41 },
    { id: 3987, nome: 'CHOPINZINHO', codigo_ibge: 4105409, codigo_uf: 41 },
    { id: 3988, nome: 'CIANORTE', codigo_ibge: 4105508, codigo_uf: 41 },
    { id: 3989, nome: 'CIDADE GAUCHA', codigo_ibge: 4105607, codigo_uf: 41 },
    { id: 3990, nome: 'CLEVELANDIA', codigo_ibge: 4105706, codigo_uf: 41 },
    { id: 3991, nome: 'COLOMBO', codigo_ibge: 4105805, codigo_uf: 41 },
    { id: 3992, nome: 'COLORADO', codigo_ibge: 4105904, codigo_uf: 41 },
    { id: 3993, nome: 'CONGONHINHAS', codigo_ibge: 4106001, codigo_uf: 41 },
    { id: 3994, nome: 'CONSELHEIRO MAIRINCK', codigo_ibge: 4106100, codigo_uf: 41 },
    { id: 3995, nome: 'CONTENDA', codigo_ibge: 4106209, codigo_uf: 41 },
    { id: 3996, nome: 'CORBELIA', codigo_ibge: 4106308, codigo_uf: 41 },
    { id: 3997, nome: 'CORNELIO PROCOPIO', codigo_ibge: 4106407, codigo_uf: 41 },
    { id: 3998, nome: 'CORONEL DOMINGOS SOARES', codigo_ibge: 4106456, codigo_uf: 41 },
    { id: 3999, nome: 'CORONEL VIVIDA', codigo_ibge: 4106506, codigo_uf: 41 },
    { id: 4000, nome: 'CORUMBATAI DO SUL', codigo_ibge: 4106555, codigo_uf: 41 },
    { id: 4004, nome: 'CRUZ MACHADO', codigo_ibge: 4106803, codigo_uf: 41 },
    { id: 4001, nome: 'CRUZEIRO DO IGUACU', codigo_ibge: 4106571, codigo_uf: 41 },
    { id: 4002, nome: 'CRUZEIRO DO OESTE', codigo_ibge: 4106605, codigo_uf: 41 },
    { id: 4003, nome: 'CRUZEIRO DO SUL', codigo_ibge: 4106704, codigo_uf: 41 },
    { id: 4005, nome: 'CRUZMALTINA', codigo_ibge: 4106852, codigo_uf: 41 },
    { id: 4006, nome: 'CURITIBA', codigo_ibge: 4106902, codigo_uf: 41 },
    { id: 4007, nome: 'CURIUVA', codigo_ibge: 4107009, codigo_uf: 41 },
    { id: 4010, nome: 'DIAMANTE D OESTE', codigo_ibge: 4107157, codigo_uf: 41 },
    { id: 4008, nome: 'DIAMANTE DO NORTE', codigo_ibge: 4107108, codigo_uf: 41 },
    { id: 4009, nome: 'DIAMANTE DO SUL', codigo_ibge: 4107124, codigo_uf: 41 },
    { id: 4011, nome: 'DOIS VIZINHOS', codigo_ibge: 4107207, codigo_uf: 41 },
    { id: 4012, nome: 'DOURADINA', codigo_ibge: 4107256, codigo_uf: 41 },
    { id: 4013, nome: 'DOUTOR CAMARGO', codigo_ibge: 4107306, codigo_uf: 41 },
    { id: 4308, nome: 'DOUTOR ULYSSES', codigo_ibge: 4128633, codigo_uf: 41 },
    { id: 4014, nome: 'ENEAS MARQUES', codigo_ibge: 4107405, codigo_uf: 41 },
    { id: 4015, nome: 'ENGENHEIRO BELTRAO', codigo_ibge: 4107504, codigo_uf: 41 },
    { id: 4017, nome: 'ENTRE RIOS DO OESTE', codigo_ibge: 4107538, codigo_uf: 41 },
    { id: 4016, nome: 'ESPERANCA NOVA', codigo_ibge: 4107520, codigo_uf: 41 },
    { id: 4018, nome: 'ESPIGAO ALTO DO IGUACU', codigo_ibge: 4107546, codigo_uf: 41 },
    { id: 4019, nome: 'FAROL', codigo_ibge: 4107553, codigo_uf: 41 },
    { id: 4020, nome: 'FAXINAL', codigo_ibge: 4107603, codigo_uf: 41 },
    { id: 4021, nome: 'FAZENDA RIO GRANDE', codigo_ibge: 4107652, codigo_uf: 41 },
    { id: 4022, nome: 'FENIX', codigo_ibge: 4107702, codigo_uf: 41 },
    { id: 4023, nome: 'FERNANDES PINHEIRO', codigo_ibge: 4107736, codigo_uf: 41 },
    { id: 4024, nome: 'FIGUEIRA', codigo_ibge: 4107751, codigo_uf: 41 },
    { id: 4026, nome: 'FLOR DA SERRA DO SUL', codigo_ibge: 4107850, codigo_uf: 41 },
    { id: 4025, nome: 'FLORAI', codigo_ibge: 4107801, codigo_uf: 41 },
    { id: 4027, nome: 'FLORESTA', codigo_ibge: 4107900, codigo_uf: 41 },
    { id: 4028, nome: 'FLORESTOPOLIS', codigo_ibge: 4108007, codigo_uf: 41 },
    { id: 4029, nome: 'FLORIDA', codigo_ibge: 4108106, codigo_uf: 41 },
    { id: 4030, nome: 'FORMOSA DO OESTE', codigo_ibge: 4108205, codigo_uf: 41 },
    { id: 4031, nome: 'FOZ DO IGUACU', codigo_ibge: 4108304, codigo_uf: 41 },
    { id: 4034, nome: 'FOZ DO JORDAO', codigo_ibge: 4108452, codigo_uf: 41 },
    { id: 4032, nome: 'FRANCISCO ALVES', codigo_ibge: 4108320, codigo_uf: 41 },
    { id: 4033, nome: 'FRANCISCO BELTRAO', codigo_ibge: 4108403, codigo_uf: 41 },
    { id: 4035, nome: 'GENERAL CARNEIRO', codigo_ibge: 4108502, codigo_uf: 41 },
    { id: 4036, nome: 'GODOY MOREIRA', codigo_ibge: 4108551, codigo_uf: 41 },
    { id: 4037, nome: 'GOIOERE', codigo_ibge: 4108601, codigo_uf: 41 },
    { id: 4038, nome: 'GOIOXIM', codigo_ibge: 4108650, codigo_uf: 41 },
    { id: 4039, nome: 'GRANDES RIOS', codigo_ibge: 4108700, codigo_uf: 41 },
    { id: 4040, nome: 'GUAIRA', codigo_ibge: 4108809, codigo_uf: 41 },
    { id: 4041, nome: 'GUAIRACA', codigo_ibge: 4108908, codigo_uf: 41 },
    { id: 4042, nome: 'GUAMIRANGA', codigo_ibge: 4108957, codigo_uf: 41 },
    { id: 4043, nome: 'GUAPIRAMA', codigo_ibge: 4109005, codigo_uf: 41 },
    { id: 4044, nome: 'GUAPOREMA', codigo_ibge: 4109104, codigo_uf: 41 },
    { id: 4045, nome: 'GUARACI', codigo_ibge: 4109203, codigo_uf: 41 },
    { id: 4046, nome: 'GUARANIACU', codigo_ibge: 4109302, codigo_uf: 41 },
    { id: 4047, nome: 'GUARAPUAVA', codigo_ibge: 4109401, codigo_uf: 41 },
    { id: 4048, nome: 'GUARAQUECABA', codigo_ibge: 4109500, codigo_uf: 41 },
    { id: 4049, nome: 'GUARATUBA', codigo_ibge: 4109609, codigo_uf: 41 },
    { id: 4050, nome: 'HONORIO SERPA', codigo_ibge: 4109658, codigo_uf: 41 },
    { id: 4051, nome: 'IBAITI', codigo_ibge: 4109708, codigo_uf: 41 },
    { id: 4052, nome: 'IBEMA', codigo_ibge: 4109757, codigo_uf: 41 },
    { id: 4053, nome: 'IBIPORA', codigo_ibge: 4109807, codigo_uf: 41 },
    { id: 4054, nome: 'ICARAIMA', codigo_ibge: 4109906, codigo_uf: 41 },
    { id: 4055, nome: 'IGUARACU', codigo_ibge: 4110003, codigo_uf: 41 },
    { id: 4056, nome: 'IGUATU', codigo_ibge: 4110052, codigo_uf: 41 },
    { id: 4057, nome: 'IMBAU', codigo_ibge: 4110078, codigo_uf: 41 },
    { id: 4058, nome: 'IMBITUVA', codigo_ibge: 4110102, codigo_uf: 41 },
    { id: 4059, nome: 'INACIO MARTINS', codigo_ibge: 4110201, codigo_uf: 41 },
    { id: 4060, nome: 'INAJA', codigo_ibge: 4110300, codigo_uf: 41 },
    { id: 4061, nome: 'INDIANOPOLIS', codigo_ibge: 4110409, codigo_uf: 41 },
    { id: 4062, nome: 'IPIRANGA', codigo_ibge: 4110508, codigo_uf: 41 },
    { id: 4063, nome: 'IPORA', codigo_ibge: 4110607, codigo_uf: 41 },
    { id: 4064, nome: 'IRACEMA DO OESTE', codigo_ibge: 4110656, codigo_uf: 41 },
    { id: 4065, nome: 'IRATI', codigo_ibge: 4110706, codigo_uf: 41 },
    { id: 4066, nome: 'IRETAMA', codigo_ibge: 4110805, codigo_uf: 41 },
    { id: 4067, nome: 'ITAGUAJE', codigo_ibge: 4110904, codigo_uf: 41 },
    { id: 4068, nome: 'ITAIPULANDIA', codigo_ibge: 4110953, codigo_uf: 41 },
    { id: 4069, nome: 'ITAMBARACA', codigo_ibge: 4111001, codigo_uf: 41 },
    { id: 4070, nome: 'ITAMBE', codigo_ibge: 4111100, codigo_uf: 41 },
    { id: 4071, nome: 'ITAPEJARA D OESTE', codigo_ibge: 4111209, codigo_uf: 41 },
    { id: 4072, nome: 'ITAPERUCU', codigo_ibge: 4111258, codigo_uf: 41 },
    { id: 4073, nome: 'ITAUNA DO SUL', codigo_ibge: 4111308, codigo_uf: 41 },
    { id: 4074, nome: 'IVAI', codigo_ibge: 4111407, codigo_uf: 41 },
    { id: 4075, nome: 'IVAIPORA', codigo_ibge: 4111506, codigo_uf: 41 },
    { id: 4076, nome: 'IVATE', codigo_ibge: 4111555, codigo_uf: 41 },
    { id: 4077, nome: 'IVATUBA', codigo_ibge: 4111605, codigo_uf: 41 },
    { id: 4078, nome: 'JABOTI', codigo_ibge: 4111704, codigo_uf: 41 },
    { id: 4079, nome: 'JACAREZINHO', codigo_ibge: 4111803, codigo_uf: 41 },
    { id: 4080, nome: 'JAGUAPITA', codigo_ibge: 4111902, codigo_uf: 41 },
    { id: 4081, nome: 'JAGUARIAIVA', codigo_ibge: 4112009, codigo_uf: 41 },
    { id: 4082, nome: 'JANDAIA DO SUL', codigo_ibge: 4112108, codigo_uf: 41 },
    { id: 4083, nome: 'JANIOPOLIS', codigo_ibge: 4112207, codigo_uf: 41 },
    { id: 4084, nome: 'JAPIRA', codigo_ibge: 4112306, codigo_uf: 41 },
    { id: 4085, nome: 'JAPURA', codigo_ibge: 4112405, codigo_uf: 41 },
    { id: 4086, nome: 'JARDIM ALEGRE', codigo_ibge: 4112504, codigo_uf: 41 },
    { id: 4087, nome: 'JARDIM OLINDA', codigo_ibge: 4112603, codigo_uf: 41 },
    { id: 4088, nome: 'JATAIZINHO', codigo_ibge: 4112702, codigo_uf: 41 },
    { id: 4089, nome: 'JESUITAS', codigo_ibge: 4112751, codigo_uf: 41 },
    { id: 4090, nome: 'JOAQUIM TAVORA', codigo_ibge: 4112801, codigo_uf: 41 },
    { id: 4091, nome: 'JUNDIAI DO SUL', codigo_ibge: 4112900, codigo_uf: 41 },
    { id: 4092, nome: 'JURANDA', codigo_ibge: 4112959, codigo_uf: 41 },
    { id: 4093, nome: 'JUSSARA', codigo_ibge: 4113007, codigo_uf: 41 },
    { id: 4094, nome: 'KALORE', codigo_ibge: 4113106, codigo_uf: 41 },
    { id: 4095, nome: 'LAPA', codigo_ibge: 4113205, codigo_uf: 41 },
    { id: 4096, nome: 'LARANJAL', codigo_ibge: 4113254, codigo_uf: 41 },
    { id: 4097, nome: 'LARANJEIRAS DO SUL', codigo_ibge: 4113304, codigo_uf: 41 },
    { id: 4098, nome: 'LEOPOLIS', codigo_ibge: 4113403, codigo_uf: 41 },
    { id: 4099, nome: 'LIDIANOPOLIS', codigo_ibge: 4113429, codigo_uf: 41 },
    { id: 4100, nome: 'LINDOESTE', codigo_ibge: 4113452, codigo_uf: 41 },
    { id: 4101, nome: 'LOANDA', codigo_ibge: 4113502, codigo_uf: 41 },
    { id: 4102, nome: 'LOBATO', codigo_ibge: 4113601, codigo_uf: 41 },
    { id: 4103, nome: 'LONDRINA', codigo_ibge: 4113700, codigo_uf: 41 },
    { id: 4104, nome: 'LUIZIANA', codigo_ibge: 4113734, codigo_uf: 41 },
    { id: 4105, nome: 'LUNARDELLI', codigo_ibge: 4113759, codigo_uf: 41 },
    { id: 4106, nome: 'LUPIONOPOLIS', codigo_ibge: 4113809, codigo_uf: 41 },
    { id: 4107, nome: 'MALLET', codigo_ibge: 4113908, codigo_uf: 41 },
    { id: 4108, nome: 'MAMBORE', codigo_ibge: 4114005, codigo_uf: 41 },
    { id: 4109, nome: 'MANDAGUACU', codigo_ibge: 4114104, codigo_uf: 41 },
    { id: 4110, nome: 'MANDAGUARI', codigo_ibge: 4114203, codigo_uf: 41 },
    { id: 4111, nome: 'MANDIRITUBA', codigo_ibge: 4114302, codigo_uf: 41 },
    { id: 4112, nome: 'MANFRINOPOLIS', codigo_ibge: 4114351, codigo_uf: 41 },
    { id: 4113, nome: 'MANGUEIRINHA', codigo_ibge: 4114401, codigo_uf: 41 },
    { id: 4114, nome: 'MANOEL RIBAS', codigo_ibge: 4114500, codigo_uf: 41 },
    { id: 4115, nome: 'MARECHAL CANDIDO RONDON', codigo_ibge: 4114609, codigo_uf: 41 },
    { id: 4116, nome: 'MARIA HELENA', codigo_ibge: 4114708, codigo_uf: 41 },
    { id: 4117, nome: 'MARIALVA', codigo_ibge: 4114807, codigo_uf: 41 },
    { id: 4118, nome: 'MARILANDIA DO SUL', codigo_ibge: 4114906, codigo_uf: 41 },
    { id: 4119, nome: 'MARILENA', codigo_ibge: 4115002, codigo_uf: 41 },
    { id: 4120, nome: 'MARILUZ', codigo_ibge: 4115101, codigo_uf: 41 },
    { id: 4121, nome: 'MARINGA', codigo_ibge: 4115200, codigo_uf: 41 },
    { id: 4122, nome: 'MARIOPOLIS', codigo_ibge: 4115309, codigo_uf: 41 },
    { id: 4123, nome: 'MARIPA', codigo_ibge: 4115358, codigo_uf: 41 },
    { id: 4124, nome: 'MARMELEIRO', codigo_ibge: 4115408, codigo_uf: 41 },
    { id: 4125, nome: 'MARQUINHO', codigo_ibge: 4115457, codigo_uf: 41 },
    { id: 4126, nome: 'MARUMBI', codigo_ibge: 4115507, codigo_uf: 41 },
    { id: 4127, nome: 'MATELANDIA', codigo_ibge: 4115606, codigo_uf: 41 },
    { id: 4128, nome: 'MATINHOS', codigo_ibge: 4115705, codigo_uf: 41 },
    { id: 4129, nome: 'MATO RICO', codigo_ibge: 4115739, codigo_uf: 41 },
    { id: 4130, nome: 'MAUA DA SERRA', codigo_ibge: 4115754, codigo_uf: 41 },
    { id: 4131, nome: 'MEDIANEIRA', codigo_ibge: 4115804, codigo_uf: 41 },
    { id: 4132, nome: 'MERCEDES', codigo_ibge: 4115853, codigo_uf: 41 },
    { id: 4133, nome: 'MIRADOR', codigo_ibge: 4115903, codigo_uf: 41 },
    { id: 4134, nome: 'MIRASELVA', codigo_ibge: 4116000, codigo_uf: 41 },
    { id: 4135, nome: 'MISSAL', codigo_ibge: 4116059, codigo_uf: 41 },
    { id: 4136, nome: 'MOREIRA SALES', codigo_ibge: 4116109, codigo_uf: 41 },
    { id: 4137, nome: 'MORRETES', codigo_ibge: 4116208, codigo_uf: 41 },
    { id: 4138, nome: 'MUNHOZ DE MELO', codigo_ibge: 4116307, codigo_uf: 41 },
    { id: 4139, nome: 'NOSSA SENHORA DAS GRACAS', codigo_ibge: 4116406, codigo_uf: 41 },
    { id: 4140, nome: 'NOVA ALIANCA DO IVAI', codigo_ibge: 4116505, codigo_uf: 41 },
    { id: 4141, nome: 'NOVA AMERICA DA COLINA', codigo_ibge: 4116604, codigo_uf: 41 },
    { id: 4142, nome: 'NOVA AURORA', codigo_ibge: 4116703, codigo_uf: 41 },
    { id: 4143, nome: 'NOVA CANTU', codigo_ibge: 4116802, codigo_uf: 41 },
    { id: 4144, nome: 'NOVA ESPERANCA', codigo_ibge: 4116901, codigo_uf: 41 },
    { id: 4145, nome: 'NOVA ESPERANCA DO SUDOESTE', codigo_ibge: 4116950, codigo_uf: 41 },
    { id: 4146, nome: 'NOVA FATIMA', codigo_ibge: 4117008, codigo_uf: 41 },
    { id: 4147, nome: 'NOVA LARANJEIRAS', codigo_ibge: 4117057, codigo_uf: 41 },
    { id: 4148, nome: 'NOVA LONDRINA', codigo_ibge: 4117107, codigo_uf: 41 },
    { id: 4149, nome: 'NOVA OLIMPIA', codigo_ibge: 4117206, codigo_uf: 41 },
    { id: 4152, nome: 'NOVA PRATA DO IGUACU', codigo_ibge: 4117255, codigo_uf: 41 },
    { id: 4150, nome: 'NOVA SANTA BARBARA', codigo_ibge: 4117214, codigo_uf: 41 },
    { id: 4151, nome: 'NOVA SANTA ROSA', codigo_ibge: 4117222, codigo_uf: 41 },
    { id: 4153, nome: 'NOVA TEBAS', codigo_ibge: 4117271, codigo_uf: 41 },
    { id: 4154, nome: 'NOVO ITACOLOMI', codigo_ibge: 4117297, codigo_uf: 41 },
    { id: 4155, nome: 'ORTIGUEIRA', codigo_ibge: 4117305, codigo_uf: 41 },
    { id: 4156, nome: 'OURIZONA', codigo_ibge: 4117404, codigo_uf: 41 },
    { id: 4157, nome: 'OURO VERDE DO OESTE', codigo_ibge: 4117453, codigo_uf: 41 },
    { id: 4158, nome: 'PAICANDU', codigo_ibge: 4117503, codigo_uf: 41 },
    { id: 4159, nome: 'PALMAS', codigo_ibge: 4117602, codigo_uf: 41 },
    { id: 4160, nome: 'PALMEIRA', codigo_ibge: 4117701, codigo_uf: 41 },
    { id: 4161, nome: 'PALMITAL', codigo_ibge: 4117800, codigo_uf: 41 },
    { id: 4162, nome: 'PALOTINA', codigo_ibge: 4117909, codigo_uf: 41 },
    { id: 4163, nome: 'PARAISO DO NORTE', codigo_ibge: 4118006, codigo_uf: 41 },
    { id: 4164, nome: 'PARANACITY', codigo_ibge: 4118105, codigo_uf: 41 },
    { id: 4165, nome: 'PARANAGUA', codigo_ibge: 4118204, codigo_uf: 41 },
    { id: 4166, nome: 'PARANAPOEMA', codigo_ibge: 4118303, codigo_uf: 41 },
    { id: 4167, nome: 'PARANAVAI', codigo_ibge: 4118402, codigo_uf: 41 },
    { id: 4168, nome: 'PATO BRAGADO', codigo_ibge: 4118451, codigo_uf: 41 },
    { id: 4169, nome: 'PATO BRANCO', codigo_ibge: 4118501, codigo_uf: 41 },
    { id: 4170, nome: 'PAULA FREITAS', codigo_ibge: 4118600, codigo_uf: 41 },
    { id: 4171, nome: 'PAULO FRONTIN', codigo_ibge: 4118709, codigo_uf: 41 },
    { id: 4172, nome: 'PEABIRU', codigo_ibge: 4118808, codigo_uf: 41 },
    { id: 4173, nome: 'PEROBAL', codigo_ibge: 4118857, codigo_uf: 41 },
    { id: 4174, nome: 'PEROLA', codigo_ibge: 4118907, codigo_uf: 41 },
    { id: 4175, nome: 'PEROLA D OESTE', codigo_ibge: 4119004, codigo_uf: 41 },
    { id: 4176, nome: 'PIEN', codigo_ibge: 4119103, codigo_uf: 41 },
    { id: 4177, nome: 'PINHAIS', codigo_ibge: 4119152, codigo_uf: 41 },
    { id: 4179, nome: 'PINHAL DE SAO BENTO', codigo_ibge: 4119251, codigo_uf: 41 },
    { id: 4178, nome: 'PINHALAO', codigo_ibge: 4119202, codigo_uf: 41 },
    { id: 4180, nome: 'PINHAO', codigo_ibge: 4119301, codigo_uf: 41 },
    { id: 4181, nome: 'PIRAI DO SUL', codigo_ibge: 4119400, codigo_uf: 41 },
    { id: 4182, nome: 'PIRAQUARA', codigo_ibge: 4119509, codigo_uf: 41 },
    { id: 4183, nome: 'PITANGA', codigo_ibge: 4119608, codigo_uf: 41 },
    { id: 4184, nome: 'PITANGUEIRAS', codigo_ibge: 4119657, codigo_uf: 41 },
    { id: 4185, nome: 'PLANALTINA DO PARANA', codigo_ibge: 4119707, codigo_uf: 41 },
    { id: 4186, nome: 'PLANALTO', codigo_ibge: 4119806, codigo_uf: 41 },
    { id: 4187, nome: 'PONTA GROSSA', codigo_ibge: 4119905, codigo_uf: 41 },
    { id: 4188, nome: 'PONTAL DO PARANA', codigo_ibge: 4119954, codigo_uf: 41 },
    { id: 4189, nome: 'PORECATU', codigo_ibge: 4120002, codigo_uf: 41 },
    { id: 4190, nome: 'PORTO AMAZONAS', codigo_ibge: 4120101, codigo_uf: 41 },
    { id: 4191, nome: 'PORTO BARREIRO', codigo_ibge: 4120150, codigo_uf: 41 },
    { id: 4192, nome: 'PORTO RICO', codigo_ibge: 4120200, codigo_uf: 41 },
    { id: 4193, nome: 'PORTO VITORIA', codigo_ibge: 4120309, codigo_uf: 41 },
    { id: 4194, nome: 'PRADO FERREIRA', codigo_ibge: 4120333, codigo_uf: 41 },
    { id: 4195, nome: 'PRANCHITA', codigo_ibge: 4120358, codigo_uf: 41 },
    { id: 4196, nome: 'PRESIDENTE CASTELO BRANCO', codigo_ibge: 4120408, codigo_uf: 41 },
    { id: 4197, nome: 'PRIMEIRO DE MAIO', codigo_ibge: 4120507, codigo_uf: 41 },
    { id: 4198, nome: 'PRUDENTOPOLIS', codigo_ibge: 4120606, codigo_uf: 41 },
    { id: 4199, nome: 'QUARTO CENTENARIO', codigo_ibge: 4120655, codigo_uf: 41 },
    { id: 4200, nome: 'QUATIGUA', codigo_ibge: 4120705, codigo_uf: 41 },
    { id: 4201, nome: 'QUATRO BARRAS', codigo_ibge: 4120804, codigo_uf: 41 },
    { id: 4202, nome: 'QUATRO PONTES', codigo_ibge: 4120853, codigo_uf: 41 },
    { id: 4203, nome: 'QUEDAS DO IGUACU', codigo_ibge: 4120903, codigo_uf: 41 },
    { id: 4204, nome: 'QUERENCIA DO NORTE', codigo_ibge: 4121000, codigo_uf: 41 },
    { id: 4205, nome: 'QUINTA DO SOL', codigo_ibge: 4121109, codigo_uf: 41 },
    { id: 4206, nome: 'QUITANDINHA', codigo_ibge: 4121208, codigo_uf: 41 },
    { id: 4207, nome: 'RAMILANDIA', codigo_ibge: 4121257, codigo_uf: 41 },
    { id: 4208, nome: 'RANCHO ALEGRE', codigo_ibge: 4121307, codigo_uf: 41 },
    { id: 4209, nome: 'RANCHO ALEGRE D OESTE', codigo_ibge: 4121356, codigo_uf: 41 },
    { id: 4210, nome: 'REALEZA', codigo_ibge: 4121406, codigo_uf: 41 },
    { id: 4211, nome: 'REBOUCAS', codigo_ibge: 4121505, codigo_uf: 41 },
    { id: 4212, nome: 'RENASCENCA', codigo_ibge: 4121604, codigo_uf: 41 },
    { id: 4213, nome: 'RESERVA', codigo_ibge: 4121703, codigo_uf: 41 },
    { id: 4214, nome: 'RESERVA DO IGUACU', codigo_ibge: 4121752, codigo_uf: 41 },
    { id: 4215, nome: 'RIBEIRAO CLARO', codigo_ibge: 4121802, codigo_uf: 41 },
    { id: 4216, nome: 'RIBEIRAO DO PINHAL', codigo_ibge: 4121901, codigo_uf: 41 },
    { id: 4217, nome: 'RIO AZUL', codigo_ibge: 4122008, codigo_uf: 41 },
    { id: 4218, nome: 'RIO BOM', codigo_ibge: 4122107, codigo_uf: 41 },
    { id: 4219, nome: 'RIO BONITO DO IGUACU', codigo_ibge: 4122156, codigo_uf: 41 },
    { id: 4220, nome: 'RIO BRANCO DO IVAI', codigo_ibge: 4122172, codigo_uf: 41 },
    { id: 4221, nome: 'RIO BRANCO DO SUL', codigo_ibge: 4122206, codigo_uf: 41 },
    { id: 4222, nome: 'RIO NEGRO', codigo_ibge: 4122305, codigo_uf: 41 },
    { id: 4223, nome: 'ROLANDIA', codigo_ibge: 4122404, codigo_uf: 41 },
    { id: 4224, nome: 'RONCADOR', codigo_ibge: 4122503, codigo_uf: 41 },
    { id: 4225, nome: 'RONDON', codigo_ibge: 4122602, codigo_uf: 41 },
    { id: 4226, nome: 'ROSARIO DO IVAI', codigo_ibge: 4122651, codigo_uf: 41 },
    { id: 4227, nome: 'SABAUDIA', codigo_ibge: 4122701, codigo_uf: 41 },
    { id: 4228, nome: 'SALGADO FILHO', codigo_ibge: 4122800, codigo_uf: 41 },
    { id: 4229, nome: 'SALTO DO ITARARE', codigo_ibge: 4122909, codigo_uf: 41 },
    { id: 4230, nome: 'SALTO DO LONTRA', codigo_ibge: 4123006, codigo_uf: 41 },
    { id: 4231, nome: 'SANTA AMELIA', codigo_ibge: 4123105, codigo_uf: 41 },
    { id: 4232, nome: 'SANTA CECILIA DO PAVAO', codigo_ibge: 4123204, codigo_uf: 41 },
    { id: 4233, nome: 'SANTA CRUZ DE MONTE CASTELO', codigo_ibge: 4123303, codigo_uf: 41 },
    { id: 4234, nome: 'SANTA FE', codigo_ibge: 4123402, codigo_uf: 41 },
    { id: 4235, nome: 'SANTA HELENA', codigo_ibge: 4123501, codigo_uf: 41 },
    { id: 4236, nome: 'SANTA INES', codigo_ibge: 4123600, codigo_uf: 41 },
    { id: 4237, nome: 'SANTA ISABEL DO IVAI', codigo_ibge: 4123709, codigo_uf: 41 },
    { id: 4238, nome: 'SANTA IZABEL DO OESTE', codigo_ibge: 4123808, codigo_uf: 41 },
    { id: 4239, nome: 'SANTA LUCIA', codigo_ibge: 4123824, codigo_uf: 41 },
    { id: 4240, nome: 'SANTA MARIA DO OESTE', codigo_ibge: 4123857, codigo_uf: 41 },
    { id: 4241, nome: 'SANTA MARIANA', codigo_ibge: 4123907, codigo_uf: 41 },
    { id: 4242, nome: 'SANTA MONICA', codigo_ibge: 4123956, codigo_uf: 41 },
    { id: 4244, nome: 'SANTA TEREZA DO OESTE', codigo_ibge: 4124020, codigo_uf: 41 },
    { id: 4245, nome: 'SANTA TEREZINHA DE ITAIPU', codigo_ibge: 4124053, codigo_uf: 41 },
    { id: 4243, nome: 'SANTANA DO ITARARE', codigo_ibge: 4124004, codigo_uf: 41 },
    { id: 4246, nome: 'SANTO ANTONIO DA PLATINA', codigo_ibge: 4124103, codigo_uf: 41 },
    { id: 4247, nome: 'SANTO ANTONIO DO CAIUA', codigo_ibge: 4124202, codigo_uf: 41 },
    { id: 4248, nome: 'SANTO ANTONIO DO PARAISO', codigo_ibge: 4124301, codigo_uf: 41 },
    { id: 4249, nome: 'SANTO ANTONIO DO SUDOESTE', codigo_ibge: 4124400, codigo_uf: 41 },
    { id: 4250, nome: 'SANTO INACIO', codigo_ibge: 4124509, codigo_uf: 41 },
    { id: 4251, nome: 'SAO CARLOS DO IVAI', codigo_ibge: 4124608, codigo_uf: 41 },
    { id: 4252, nome: 'SAO JERONIMO DA SERRA', codigo_ibge: 4124707, codigo_uf: 41 },
    { id: 4253, nome: 'SAO JOAO', codigo_ibge: 4124806, codigo_uf: 41 },
    { id: 4254, nome: 'SAO JOAO DO CAIUA', codigo_ibge: 4124905, codigo_uf: 41 },
    { id: 4255, nome: 'SAO JOAO DO IVAI', codigo_ibge: 4125001, codigo_uf: 41 },
    { id: 4256, nome: 'SAO JOAO DO TRIUNFO', codigo_ibge: 4125100, codigo_uf: 41 },
    { id: 4257, nome: 'SAO JORGE D OESTE', codigo_ibge: 4125209, codigo_uf: 41 },
    { id: 4258, nome: 'SAO JORGE DO IVAI', codigo_ibge: 4125308, codigo_uf: 41 },
    { id: 4259, nome: 'SAO JORGE DO PATROCINIO', codigo_ibge: 4125357, codigo_uf: 41 },
    { id: 4260, nome: 'SAO JOSE DA BOA VISTA', codigo_ibge: 4125407, codigo_uf: 41 },
    { id: 4261, nome: 'SAO JOSE DAS PALMEIRAS', codigo_ibge: 4125456, codigo_uf: 41 },
    { id: 4262, nome: 'SAO JOSE DOS PINHAIS', codigo_ibge: 4125506, codigo_uf: 41 },
    { id: 4263, nome: 'SAO MANOEL DO PARANA', codigo_ibge: 4125555, codigo_uf: 41 },
    { id: 4264, nome: 'SAO MATEUS DO SUL', codigo_ibge: 4125605, codigo_uf: 41 },
    { id: 4265, nome: 'SAO MIGUEL DO IGUACU', codigo_ibge: 4125704, codigo_uf: 41 },
    { id: 4266, nome: 'SAO PEDRO DO IGUACU', codigo_ibge: 4125753, codigo_uf: 41 },
    { id: 4267, nome: 'SAO PEDRO DO IVAI', codigo_ibge: 4125803, codigo_uf: 41 },
    { id: 4268, nome: 'SAO PEDRO DO PARANA', codigo_ibge: 4125902, codigo_uf: 41 },
    { id: 4269, nome: 'SAO SEBASTIAO DA AMOREIRA', codigo_ibge: 4126009, codigo_uf: 41 },
    { id: 4270, nome: 'SAO TOME', codigo_ibge: 4126108, codigo_uf: 41 },
    { id: 4271, nome: 'SAPOPEMA', codigo_ibge: 4126207, codigo_uf: 41 },
    { id: 4272, nome: 'SARANDI', codigo_ibge: 4126256, codigo_uf: 41 },
    { id: 4273, nome: 'SAUDADE DO IGUACU', codigo_ibge: 4126272, codigo_uf: 41 },
    { id: 4274, nome: 'SENGES', codigo_ibge: 4126306, codigo_uf: 41 },
    { id: 4275, nome: 'SERRANOPOLIS DO IGUACU', codigo_ibge: 4126355, codigo_uf: 41 },
    { id: 4276, nome: 'SERTANEJA', codigo_ibge: 4126405, codigo_uf: 41 },
    { id: 4277, nome: 'SERTANOPOLIS', codigo_ibge: 4126504, codigo_uf: 41 },
    { id: 4278, nome: 'SIQUEIRA CAMPOS', codigo_ibge: 4126603, codigo_uf: 41 },
    { id: 4279, nome: 'SULINA', codigo_ibge: 4126652, codigo_uf: 41 },
    { id: 4280, nome: 'TAMARANA', codigo_ibge: 4126678, codigo_uf: 41 },
    { id: 4281, nome: 'TAMBOARA', codigo_ibge: 4126702, codigo_uf: 41 },
    { id: 4282, nome: 'TAPEJARA', codigo_ibge: 4126801, codigo_uf: 41 },
    { id: 4283, nome: 'TAPIRA', codigo_ibge: 4126900, codigo_uf: 41 },
    { id: 4284, nome: 'TEIXEIRA SOARES', codigo_ibge: 4127007, codigo_uf: 41 },
    { id: 4285, nome: 'TELEMACO BORBA', codigo_ibge: 4127106, codigo_uf: 41 },
    { id: 4286, nome: 'TERRA BOA', codigo_ibge: 4127205, codigo_uf: 41 },
    { id: 4287, nome: 'TERRA RICA', codigo_ibge: 4127304, codigo_uf: 41 },
    { id: 4288, nome: 'TERRA ROXA', codigo_ibge: 4127403, codigo_uf: 41 },
    { id: 4289, nome: 'TIBAGI', codigo_ibge: 4127502, codigo_uf: 41 },
    { id: 4290, nome: 'TIJUCAS DO SUL', codigo_ibge: 4127601, codigo_uf: 41 },
    { id: 4291, nome: 'TOLEDO', codigo_ibge: 4127700, codigo_uf: 41 },
    { id: 4292, nome: 'TOMAZINA', codigo_ibge: 4127809, codigo_uf: 41 },
    { id: 4293, nome: 'TRES BARRAS DO PARANA', codigo_ibge: 4127858, codigo_uf: 41 },
    { id: 4294, nome: 'TUNAS DO PARANA', codigo_ibge: 4127882, codigo_uf: 41 },
    { id: 4295, nome: 'TUNEIRAS DO OESTE', codigo_ibge: 4127908, codigo_uf: 41 },
    { id: 4296, nome: 'TUPASSI', codigo_ibge: 4127957, codigo_uf: 41 },
    { id: 4297, nome: 'TURVO', codigo_ibge: 4127965, codigo_uf: 41 },
    { id: 4298, nome: 'UBIRATA', codigo_ibge: 4128005, codigo_uf: 41 },
    { id: 4299, nome: 'UMUARAMA', codigo_ibge: 4128104, codigo_uf: 41 },
    { id: 4300, nome: 'UNIAO DA VITORIA', codigo_ibge: 4128203, codigo_uf: 41 },
    { id: 4301, nome: 'UNIFLOR', codigo_ibge: 4128302, codigo_uf: 41 },
    { id: 4302, nome: 'URAI', codigo_ibge: 4128401, codigo_uf: 41 },
    { id: 4304, nome: 'VENTANIA', codigo_ibge: 4128534, codigo_uf: 41 },
    { id: 4305, nome: 'VERA CRUZ DO OESTE', codigo_ibge: 4128559, codigo_uf: 41 },
    { id: 4306, nome: 'VERE', codigo_ibge: 4128609, codigo_uf: 41 },
    { id: 4309, nome: 'VIRMOND', codigo_ibge: 4128658, codigo_uf: 41 },
    { id: 4310, nome: 'VITORINO', codigo_ibge: 4128708, codigo_uf: 41 },
    { id: 4303, nome: 'WENCESLAU BRAZ', codigo_ibge: 4128500, codigo_uf: 41 },
    { id: 4311, nome: 'XAMBRE', codigo_ibge: 4128807, codigo_uf: 41 },
    { id: 4312, nome: 'ABDON BATISTA', codigo_ibge: 4200051, codigo_uf: 42 },
    { id: 4313, nome: 'ABELARDO LUZ', codigo_ibge: 4200101, codigo_uf: 42 },
    { id: 4314, nome: 'AGROLANDIA', codigo_ibge: 4200200, codigo_uf: 42 },
    { id: 4315, nome: 'AGRONOMICA', codigo_ibge: 4200309, codigo_uf: 42 },
    { id: 4316, nome: 'AGUA DOCE', codigo_ibge: 4200408, codigo_uf: 42 },
    { id: 4317, nome: 'AGUAS DE CHAPECO', codigo_ibge: 4200507, codigo_uf: 42 },
    { id: 4318, nome: 'AGUAS FRIAS', codigo_ibge: 4200556, codigo_uf: 42 },
    { id: 4319, nome: 'AGUAS MORNAS', codigo_ibge: 4200606, codigo_uf: 42 },
    { id: 4320, nome: 'ALFREDO WAGNER', codigo_ibge: 4200705, codigo_uf: 42 },
    { id: 4321, nome: 'ALTO BELA VISTA', codigo_ibge: 4200754, codigo_uf: 42 },
    { id: 4322, nome: 'ANCHIETA', codigo_ibge: 4200804, codigo_uf: 42 },
    { id: 4323, nome: 'ANGELINA', codigo_ibge: 4200903, codigo_uf: 42 },
    { id: 4324, nome: 'ANITA GARIBALDI', codigo_ibge: 4201000, codigo_uf: 42 },
    { id: 4325, nome: 'ANITAPOLIS', codigo_ibge: 4201109, codigo_uf: 42 },
    { id: 4326, nome: 'ANTONIO CARLOS', codigo_ibge: 4201208, codigo_uf: 42 },
    { id: 4327, nome: 'APIUNA', codigo_ibge: 4201257, codigo_uf: 42 },
    { id: 4328, nome: 'ARABUTA', codigo_ibge: 4201273, codigo_uf: 42 },
    { id: 4329, nome: 'ARAQUARI', codigo_ibge: 4201307, codigo_uf: 42 },
    { id: 4330, nome: 'ARARANGUA', codigo_ibge: 4201406, codigo_uf: 42 },
    { id: 4331, nome: 'ARMAZEM', codigo_ibge: 4201505, codigo_uf: 42 },
    { id: 4332, nome: 'ARROIO TRINTA', codigo_ibge: 4201604, codigo_uf: 42 },
    { id: 4333, nome: 'ARVOREDO', codigo_ibge: 4201653, codigo_uf: 42 },
    { id: 4334, nome: 'ASCURRA', codigo_ibge: 4201703, codigo_uf: 42 },
    { id: 4335, nome: 'ATALANTA', codigo_ibge: 4201802, codigo_uf: 42 },
    { id: 4336, nome: 'AURORA', codigo_ibge: 4201901, codigo_uf: 42 },
    { id: 4337, nome: 'BALNEARIO ARROIO DO SILVA', codigo_ibge: 4201950, codigo_uf: 42 },
    { id: 4339, nome: 'BALNEARIO BARRA DO SUL', codigo_ibge: 4202057, codigo_uf: 42 },
    { id: 4338, nome: 'BALNEARIO CAMBORIU', codigo_ibge: 4202008, codigo_uf: 42 },
    { id: 4340, nome: 'BALNEARIO GAIVOTA', codigo_ibge: 4202073, codigo_uf: 42 },
    { id: 4506, nome: 'BALNEARIO PICARRAS', codigo_ibge: 4212809, codigo_uf: 42 },
    { id: 4606, nome: 'BALNEARIO RINCAO', codigo_ibge: 4220000, codigo_uf: 42 },
    { id: 4341, nome: 'BANDEIRANTE', codigo_ibge: 4202081, codigo_uf: 42 },
    { id: 4342, nome: 'BARRA BONITA', codigo_ibge: 4202099, codigo_uf: 42 },
    { id: 4343, nome: 'BARRA VELHA', codigo_ibge: 4202107, codigo_uf: 42 },
    { id: 4344, nome: 'BELA VISTA DO TOLDO', codigo_ibge: 4202131, codigo_uf: 42 },
    { id: 4345, nome: 'BELMONTE', codigo_ibge: 4202156, codigo_uf: 42 },
    { id: 4346, nome: 'BENEDITO NOVO', codigo_ibge: 4202206, codigo_uf: 42 },
    { id: 4347, nome: 'BIGUACU', codigo_ibge: 4202305, codigo_uf: 42 },
    { id: 4348, nome: 'BLUMENAU', codigo_ibge: 4202404, codigo_uf: 42 },
    { id: 4349, nome: 'BOCAINA DO SUL', codigo_ibge: 4202438, codigo_uf: 42 },
    { id: 4351, nome: 'BOM JARDIM DA SERRA', codigo_ibge: 4202503, codigo_uf: 42 },
    { id: 4352, nome: 'BOM JESUS', codigo_ibge: 4202537, codigo_uf: 42 },
    { id: 4353, nome: 'BOM JESUS DO OESTE', codigo_ibge: 4202578, codigo_uf: 42 },
    { id: 4354, nome: 'BOM RETIRO', codigo_ibge: 4202602, codigo_uf: 42 },
    { id: 4350, nome: 'BOMBINHAS', codigo_ibge: 4202453, codigo_uf: 42 },
    { id: 4355, nome: 'BOTUVERA', codigo_ibge: 4202701, codigo_uf: 42 },
    { id: 4356, nome: 'BRACO DO NORTE', codigo_ibge: 4202800, codigo_uf: 42 },
    { id: 4357, nome: 'BRACO DO TROMBUDO', codigo_ibge: 4202859, codigo_uf: 42 },
    { id: 4358, nome: 'BRUNOPOLIS', codigo_ibge: 4202875, codigo_uf: 42 },
    { id: 4359, nome: 'BRUSQUE', codigo_ibge: 4202909, codigo_uf: 42 },
    { id: 4360, nome: 'CACADOR', codigo_ibge: 4203006, codigo_uf: 42 },
    { id: 4361, nome: 'CAIBI', codigo_ibge: 4203105, codigo_uf: 42 },
    { id: 4362, nome: 'CALMON', codigo_ibge: 4203154, codigo_uf: 42 },
    { id: 4363, nome: 'CAMBORIU', codigo_ibge: 4203204, codigo_uf: 42 },
    { id: 4365, nome: 'CAMPO ALEGRE', codigo_ibge: 4203303, codigo_uf: 42 },
    { id: 4366, nome: 'CAMPO BELO DO SUL', codigo_ibge: 4203402, codigo_uf: 42 },
    { id: 4367, nome: 'CAMPO ERE', codigo_ibge: 4203501, codigo_uf: 42 },
    { id: 4368, nome: 'CAMPOS NOVOS', codigo_ibge: 4203600, codigo_uf: 42 },
    { id: 4369, nome: 'CANELINHA', codigo_ibge: 4203709, codigo_uf: 42 },
    { id: 4370, nome: 'CANOINHAS', codigo_ibge: 4203808, codigo_uf: 42 },
    { id: 4364, nome: 'CAPAO ALTO', codigo_ibge: 4203253, codigo_uf: 42 },
    { id: 4371, nome: 'CAPINZAL', codigo_ibge: 4203907, codigo_uf: 42 },
    { id: 4372, nome: 'CAPIVARI DE BAIXO', codigo_ibge: 4203956, codigo_uf: 42 },
    { id: 4373, nome: 'CATANDUVAS', codigo_ibge: 4204004, codigo_uf: 42 },
    { id: 4374, nome: 'CAXAMBU DO SUL', codigo_ibge: 4204103, codigo_uf: 42 },
    { id: 4375, nome: 'CELSO RAMOS', codigo_ibge: 4204152, codigo_uf: 42 },
    { id: 4376, nome: 'CERRO NEGRO', codigo_ibge: 4204178, codigo_uf: 42 },
    { id: 4377, nome: 'CHAPADAO DO LAGEADO', codigo_ibge: 4204194, codigo_uf: 42 },
    { id: 4378, nome: 'CHAPECO', codigo_ibge: 4204202, codigo_uf: 42 },
    { id: 4379, nome: 'COCAL DO SUL', codigo_ibge: 4204251, codigo_uf: 42 },
    { id: 4380, nome: 'CONCORDIA', codigo_ibge: 4204301, codigo_uf: 42 },
    { id: 4381, nome: 'CORDILHEIRA ALTA', codigo_ibge: 4204350, codigo_uf: 42 },
    { id: 4382, nome: 'CORONEL FREITAS', codigo_ibge: 4204400, codigo_uf: 42 },
    { id: 4383, nome: 'CORONEL MARTINS', codigo_ibge: 4204459, codigo_uf: 42 },
    { id: 4385, nome: 'CORREIA PINTO', codigo_ibge: 4204558, codigo_uf: 42 },
    { id: 4384, nome: 'CORUPA', codigo_ibge: 4204509, codigo_uf: 42 },
    { id: 4386, nome: 'CRICIUMA', codigo_ibge: 4204608, codigo_uf: 42 },
    { id: 4387, nome: 'CUNHA PORA', codigo_ibge: 4204707, codigo_uf: 42 },
    { id: 4388, nome: 'CUNHATAI', codigo_ibge: 4204756, codigo_uf: 42 },
    { id: 4389, nome: 'CURITIBANOS', codigo_ibge: 4204806, codigo_uf: 42 },
    { id: 4390, nome: 'DESCANSO', codigo_ibge: 4204905, codigo_uf: 42 },
    { id: 4391, nome: 'DIONISIO CERQUEIRA', codigo_ibge: 4205001, codigo_uf: 42 },
    { id: 4392, nome: 'DONA EMMA', codigo_ibge: 4205100, codigo_uf: 42 },
    { id: 4393, nome: 'DOUTOR PEDRINHO', codigo_ibge: 4205159, codigo_uf: 42 },
    { id: 4394, nome: 'ENTRE RIOS', codigo_ibge: 4205175, codigo_uf: 42 },
    { id: 4395, nome: 'ERMO', codigo_ibge: 4205191, codigo_uf: 42 },
    { id: 4396, nome: 'ERVAL VELHO', codigo_ibge: 4205209, codigo_uf: 42 },
    { id: 4397, nome: 'FAXINAL DOS GUEDES', codigo_ibge: 4205308, codigo_uf: 42 },
    { id: 4398, nome: 'FLOR DO SERTAO', codigo_ibge: 4205357, codigo_uf: 42 },
    { id: 4399, nome: 'FLORIANOPOLIS', codigo_ibge: 4205407, codigo_uf: 42 },
    { id: 4400, nome: 'FORMOSA DO SUL', codigo_ibge: 4205431, codigo_uf: 42 },
    { id: 4401, nome: 'FORQUILHINHA', codigo_ibge: 4205456, codigo_uf: 42 },
    { id: 4402, nome: 'FRAIBURGO', codigo_ibge: 4205506, codigo_uf: 42 },
    { id: 4403, nome: 'FREI ROGERIO', codigo_ibge: 4205555, codigo_uf: 42 },
    { id: 4404, nome: 'GALVAO', codigo_ibge: 4205605, codigo_uf: 42 },
    { id: 4405, nome: 'GAROPABA', codigo_ibge: 4205704, codigo_uf: 42 },
    { id: 4406, nome: 'GARUVA', codigo_ibge: 4205803, codigo_uf: 42 },
    { id: 4407, nome: 'GASPAR', codigo_ibge: 4205902, codigo_uf: 42 },
    { id: 4408, nome: 'GOVERNADOR CELSO RAMOS', codigo_ibge: 4206009, codigo_uf: 42 },
    { id: 4409, nome: 'GRAO PARA', codigo_ibge: 4206108, codigo_uf: 42 },
    { id: 4410, nome: 'GRAVATAL', codigo_ibge: 4206207, codigo_uf: 42 },
    { id: 4411, nome: 'GUABIRUBA', codigo_ibge: 4206306, codigo_uf: 42 },
    { id: 4412, nome: 'GUARACIABA', codigo_ibge: 4206405, codigo_uf: 42 },
    { id: 4413, nome: 'GUARAMIRIM', codigo_ibge: 4206504, codigo_uf: 42 },
    { id: 4414, nome: 'GUARUJA DO SUL', codigo_ibge: 4206603, codigo_uf: 42 },
    { id: 4415, nome: 'GUATAMBU', codigo_ibge: 4206652, codigo_uf: 42 },
    { id: 4416, nome: 'HERVAL D OESTE', codigo_ibge: 4206702, codigo_uf: 42 },
    { id: 4417, nome: 'IBIAM', codigo_ibge: 4206751, codigo_uf: 42 },
    { id: 4418, nome: 'IBICARE', codigo_ibge: 4206801, codigo_uf: 42 },
    { id: 4419, nome: 'IBIRAMA', codigo_ibge: 4206900, codigo_uf: 42 },
    { id: 4420, nome: 'ICARA', codigo_ibge: 4207007, codigo_uf: 42 },
    { id: 4421, nome: 'ILHOTA', codigo_ibge: 4207106, codigo_uf: 42 },
    { id: 4422, nome: 'IMARUI', codigo_ibge: 4207205, codigo_uf: 42 },
    { id: 4423, nome: 'IMBITUBA', codigo_ibge: 4207304, codigo_uf: 42 },
    { id: 4424, nome: 'IMBUIA', codigo_ibge: 4207403, codigo_uf: 42 },
    { id: 4425, nome: 'INDAIAL', codigo_ibge: 4207502, codigo_uf: 42 },
    { id: 4426, nome: 'IOMERE', codigo_ibge: 4207577, codigo_uf: 42 },
    { id: 4427, nome: 'IPIRA', codigo_ibge: 4207601, codigo_uf: 42 },
    { id: 4428, nome: 'IPORA DO OESTE', codigo_ibge: 4207650, codigo_uf: 42 },
    { id: 4429, nome: 'IPUACU', codigo_ibge: 4207684, codigo_uf: 42 },
    { id: 4430, nome: 'IPUMIRIM', codigo_ibge: 4207700, codigo_uf: 42 },
    { id: 4431, nome: 'IRACEMINHA', codigo_ibge: 4207759, codigo_uf: 42 },
    { id: 4432, nome: 'IRANI', codigo_ibge: 4207809, codigo_uf: 42 },
    { id: 4433, nome: 'IRATI', codigo_ibge: 4207858, codigo_uf: 42 },
    { id: 4434, nome: 'IRINEOPOLIS', codigo_ibge: 4207908, codigo_uf: 42 },
    { id: 4435, nome: 'ITA', codigo_ibge: 4208005, codigo_uf: 42 },
    { id: 4436, nome: 'ITAIOPOLIS', codigo_ibge: 4208104, codigo_uf: 42 },
    { id: 4437, nome: 'ITAJAI', codigo_ibge: 4208203, codigo_uf: 42 },
    { id: 4438, nome: 'ITAPEMA', codigo_ibge: 4208302, codigo_uf: 42 },
    { id: 4439, nome: 'ITAPIRANGA', codigo_ibge: 4208401, codigo_uf: 42 },
    { id: 4440, nome: 'ITAPOA', codigo_ibge: 4208450, codigo_uf: 42 },
    { id: 4441, nome: 'ITUPORANGA', codigo_ibge: 4208500, codigo_uf: 42 },
    { id: 4442, nome: 'JABORA', codigo_ibge: 4208609, codigo_uf: 42 },
    { id: 4443, nome: 'JACINTO MACHADO', codigo_ibge: 4208708, codigo_uf: 42 },
    { id: 4444, nome: 'JAGUARUNA', codigo_ibge: 4208807, codigo_uf: 42 },
    { id: 4445, nome: 'JARAGUA DO SUL', codigo_ibge: 4208906, codigo_uf: 42 },
    { id: 4446, nome: 'JARDINOPOLIS', codigo_ibge: 4208955, codigo_uf: 42 },
    { id: 4447, nome: 'JOACABA', codigo_ibge: 4209003, codigo_uf: 42 },
    { id: 4448, nome: 'JOINVILLE', codigo_ibge: 4209102, codigo_uf: 42 },
    { id: 4449, nome: 'JOSE BOITEUX', codigo_ibge: 4209151, codigo_uf: 42 },
    { id: 4450, nome: 'JUPIA', codigo_ibge: 4209177, codigo_uf: 42 },
    { id: 4451, nome: 'LACERDOPOLIS', codigo_ibge: 4209201, codigo_uf: 42 },
    { id: 4452, nome: 'LAGES', codigo_ibge: 4209300, codigo_uf: 42 },
    { id: 4453, nome: 'LAGUNA', codigo_ibge: 4209409, codigo_uf: 42 },
    { id: 4454, nome: 'LAJEADO GRANDE', codigo_ibge: 4209458, codigo_uf: 42 },
    { id: 4455, nome: 'LAURENTINO', codigo_ibge: 4209508, codigo_uf: 42 },
    { id: 4456, nome: 'LAURO MULLER', codigo_ibge: 4209607, codigo_uf: 42 },
    { id: 4457, nome: 'LEBON REGIS', codigo_ibge: 4209706, codigo_uf: 42 },
    { id: 4458, nome: 'LEOBERTO LEAL', codigo_ibge: 4209805, codigo_uf: 42 },
    { id: 4459, nome: 'LINDOIA DO SUL', codigo_ibge: 4209854, codigo_uf: 42 },
    { id: 4460, nome: 'LONTRAS', codigo_ibge: 4209904, codigo_uf: 42 },
    { id: 4461, nome: 'LUIZ ALVES', codigo_ibge: 4210001, codigo_uf: 42 },
    { id: 4462, nome: 'LUZERNA', codigo_ibge: 4210035, codigo_uf: 42 },
    { id: 4463, nome: 'MACIEIRA', codigo_ibge: 4210050, codigo_uf: 42 },
    { id: 4464, nome: 'MAFRA', codigo_ibge: 4210100, codigo_uf: 42 },
    { id: 4465, nome: 'MAJOR GERCINO', codigo_ibge: 4210209, codigo_uf: 42 },
    { id: 4466, nome: 'MAJOR VIEIRA', codigo_ibge: 4210308, codigo_uf: 42 },
    { id: 4467, nome: 'MARACAJA', codigo_ibge: 4210407, codigo_uf: 42 },
    { id: 4468, nome: 'MARAVILHA', codigo_ibge: 4210506, codigo_uf: 42 },
    { id: 4469, nome: 'MAREMA', codigo_ibge: 4210555, codigo_uf: 42 },
    { id: 4470, nome: 'MASSARANDUBA', codigo_ibge: 4210605, codigo_uf: 42 },
    { id: 4471, nome: 'MATOS COSTA', codigo_ibge: 4210704, codigo_uf: 42 },
    { id: 4472, nome: 'MELEIRO', codigo_ibge: 4210803, codigo_uf: 42 },
    { id: 4473, nome: 'MIRIM DOCE', codigo_ibge: 4210852, codigo_uf: 42 },
    { id: 4474, nome: 'MODELO', codigo_ibge: 4210902, codigo_uf: 42 },
    { id: 4475, nome: 'MONDAI', codigo_ibge: 4211009, codigo_uf: 42 },
    { id: 4476, nome: 'MONTE CARLO', codigo_ibge: 4211058, codigo_uf: 42 },
    { id: 4477, nome: 'MONTE CASTELO', codigo_ibge: 4211108, codigo_uf: 42 },
    { id: 4478, nome: 'MORRO DA FUMACA', codigo_ibge: 4211207, codigo_uf: 42 },
    { id: 4479, nome: 'MORRO GRANDE', codigo_ibge: 4211256, codigo_uf: 42 },
    { id: 4480, nome: 'NAVEGANTES', codigo_ibge: 4211306, codigo_uf: 42 },
    { id: 4481, nome: 'NOVA ERECHIM', codigo_ibge: 4211405, codigo_uf: 42 },
    { id: 4482, nome: 'NOVA ITABERABA', codigo_ibge: 4211454, codigo_uf: 42 },
    { id: 4483, nome: 'NOVA TRENTO', codigo_ibge: 4211504, codigo_uf: 42 },
    { id: 4484, nome: 'NOVA VENEZA', codigo_ibge: 4211603, codigo_uf: 42 },
    { id: 4485, nome: 'NOVO HORIZONTE', codigo_ibge: 4211652, codigo_uf: 42 },
    { id: 4486, nome: 'ORLEANS', codigo_ibge: 4211702, codigo_uf: 42 },
    { id: 4487, nome: 'OTACILIO COSTA', codigo_ibge: 4211751, codigo_uf: 42 },
    { id: 4488, nome: 'OURO', codigo_ibge: 4211801, codigo_uf: 42 },
    { id: 4489, nome: 'OURO VERDE', codigo_ibge: 4211850, codigo_uf: 42 },
    { id: 4490, nome: 'PAIAL', codigo_ibge: 4211876, codigo_uf: 42 },
    { id: 4491, nome: 'PAINEL', codigo_ibge: 4211892, codigo_uf: 42 },
    { id: 4492, nome: 'PALHOCA', codigo_ibge: 4211900, codigo_uf: 42 },
    { id: 4493, nome: 'PALMA SOLA', codigo_ibge: 4212007, codigo_uf: 42 },
    { id: 4494, nome: 'PALMEIRA', codigo_ibge: 4212056, codigo_uf: 42 },
    { id: 4495, nome: 'PALMITOS', codigo_ibge: 4212106, codigo_uf: 42 },
    { id: 4496, nome: 'PAPANDUVA', codigo_ibge: 4212205, codigo_uf: 42 },
    { id: 4497, nome: 'PARAISO', codigo_ibge: 4212239, codigo_uf: 42 },
    { id: 4498, nome: 'PASSO DE TORRES', codigo_ibge: 4212254, codigo_uf: 42 },
    { id: 4499, nome: 'PASSOS MAIA', codigo_ibge: 4212270, codigo_uf: 42 },
    { id: 4500, nome: 'PAULO LOPES', codigo_ibge: 4212304, codigo_uf: 42 },
    { id: 4501, nome: 'PEDRAS GRANDES', codigo_ibge: 4212403, codigo_uf: 42 },
    { id: 4502, nome: 'PENHA', codigo_ibge: 4212502, codigo_uf: 42 },
    { id: 4503, nome: 'PERITIBA', codigo_ibge: 4212601, codigo_uf: 42 },
    { id: 4504, nome: 'PESCARIA BRAVA', codigo_ibge: 4212650, codigo_uf: 42 },
    { id: 4505, nome: 'PETROLANDIA', codigo_ibge: 4212700, codigo_uf: 42 },
    { id: 4507, nome: 'PINHALZINHO', codigo_ibge: 4212908, codigo_uf: 42 },
    { id: 4508, nome: 'PINHEIRO PRETO', codigo_ibge: 4213005, codigo_uf: 42 },
    { id: 4509, nome: 'PIRATUBA', codigo_ibge: 4213104, codigo_uf: 42 },
    { id: 4510, nome: 'PLANALTO ALEGRE', codigo_ibge: 4213153, codigo_uf: 42 },
    { id: 4511, nome: 'POMERODE', codigo_ibge: 4213203, codigo_uf: 42 },
    { id: 4512, nome: 'PONTE ALTA', codigo_ibge: 4213302, codigo_uf: 42 },
    { id: 4513, nome: 'PONTE ALTA DO NORTE', codigo_ibge: 4213351, codigo_uf: 42 },
    { id: 4514, nome: 'PONTE SERRADA', codigo_ibge: 4213401, codigo_uf: 42 },
    { id: 4515, nome: 'PORTO BELO', codigo_ibge: 4213500, codigo_uf: 42 },
    { id: 4516, nome: 'PORTO UNIAO', codigo_ibge: 4213609, codigo_uf: 42 },
    { id: 4517, nome: 'POUSO REDONDO', codigo_ibge: 4213708, codigo_uf: 42 },
    { id: 4518, nome: 'PRAIA GRANDE', codigo_ibge: 4213807, codigo_uf: 42 },
    { id: 4519, nome: 'PRESIDENTE CASTELLO BRANCO', codigo_ibge: 4213906, codigo_uf: 42 },
    { id: 4520, nome: 'PRESIDENTE GETULIO', codigo_ibge: 4214003, codigo_uf: 42 },
    { id: 4521, nome: 'PRESIDENTE NEREU', codigo_ibge: 4214102, codigo_uf: 42 },
    { id: 4522, nome: 'PRINCESA', codigo_ibge: 4214151, codigo_uf: 42 },
    { id: 4523, nome: 'QUILOMBO', codigo_ibge: 4214201, codigo_uf: 42 },
    { id: 4524, nome: 'RANCHO QUEIMADO', codigo_ibge: 4214300, codigo_uf: 42 },
    { id: 4525, nome: 'RIO DAS ANTAS', codigo_ibge: 4214409, codigo_uf: 42 },
    { id: 4526, nome: 'RIO DO CAMPO', codigo_ibge: 4214508, codigo_uf: 42 },
    { id: 4527, nome: 'RIO DO OESTE', codigo_ibge: 4214607, codigo_uf: 42 },
    { id: 4529, nome: 'RIO DO SUL', codigo_ibge: 4214805, codigo_uf: 42 },
    { id: 4528, nome: 'RIO DOS CEDROS', codigo_ibge: 4214706, codigo_uf: 42 },
    { id: 4530, nome: 'RIO FORTUNA', codigo_ibge: 4214904, codigo_uf: 42 },
    { id: 4531, nome: 'RIO NEGRINHO', codigo_ibge: 4215000, codigo_uf: 42 },
    { id: 4532, nome: 'RIO RUFINO', codigo_ibge: 4215059, codigo_uf: 42 },
    { id: 4533, nome: 'RIQUEZA', codigo_ibge: 4215075, codigo_uf: 42 },
    { id: 4534, nome: 'RODEIO', codigo_ibge: 4215109, codigo_uf: 42 },
    { id: 4535, nome: 'ROMELANDIA', codigo_ibge: 4215208, codigo_uf: 42 },
    { id: 4536, nome: 'SALETE', codigo_ibge: 4215307, codigo_uf: 42 },
    { id: 4537, nome: 'SALTINHO', codigo_ibge: 4215356, codigo_uf: 42 },
    { id: 4538, nome: 'SALTO VELOSO', codigo_ibge: 4215406, codigo_uf: 42 },
    { id: 4539, nome: 'SANGAO', codigo_ibge: 4215455, codigo_uf: 42 },
    { id: 4540, nome: 'SANTA CECILIA', codigo_ibge: 4215505, codigo_uf: 42 },
    { id: 4541, nome: 'SANTA HELENA', codigo_ibge: 4215554, codigo_uf: 42 },
    { id: 4542, nome: 'SANTA ROSA DE LIMA', codigo_ibge: 4215604, codigo_uf: 42 },
    { id: 4543, nome: 'SANTA ROSA DO SUL', codigo_ibge: 4215653, codigo_uf: 42 },
    { id: 4544, nome: 'SANTA TEREZINHA', codigo_ibge: 4215679, codigo_uf: 42 },
    { id: 4545, nome: 'SANTA TEREZINHA DO PROGRESSO', codigo_ibge: 4215687, codigo_uf: 42 },
    { id: 4546, nome: 'SANTIAGO DO SUL', codigo_ibge: 4215695, codigo_uf: 42 },
    { id: 4547, nome: 'SANTO AMARO DA IMPERATRIZ', codigo_ibge: 4215703, codigo_uf: 42 },
    { id: 4549, nome: 'SAO BENTO DO SUL', codigo_ibge: 4215802, codigo_uf: 42 },
    { id: 4548, nome: 'SAO BERNARDINO', codigo_ibge: 4215752, codigo_uf: 42 },
    { id: 4550, nome: 'SAO BONIFACIO', codigo_ibge: 4215901, codigo_uf: 42 },
    { id: 4551, nome: 'SAO CARLOS', codigo_ibge: 4216008, codigo_uf: 42 },
    { id: 4552, nome: 'SAO CRISTOVAO DO SUL', codigo_ibge: 4216057, codigo_uf: 42 },
    { id: 4553, nome: 'SAO DOMINGOS', codigo_ibge: 4216107, codigo_uf: 42 },
    { id: 4554, nome: 'SAO FRANCISCO DO SUL', codigo_ibge: 4216206, codigo_uf: 42 },
    { id: 4556, nome: 'SAO JOAO BATISTA', codigo_ibge: 4216305, codigo_uf: 42 },
    { id: 4557, nome: 'SAO JOAO DO ITAPERIU', codigo_ibge: 4216354, codigo_uf: 42 },
    { id: 4555, nome: 'SAO JOAO DO OESTE', codigo_ibge: 4216255, codigo_uf: 42 },
    { id: 4558, nome: 'SAO JOAO DO SUL', codigo_ibge: 4216404, codigo_uf: 42 },
    { id: 4559, nome: 'SAO JOAQUIM', codigo_ibge: 4216503, codigo_uf: 42 },
    { id: 4560, nome: 'SAO JOSE', codigo_ibge: 4216602, codigo_uf: 42 },
    { id: 4561, nome: 'SAO JOSE DO CEDRO', codigo_ibge: 4216701, codigo_uf: 42 },
    { id: 4562, nome: 'SAO JOSE DO CERRITO', codigo_ibge: 4216800, codigo_uf: 42 },
    { id: 4563, nome: 'SAO LOURENCO DO OESTE', codigo_ibge: 4216909, codigo_uf: 42 },
    { id: 4564, nome: 'SAO LUDGERO', codigo_ibge: 4217006, codigo_uf: 42 },
    { id: 4565, nome: 'SAO MARTINHO', codigo_ibge: 4217105, codigo_uf: 42 },
    { id: 4566, nome: 'SAO MIGUEL DA BOA VISTA', codigo_ibge: 4217154, codigo_uf: 42 },
    { id: 4567, nome: 'SAO MIGUEL DO OESTE', codigo_ibge: 4217204, codigo_uf: 42 },
    { id: 4568, nome: 'SAO PEDRO DE ALCANTARA', codigo_ibge: 4217253, codigo_uf: 42 },
    { id: 4569, nome: 'SAUDADES', codigo_ibge: 4217303, codigo_uf: 42 },
    { id: 4570, nome: 'SCHROEDER', codigo_ibge: 4217402, codigo_uf: 42 },
    { id: 4571, nome: 'SEARA', codigo_ibge: 4217501, codigo_uf: 42 },
    { id: 4572, nome: 'SERRA ALTA', codigo_ibge: 4217550, codigo_uf: 42 },
    { id: 4573, nome: 'SIDEROPOLIS', codigo_ibge: 4217600, codigo_uf: 42 },
    { id: 4574, nome: 'SOMBRIO', codigo_ibge: 4217709, codigo_uf: 42 },
    { id: 4575, nome: 'SUL BRASIL', codigo_ibge: 4217758, codigo_uf: 42 },
    { id: 4576, nome: 'TAIO', codigo_ibge: 4217808, codigo_uf: 42 },
    { id: 4577, nome: 'TANGARA', codigo_ibge: 4217907, codigo_uf: 42 },
    { id: 4578, nome: 'TIGRINHOS', codigo_ibge: 4217956, codigo_uf: 42 },
    { id: 4579, nome: 'TIJUCAS', codigo_ibge: 4218004, codigo_uf: 42 },
    { id: 4580, nome: 'TIMBE DO SUL', codigo_ibge: 4218103, codigo_uf: 42 },
    { id: 4581, nome: 'TIMBO', codigo_ibge: 4218202, codigo_uf: 42 },
    { id: 4582, nome: 'TIMBO GRANDE', codigo_ibge: 4218251, codigo_uf: 42 },
    { id: 4583, nome: 'TRES BARRAS', codigo_ibge: 4218301, codigo_uf: 42 },
    { id: 4584, nome: 'TREVISO', codigo_ibge: 4218350, codigo_uf: 42 },
    { id: 4585, nome: 'TREZE DE MAIO', codigo_ibge: 4218400, codigo_uf: 42 },
    { id: 4586, nome: 'TREZE TILIAS', codigo_ibge: 4218509, codigo_uf: 42 },
    { id: 4587, nome: 'TROMBUDO CENTRAL', codigo_ibge: 4218608, codigo_uf: 42 },
    { id: 4588, nome: 'TUBARAO', codigo_ibge: 4218707, codigo_uf: 42 },
    { id: 4589, nome: 'TUNAPOLIS', codigo_ibge: 4218756, codigo_uf: 42 },
    { id: 4590, nome: 'TURVO', codigo_ibge: 4218806, codigo_uf: 42 },
    { id: 4591, nome: 'UNIAO DO OESTE', codigo_ibge: 4218855, codigo_uf: 42 },
    { id: 4592, nome: 'URUBICI', codigo_ibge: 4218905, codigo_uf: 42 },
    { id: 4593, nome: 'URUPEMA', codigo_ibge: 4218954, codigo_uf: 42 },
    { id: 4594, nome: 'URUSSANGA', codigo_ibge: 4219002, codigo_uf: 42 },
    { id: 4595, nome: 'VARGEAO', codigo_ibge: 4219101, codigo_uf: 42 },
    { id: 4596, nome: 'VARGEM', codigo_ibge: 4219150, codigo_uf: 42 },
    { id: 4597, nome: 'VARGEM BONITA', codigo_ibge: 4219176, codigo_uf: 42 },
    { id: 4598, nome: 'VIDAL RAMOS', codigo_ibge: 4219200, codigo_uf: 42 },
    { id: 4599, nome: 'VIDEIRA', codigo_ibge: 4219309, codigo_uf: 42 },
    { id: 4600, nome: 'VITOR MEIRELES', codigo_ibge: 4219358, codigo_uf: 42 },
    { id: 4601, nome: 'WITMARSUM', codigo_ibge: 4219408, codigo_uf: 42 },
    { id: 4602, nome: 'XANXERE', codigo_ibge: 4219507, codigo_uf: 42 },
    { id: 4603, nome: 'XAVANTINA', codigo_ibge: 4219606, codigo_uf: 42 },
    { id: 4604, nome: 'XAXIM', codigo_ibge: 4219705, codigo_uf: 42 },
    { id: 4605, nome: 'ZORTEA', codigo_ibge: 4219853, codigo_uf: 42 },
    { id: 4607, nome: 'ACEGUA', codigo_ibge: 4300034, codigo_uf: 43 },
    { id: 4608, nome: 'AGUA SANTA', codigo_ibge: 4300059, codigo_uf: 43 },
    { id: 4609, nome: 'AGUDO', codigo_ibge: 4300109, codigo_uf: 43 },
    { id: 4610, nome: 'AJURICABA', codigo_ibge: 4300208, codigo_uf: 43 },
    { id: 4611, nome: 'ALECRIM', codigo_ibge: 4300307, codigo_uf: 43 },
    { id: 4612, nome: 'ALEGRETE', codigo_ibge: 4300406, codigo_uf: 43 },
    { id: 4613, nome: 'ALEGRIA', codigo_ibge: 4300455, codigo_uf: 43 },
    { id: 4614, nome: 'ALMIRANTE TAMANDARE DO SUL', codigo_ibge: 4300471, codigo_uf: 43 },
    { id: 4615, nome: 'ALPESTRE', codigo_ibge: 4300505, codigo_uf: 43 },
    { id: 4616, nome: 'ALTO ALEGRE', codigo_ibge: 4300554, codigo_uf: 43 },
    { id: 4617, nome: 'ALTO FELIZ', codigo_ibge: 4300570, codigo_uf: 43 },
    { id: 4618, nome: 'ALVORADA', codigo_ibge: 4300604, codigo_uf: 43 },
    { id: 4619, nome: 'AMARAL FERRADOR', codigo_ibge: 4300638, codigo_uf: 43 },
    { id: 4620, nome: 'AMETISTA DO SUL', codigo_ibge: 4300646, codigo_uf: 43 },
    { id: 4621, nome: 'ANDRE DA ROCHA', codigo_ibge: 4300661, codigo_uf: 43 },
    { id: 4622, nome: 'ANTA GORDA', codigo_ibge: 4300703, codigo_uf: 43 },
    { id: 4623, nome: 'ANTONIO PRADO', codigo_ibge: 4300802, codigo_uf: 43 },
    { id: 4624, nome: 'ARAMBARE', codigo_ibge: 4300851, codigo_uf: 43 },
    { id: 4625, nome: 'ARARICA', codigo_ibge: 4300877, codigo_uf: 43 },
    { id: 4626, nome: 'ARATIBA', codigo_ibge: 4300901, codigo_uf: 43 },
    { id: 4627, nome: 'ARROIO DO MEIO', codigo_ibge: 4301008, codigo_uf: 43 },
    { id: 4629, nome: 'ARROIO DO PADRE', codigo_ibge: 4301073, codigo_uf: 43 },
    { id: 4628, nome: 'ARROIO DO SAL', codigo_ibge: 4301057, codigo_uf: 43 },
    { id: 4631, nome: 'ARROIO DO TIGRE', codigo_ibge: 4301206, codigo_uf: 43 },
    { id: 4630, nome: 'ARROIO DOS RATOS', codigo_ibge: 4301107, codigo_uf: 43 },
    { id: 4632, nome: 'ARROIO GRANDE', codigo_ibge: 4301305, codigo_uf: 43 },
    { id: 4633, nome: 'ARVOREZINHA', codigo_ibge: 4301404, codigo_uf: 43 },
    { id: 4634, nome: 'AUGUSTO PESTANA', codigo_ibge: 4301503, codigo_uf: 43 },
    { id: 4635, nome: 'AUREA', codigo_ibge: 4301552, codigo_uf: 43 },
    { id: 4636, nome: 'BAGE', codigo_ibge: 4301602, codigo_uf: 43 },
    { id: 4637, nome: 'BALNEARIO PINHAL', codigo_ibge: 4301636, codigo_uf: 43 },
    { id: 4638, nome: 'BARAO', codigo_ibge: 4301651, codigo_uf: 43 },
    { id: 4639, nome: 'BARAO DE COTEGIPE', codigo_ibge: 4301701, codigo_uf: 43 },
    { id: 4640, nome: 'BARAO DO TRIUNFO', codigo_ibge: 4301750, codigo_uf: 43 },
    { id: 4642, nome: 'BARRA DO GUARITA', codigo_ibge: 4301859, codigo_uf: 43 },
    { id: 4643, nome: 'BARRA DO QUARAI', codigo_ibge: 4301875, codigo_uf: 43 },
    { id: 4644, nome: 'BARRA DO RIBEIRO', codigo_ibge: 4301909, codigo_uf: 43 },
    { id: 4645, nome: 'BARRA DO RIO AZUL', codigo_ibge: 4301925, codigo_uf: 43 },
    { id: 4646, nome: 'BARRA FUNDA', codigo_ibge: 4301958, codigo_uf: 43 },
    { id: 4641, nome: 'BARRACAO', codigo_ibge: 4301800, codigo_uf: 43 },
    { id: 4647, nome: 'BARROS CASSAL', codigo_ibge: 4302006, codigo_uf: 43 },
    { id: 4648, nome: 'BENJAMIN CONSTANT DO SUL', codigo_ibge: 4302055, codigo_uf: 43 },
    { id: 4649, nome: 'BENTO GONCALVES', codigo_ibge: 4302105, codigo_uf: 43 },
    { id: 4650, nome: 'BOA VISTA DAS MISSOES', codigo_ibge: 4302154, codigo_uf: 43 },
    { id: 4651, nome: 'BOA VISTA DO BURICA', codigo_ibge: 4302204, codigo_uf: 43 },
    { id: 4652, nome: 'BOA VISTA DO CADEADO', codigo_ibge: 4302220, codigo_uf: 43 },
    { id: 4653, nome: 'BOA VISTA DO INCRA', codigo_ibge: 4302238, codigo_uf: 43 },
    { id: 4654, nome: 'BOA VISTA DO SUL', codigo_ibge: 4302253, codigo_uf: 43 },
    { id: 4655, nome: 'BOM JESUS', codigo_ibge: 4302303, codigo_uf: 43 },
    { id: 4656, nome: 'BOM PRINCIPIO', codigo_ibge: 4302352, codigo_uf: 43 },
    { id: 4657, nome: 'BOM PROGRESSO', codigo_ibge: 4302378, codigo_uf: 43 },
    { id: 4658, nome: 'BOM RETIRO DO SUL', codigo_ibge: 4302402, codigo_uf: 43 },
    { id: 4659, nome: 'BOQUEIRAO DO LEAO', codigo_ibge: 4302451, codigo_uf: 43 },
    { id: 4660, nome: 'BOSSOROCA', codigo_ibge: 4302501, codigo_uf: 43 },
    { id: 4661, nome: 'BOZANO', codigo_ibge: 4302584, codigo_uf: 43 },
    { id: 4662, nome: 'BRAGA', codigo_ibge: 4302600, codigo_uf: 43 },
    { id: 4663, nome: 'BROCHIER', codigo_ibge: 4302659, codigo_uf: 43 },
    { id: 4664, nome: 'BUTIA', codigo_ibge: 4302709, codigo_uf: 43 },
    { id: 4665, nome: 'CACAPAVA DO SUL', codigo_ibge: 4302808, codigo_uf: 43 },
    { id: 4666, nome: 'CACEQUI', codigo_ibge: 4302907, codigo_uf: 43 },
    { id: 4667, nome: 'CACHOEIRA DO SUL', codigo_ibge: 4303004, codigo_uf: 43 },
    { id: 4668, nome: 'CACHOEIRINHA', codigo_ibge: 4303103, codigo_uf: 43 },
    { id: 4669, nome: 'CACIQUE DOBLE', codigo_ibge: 4303202, codigo_uf: 43 },
    { id: 4670, nome: 'CAIBATE', codigo_ibge: 4303301, codigo_uf: 43 },
    { id: 4671, nome: 'CAICARA', codigo_ibge: 4303400, codigo_uf: 43 },
    { id: 4672, nome: 'CAMAQUA', codigo_ibge: 4303509, codigo_uf: 43 },
    { id: 4673, nome: 'CAMARGO', codigo_ibge: 4303558, codigo_uf: 43 },
    { id: 4674, nome: 'CAMBARA DO SUL', codigo_ibge: 4303608, codigo_uf: 43 },
    { id: 4675, nome: 'CAMPESTRE DA SERRA', codigo_ibge: 4303673, codigo_uf: 43 },
    { id: 4676, nome: 'CAMPINA DAS MISSOES', codigo_ibge: 4303707, codigo_uf: 43 },
    { id: 4677, nome: 'CAMPINAS DO SUL', codigo_ibge: 4303806, codigo_uf: 43 },
    { id: 4678, nome: 'CAMPO BOM', codigo_ibge: 4303905, codigo_uf: 43 },
    { id: 4679, nome: 'CAMPO NOVO', codigo_ibge: 4304002, codigo_uf: 43 },
    { id: 4680, nome: 'CAMPOS BORGES', codigo_ibge: 4304101, codigo_uf: 43 },
    { id: 4681, nome: 'CANDELARIA', codigo_ibge: 4304200, codigo_uf: 43 },
    { id: 4682, nome: 'CANDIDO GODOI', codigo_ibge: 4304309, codigo_uf: 43 },
    { id: 4683, nome: 'CANDIOTA', codigo_ibge: 4304358, codigo_uf: 43 },
    { id: 4684, nome: 'CANELA', codigo_ibge: 4304408, codigo_uf: 43 },
    { id: 4685, nome: 'CANGUCU', codigo_ibge: 4304507, codigo_uf: 43 },
    { id: 4686, nome: 'CANOAS', codigo_ibge: 4304606, codigo_uf: 43 },
    { id: 4687, nome: 'CANUDOS DO VALE', codigo_ibge: 4304614, codigo_uf: 43 },
    { id: 4688, nome: 'CAPAO BONITO DO SUL', codigo_ibge: 4304622, codigo_uf: 43 },
    { id: 4689, nome: 'CAPAO DA CANOA', codigo_ibge: 4304630, codigo_uf: 43 },
    { id: 4690, nome: 'CAPAO DO CIPO', codigo_ibge: 4304655, codigo_uf: 43 },
    { id: 4691, nome: 'CAPAO DO LEAO', codigo_ibge: 4304663, codigo_uf: 43 },
    { id: 4693, nome: 'CAPELA DE SANTANA', codigo_ibge: 4304689, codigo_uf: 43 },
    { id: 4694, nome: 'CAPITAO', codigo_ibge: 4304697, codigo_uf: 43 },
    { id: 4692, nome: 'CAPIVARI DO SUL', codigo_ibge: 4304671, codigo_uf: 43 },
    { id: 4696, nome: 'CARAA', codigo_ibge: 4304713, codigo_uf: 43 },
    { id: 4695, nome: 'CARAZINHO', codigo_ibge: 4304705, codigo_uf: 43 },
    { id: 4697, nome: 'CARLOS BARBOSA', codigo_ibge: 4304804, codigo_uf: 43 },
    { id: 4698, nome: 'CARLOS GOMES', codigo_ibge: 4304853, codigo_uf: 43 },
    { id: 4699, nome: 'CASCA', codigo_ibge: 4304903, codigo_uf: 43 },
    { id: 4700, nome: 'CASEIROS', codigo_ibge: 4304952, codigo_uf: 43 },
    { id: 4701, nome: 'CATUIPE', codigo_ibge: 4305009, codigo_uf: 43 },
    { id: 4702, nome: 'CAXIAS DO SUL', codigo_ibge: 4305108, codigo_uf: 43 },
    { id: 4703, nome: 'CENTENARIO', codigo_ibge: 4305116, codigo_uf: 43 },
    { id: 4704, nome: 'CERRITO', codigo_ibge: 4305124, codigo_uf: 43 },
    { id: 4705, nome: 'CERRO BRANCO', codigo_ibge: 4305132, codigo_uf: 43 },
    { id: 4706, nome: 'CERRO GRANDE', codigo_ibge: 4305157, codigo_uf: 43 },
    { id: 4707, nome: 'CERRO GRANDE DO SUL', codigo_ibge: 4305173, codigo_uf: 43 },
    { id: 4708, nome: 'CERRO LARGO', codigo_ibge: 4305207, codigo_uf: 43 },
    { id: 4709, nome: 'CHAPADA', codigo_ibge: 4305306, codigo_uf: 43 },
    { id: 4710, nome: 'CHARQUEADAS', codigo_ibge: 4305355, codigo_uf: 43 },
    { id: 4711, nome: 'CHARRUA', codigo_ibge: 4305371, codigo_uf: 43 },
    { id: 4712, nome: 'CHIAPETTA', codigo_ibge: 4305405, codigo_uf: 43 },
    { id: 4713, nome: 'CHUI', codigo_ibge: 4305439, codigo_uf: 43 },
    { id: 4714, nome: 'CHUVISCA', codigo_ibge: 4305447, codigo_uf: 43 },
    { id: 4715, nome: 'CIDREIRA', codigo_ibge: 4305454, codigo_uf: 43 },
    { id: 4716, nome: 'CIRIACO', codigo_ibge: 4305504, codigo_uf: 43 },
    { id: 4717, nome: 'COLINAS', codigo_ibge: 4305587, codigo_uf: 43 },
    { id: 4718, nome: 'COLORADO', codigo_ibge: 4305603, codigo_uf: 43 },
    { id: 4719, nome: 'CONDOR', codigo_ibge: 4305702, codigo_uf: 43 },
    { id: 4720, nome: 'CONSTANTINA', codigo_ibge: 4305801, codigo_uf: 43 },
    { id: 4721, nome: 'COQUEIRO BAIXO', codigo_ibge: 4305835, codigo_uf: 43 },
    { id: 4722, nome: 'COQUEIROS DO SUL', codigo_ibge: 4305850, codigo_uf: 43 },
    { id: 4723, nome: 'CORONEL BARROS', codigo_ibge: 4305871, codigo_uf: 43 },
    { id: 4724, nome: 'CORONEL BICACO', codigo_ibge: 4305900, codigo_uf: 43 },
    { id: 4725, nome: 'CORONEL PILAR', codigo_ibge: 4305934, codigo_uf: 43 },
    { id: 4726, nome: 'COTIPORA', codigo_ibge: 4305959, codigo_uf: 43 },
    { id: 4727, nome: 'COXILHA', codigo_ibge: 4305975, codigo_uf: 43 },
    { id: 4728, nome: 'CRISSIUMAL', codigo_ibge: 4306007, codigo_uf: 43 },
    { id: 4729, nome: 'CRISTAL', codigo_ibge: 4306056, codigo_uf: 43 },
    { id: 4730, nome: 'CRISTAL DO SUL', codigo_ibge: 4306072, codigo_uf: 43 },
    { id: 4731, nome: 'CRUZ ALTA', codigo_ibge: 4306106, codigo_uf: 43 },
    { id: 4732, nome: 'CRUZALTENSE', codigo_ibge: 4306130, codigo_uf: 43 },
    { id: 4733, nome: 'CRUZEIRO DO SUL', codigo_ibge: 4306205, codigo_uf: 43 },
    { id: 4734, nome: 'DAVID CANABARRO', codigo_ibge: 4306304, codigo_uf: 43 },
    { id: 4735, nome: 'DERRUBADAS', codigo_ibge: 4306320, codigo_uf: 43 },
    { id: 4736, nome: 'DEZESSEIS DE NOVEMBRO', codigo_ibge: 4306353, codigo_uf: 43 },
    { id: 4737, nome: 'DILERMANDO DE AGUIAR', codigo_ibge: 4306379, codigo_uf: 43 },
    { id: 4738, nome: 'DOIS IRMAOS', codigo_ibge: 4306403, codigo_uf: 43 },
    { id: 4739, nome: 'DOIS IRMAOS DAS MISSOES', codigo_ibge: 4306429, codigo_uf: 43 },
    { id: 4740, nome: 'DOIS LAJEADOS', codigo_ibge: 4306452, codigo_uf: 43 },
    { id: 4741, nome: 'DOM FELICIANO', codigo_ibge: 4306502, codigo_uf: 43 },
    { id: 4743, nome: 'DOM PEDRITO', codigo_ibge: 4306601, codigo_uf: 43 },
    { id: 4742, nome: 'DOM PEDRO DE ALCANTARA', codigo_ibge: 4306551, codigo_uf: 43 },
    { id: 4744, nome: 'DONA FRANCISCA', codigo_ibge: 4306700, codigo_uf: 43 },
    { id: 4745, nome: 'DOUTOR MAURICIO CARDOSO', codigo_ibge: 4306734, codigo_uf: 43 },
    { id: 4746, nome: 'DOUTOR RICARDO', codigo_ibge: 4306759, codigo_uf: 43 },
    { id: 4747, nome: 'ELDORADO DO SUL', codigo_ibge: 4306767, codigo_uf: 43 },
    { id: 4748, nome: 'ENCANTADO', codigo_ibge: 4306809, codigo_uf: 43 },
    { id: 4749, nome: 'ENCRUZILHADA DO SUL', codigo_ibge: 4306908, codigo_uf: 43 },
    { id: 4750, nome: 'ENGENHO VELHO', codigo_ibge: 4306924, codigo_uf: 43 },
    { id: 4752, nome: 'ENTRE RIOS DO SUL', codigo_ibge: 4306957, codigo_uf: 43 },
    { id: 4751, nome: 'ENTRE-IJUIS', codigo_ibge: 4306932, codigo_uf: 43 },
    { id: 4753, nome: 'EREBANGO', codigo_ibge: 4306973, codigo_uf: 43 },
    { id: 4754, nome: 'ERECHIM', codigo_ibge: 4307005, codigo_uf: 43 },
    { id: 4755, nome: 'ERNESTINA', codigo_ibge: 4307054, codigo_uf: 43 },
    { id: 4757, nome: 'ERVAL GRANDE', codigo_ibge: 4307203, codigo_uf: 43 },
    { id: 4758, nome: 'ERVAL SECO', codigo_ibge: 4307302, codigo_uf: 43 },
    { id: 4759, nome: 'ESMERALDA', codigo_ibge: 4307401, codigo_uf: 43 },
    { id: 4760, nome: 'ESPERANCA DO SUL', codigo_ibge: 4307450, codigo_uf: 43 },
    { id: 4761, nome: 'ESPUMOSO', codigo_ibge: 4307500, codigo_uf: 43 },
    { id: 4762, nome: 'ESTACAO', codigo_ibge: 4307559, codigo_uf: 43 },
    { id: 4763, nome: 'ESTANCIA VELHA', codigo_ibge: 4307609, codigo_uf: 43 },
    { id: 4764, nome: 'ESTEIO', codigo_ibge: 4307708, codigo_uf: 43 },
    { id: 4765, nome: 'ESTRELA', codigo_ibge: 4307807, codigo_uf: 43 },
    { id: 4766, nome: 'ESTRELA VELHA', codigo_ibge: 4307815, codigo_uf: 43 },
    { id: 4767, nome: 'EUGENIO DE CASTRO', codigo_ibge: 4307831, codigo_uf: 43 },
    { id: 4768, nome: 'FAGUNDES VARELA', codigo_ibge: 4307864, codigo_uf: 43 },
    { id: 4769, nome: 'FARROUPILHA', codigo_ibge: 4307906, codigo_uf: 43 },
    { id: 4770, nome: 'FAXINAL DO SOTURNO', codigo_ibge: 4308003, codigo_uf: 43 },
    { id: 4771, nome: 'FAXINALZINHO', codigo_ibge: 4308052, codigo_uf: 43 },
    { id: 4772, nome: 'FAZENDA VILANOVA', codigo_ibge: 4308078, codigo_uf: 43 },
    { id: 4773, nome: 'FELIZ', codigo_ibge: 4308102, codigo_uf: 43 },
    { id: 4774, nome: 'FLORES DA CUNHA', codigo_ibge: 4308201, codigo_uf: 43 },
    { id: 4775, nome: 'FLORIANO PEIXOTO', codigo_ibge: 4308250, codigo_uf: 43 },
    { id: 4776, nome: 'FONTOURA XAVIER', codigo_ibge: 4308300, codigo_uf: 43 },
    { id: 4777, nome: 'FORMIGUEIRO', codigo_ibge: 4308409, codigo_uf: 43 },
    { id: 4778, nome: 'FORQUETINHA', codigo_ibge: 4308433, codigo_uf: 43 },
    { id: 4779, nome: 'FORTALEZA DOS VALOS', codigo_ibge: 4308458, codigo_uf: 43 },
    { id: 4780, nome: 'FREDERICO WESTPHALEN', codigo_ibge: 4308508, codigo_uf: 43 },
    { id: 4781, nome: 'GARIBALDI', codigo_ibge: 4308607, codigo_uf: 43 },
    { id: 4782, nome: 'GARRUCHOS', codigo_ibge: 4308656, codigo_uf: 43 },
    { id: 4783, nome: 'GAURAMA', codigo_ibge: 4308706, codigo_uf: 43 },
    { id: 4784, nome: 'GENERAL CAMARA', codigo_ibge: 4308805, codigo_uf: 43 },
    { id: 4785, nome: 'GENTIL', codigo_ibge: 4308854, codigo_uf: 43 },
    { id: 4786, nome: 'GETULIO VARGAS', codigo_ibge: 4308904, codigo_uf: 43 },
    { id: 4787, nome: 'GIRUA', codigo_ibge: 4309001, codigo_uf: 43 },
    { id: 4788, nome: 'GLORINHA', codigo_ibge: 4309050, codigo_uf: 43 },
    { id: 4789, nome: 'GRAMADO', codigo_ibge: 4309100, codigo_uf: 43 },
    { id: 4790, nome: 'GRAMADO DOS LOUREIROS', codigo_ibge: 4309126, codigo_uf: 43 },
    { id: 4791, nome: 'GRAMADO XAVIER', codigo_ibge: 4309159, codigo_uf: 43 },
    { id: 4792, nome: 'GRAVATAI', codigo_ibge: 4309209, codigo_uf: 43 },
    { id: 4793, nome: 'GUABIJU', codigo_ibge: 4309258, codigo_uf: 43 },
    { id: 4794, nome: 'GUAIBA', codigo_ibge: 4309308, codigo_uf: 43 },
    { id: 4795, nome: 'GUAPORE', codigo_ibge: 4309407, codigo_uf: 43 },
    { id: 4796, nome: 'GUARANI DAS MISSOES', codigo_ibge: 4309506, codigo_uf: 43 },
    { id: 4797, nome: 'HARMONIA', codigo_ibge: 4309555, codigo_uf: 43 },
    { id: 4756, nome: 'HERVAL', codigo_ibge: 4307104, codigo_uf: 43 },
    { id: 4798, nome: 'HERVEIRAS', codigo_ibge: 4309571, codigo_uf: 43 },
    { id: 4799, nome: 'HORIZONTINA', codigo_ibge: 4309605, codigo_uf: 43 },
    { id: 4800, nome: 'HULHA NEGRA', codigo_ibge: 4309654, codigo_uf: 43 },
    { id: 4801, nome: 'HUMAITA', codigo_ibge: 4309704, codigo_uf: 43 },
    { id: 4802, nome: 'IBARAMA', codigo_ibge: 4309753, codigo_uf: 43 },
    { id: 4803, nome: 'IBIACA', codigo_ibge: 4309803, codigo_uf: 43 },
    { id: 4804, nome: 'IBIRAIARAS', codigo_ibge: 4309902, codigo_uf: 43 },
    { id: 4805, nome: 'IBIRAPUITA', codigo_ibge: 4309951, codigo_uf: 43 },
    { id: 4806, nome: 'IBIRUBA', codigo_ibge: 4310009, codigo_uf: 43 },
    { id: 4807, nome: 'IGREJINHA', codigo_ibge: 4310108, codigo_uf: 43 },
    { id: 4808, nome: 'IJUI', codigo_ibge: 4310207, codigo_uf: 43 },
    { id: 4809, nome: 'ILOPOLIS', codigo_ibge: 4310306, codigo_uf: 43 },
    { id: 4810, nome: 'IMBE', codigo_ibge: 4310330, codigo_uf: 43 },
    { id: 4811, nome: 'IMIGRANTE', codigo_ibge: 4310363, codigo_uf: 43 },
    { id: 4812, nome: 'INDEPENDENCIA', codigo_ibge: 4310405, codigo_uf: 43 },
    { id: 4813, nome: 'INHACORA', codigo_ibge: 4310413, codigo_uf: 43 },
    { id: 4814, nome: 'IPE', codigo_ibge: 4310439, codigo_uf: 43 },
    { id: 4815, nome: 'IPIRANGA DO SUL', codigo_ibge: 4310462, codigo_uf: 43 },
    { id: 4816, nome: 'IRAI', codigo_ibge: 4310504, codigo_uf: 43 },
    { id: 4817, nome: 'ITAARA', codigo_ibge: 4310538, codigo_uf: 43 },
    { id: 4818, nome: 'ITACURUBI', codigo_ibge: 4310553, codigo_uf: 43 },
    { id: 4819, nome: 'ITAPUCA', codigo_ibge: 4310579, codigo_uf: 43 },
    { id: 4820, nome: 'ITAQUI', codigo_ibge: 4310603, codigo_uf: 43 },
    { id: 4821, nome: 'ITATI', codigo_ibge: 4310652, codigo_uf: 43 },
    { id: 4822, nome: 'ITATIBA DO SUL', codigo_ibge: 4310702, codigo_uf: 43 },
    { id: 4823, nome: 'IVORA', codigo_ibge: 4310751, codigo_uf: 43 },
    { id: 4824, nome: 'IVOTI', codigo_ibge: 4310801, codigo_uf: 43 },
    { id: 4825, nome: 'JABOTICABA', codigo_ibge: 4310850, codigo_uf: 43 },
    { id: 4826, nome: 'JACUIZINHO', codigo_ibge: 4310876, codigo_uf: 43 },
    { id: 4827, nome: 'JACUTINGA', codigo_ibge: 4310900, codigo_uf: 43 },
    { id: 4828, nome: 'JAGUARAO', codigo_ibge: 4311007, codigo_uf: 43 },
    { id: 4829, nome: 'JAGUARI', codigo_ibge: 4311106, codigo_uf: 43 },
    { id: 4830, nome: 'JAQUIRANA', codigo_ibge: 4311122, codigo_uf: 43 },
    { id: 4831, nome: 'JARI', codigo_ibge: 4311130, codigo_uf: 43 },
    { id: 4832, nome: 'JOIA', codigo_ibge: 4311155, codigo_uf: 43 },
    { id: 4833, nome: 'JULIO DE CASTILHOS', codigo_ibge: 4311205, codigo_uf: 43 },
    { id: 4834, nome: 'LAGOA BONITA DO SUL', codigo_ibge: 4311239, codigo_uf: 43 },
    { id: 4836, nome: 'LAGOA DOS TRES CANTOS', codigo_ibge: 4311270, codigo_uf: 43 },
    { id: 4837, nome: 'LAGOA VERMELHA', codigo_ibge: 4311304, codigo_uf: 43 },
    { id: 4835, nome: 'LAGOAO', codigo_ibge: 4311254, codigo_uf: 43 },
    { id: 4838, nome: 'LAJEADO', codigo_ibge: 4311403, codigo_uf: 43 },
    { id: 4839, nome: 'LAJEADO DO BUGRE', codigo_ibge: 4311429, codigo_uf: 43 },
    { id: 4840, nome: 'LAVRAS DO SUL', codigo_ibge: 4311502, codigo_uf: 43 },
    { id: 4841, nome: 'LIBERATO SALZANO', codigo_ibge: 4311601, codigo_uf: 43 },
    { id: 4842, nome: 'LINDOLFO COLLOR', codigo_ibge: 4311627, codigo_uf: 43 },
    { id: 4843, nome: 'LINHA NOVA', codigo_ibge: 4311643, codigo_uf: 43 },
    { id: 4845, nome: 'MACAMBARA', codigo_ibge: 4311718, codigo_uf: 43 },
    { id: 4844, nome: 'MACHADINHO', codigo_ibge: 4311700, codigo_uf: 43 },
    { id: 4846, nome: 'MAMPITUBA', codigo_ibge: 4311734, codigo_uf: 43 },
    { id: 4847, nome: 'MANOEL VIANA', codigo_ibge: 4311759, codigo_uf: 43 },
    { id: 4848, nome: 'MAQUINE', codigo_ibge: 4311775, codigo_uf: 43 },
    { id: 4849, nome: 'MARATA', codigo_ibge: 4311791, codigo_uf: 43 },
    { id: 4850, nome: 'MARAU', codigo_ibge: 4311809, codigo_uf: 43 },
    { id: 4851, nome: 'MARCELINO RAMOS', codigo_ibge: 4311908, codigo_uf: 43 },
    { id: 4852, nome: 'MARIANA PIMENTEL', codigo_ibge: 4311981, codigo_uf: 43 },
    { id: 4853, nome: 'MARIANO MORO', codigo_ibge: 4312005, codigo_uf: 43 },
    { id: 4854, nome: 'MARQUES DE SOUZA', codigo_ibge: 4312054, codigo_uf: 43 },
    { id: 4855, nome: 'MATA', codigo_ibge: 4312104, codigo_uf: 43 },
    { id: 4856, nome: 'MATO CASTELHANO', codigo_ibge: 4312138, codigo_uf: 43 },
    { id: 4857, nome: 'MATO LEITAO', codigo_ibge: 4312153, codigo_uf: 43 },
    { id: 4858, nome: 'MATO QUEIMADO', codigo_ibge: 4312179, codigo_uf: 43 },
    { id: 4859, nome: 'MAXIMILIANO DE ALMEIDA', codigo_ibge: 4312203, codigo_uf: 43 },
    { id: 4860, nome: 'MINAS DO LEAO', codigo_ibge: 4312252, codigo_uf: 43 },
    { id: 4861, nome: 'MIRAGUAI', codigo_ibge: 4312302, codigo_uf: 43 },
    { id: 4862, nome: 'MONTAURI', codigo_ibge: 4312351, codigo_uf: 43 },
    { id: 4863, nome: 'MONTE ALEGRE DOS CAMPOS', codigo_ibge: 4312377, codigo_uf: 43 },
    { id: 4864, nome: 'MONTE BELO DO SUL', codigo_ibge: 4312385, codigo_uf: 43 },
    { id: 4865, nome: 'MONTENEGRO', codigo_ibge: 4312401, codigo_uf: 43 },
    { id: 4866, nome: 'MORMACO', codigo_ibge: 4312427, codigo_uf: 43 },
    { id: 4867, nome: 'MORRINHOS DO SUL', codigo_ibge: 4312443, codigo_uf: 43 },
    { id: 4868, nome: 'MORRO REDONDO', codigo_ibge: 4312450, codigo_uf: 43 },
    { id: 4869, nome: 'MORRO REUTER', codigo_ibge: 4312476, codigo_uf: 43 },
    { id: 4870, nome: 'MOSTARDAS', codigo_ibge: 4312500, codigo_uf: 43 },
    { id: 4871, nome: 'MUCUM', codigo_ibge: 4312609, codigo_uf: 43 },
    { id: 4872, nome: 'MUITOS CAPOES', codigo_ibge: 4312617, codigo_uf: 43 },
    { id: 4873, nome: 'MULITERNO', codigo_ibge: 4312625, codigo_uf: 43 },
    { id: 4874, nome: 'NAO-ME-TOQUE', codigo_ibge: 4312658, codigo_uf: 43 },
    { id: 4875, nome: 'NICOLAU VERGUEIRO', codigo_ibge: 4312674, codigo_uf: 43 },
    { id: 4876, nome: 'NONOAI', codigo_ibge: 4312708, codigo_uf: 43 },
    { id: 4877, nome: 'NOVA ALVORADA', codigo_ibge: 4312757, codigo_uf: 43 },
    { id: 4878, nome: 'NOVA ARACA', codigo_ibge: 4312807, codigo_uf: 43 },
    { id: 4879, nome: 'NOVA BASSANO', codigo_ibge: 4312906, codigo_uf: 43 },
    { id: 4880, nome: 'NOVA BOA VISTA', codigo_ibge: 4312955, codigo_uf: 43 },
    { id: 4881, nome: 'NOVA BRESCIA', codigo_ibge: 4313003, codigo_uf: 43 },
    { id: 4882, nome: 'NOVA CANDELARIA', codigo_ibge: 4313011, codigo_uf: 43 },
    { id: 4883, nome: 'NOVA ESPERANCA DO SUL', codigo_ibge: 4313037, codigo_uf: 43 },
    { id: 4884, nome: 'NOVA HARTZ', codigo_ibge: 4313060, codigo_uf: 43 },
    { id: 4885, nome: 'NOVA PADUA', codigo_ibge: 4313086, codigo_uf: 43 },
    { id: 4886, nome: 'NOVA PALMA', codigo_ibge: 4313102, codigo_uf: 43 },
    { id: 4887, nome: 'NOVA PETROPOLIS', codigo_ibge: 4313201, codigo_uf: 43 },
    { id: 4888, nome: 'NOVA PRATA', codigo_ibge: 4313300, codigo_uf: 43 },
    { id: 4889, nome: 'NOVA RAMADA', codigo_ibge: 4313334, codigo_uf: 43 },
    { id: 4890, nome: 'NOVA ROMA DO SUL', codigo_ibge: 4313359, codigo_uf: 43 },
    { id: 4891, nome: 'NOVA SANTA RITA', codigo_ibge: 4313375, codigo_uf: 43 },
    { id: 4897, nome: 'NOVO BARREIRO', codigo_ibge: 4313490, codigo_uf: 43 },
    { id: 4892, nome: 'NOVO CABRAIS', codigo_ibge: 4313391, codigo_uf: 43 },
    { id: 4893, nome: 'NOVO HAMBURGO', codigo_ibge: 4313409, codigo_uf: 43 },
    { id: 4894, nome: 'NOVO MACHADO', codigo_ibge: 4313425, codigo_uf: 43 },
    { id: 4895, nome: 'NOVO TIRADENTES', codigo_ibge: 4313441, codigo_uf: 43 },
    { id: 4896, nome: 'NOVO XINGU', codigo_ibge: 4313466, codigo_uf: 43 },
    { id: 4898, nome: 'OSORIO', codigo_ibge: 4313508, codigo_uf: 43 },
    { id: 4899, nome: 'PAIM FILHO', codigo_ibge: 4313607, codigo_uf: 43 },
    { id: 4900, nome: 'PALMARES DO SUL', codigo_ibge: 4313656, codigo_uf: 43 },
    { id: 4901, nome: 'PALMEIRA DAS MISSOES', codigo_ibge: 4313706, codigo_uf: 43 },
    { id: 4902, nome: 'PALMITINHO', codigo_ibge: 4313805, codigo_uf: 43 },
    { id: 4903, nome: 'PANAMBI', codigo_ibge: 4313904, codigo_uf: 43 },
    { id: 4904, nome: 'PANTANO GRANDE', codigo_ibge: 4313953, codigo_uf: 43 },
    { id: 4905, nome: 'PARAI', codigo_ibge: 4314001, codigo_uf: 43 },
    { id: 4906, nome: 'PARAISO DO SUL', codigo_ibge: 4314027, codigo_uf: 43 },
    { id: 4907, nome: 'PARECI NOVO', codigo_ibge: 4314035, codigo_uf: 43 },
    { id: 4908, nome: 'PAROBE', codigo_ibge: 4314050, codigo_uf: 43 },
    { id: 4909, nome: 'PASSA SETE', codigo_ibge: 4314068, codigo_uf: 43 },
    { id: 4910, nome: 'PASSO DO SOBRADO', codigo_ibge: 4314076, codigo_uf: 43 },
    { id: 4911, nome: 'PASSO FUNDO', codigo_ibge: 4314100, codigo_uf: 43 },
    { id: 4912, nome: 'PAULO BENTO', codigo_ibge: 4314134, codigo_uf: 43 },
    { id: 4913, nome: 'PAVERAMA', codigo_ibge: 4314159, codigo_uf: 43 },
    { id: 4914, nome: 'PEDRAS ALTAS', codigo_ibge: 4314175, codigo_uf: 43 },
    { id: 4915, nome: 'PEDRO OSORIO', codigo_ibge: 4314209, codigo_uf: 43 },
    { id: 4916, nome: 'PEJUCARA', codigo_ibge: 4314308, codigo_uf: 43 },
    { id: 4917, nome: 'PELOTAS', codigo_ibge: 4314407, codigo_uf: 43 },
    { id: 4918, nome: 'PICADA CAFE', codigo_ibge: 4314423, codigo_uf: 43 },
    { id: 4919, nome: 'PINHAL', codigo_ibge: 4314456, codigo_uf: 43 },
    { id: 4920, nome: 'PINHAL DA SERRA', codigo_ibge: 4314464, codigo_uf: 43 },
    { id: 4921, nome: 'PINHAL GRANDE', codigo_ibge: 4314472, codigo_uf: 43 },
    { id: 4922, nome: 'PINHEIRINHO DO VALE', codigo_ibge: 4314498, codigo_uf: 43 },
    { id: 4923, nome: 'PINHEIRO MACHADO', codigo_ibge: 4314506, codigo_uf: 43 },
    { id: 4924, nome: 'PINTO BANDEIRA', codigo_ibge: 4314548, codigo_uf: 43 },
    { id: 4925, nome: 'PIRAPO', codigo_ibge: 4314555, codigo_uf: 43 },
    { id: 4926, nome: 'PIRATINI', codigo_ibge: 4314605, codigo_uf: 43 },
    { id: 4927, nome: 'PLANALTO', codigo_ibge: 4314704, codigo_uf: 43 },
    { id: 4928, nome: 'POCO DAS ANTAS', codigo_ibge: 4314753, codigo_uf: 43 },
    { id: 4929, nome: 'PONTAO', codigo_ibge: 4314779, codigo_uf: 43 },
    { id: 4930, nome: 'PONTE PRETA', codigo_ibge: 4314787, codigo_uf: 43 },
    { id: 4931, nome: 'PORTAO', codigo_ibge: 4314803, codigo_uf: 43 },
    { id: 4932, nome: 'PORTO ALEGRE', codigo_ibge: 4314902, codigo_uf: 43 },
    { id: 4933, nome: 'PORTO LUCENA', codigo_ibge: 4315008, codigo_uf: 43 },
    { id: 4934, nome: 'PORTO MAUA', codigo_ibge: 4315057, codigo_uf: 43 },
    { id: 4935, nome: 'PORTO VERA CRUZ', codigo_ibge: 4315073, codigo_uf: 43 },
    { id: 4936, nome: 'PORTO XAVIER', codigo_ibge: 4315107, codigo_uf: 43 },
    { id: 4937, nome: 'POUSO NOVO', codigo_ibge: 4315131, codigo_uf: 43 },
    { id: 4938, nome: 'PRESIDENTE LUCENA', codigo_ibge: 4315149, codigo_uf: 43 },
    { id: 4939, nome: 'PROGRESSO', codigo_ibge: 4315156, codigo_uf: 43 },
    { id: 4940, nome: 'PROTASIO ALVES', codigo_ibge: 4315172, codigo_uf: 43 },
    { id: 4941, nome: 'PUTINGA', codigo_ibge: 4315206, codigo_uf: 43 },
    { id: 4942, nome: 'QUARAI', codigo_ibge: 4315305, codigo_uf: 43 },
    { id: 4943, nome: 'QUATRO IRMAOS', codigo_ibge: 4315313, codigo_uf: 43 },
    { id: 4944, nome: 'QUEVEDOS', codigo_ibge: 4315321, codigo_uf: 43 },
    { id: 4945, nome: 'QUINZE DE NOVEMBRO', codigo_ibge: 4315354, codigo_uf: 43 },
    { id: 4946, nome: 'REDENTORA', codigo_ibge: 4315404, codigo_uf: 43 },
    { id: 4947, nome: 'RELVADO', codigo_ibge: 4315453, codigo_uf: 43 },
    { id: 4948, nome: 'RESTINGA SECA', codigo_ibge: 4315503, codigo_uf: 43 },
    { id: 4949, nome: 'RIO DOS INDIOS', codigo_ibge: 4315552, codigo_uf: 43 },
    { id: 4950, nome: 'RIO GRANDE', codigo_ibge: 4315602, codigo_uf: 43 },
    { id: 4951, nome: 'RIO PARDO', codigo_ibge: 4315701, codigo_uf: 43 },
    { id: 4952, nome: 'RIOZINHO', codigo_ibge: 4315750, codigo_uf: 43 },
    { id: 4953, nome: 'ROCA SALES', codigo_ibge: 4315800, codigo_uf: 43 },
    { id: 4954, nome: 'RODEIO BONITO', codigo_ibge: 4315909, codigo_uf: 43 },
    { id: 4955, nome: 'ROLADOR', codigo_ibge: 4315958, codigo_uf: 43 },
    { id: 4956, nome: 'ROLANTE', codigo_ibge: 4316006, codigo_uf: 43 },
    { id: 4957, nome: 'RONDA ALTA', codigo_ibge: 4316105, codigo_uf: 43 },
    { id: 4958, nome: 'RONDINHA', codigo_ibge: 4316204, codigo_uf: 43 },
    { id: 4959, nome: 'ROQUE GONZALES', codigo_ibge: 4316303, codigo_uf: 43 },
    { id: 4960, nome: 'ROSARIO DO SUL', codigo_ibge: 4316402, codigo_uf: 43 },
    { id: 4961, nome: 'SAGRADA FAMILIA', codigo_ibge: 4316428, codigo_uf: 43 },
    { id: 4962, nome: 'SALDANHA MARINHO', codigo_ibge: 4316436, codigo_uf: 43 },
    { id: 4963, nome: 'SALTO DO JACUI', codigo_ibge: 4316451, codigo_uf: 43 },
    { id: 4964, nome: 'SALVADOR DAS MISSOES', codigo_ibge: 4316477, codigo_uf: 43 },
    { id: 4965, nome: 'SALVADOR DO SUL', codigo_ibge: 4316501, codigo_uf: 43 },
    { id: 4966, nome: 'SANANDUVA', codigo_ibge: 4316600, codigo_uf: 43 },
    { id: 4975, nome: 'SANT ANA DO LIVRAMENTO', codigo_ibge: 4317103, codigo_uf: 43 },
    { id: 4967, nome: 'SANTA BARBARA DO SUL', codigo_ibge: 4316709, codigo_uf: 43 },
    { id: 4968, nome: 'SANTA CECILIA DO SUL', codigo_ibge: 4316733, codigo_uf: 43 },
    { id: 4969, nome: 'SANTA CLARA DO SUL', codigo_ibge: 4316758, codigo_uf: 43 },
    { id: 4970, nome: 'SANTA CRUZ DO SUL', codigo_ibge: 4316808, codigo_uf: 43 },
    { id: 4973, nome: 'SANTA MARGARIDA DO SUL', codigo_ibge: 4316972, codigo_uf: 43 },
    { id: 4971, nome: 'SANTA MARIA', codigo_ibge: 4316907, codigo_uf: 43 },
    { id: 4972, nome: 'SANTA MARIA DO HERVAL', codigo_ibge: 4316956, codigo_uf: 43 },
    { id: 4976, nome: 'SANTA ROSA', codigo_ibge: 4317202, codigo_uf: 43 },
    { id: 4977, nome: 'SANTA TEREZA', codigo_ibge: 4317251, codigo_uf: 43 },
    { id: 4978, nome: 'SANTA VITORIA DO PALMAR', codigo_ibge: 4317301, codigo_uf: 43 },
    { id: 4974, nome: 'SANTANA DA BOA VISTA', codigo_ibge: 4317004, codigo_uf: 43 },
    { id: 4979, nome: 'SANTIAGO', codigo_ibge: 4317400, codigo_uf: 43 },
    { id: 4980, nome: 'SANTO ANGELO', codigo_ibge: 4317509, codigo_uf: 43 },
    { id: 4982, nome: 'SANTO ANTONIO DA PATRULHA', codigo_ibge: 4317608, codigo_uf: 43 },
    { id: 4983, nome: 'SANTO ANTONIO DAS MISSOES', codigo_ibge: 4317707, codigo_uf: 43 },
    { id: 4981, nome: 'SANTO ANTONIO DO PALMA', codigo_ibge: 4317558, codigo_uf: 43 },
    { id: 4984, nome: 'SANTO ANTONIO DO PLANALTO', codigo_ibge: 4317756, codigo_uf: 43 },
    { id: 4985, nome: 'SANTO AUGUSTO', codigo_ibge: 4317806, codigo_uf: 43 },
    { id: 4986, nome: 'SANTO CRISTO', codigo_ibge: 4317905, codigo_uf: 43 },
    { id: 4987, nome: 'SANTO EXPEDITO DO SUL', codigo_ibge: 4317954, codigo_uf: 43 },
    { id: 4988, nome: 'SAO BORJA', codigo_ibge: 4318002, codigo_uf: 43 },
    { id: 4989, nome: 'SAO DOMINGOS DO SUL', codigo_ibge: 4318051, codigo_uf: 43 },
    { id: 4990, nome: 'SAO FRANCISCO DE ASSIS', codigo_ibge: 4318101, codigo_uf: 43 },
    { id: 4991, nome: 'SAO FRANCISCO DE PAULA', codigo_ibge: 4318200, codigo_uf: 43 },
    { id: 4992, nome: 'SAO GABRIEL', codigo_ibge: 4318309, codigo_uf: 43 },
    { id: 4993, nome: 'SAO JERONIMO', codigo_ibge: 4318408, codigo_uf: 43 },
    { id: 4994, nome: 'SAO JOAO DA URTIGA', codigo_ibge: 4318424, codigo_uf: 43 },
    { id: 4995, nome: 'SAO JOAO DO POLESINE', codigo_ibge: 4318432, codigo_uf: 43 },
    { id: 4996, nome: 'SAO JORGE', codigo_ibge: 4318440, codigo_uf: 43 },
    { id: 4997, nome: 'SAO JOSE DAS MISSOES', codigo_ibge: 4318457, codigo_uf: 43 },
    { id: 4998, nome: 'SAO JOSE DO HERVAL', codigo_ibge: 4318465, codigo_uf: 43 },
    { id: 4999, nome: 'SAO JOSE DO HORTENCIO', codigo_ibge: 4318481, codigo_uf: 43 },
    { id: 5000, nome: 'SAO JOSE DO INHACORA', codigo_ibge: 4318499, codigo_uf: 43 },
    { id: 5001, nome: 'SAO JOSE DO NORTE', codigo_ibge: 4318507, codigo_uf: 43 },
    { id: 5002, nome: 'SAO JOSE DO OURO', codigo_ibge: 4318606, codigo_uf: 43 },
    { id: 5003, nome: 'SAO JOSE DO SUL', codigo_ibge: 4318614, codigo_uf: 43 },
    { id: 5004, nome: 'SAO JOSE DOS AUSENTES', codigo_ibge: 4318622, codigo_uf: 43 },
    { id: 5005, nome: 'SAO LEOPOLDO', codigo_ibge: 4318705, codigo_uf: 43 },
    { id: 5006, nome: 'SAO LOURENCO DO SUL', codigo_ibge: 4318804, codigo_uf: 43 },
    { id: 5007, nome: 'SAO LUIZ GONZAGA', codigo_ibge: 4318903, codigo_uf: 43 },
    { id: 5008, nome: 'SAO MARCOS', codigo_ibge: 4319000, codigo_uf: 43 },
    { id: 5009, nome: 'SAO MARTINHO', codigo_ibge: 4319109, codigo_uf: 43 },
    { id: 5010, nome: 'SAO MARTINHO DA SERRA', codigo_ibge: 4319125, codigo_uf: 43 },
    { id: 5011, nome: 'SAO MIGUEL DAS MISSOES', codigo_ibge: 4319158, codigo_uf: 43 },
    { id: 5012, nome: 'SAO NICOLAU', codigo_ibge: 4319208, codigo_uf: 43 },
    { id: 5013, nome: 'SAO PAULO DAS MISSOES', codigo_ibge: 4319307, codigo_uf: 43 },
    { id: 5014, nome: 'SAO PEDRO DA SERRA', codigo_ibge: 4319356, codigo_uf: 43 },
    { id: 5015, nome: 'SAO PEDRO DAS MISSOES', codigo_ibge: 4319364, codigo_uf: 43 },
    { id: 5016, nome: 'SAO PEDRO DO BUTIA', codigo_ibge: 4319372, codigo_uf: 43 },
    { id: 5017, nome: 'SAO PEDRO DO SUL', codigo_ibge: 4319406, codigo_uf: 43 },
    { id: 5018, nome: 'SAO SEBASTIAO DO CAI', codigo_ibge: 4319505, codigo_uf: 43 },
    { id: 5019, nome: 'SAO SEPE', codigo_ibge: 4319604, codigo_uf: 43 },
    { id: 5020, nome: 'SAO VALENTIM', codigo_ibge: 4319703, codigo_uf: 43 },
    { id: 5021, nome: 'SAO VALENTIM DO SUL', codigo_ibge: 4319711, codigo_uf: 43 },
    { id: 5022, nome: 'SAO VALERIO DO SUL', codigo_ibge: 4319737, codigo_uf: 43 },
    { id: 5023, nome: 'SAO VENDELINO', codigo_ibge: 4319752, codigo_uf: 43 },
    { id: 5024, nome: 'SAO VICENTE DO SUL', codigo_ibge: 4319802, codigo_uf: 43 },
    { id: 5025, nome: 'SAPIRANGA', codigo_ibge: 4319901, codigo_uf: 43 },
    { id: 5026, nome: 'SAPUCAIA DO SUL', codigo_ibge: 4320008, codigo_uf: 43 },
    { id: 5027, nome: 'SARANDI', codigo_ibge: 4320107, codigo_uf: 43 },
    { id: 5028, nome: 'SEBERI', codigo_ibge: 4320206, codigo_uf: 43 },
    { id: 5029, nome: 'SEDE NOVA', codigo_ibge: 4320230, codigo_uf: 43 },
    { id: 5030, nome: 'SEGREDO', codigo_ibge: 4320263, codigo_uf: 43 },
    { id: 5031, nome: 'SELBACH', codigo_ibge: 4320305, codigo_uf: 43 },
    { id: 5032, nome: 'SENADOR SALGADO FILHO', codigo_ibge: 4320321, codigo_uf: 43 },
    { id: 5033, nome: 'SENTINELA DO SUL', codigo_ibge: 4320354, codigo_uf: 43 },
    { id: 5034, nome: 'SERAFINA CORREA', codigo_ibge: 4320404, codigo_uf: 43 },
    { id: 5035, nome: 'SERIO', codigo_ibge: 4320453, codigo_uf: 43 },
    { id: 5036, nome: 'SERTAO', codigo_ibge: 4320503, codigo_uf: 43 },
    { id: 5037, nome: 'SERTAO SANTANA', codigo_ibge: 4320552, codigo_uf: 43 },
    { id: 5038, nome: 'SETE DE SETEMBRO', codigo_ibge: 4320578, codigo_uf: 43 },
    { id: 5039, nome: 'SEVERIANO DE ALMEIDA', codigo_ibge: 4320602, codigo_uf: 43 },
    { id: 5040, nome: 'SILVEIRA MARTINS', codigo_ibge: 4320651, codigo_uf: 43 },
    { id: 5041, nome: 'SINIMBU', codigo_ibge: 4320677, codigo_uf: 43 },
    { id: 5042, nome: 'SOBRADINHO', codigo_ibge: 4320701, codigo_uf: 43 },
    { id: 5043, nome: 'SOLEDADE', codigo_ibge: 4320800, codigo_uf: 43 },
    { id: 5044, nome: 'TABAI', codigo_ibge: 4320859, codigo_uf: 43 },
    { id: 5045, nome: 'TAPEJARA', codigo_ibge: 4320909, codigo_uf: 43 },
    { id: 5046, nome: 'TAPERA', codigo_ibge: 4321006, codigo_uf: 43 },
    { id: 5047, nome: 'TAPES', codigo_ibge: 4321105, codigo_uf: 43 },
    { id: 5048, nome: 'TAQUARA', codigo_ibge: 4321204, codigo_uf: 43 },
    { id: 5049, nome: 'TAQUARI', codigo_ibge: 4321303, codigo_uf: 43 },
    { id: 5050, nome: 'TAQUARUCU DO SUL', codigo_ibge: 4321329, codigo_uf: 43 },
    { id: 5051, nome: 'TAVARES', codigo_ibge: 4321352, codigo_uf: 43 },
    { id: 5052, nome: 'TENENTE PORTELA', codigo_ibge: 4321402, codigo_uf: 43 },
    { id: 5053, nome: 'TERRA DE AREIA', codigo_ibge: 4321436, codigo_uf: 43 },
    { id: 5054, nome: 'TEUTONIA', codigo_ibge: 4321451, codigo_uf: 43 },
    { id: 5055, nome: 'TIO HUGO', codigo_ibge: 4321469, codigo_uf: 43 },
    { id: 5056, nome: 'TIRADENTES DO SUL', codigo_ibge: 4321477, codigo_uf: 43 },
    { id: 5057, nome: 'TOROPI', codigo_ibge: 4321493, codigo_uf: 43 },
    { id: 5058, nome: 'TORRES', codigo_ibge: 4321501, codigo_uf: 43 },
    { id: 5059, nome: 'TRAMANDAI', codigo_ibge: 4321600, codigo_uf: 43 },
    { id: 5060, nome: 'TRAVESSEIRO', codigo_ibge: 4321626, codigo_uf: 43 },
    { id: 5061, nome: 'TRES ARROIOS', codigo_ibge: 4321634, codigo_uf: 43 },
    { id: 5062, nome: 'TRES CACHOEIRAS', codigo_ibge: 4321667, codigo_uf: 43 },
    { id: 5063, nome: 'TRES COROAS', codigo_ibge: 4321709, codigo_uf: 43 },
    { id: 5064, nome: 'TRES DE MAIO', codigo_ibge: 4321808, codigo_uf: 43 },
    { id: 5065, nome: 'TRES FORQUILHAS', codigo_ibge: 4321832, codigo_uf: 43 },
    { id: 5066, nome: 'TRES PALMEIRAS', codigo_ibge: 4321857, codigo_uf: 43 },
    { id: 5067, nome: 'TRES PASSOS', codigo_ibge: 4321907, codigo_uf: 43 },
    { id: 5068, nome: 'TRINDADE DO SUL', codigo_ibge: 4321956, codigo_uf: 43 },
    { id: 5069, nome: 'TRIUNFO', codigo_ibge: 4322004, codigo_uf: 43 },
    { id: 5070, nome: 'TUCUNDUVA', codigo_ibge: 4322103, codigo_uf: 43 },
    { id: 5071, nome: 'TUNAS', codigo_ibge: 4322152, codigo_uf: 43 },
    { id: 5072, nome: 'TUPANCI DO SUL', codigo_ibge: 4322186, codigo_uf: 43 },
    { id: 5073, nome: 'TUPANCIRETA', codigo_ibge: 4322202, codigo_uf: 43 },
    { id: 5074, nome: 'TUPANDI', codigo_ibge: 4322251, codigo_uf: 43 },
    { id: 5075, nome: 'TUPARENDI', codigo_ibge: 4322301, codigo_uf: 43 },
    { id: 5076, nome: 'TURUCU', codigo_ibge: 4322327, codigo_uf: 43 },
    { id: 5077, nome: 'UBIRETAMA', codigo_ibge: 4322343, codigo_uf: 43 },
    { id: 5078, nome: 'UNIAO DA SERRA', codigo_ibge: 4322350, codigo_uf: 43 },
    { id: 5079, nome: 'UNISTALDA', codigo_ibge: 4322376, codigo_uf: 43 },
    { id: 5080, nome: 'URUGUAIANA', codigo_ibge: 4322400, codigo_uf: 43 },
    { id: 5081, nome: 'VACARIA', codigo_ibge: 4322509, codigo_uf: 43 },
    { id: 5083, nome: 'VALE DO SOL', codigo_ibge: 4322533, codigo_uf: 43 },
    { id: 5084, nome: 'VALE REAL', codigo_ibge: 4322541, codigo_uf: 43 },
    { id: 5082, nome: 'VALE VERDE', codigo_ibge: 4322525, codigo_uf: 43 },
    { id: 5085, nome: 'VANINI', codigo_ibge: 4322558, codigo_uf: 43 },
    { id: 5086, nome: 'VENANCIO AIRES', codigo_ibge: 4322608, codigo_uf: 43 },
    { id: 5087, nome: 'VERA CRUZ', codigo_ibge: 4322707, codigo_uf: 43 },
    { id: 5088, nome: 'VERANOPOLIS', codigo_ibge: 4322806, codigo_uf: 43 },
    { id: 5089, nome: 'VESPASIANO CORREA', codigo_ibge: 4322855, codigo_uf: 43 },
    { id: 5090, nome: 'VIADUTOS', codigo_ibge: 4322905, codigo_uf: 43 },
    { id: 5091, nome: 'VIAMAO', codigo_ibge: 4323002, codigo_uf: 43 },
    { id: 5092, nome: 'VICENTE DUTRA', codigo_ibge: 4323101, codigo_uf: 43 },
    { id: 5093, nome: 'VICTOR GRAEFF', codigo_ibge: 4323200, codigo_uf: 43 },
    { id: 5094, nome: 'VILA FLORES', codigo_ibge: 4323309, codigo_uf: 43 },
    { id: 5095, nome: 'VILA LANGARO', codigo_ibge: 4323358, codigo_uf: 43 },
    { id: 5096, nome: 'VILA MARIA', codigo_ibge: 4323408, codigo_uf: 43 },
    { id: 5097, nome: 'VILA NOVA DO SUL', codigo_ibge: 4323457, codigo_uf: 43 },
    { id: 5098, nome: 'VISTA ALEGRE', codigo_ibge: 4323507, codigo_uf: 43 },
    { id: 5099, nome: 'VISTA ALEGRE DO PRATA', codigo_ibge: 4323606, codigo_uf: 43 },
    { id: 5100, nome: 'VISTA GAUCHA', codigo_ibge: 4323705, codigo_uf: 43 },
    { id: 5101, nome: 'VITORIA DAS MISSOES', codigo_ibge: 4323754, codigo_uf: 43 },
    { id: 5102, nome: 'WESTFALIA', codigo_ibge: 4323770, codigo_uf: 43 },
    { id: 5103, nome: 'XANGRI-LA', codigo_ibge: 4323804, codigo_uf: 43 },
    { id: 5104, nome: 'AGUA CLARA', codigo_ibge: 5000203, codigo_uf: 50 },
    { id: 5105, nome: 'ALCINOPOLIS', codigo_ibge: 5000252, codigo_uf: 50 },
    { id: 5106, nome: 'AMAMBAI', codigo_ibge: 5000609, codigo_uf: 50 },
    { id: 5107, nome: 'ANASTACIO', codigo_ibge: 5000708, codigo_uf: 50 },
    { id: 5108, nome: 'ANAURILANDIA', codigo_ibge: 5000807, codigo_uf: 50 },
    { id: 5109, nome: 'ANGELICA', codigo_ibge: 5000856, codigo_uf: 50 },
    { id: 5110, nome: 'ANTONIO JOAO', codigo_ibge: 5000906, codigo_uf: 50 },
    { id: 5111, nome: 'APARECIDA DO TABOADO', codigo_ibge: 5001003, codigo_uf: 50 },
    { id: 5112, nome: 'AQUIDAUANA', codigo_ibge: 5001102, codigo_uf: 50 },
    { id: 5113, nome: 'ARAL MOREIRA', codigo_ibge: 5001243, codigo_uf: 50 },
    { id: 5114, nome: 'BANDEIRANTES', codigo_ibge: 5001508, codigo_uf: 50 },
    { id: 5115, nome: 'BATAGUASSU', codigo_ibge: 5001904, codigo_uf: 50 },
    { id: 5116, nome: 'BATAYPORA', codigo_ibge: 5002001, codigo_uf: 50 },
    { id: 5117, nome: 'BELA VISTA', codigo_ibge: 5002100, codigo_uf: 50 },
    { id: 5118, nome: 'BODOQUENA', codigo_ibge: 5002159, codigo_uf: 50 },
    { id: 5119, nome: 'BONITO', codigo_ibge: 5002209, codigo_uf: 50 },
    { id: 5120, nome: 'BRASILANDIA', codigo_ibge: 5002308, codigo_uf: 50 },
    { id: 5121, nome: 'CAARAPO', codigo_ibge: 5002407, codigo_uf: 50 },
    { id: 5122, nome: 'CAMAPUA', codigo_ibge: 5002605, codigo_uf: 50 },
    { id: 5123, nome: 'CAMPO GRANDE', codigo_ibge: 5002704, codigo_uf: 50 },
    { id: 5124, nome: 'CARACOL', codigo_ibge: 5002803, codigo_uf: 50 },
    { id: 5125, nome: 'CASSILANDIA', codigo_ibge: 5002902, codigo_uf: 50 },
    { id: 5126, nome: 'CHAPADAO DO SUL', codigo_ibge: 5002951, codigo_uf: 50 },
    { id: 5127, nome: 'CORGUINHO', codigo_ibge: 5003108, codigo_uf: 50 },
    { id: 5128, nome: 'CORONEL SAPUCAIA', codigo_ibge: 5003157, codigo_uf: 50 },
    { id: 5129, nome: 'CORUMBA', codigo_ibge: 5003207, codigo_uf: 50 },
    { id: 5130, nome: 'COSTA RICA', codigo_ibge: 5003256, codigo_uf: 50 },
    { id: 5131, nome: 'COXIM', codigo_ibge: 5003306, codigo_uf: 50 },
    { id: 5132, nome: 'DEODAPOLIS', codigo_ibge: 5003454, codigo_uf: 50 },
    { id: 5133, nome: 'DOIS IRMAOS DO BURITI', codigo_ibge: 5003488, codigo_uf: 50 },
    { id: 5134, nome: 'DOURADINA', codigo_ibge: 5003504, codigo_uf: 50 },
    { id: 5135, nome: 'DOURADOS', codigo_ibge: 5003702, codigo_uf: 50 },
    { id: 5136, nome: 'ELDORADO', codigo_ibge: 5003751, codigo_uf: 50 },
    { id: 5137, nome: 'FATIMA DO SUL', codigo_ibge: 5003801, codigo_uf: 50 },
    { id: 5138, nome: 'FIGUEIRAO', codigo_ibge: 5003900, codigo_uf: 50 },
    { id: 5139, nome: 'GLORIA DE DOURADOS', codigo_ibge: 5004007, codigo_uf: 50 },
    { id: 5140, nome: 'GUIA LOPES DA LAGUNA', codigo_ibge: 5004106, codigo_uf: 50 },
    { id: 5141, nome: 'IGUATEMI', codigo_ibge: 5004304, codigo_uf: 50 },
    { id: 5142, nome: 'INOCENCIA', codigo_ibge: 5004403, codigo_uf: 50 },
    { id: 5143, nome: 'ITAPORA', codigo_ibge: 5004502, codigo_uf: 50 },
    { id: 5144, nome: 'ITAQUIRAI', codigo_ibge: 5004601, codigo_uf: 50 },
    { id: 5145, nome: 'IVINHEMA', codigo_ibge: 5004700, codigo_uf: 50 },
    { id: 5146, nome: 'JAPORA', codigo_ibge: 5004809, codigo_uf: 50 },
    { id: 5147, nome: 'JARAGUARI', codigo_ibge: 5004908, codigo_uf: 50 },
    { id: 5148, nome: 'JARDIM', codigo_ibge: 5005004, codigo_uf: 50 },
    { id: 5149, nome: 'JATEI', codigo_ibge: 5005103, codigo_uf: 50 },
    { id: 5150, nome: 'JUTI', codigo_ibge: 5005152, codigo_uf: 50 },
    { id: 5151, nome: 'LADARIO', codigo_ibge: 5005202, codigo_uf: 50 },
    { id: 5152, nome: 'LAGUNA CARAPA', codigo_ibge: 5005251, codigo_uf: 50 },
    { id: 5153, nome: 'MARACAJU', codigo_ibge: 5005400, codigo_uf: 50 },
    { id: 5154, nome: 'MIRANDA', codigo_ibge: 5005608, codigo_uf: 50 },
    { id: 5155, nome: 'MUNDO NOVO', codigo_ibge: 5005681, codigo_uf: 50 },
    { id: 5156, nome: 'NAVIRAI', codigo_ibge: 5005707, codigo_uf: 50 },
    { id: 5157, nome: 'NIOAQUE', codigo_ibge: 5005806, codigo_uf: 50 },
    { id: 5158, nome: 'NOVA ALVORADA DO SUL', codigo_ibge: 5006002, codigo_uf: 50 },
    { id: 5159, nome: 'NOVA ANDRADINA', codigo_ibge: 5006200, codigo_uf: 50 },
    { id: 5160, nome: 'NOVO HORIZONTE DO SUL', codigo_ibge: 5006259, codigo_uf: 50 },
    { id: 5161, nome: 'PARAISO DAS AGUAS', codigo_ibge: 5006275, codigo_uf: 50 },
    { id: 5162, nome: 'PARANAIBA', codigo_ibge: 5006309, codigo_uf: 50 },
    { id: 5163, nome: 'PARANHOS', codigo_ibge: 5006358, codigo_uf: 50 },
    { id: 5164, nome: 'PEDRO GOMES', codigo_ibge: 5006408, codigo_uf: 50 },
    { id: 5165, nome: 'PONTA PORA', codigo_ibge: 5006606, codigo_uf: 50 },
    { id: 5166, nome: 'PORTO MURTINHO', codigo_ibge: 5006903, codigo_uf: 50 },
    { id: 5167, nome: 'RIBAS DO RIO PARDO', codigo_ibge: 5007109, codigo_uf: 50 },
    { id: 5168, nome: 'RIO BRILHANTE', codigo_ibge: 5007208, codigo_uf: 50 },
    { id: 5169, nome: 'RIO NEGRO', codigo_ibge: 5007307, codigo_uf: 50 },
    { id: 5170, nome: 'RIO VERDE DE MATO GROSSO', codigo_ibge: 5007406, codigo_uf: 50 },
    { id: 5171, nome: 'ROCHEDO', codigo_ibge: 5007505, codigo_uf: 50 },
    { id: 5172, nome: 'SANTA RITA DO PARDO', codigo_ibge: 5007554, codigo_uf: 50 },
    { id: 5173, nome: 'SAO GABRIEL DO OESTE', codigo_ibge: 5007695, codigo_uf: 50 },
    { id: 5175, nome: 'SELVIRIA', codigo_ibge: 5007802, codigo_uf: 50 },
    { id: 5174, nome: 'SETE QUEDAS', codigo_ibge: 5007703, codigo_uf: 50 },
    { id: 5176, nome: 'SIDROLANDIA', codigo_ibge: 5007901, codigo_uf: 50 },
    { id: 5177, nome: 'SONORA', codigo_ibge: 5007935, codigo_uf: 50 },
    { id: 5178, nome: 'TACURU', codigo_ibge: 5007950, codigo_uf: 50 },
    { id: 5179, nome: 'TAQUARUSSU', codigo_ibge: 5007976, codigo_uf: 50 },
    { id: 5180, nome: 'TERENOS', codigo_ibge: 5008008, codigo_uf: 50 },
    { id: 5181, nome: 'TRES LAGOAS', codigo_ibge: 5008305, codigo_uf: 50 },
    { id: 5182, nome: 'VICENTINA', codigo_ibge: 5008404, codigo_uf: 50 },
    { id: 5183, nome: 'ACORIZAL', codigo_ibge: 5100102, codigo_uf: 51 },
    { id: 5184, nome: 'AGUA BOA', codigo_ibge: 5100201, codigo_uf: 51 },
    { id: 5185, nome: 'ALTA FLORESTA', codigo_ibge: 5100250, codigo_uf: 51 },
    { id: 5186, nome: 'ALTO ARAGUAIA', codigo_ibge: 5100300, codigo_uf: 51 },
    { id: 5187, nome: 'ALTO BOA VISTA', codigo_ibge: 5100359, codigo_uf: 51 },
    { id: 5188, nome: 'ALTO GARCAS', codigo_ibge: 5100409, codigo_uf: 51 },
    { id: 5189, nome: 'ALTO PARAGUAI', codigo_ibge: 5100508, codigo_uf: 51 },
    { id: 5190, nome: 'ALTO TAQUARI', codigo_ibge: 5100607, codigo_uf: 51 },
    { id: 5191, nome: 'APIACAS', codigo_ibge: 5100805, codigo_uf: 51 },
    { id: 5192, nome: 'ARAGUAIANA', codigo_ibge: 5101001, codigo_uf: 51 },
    { id: 5193, nome: 'ARAGUAINHA', codigo_ibge: 5101209, codigo_uf: 51 },
    { id: 5194, nome: 'ARAPUTANGA', codigo_ibge: 5101258, codigo_uf: 51 },
    { id: 5195, nome: 'ARENAPOLIS', codigo_ibge: 5101308, codigo_uf: 51 },
    { id: 5196, nome: 'ARIPUANA', codigo_ibge: 5101407, codigo_uf: 51 },
    { id: 5197, nome: 'BARAO DE MELGACO', codigo_ibge: 5101605, codigo_uf: 51 },
    { id: 5198, nome: 'BARRA DO BUGRES', codigo_ibge: 5101704, codigo_uf: 51 },
    { id: 5199, nome: 'BARRA DO GARCAS', codigo_ibge: 5101803, codigo_uf: 51 },
    { id: 5200, nome: 'BOM JESUS DO ARAGUAIA', codigo_ibge: 5101852, codigo_uf: 51 },
    { id: 5201, nome: 'BRASNORTE', codigo_ibge: 5101902, codigo_uf: 51 },
    { id: 5202, nome: 'CACERES', codigo_ibge: 5102504, codigo_uf: 51 },
    { id: 5203, nome: 'CAMPINAPOLIS', codigo_ibge: 5102603, codigo_uf: 51 },
    { id: 5204, nome: 'CAMPO NOVO DO PARECIS', codigo_ibge: 5102637, codigo_uf: 51 },
    { id: 5205, nome: 'CAMPO VERDE', codigo_ibge: 5102678, codigo_uf: 51 },
    { id: 5206, nome: 'CAMPOS DE JULIO', codigo_ibge: 5102686, codigo_uf: 51 },
    { id: 5207, nome: 'CANABRAVA DO NORTE', codigo_ibge: 5102694, codigo_uf: 51 },
    { id: 5208, nome: 'CANARANA', codigo_ibge: 5102702, codigo_uf: 51 },
    { id: 5209, nome: 'CARLINDA', codigo_ibge: 5102793, codigo_uf: 51 },
    { id: 5210, nome: 'CASTANHEIRA', codigo_ibge: 5102850, codigo_uf: 51 },
    { id: 5211, nome: 'CHAPADA DOS GUIMARAES', codigo_ibge: 5103007, codigo_uf: 51 },
    { id: 5212, nome: 'CLAUDIA', codigo_ibge: 5103056, codigo_uf: 51 },
    { id: 5213, nome: 'COCALINHO', codigo_ibge: 5103106, codigo_uf: 51 },
    { id: 5214, nome: 'COLIDER', codigo_ibge: 5103205, codigo_uf: 51 },
    { id: 5215, nome: 'COLNIZA', codigo_ibge: 5103254, codigo_uf: 51 },
    { id: 5216, nome: 'COMODORO', codigo_ibge: 5103304, codigo_uf: 51 },
    { id: 5217, nome: 'CONFRESA', codigo_ibge: 5103353, codigo_uf: 51 },
    { id: 5218, nome: 'CONQUISTA D OESTE', codigo_ibge: 5103361, codigo_uf: 51 },
    { id: 5219, nome: 'COTRIGUACU', codigo_ibge: 5103379, codigo_uf: 51 },
    { id: 5220, nome: 'CUIABA', codigo_ibge: 5103403, codigo_uf: 51 },
    { id: 5221, nome: 'CURVELANDIA', codigo_ibge: 5103437, codigo_uf: 51 },
    { id: 5222, nome: 'DENISE', codigo_ibge: 5103452, codigo_uf: 51 },
    { id: 5223, nome: 'DIAMANTINO', codigo_ibge: 5103502, codigo_uf: 51 },
    { id: 5224, nome: 'DOM AQUINO', codigo_ibge: 5103601, codigo_uf: 51 },
    { id: 5225, nome: 'FELIZ NATAL', codigo_ibge: 5103700, codigo_uf: 51 },
    { id: 5226, nome: 'FIGUEIROPOLIS D OESTE', codigo_ibge: 5103809, codigo_uf: 51 },
    { id: 5227, nome: 'GAUCHA DO NORTE', codigo_ibge: 5103858, codigo_uf: 51 },
    { id: 5228, nome: 'GENERAL CARNEIRO', codigo_ibge: 5103908, codigo_uf: 51 },
    { id: 5229, nome: 'GLORIA D OESTE', codigo_ibge: 5103957, codigo_uf: 51 },
    { id: 5230, nome: 'GUARANTA DO NORTE', codigo_ibge: 5104104, codigo_uf: 51 },
    { id: 5231, nome: 'GUIRATINGA', codigo_ibge: 5104203, codigo_uf: 51 },
    { id: 5232, nome: 'INDIAVAI', codigo_ibge: 5104500, codigo_uf: 51 },
    { id: 5233, nome: 'IPIRANGA DO NORTE', codigo_ibge: 5104526, codigo_uf: 51 },
    { id: 5234, nome: 'ITANHANGA', codigo_ibge: 5104542, codigo_uf: 51 },
    { id: 5235, nome: 'ITAUBA', codigo_ibge: 5104559, codigo_uf: 51 },
    { id: 5236, nome: 'ITIQUIRA', codigo_ibge: 5104609, codigo_uf: 51 },
    { id: 5237, nome: 'JACIARA', codigo_ibge: 5104807, codigo_uf: 51 },
    { id: 5238, nome: 'JANGADA', codigo_ibge: 5104906, codigo_uf: 51 },
    { id: 5239, nome: 'JAURU', codigo_ibge: 5105002, codigo_uf: 51 },
    { id: 5240, nome: 'JUARA', codigo_ibge: 5105101, codigo_uf: 51 },
    { id: 5241, nome: 'JUINA', codigo_ibge: 5105150, codigo_uf: 51 },
    { id: 5242, nome: 'JURUENA', codigo_ibge: 5105176, codigo_uf: 51 },
    { id: 5243, nome: 'JUSCIMEIRA', codigo_ibge: 5105200, codigo_uf: 51 },
    { id: 5244, nome: 'LAMBARI D OESTE', codigo_ibge: 5105234, codigo_uf: 51 },
    { id: 5245, nome: 'LUCAS DO RIO VERDE', codigo_ibge: 5105259, codigo_uf: 51 },
    { id: 5246, nome: 'LUCIARA', codigo_ibge: 5105309, codigo_uf: 51 },
    { id: 5248, nome: 'MARCELANDIA', codigo_ibge: 5105580, codigo_uf: 51 },
    { id: 5249, nome: 'MATUPA', codigo_ibge: 5105606, codigo_uf: 51 },
    { id: 5250, nome: 'MIRASSOL D OESTE', codigo_ibge: 5105622, codigo_uf: 51 },
    { id: 5251, nome: 'NOBRES', codigo_ibge: 5105903, codigo_uf: 51 },
    { id: 5252, nome: 'NORTELANDIA', codigo_ibge: 5106000, codigo_uf: 51 },
    { id: 5253, nome: 'NOSSA SENHORA DO LIVRAMENTO', codigo_ibge: 5106109, codigo_uf: 51 },
    { id: 5254, nome: 'NOVA BANDEIRANTES', codigo_ibge: 5106158, codigo_uf: 51 },
    { id: 5258, nome: 'NOVA BRASILANDIA', codigo_ibge: 5106208, codigo_uf: 51 },
    { id: 5259, nome: 'NOVA CANAA DO NORTE', codigo_ibge: 5106216, codigo_uf: 51 },
    { id: 5320, nome: 'NOVA GUARITA', codigo_ibge: 5108808, codigo_uf: 51 },
    { id: 5256, nome: 'NOVA LACERDA', codigo_ibge: 5106182, codigo_uf: 51 },
    { id: 5321, nome: 'NOVA MARILANDIA', codigo_ibge: 5108857, codigo_uf: 51 },
    { id: 5322, nome: 'NOVA MARINGA', codigo_ibge: 5108907, codigo_uf: 51 },
    { id: 5323, nome: 'NOVA MONTE VERDE', codigo_ibge: 5108956, codigo_uf: 51 },
    { id: 5260, nome: 'NOVA MUTUM', codigo_ibge: 5106224, codigo_uf: 51 },
    { id: 5255, nome: 'NOVA NAZARE', codigo_ibge: 5106174, codigo_uf: 51 },
    { id: 5261, nome: 'NOVA OLIMPIA', codigo_ibge: 5106232, codigo_uf: 51 },
    { id: 5257, nome: 'NOVA SANTA HELENA', codigo_ibge: 5106190, codigo_uf: 51 },
    { id: 5262, nome: 'NOVA UBIRATA', codigo_ibge: 5106240, codigo_uf: 51 },
    { id: 5263, nome: 'NOVA XAVANTINA', codigo_ibge: 5106257, codigo_uf: 51 },
    { id: 5265, nome: 'NOVO HORIZONTE DO NORTE', codigo_ibge: 5106273, codigo_uf: 51 },
    { id: 5264, nome: 'NOVO MUNDO', codigo_ibge: 5106265, codigo_uf: 51 },
    { id: 5269, nome: 'NOVO SANTO ANTONIO', codigo_ibge: 5106315, codigo_uf: 51 },
    { id: 5266, nome: 'NOVO SAO JOAQUIM', codigo_ibge: 5106281, codigo_uf: 51 },
    { id: 5267, nome: 'PARANAITA', codigo_ibge: 5106299, codigo_uf: 51 },
    { id: 5268, nome: 'PARANATINGA', codigo_ibge: 5106307, codigo_uf: 51 },
    { id: 5270, nome: 'PEDRA PRETA', codigo_ibge: 5106372, codigo_uf: 51 },
    { id: 5271, nome: 'PEIXOTO DE AZEVEDO', codigo_ibge: 5106422, codigo_uf: 51 },
    { id: 5272, nome: 'PLANALTO DA SERRA', codigo_ibge: 5106455, codigo_uf: 51 },
    { id: 5273, nome: 'POCONE', codigo_ibge: 5106505, codigo_uf: 51 },
    { id: 5274, nome: 'PONTAL DO ARAGUAIA', codigo_ibge: 5106653, codigo_uf: 51 },
    { id: 5275, nome: 'PONTE BRANCA', codigo_ibge: 5106703, codigo_uf: 51 },
    { id: 5276, nome: 'PONTES E LACERDA', codigo_ibge: 5106752, codigo_uf: 51 },
    { id: 5277, nome: 'PORTO ALEGRE DO NORTE', codigo_ibge: 5106778, codigo_uf: 51 },
    { id: 5278, nome: 'PORTO DOS GAUCHOS', codigo_ibge: 5106802, codigo_uf: 51 },
    { id: 5279, nome: 'PORTO ESPERIDIAO', codigo_ibge: 5106828, codigo_uf: 51 },
    { id: 5280, nome: 'PORTO ESTRELA', codigo_ibge: 5106851, codigo_uf: 51 },
    { id: 5281, nome: 'POXOREU', codigo_ibge: 5107008, codigo_uf: 51 },
    { id: 5282, nome: 'PRIMAVERA DO LESTE', codigo_ibge: 5107040, codigo_uf: 51 },
    { id: 5283, nome: 'QUERENCIA', codigo_ibge: 5107065, codigo_uf: 51 },
    { id: 5285, nome: 'RESERVA DO CABACAL', codigo_ibge: 5107156, codigo_uf: 51 },
    { id: 5286, nome: 'RIBEIRAO CASCALHEIRA', codigo_ibge: 5107180, codigo_uf: 51 },
    { id: 5287, nome: 'RIBEIRAOZINHO', codigo_ibge: 5107198, codigo_uf: 51 },
    { id: 5288, nome: 'RIO BRANCO', codigo_ibge: 5107206, codigo_uf: 51 },
    { id: 5295, nome: 'RONDOLANDIA', codigo_ibge: 5107578, codigo_uf: 51 },
    { id: 5296, nome: 'RONDONOPOLIS', codigo_ibge: 5107602, codigo_uf: 51 },
    { id: 5297, nome: 'ROSARIO OESTE', codigo_ibge: 5107701, codigo_uf: 51 },
    { id: 5299, nome: 'SALTO DO CEU', codigo_ibge: 5107750, codigo_uf: 51 },
    { id: 5289, nome: 'SANTA CARMEM', codigo_ibge: 5107248, codigo_uf: 51 },
    { id: 5298, nome: 'SANTA CRUZ DO XINGU', codigo_ibge: 5107743, codigo_uf: 51 },
    { id: 5300, nome: 'SANTA RITA DO TRIVELATO', codigo_ibge: 5107768, codigo_uf: 51 },
    { id: 5301, nome: 'SANTA TEREZINHA', codigo_ibge: 5107776, codigo_uf: 51 },
    { id: 5290, nome: 'SANTO AFONSO', codigo_ibge: 5107263, codigo_uf: 51 },
    { id: 5302, nome: 'SANTO ANTONIO DO LESTE', codigo_ibge: 5107792, codigo_uf: 51 },
    { id: 5303, nome: 'SANTO ANTONIO DO LEVERGER', codigo_ibge: 5107800, codigo_uf: 51 },
    { id: 5304, nome: 'SAO FELIX DO ARAGUAIA', codigo_ibge: 5107859, codigo_uf: 51 },
    { id: 5291, nome: 'SAO JOSE DO POVO', codigo_ibge: 5107297, codigo_uf: 51 },
    { id: 5292, nome: 'SAO JOSE DO RIO CLARO', codigo_ibge: 5107305, codigo_uf: 51 },
    { id: 5293, nome: 'SAO JOSE DO XINGU', codigo_ibge: 5107354, codigo_uf: 51 },
    { id: 5284, nome: 'SAO JOSE DOS QUATRO MARCOS', codigo_ibge: 5107107, codigo_uf: 51 },
    { id: 5294, nome: 'SAO PEDRO DA CIPA', codigo_ibge: 5107404, codigo_uf: 51 },
    { id: 5305, nome: 'SAPEZAL', codigo_ibge: 5107875, codigo_uf: 51 },
    { id: 5306, nome: 'SERRA NOVA DOURADA', codigo_ibge: 5107883, codigo_uf: 51 },
    { id: 5307, nome: 'SINOP', codigo_ibge: 5107909, codigo_uf: 51 },
    { id: 5308, nome: 'SORRISO', codigo_ibge: 5107925, codigo_uf: 51 },
    { id: 5309, nome: 'TABAPORA', codigo_ibge: 5107941, codigo_uf: 51 },
    { id: 5310, nome: 'TANGARA DA SERRA', codigo_ibge: 5107958, codigo_uf: 51 },
    { id: 5311, nome: 'TAPURAH', codigo_ibge: 5108006, codigo_uf: 51 },
    { id: 5312, nome: 'TERRA NOVA DO NORTE', codigo_ibge: 5108055, codigo_uf: 51 },
    { id: 5313, nome: 'TESOURO', codigo_ibge: 5108105, codigo_uf: 51 },
    { id: 5314, nome: 'TORIXOREU', codigo_ibge: 5108204, codigo_uf: 51 },
    { id: 5315, nome: 'UNIAO DO SUL', codigo_ibge: 5108303, codigo_uf: 51 },
    { id: 5316, nome: 'VALE DE SAO DOMINGOS', codigo_ibge: 5108352, codigo_uf: 51 },
    { id: 5317, nome: 'VARZEA GRANDE', codigo_ibge: 5108402, codigo_uf: 51 },
    { id: 5318, nome: 'VERA', codigo_ibge: 5108501, codigo_uf: 51 },
    { id: 5247, nome: 'VILA BELA DA SANTISSIMA TRINDADE', codigo_ibge: 5105507, codigo_uf: 51 },
    { id: 5319, nome: 'VILA RICA', codigo_ibge: 5108600, codigo_uf: 51 },
    { id: 5324, nome: 'ABADIA DE GOIAS', codigo_ibge: 5200050, codigo_uf: 52 },
    { id: 5325, nome: 'ABADIANIA', codigo_ibge: 5200100, codigo_uf: 52 },
    { id: 5326, nome: 'ACREUNA', codigo_ibge: 5200134, codigo_uf: 52 },
    { id: 5327, nome: 'ADELANDIA', codigo_ibge: 5200159, codigo_uf: 52 },
    { id: 5328, nome: 'AGUA FRIA DE GOIAS', codigo_ibge: 5200175, codigo_uf: 52 },
    { id: 5329, nome: 'AGUA LIMPA', codigo_ibge: 5200209, codigo_uf: 52 },
    { id: 5330, nome: 'AGUAS LINDAS DE GOIAS', codigo_ibge: 5200258, codigo_uf: 52 },
    { id: 5331, nome: 'ALEXANIA', codigo_ibge: 5200308, codigo_uf: 52 },
    { id: 5332, nome: 'ALOANDIA', codigo_ibge: 5200506, codigo_uf: 52 },
    { id: 5333, nome: 'ALTO HORIZONTE', codigo_ibge: 5200555, codigo_uf: 52 },
    { id: 5334, nome: 'ALTO PARAISO DE GOIAS', codigo_ibge: 5200605, codigo_uf: 52 },
    { id: 5335, nome: 'ALVORADA DO NORTE', codigo_ibge: 5200803, codigo_uf: 52 },
    { id: 5336, nome: 'AMARALINA', codigo_ibge: 5200829, codigo_uf: 52 },
    { id: 5337, nome: 'AMERICANO DO BRASIL', codigo_ibge: 5200852, codigo_uf: 52 },
    { id: 5338, nome: 'AMORINOPOLIS', codigo_ibge: 5200902, codigo_uf: 52 },
    { id: 5339, nome: 'ANAPOLIS', codigo_ibge: 5201108, codigo_uf: 52 },
    { id: 5340, nome: 'ANHANGUERA', codigo_ibge: 5201207, codigo_uf: 52 },
    { id: 5341, nome: 'ANICUNS', codigo_ibge: 5201306, codigo_uf: 52 },
    { id: 5342, nome: 'APARECIDA DE GOIANIA', codigo_ibge: 5201405, codigo_uf: 52 },
    { id: 5343, nome: 'APARECIDA DO RIO DOCE', codigo_ibge: 5201454, codigo_uf: 52 },
    { id: 5344, nome: 'APORE', codigo_ibge: 5201504, codigo_uf: 52 },
    { id: 5345, nome: 'ARACU', codigo_ibge: 5201603, codigo_uf: 52 },
    { id: 5346, nome: 'ARAGARCAS', codigo_ibge: 5201702, codigo_uf: 52 },
    { id: 5347, nome: 'ARAGOIANIA', codigo_ibge: 5201801, codigo_uf: 52 },
    { id: 5348, nome: 'ARAGUAPAZ', codigo_ibge: 5202155, codigo_uf: 52 },
    { id: 5349, nome: 'ARENOPOLIS', codigo_ibge: 5202353, codigo_uf: 52 },
    { id: 5350, nome: 'ARUANA', codigo_ibge: 5202502, codigo_uf: 52 },
    { id: 5351, nome: 'AURILANDIA', codigo_ibge: 5202601, codigo_uf: 52 },
    { id: 5352, nome: 'AVELINOPOLIS', codigo_ibge: 5202809, codigo_uf: 52 },
    { id: 5353, nome: 'BALIZA', codigo_ibge: 5203104, codigo_uf: 52 },
    { id: 5354, nome: 'BARRO ALTO', codigo_ibge: 5203203, codigo_uf: 52 },
    { id: 5355, nome: 'BELA VISTA DE GOIAS', codigo_ibge: 5203302, codigo_uf: 52 },
    { id: 5356, nome: 'BOM JARDIM DE GOIAS', codigo_ibge: 5203401, codigo_uf: 52 },
    { id: 5357, nome: 'BOM JESUS DE GOIAS', codigo_ibge: 5203500, codigo_uf: 52 },
    { id: 5358, nome: 'BONFINOPOLIS', codigo_ibge: 5203559, codigo_uf: 52 },
    { id: 5359, nome: 'BONOPOLIS', codigo_ibge: 5203575, codigo_uf: 52 },
    { id: 5360, nome: 'BRAZABRANTES', codigo_ibge: 5203609, codigo_uf: 52 },
    { id: 5361, nome: 'BRITANIA', codigo_ibge: 5203807, codigo_uf: 52 },
    { id: 5362, nome: 'BURITI ALEGRE', codigo_ibge: 5203906, codigo_uf: 52 },
    { id: 5363, nome: 'BURITI DE GOIAS', codigo_ibge: 5203939, codigo_uf: 52 },
    { id: 5364, nome: 'BURITINOPOLIS', codigo_ibge: 5203962, codigo_uf: 52 },
    { id: 5365, nome: 'CABECEIRAS', codigo_ibge: 5204003, codigo_uf: 52 },
    { id: 5366, nome: 'CACHOEIRA ALTA', codigo_ibge: 5204102, codigo_uf: 52 },
    { id: 5367, nome: 'CACHOEIRA DE GOIAS', codigo_ibge: 5204201, codigo_uf: 52 },
    { id: 5368, nome: 'CACHOEIRA DOURADA', codigo_ibge: 5204250, codigo_uf: 52 },
    { id: 5369, nome: 'CACU', codigo_ibge: 5204300, codigo_uf: 52 },
    { id: 5370, nome: 'CAIAPONIA', codigo_ibge: 5204409, codigo_uf: 52 },
    { id: 5371, nome: 'CALDAS NOVAS', codigo_ibge: 5204508, codigo_uf: 52 },
    { id: 5372, nome: 'CALDAZINHA', codigo_ibge: 5204557, codigo_uf: 52 },
    { id: 5373, nome: 'CAMPESTRE DE GOIAS', codigo_ibge: 5204607, codigo_uf: 52 },
    { id: 5374, nome: 'CAMPINACU', codigo_ibge: 5204656, codigo_uf: 52 },
    { id: 5375, nome: 'CAMPINORTE', codigo_ibge: 5204706, codigo_uf: 52 },
    { id: 5376, nome: 'CAMPO ALEGRE DE GOIAS', codigo_ibge: 5204805, codigo_uf: 52 },
    { id: 5377, nome: 'CAMPO LIMPO DE GOIAS', codigo_ibge: 5204854, codigo_uf: 52 },
    { id: 5378, nome: 'CAMPOS BELOS', codigo_ibge: 5204904, codigo_uf: 52 },
    { id: 5379, nome: 'CAMPOS VERDES', codigo_ibge: 5204953, codigo_uf: 52 },
    { id: 5380, nome: 'CARMO DO RIO VERDE', codigo_ibge: 5205000, codigo_uf: 52 },
    { id: 5381, nome: 'CASTELANDIA', codigo_ibge: 5205059, codigo_uf: 52 },
    { id: 5382, nome: 'CATALAO', codigo_ibge: 5205109, codigo_uf: 52 },
    { id: 5383, nome: 'CATURAI', codigo_ibge: 5205208, codigo_uf: 52 },
    { id: 5384, nome: 'CAVALCANTE', codigo_ibge: 5205307, codigo_uf: 52 },
    { id: 5385, nome: 'CERES', codigo_ibge: 5205406, codigo_uf: 52 },
    { id: 5386, nome: 'CEZARINA', codigo_ibge: 5205455, codigo_uf: 52 },
    { id: 5387, nome: 'CHAPADAO DO CEU', codigo_ibge: 5205471, codigo_uf: 52 },
    { id: 5388, nome: 'CIDADE OCIDENTAL', codigo_ibge: 5205497, codigo_uf: 52 },
    { id: 5389, nome: 'COCALZINHO DE GOIAS', codigo_ibge: 5205513, codigo_uf: 52 },
    { id: 5390, nome: 'COLINAS DO SUL', codigo_ibge: 5205521, codigo_uf: 52 },
    { id: 5391, nome: 'CORREGO DO OURO', codigo_ibge: 5205703, codigo_uf: 52 },
    { id: 5392, nome: 'CORUMBA DE GOIAS', codigo_ibge: 5205802, codigo_uf: 52 },
    { id: 5393, nome: 'CORUMBAIBA', codigo_ibge: 5205901, codigo_uf: 52 },
    { id: 5394, nome: 'CRISTALINA', codigo_ibge: 5206206, codigo_uf: 52 },
    { id: 5395, nome: 'CRISTIANOPOLIS', codigo_ibge: 5206305, codigo_uf: 52 },
    { id: 5396, nome: 'CRIXAS', codigo_ibge: 5206404, codigo_uf: 52 },
    { id: 5397, nome: 'CROMINIA', codigo_ibge: 5206503, codigo_uf: 52 },
    { id: 5398, nome: 'CUMARI', codigo_ibge: 5206602, codigo_uf: 52 },
    { id: 5399, nome: 'DAMIANOPOLIS', codigo_ibge: 5206701, codigo_uf: 52 },
    { id: 5400, nome: 'DAMOLANDIA', codigo_ibge: 5206800, codigo_uf: 52 },
    { id: 5401, nome: 'DAVINOPOLIS', codigo_ibge: 5206909, codigo_uf: 52 },
    { id: 5402, nome: 'DIORAMA', codigo_ibge: 5207105, codigo_uf: 52 },
    { id: 5414, nome: 'DIVINOPOLIS DE GOIAS', codigo_ibge: 5208301, codigo_uf: 52 },
    { id: 5403, nome: 'DOVERLANDIA', codigo_ibge: 5207253, codigo_uf: 52 },
    { id: 5404, nome: 'EDEALINA', codigo_ibge: 5207352, codigo_uf: 52 },
    { id: 5405, nome: 'EDEIA', codigo_ibge: 5207402, codigo_uf: 52 },
    { id: 5406, nome: 'ESTRELA DO NORTE', codigo_ibge: 5207501, codigo_uf: 52 },
    { id: 5407, nome: 'FAINA', codigo_ibge: 5207535, codigo_uf: 52 },
    { id: 5408, nome: 'FAZENDA NOVA', codigo_ibge: 5207600, codigo_uf: 52 },
    { id: 5409, nome: 'FIRMINOPOLIS', codigo_ibge: 5207808, codigo_uf: 52 },
    { id: 5410, nome: 'FLORES DE GOIAS', codigo_ibge: 5207907, codigo_uf: 52 },
    { id: 5411, nome: 'FORMOSA', codigo_ibge: 5208004, codigo_uf: 52 },
    { id: 5412, nome: 'FORMOSO', codigo_ibge: 5208103, codigo_uf: 52 },
    { id: 5413, nome: 'GAMELEIRA DE GOIAS', codigo_ibge: 5208152, codigo_uf: 52 },
    { id: 5415, nome: 'GOIANAPOLIS', codigo_ibge: 5208400, codigo_uf: 52 },
    { id: 5416, nome: 'GOIANDIRA', codigo_ibge: 5208509, codigo_uf: 52 },
    { id: 5417, nome: 'GOIANESIA', codigo_ibge: 5208608, codigo_uf: 52 },
    { id: 5418, nome: 'GOIANIA', codigo_ibge: 5208707, codigo_uf: 52 },
    { id: 5419, nome: 'GOIANIRA', codigo_ibge: 5208806, codigo_uf: 52 },
    { id: 5420, nome: 'GOIAS', codigo_ibge: 5208905, codigo_uf: 52 },
    { id: 5421, nome: 'GOIATUBA', codigo_ibge: 5209101, codigo_uf: 52 },
    { id: 5422, nome: 'GOUVELANDIA', codigo_ibge: 5209150, codigo_uf: 52 },
    { id: 5423, nome: 'GUAPO', codigo_ibge: 5209200, codigo_uf: 52 },
    { id: 5424, nome: 'GUARAITA', codigo_ibge: 5209291, codigo_uf: 52 },
    { id: 5425, nome: 'GUARANI DE GOIAS', codigo_ibge: 5209408, codigo_uf: 52 },
    { id: 5426, nome: 'GUARINOS', codigo_ibge: 5209457, codigo_uf: 52 },
    { id: 5427, nome: 'HEITORAI', codigo_ibge: 5209606, codigo_uf: 52 },
    { id: 5428, nome: 'HIDROLANDIA', codigo_ibge: 5209705, codigo_uf: 52 },
    { id: 5429, nome: 'HIDROLINA', codigo_ibge: 5209804, codigo_uf: 52 },
    { id: 5430, nome: 'IACIARA', codigo_ibge: 5209903, codigo_uf: 52 },
    { id: 5431, nome: 'INACIOLANDIA', codigo_ibge: 5209937, codigo_uf: 52 },
    { id: 5432, nome: 'INDIARA', codigo_ibge: 5209952, codigo_uf: 52 },
    { id: 5433, nome: 'INHUMAS', codigo_ibge: 5210000, codigo_uf: 52 },
    { id: 5434, nome: 'IPAMERI', codigo_ibge: 5210109, codigo_uf: 52 },
    { id: 5435, nome: 'IPIRANGA DE GOIAS', codigo_ibge: 5210158, codigo_uf: 52 },
    { id: 5436, nome: 'IPORA', codigo_ibge: 5210208, codigo_uf: 52 },
    { id: 5437, nome: 'ISRAELANDIA', codigo_ibge: 5210307, codigo_uf: 52 },
    { id: 5438, nome: 'ITABERAI', codigo_ibge: 5210406, codigo_uf: 52 },
    { id: 5439, nome: 'ITAGUARI', codigo_ibge: 5210562, codigo_uf: 52 },
    { id: 5440, nome: 'ITAGUARU', codigo_ibge: 5210604, codigo_uf: 52 },
    { id: 5441, nome: 'ITAJA', codigo_ibge: 5210802, codigo_uf: 52 },
    { id: 5442, nome: 'ITAPACI', codigo_ibge: 5210901, codigo_uf: 52 },
    { id: 5443, nome: 'ITAPIRAPUA', codigo_ibge: 5211008, codigo_uf: 52 },
    { id: 5444, nome: 'ITAPURANGA', codigo_ibge: 5211206, codigo_uf: 52 },
    { id: 5445, nome: 'ITARUMA', codigo_ibge: 5211305, codigo_uf: 52 },
    { id: 5446, nome: 'ITAUCU', codigo_ibge: 5211404, codigo_uf: 52 },
    { id: 5447, nome: 'ITUMBIARA', codigo_ibge: 5211503, codigo_uf: 52 },
    { id: 5448, nome: 'IVOLANDIA', codigo_ibge: 5211602, codigo_uf: 52 },
    { id: 5449, nome: 'JANDAIA', codigo_ibge: 5211701, codigo_uf: 52 },
    { id: 5450, nome: 'JARAGUA', codigo_ibge: 5211800, codigo_uf: 52 },
    { id: 5451, nome: 'JATAI', codigo_ibge: 5211909, codigo_uf: 52 },
    { id: 5452, nome: 'JAUPACI', codigo_ibge: 5212006, codigo_uf: 52 },
    { id: 5453, nome: 'JESUPOLIS', codigo_ibge: 5212055, codigo_uf: 52 },
    { id: 5454, nome: 'JOVIANIA', codigo_ibge: 5212105, codigo_uf: 52 },
    { id: 5455, nome: 'JUSSARA', codigo_ibge: 5212204, codigo_uf: 52 },
    { id: 5456, nome: 'LAGOA SANTA', codigo_ibge: 5212253, codigo_uf: 52 },
    { id: 5457, nome: 'LEOPOLDO DE BULHOES', codigo_ibge: 5212303, codigo_uf: 52 },
    { id: 5458, nome: 'LUZIANIA', codigo_ibge: 5212501, codigo_uf: 52 },
    { id: 5459, nome: 'MAIRIPOTABA', codigo_ibge: 5212600, codigo_uf: 52 },
    { id: 5460, nome: 'MAMBAI', codigo_ibge: 5212709, codigo_uf: 52 },
    { id: 5461, nome: 'MARA ROSA', codigo_ibge: 5212808, codigo_uf: 52 },
    { id: 5462, nome: 'MARZAGAO', codigo_ibge: 5212907, codigo_uf: 52 },
    { id: 5463, nome: 'MATRINCHA', codigo_ibge: 5212956, codigo_uf: 52 },
    { id: 5464, nome: 'MAURILANDIA', codigo_ibge: 5213004, codigo_uf: 52 },
    { id: 5465, nome: 'MIMOSO DE GOIAS', codigo_ibge: 5213053, codigo_uf: 52 },
    { id: 5466, nome: 'MINACU', codigo_ibge: 5213087, codigo_uf: 52 },
    { id: 5467, nome: 'MINEIROS', codigo_ibge: 5213103, codigo_uf: 52 },
    { id: 5468, nome: 'MOIPORA', codigo_ibge: 5213400, codigo_uf: 52 },
    { id: 5469, nome: 'MONTE ALEGRE DE GOIAS', codigo_ibge: 5213509, codigo_uf: 52 },
    { id: 5470, nome: 'MONTES CLAROS DE GOIAS', codigo_ibge: 5213707, codigo_uf: 52 },
    { id: 5471, nome: 'MONTIVIDIU', codigo_ibge: 5213756, codigo_uf: 52 },
    { id: 5472, nome: 'MONTIVIDIU DO NORTE', codigo_ibge: 5213772, codigo_uf: 52 },
    { id: 5473, nome: 'MORRINHOS', codigo_ibge: 5213806, codigo_uf: 52 },
    { id: 5474, nome: 'MORRO AGUDO DE GOIAS', codigo_ibge: 5213855, codigo_uf: 52 },
    { id: 5475, nome: 'MOSSAMEDES', codigo_ibge: 5213905, codigo_uf: 52 },
    { id: 5476, nome: 'MOZARLANDIA', codigo_ibge: 5214002, codigo_uf: 52 },
    { id: 5477, nome: 'MUNDO NOVO', codigo_ibge: 5214051, codigo_uf: 52 },
    { id: 5478, nome: 'MUTUNOPOLIS', codigo_ibge: 5214101, codigo_uf: 52 },
    { id: 5479, nome: 'NAZARIO', codigo_ibge: 5214408, codigo_uf: 52 },
    { id: 5480, nome: 'NEROPOLIS', codigo_ibge: 5214507, codigo_uf: 52 },
    { id: 5481, nome: 'NIQUELANDIA', codigo_ibge: 5214606, codigo_uf: 52 },
    { id: 5482, nome: 'NOVA AMERICA', codigo_ibge: 5214705, codigo_uf: 52 },
    { id: 5483, nome: 'NOVA AURORA', codigo_ibge: 5214804, codigo_uf: 52 },
    { id: 5484, nome: 'NOVA CRIXAS', codigo_ibge: 5214838, codigo_uf: 52 },
    { id: 5485, nome: 'NOVA GLORIA', codigo_ibge: 5214861, codigo_uf: 52 },
    { id: 5486, nome: 'NOVA IGUACU DE GOIAS', codigo_ibge: 5214879, codigo_uf: 52 },
    { id: 5487, nome: 'NOVA ROMA', codigo_ibge: 5214903, codigo_uf: 52 },
    { id: 5488, nome: 'NOVA VENEZA', codigo_ibge: 5215009, codigo_uf: 52 },
    { id: 5489, nome: 'NOVO BRASIL', codigo_ibge: 5215207, codigo_uf: 52 },
    { id: 5490, nome: 'NOVO GAMA', codigo_ibge: 5215231, codigo_uf: 52 },
    { id: 5491, nome: 'NOVO PLANALTO', codigo_ibge: 5215256, codigo_uf: 52 },
    { id: 5492, nome: 'ORIZONA', codigo_ibge: 5215306, codigo_uf: 52 },
    { id: 5493, nome: 'OURO VERDE DE GOIAS', codigo_ibge: 5215405, codigo_uf: 52 },
    { id: 5494, nome: 'OUVIDOR', codigo_ibge: 5215504, codigo_uf: 52 },
    { id: 5495, nome: 'PADRE BERNARDO', codigo_ibge: 5215603, codigo_uf: 52 },
    { id: 5496, nome: 'PALESTINA DE GOIAS', codigo_ibge: 5215652, codigo_uf: 52 },
    { id: 5497, nome: 'PALMEIRAS DE GOIAS', codigo_ibge: 5215702, codigo_uf: 52 },
    { id: 5498, nome: 'PALMELO', codigo_ibge: 5215801, codigo_uf: 52 },
    { id: 5499, nome: 'PALMINOPOLIS', codigo_ibge: 5215900, codigo_uf: 52 },
    { id: 5500, nome: 'PANAMA', codigo_ibge: 5216007, codigo_uf: 52 },
    { id: 5501, nome: 'PARANAIGUARA', codigo_ibge: 5216304, codigo_uf: 52 },
    { id: 5502, nome: 'PARAUNA', codigo_ibge: 5216403, codigo_uf: 52 },
    { id: 5503, nome: 'PEROLANDIA', codigo_ibge: 5216452, codigo_uf: 52 },
    { id: 5504, nome: 'PETROLINA DE GOIAS', codigo_ibge: 5216809, codigo_uf: 52 },
    { id: 5505, nome: 'PILAR DE GOIAS', codigo_ibge: 5216908, codigo_uf: 52 },
    { id: 5506, nome: 'PIRACANJUBA', codigo_ibge: 5217104, codigo_uf: 52 },
    { id: 5507, nome: 'PIRANHAS', codigo_ibge: 5217203, codigo_uf: 52 },
    { id: 5508, nome: 'PIRENOPOLIS', codigo_ibge: 5217302, codigo_uf: 52 },
    { id: 5509, nome: 'PIRES DO RIO', codigo_ibge: 5217401, codigo_uf: 52 },
    { id: 5510, nome: 'PLANALTINA', codigo_ibge: 5217609, codigo_uf: 52 },
    { id: 5511, nome: 'PONTALINA', codigo_ibge: 5217708, codigo_uf: 52 },
    { id: 5512, nome: 'PORANGATU', codigo_ibge: 5218003, codigo_uf: 52 },
    { id: 5513, nome: 'PORTEIRAO', codigo_ibge: 5218052, codigo_uf: 52 },
    { id: 5514, nome: 'PORTELANDIA', codigo_ibge: 5218102, codigo_uf: 52 },
    { id: 5515, nome: 'POSSE', codigo_ibge: 5218300, codigo_uf: 52 },
    { id: 5516, nome: 'PROFESSOR JAMIL', codigo_ibge: 5218391, codigo_uf: 52 },
    { id: 5517, nome: 'QUIRINOPOLIS', codigo_ibge: 5218508, codigo_uf: 52 },
    { id: 5518, nome: 'RIALMA', codigo_ibge: 5218607, codigo_uf: 52 },
    { id: 5519, nome: 'RIANAPOLIS', codigo_ibge: 5218706, codigo_uf: 52 },
    { id: 5520, nome: 'RIO QUENTE', codigo_ibge: 5218789, codigo_uf: 52 },
    { id: 5521, nome: 'RIO VERDE', codigo_ibge: 5218805, codigo_uf: 52 },
    { id: 5522, nome: 'RUBIATABA', codigo_ibge: 5218904, codigo_uf: 52 },
    { id: 5523, nome: 'SANCLERLANDIA', codigo_ibge: 5219001, codigo_uf: 52 },
    { id: 5524, nome: 'SANTA BARBARA DE GOIAS', codigo_ibge: 5219100, codigo_uf: 52 },
    { id: 5525, nome: 'SANTA CRUZ DE GOIAS', codigo_ibge: 5219209, codigo_uf: 52 },
    { id: 5526, nome: 'SANTA FE DE GOIAS', codigo_ibge: 5219258, codigo_uf: 52 },
    { id: 5527, nome: 'SANTA HELENA DE GOIAS', codigo_ibge: 5219308, codigo_uf: 52 },
    { id: 5528, nome: 'SANTA ISABEL', codigo_ibge: 5219357, codigo_uf: 52 },
    { id: 5529, nome: 'SANTA RITA DO ARAGUAIA', codigo_ibge: 5219407, codigo_uf: 52 },
    { id: 5530, nome: 'SANTA RITA DO NOVO DESTINO', codigo_ibge: 5219456, codigo_uf: 52 },
    { id: 5531, nome: 'SANTA ROSA DE GOIAS', codigo_ibge: 5219506, codigo_uf: 52 },
    { id: 5532, nome: 'SANTA TEREZA DE GOIAS', codigo_ibge: 5219605, codigo_uf: 52 },
    { id: 5533, nome: 'SANTA TEREZINHA DE GOIAS', codigo_ibge: 5219704, codigo_uf: 52 },
    { id: 5534, nome: 'SANTO ANTONIO DA BARRA', codigo_ibge: 5219712, codigo_uf: 52 },
    { id: 5535, nome: 'SANTO ANTONIO DE GOIAS', codigo_ibge: 5219738, codigo_uf: 52 },
    { id: 5536, nome: 'SANTO ANTONIO DO DESCOBERTO', codigo_ibge: 5219753, codigo_uf: 52 },
    { id: 5537, nome: 'SAO DOMINGOS', codigo_ibge: 5219803, codigo_uf: 52 },
    { id: 5538, nome: 'SAO FRANCISCO DE GOIAS', codigo_ibge: 5219902, codigo_uf: 52 },
    { id: 5539, nome: 'SAO JOAO D ALIANCA', codigo_ibge: 5220009, codigo_uf: 52 },
    { id: 5540, nome: 'SAO JOAO DA PARAUNA', codigo_ibge: 5220058, codigo_uf: 52 },
    { id: 5541, nome: 'SAO LUIS DE MONTES BELOS', codigo_ibge: 5220108, codigo_uf: 52 },
    { id: 5542, nome: 'SAO LUIZ DO NORTE', codigo_ibge: 5220157, codigo_uf: 52 },
    { id: 5543, nome: 'SAO MIGUEL DO ARAGUAIA', codigo_ibge: 5220207, codigo_uf: 52 },
    { id: 5544, nome: 'SAO MIGUEL DO PASSA QUATRO', codigo_ibge: 5220264, codigo_uf: 52 },
    { id: 5545, nome: 'SAO PATRICIO', codigo_ibge: 5220280, codigo_uf: 52 },
    { id: 5546, nome: 'SAO SIMAO', codigo_ibge: 5220405, codigo_uf: 52 },
    { id: 5547, nome: 'SENADOR CANEDO', codigo_ibge: 5220454, codigo_uf: 52 },
    { id: 5548, nome: 'SERRANOPOLIS', codigo_ibge: 5220504, codigo_uf: 52 },
    { id: 5549, nome: 'SILVANIA', codigo_ibge: 5220603, codigo_uf: 52 },
    { id: 5550, nome: 'SIMOLANDIA', codigo_ibge: 5220686, codigo_uf: 52 },
    { id: 5551, nome: 'SITIO D ABADIA', codigo_ibge: 5220702, codigo_uf: 52 },
    { id: 5552, nome: 'TAQUARAL DE GOIAS', codigo_ibge: 5221007, codigo_uf: 52 },
    { id: 5553, nome: 'TERESINA DE GOIAS', codigo_ibge: 5221080, codigo_uf: 52 },
    { id: 5554, nome: 'TEREZOPOLIS DE GOIAS', codigo_ibge: 5221197, codigo_uf: 52 },
    { id: 5555, nome: 'TRES RANCHOS', codigo_ibge: 5221304, codigo_uf: 52 },
    { id: 5556, nome: 'TRINDADE', codigo_ibge: 5221403, codigo_uf: 52 },
    { id: 5557, nome: 'TROMBAS', codigo_ibge: 5221452, codigo_uf: 52 },
    { id: 5558, nome: 'TURVANIA', codigo_ibge: 5221502, codigo_uf: 52 },
    { id: 5559, nome: 'TURVELANDIA', codigo_ibge: 5221551, codigo_uf: 52 },
    { id: 5560, nome: 'UIRAPURU', codigo_ibge: 5221577, codigo_uf: 52 },
    { id: 5561, nome: 'URUACU', codigo_ibge: 5221601, codigo_uf: 52 },
    { id: 5562, nome: 'URUANA', codigo_ibge: 5221700, codigo_uf: 52 },
    { id: 5563, nome: 'URUTAI', codigo_ibge: 5221809, codigo_uf: 52 },
    { id: 5564, nome: 'VALPARAISO DE GOIAS', codigo_ibge: 5221858, codigo_uf: 52 },
    { id: 5565, nome: 'VARJAO', codigo_ibge: 5221908, codigo_uf: 52 },
    { id: 5566, nome: 'VIANOPOLIS', codigo_ibge: 5222005, codigo_uf: 52 },
    { id: 5567, nome: 'VICENTINOPOLIS', codigo_ibge: 5222054, codigo_uf: 52 },
    { id: 5568, nome: 'VILA BOA', codigo_ibge: 5222203, codigo_uf: 52 },
    { id: 5569, nome: 'VILA PROPICIO', codigo_ibge: 5222302, codigo_uf: 52 },
    { id: 5570, nome: 'BRASILIA', codigo_ibge: 5300108, codigo_uf: 53 },
    { id: 5571, nome: 'EXTERIOR', codigo_ibge: 9999999, codigo_uf: 54 },
];